// Localised meal recovery notes, ingredients and steps.
// Auto-generated by /app/scripts/translate_meal_content.py via Gemini 3 Flash.
// Re-run to fill missing or new content. Manual edits are preserved.

const __DATA = {
  "b1": {
    "ru": {
      "recovery_note": "Овсяная крупа долгого варки медленно высвобождает глюкозу, предотвращая скачки сахара в крови, которые вызывают тягу к еде. Грецкие орехи обогащают блюдо омега-3 для поддержания настроения, а ягоды добавляют антиоксиданты для восстановления работы мозга.",
      "ingredients": [
        "1/2 cup дроблёного овса (steel-cut oats)",
        "2 cups воды или несладкого молока",
        "1/2 cup смеси ягод (свежих или замороженных)",
        "2 tbsp измельчённых грецких орехов",
        "1 tsp корицы",
        "1 tsp мёда или кленового сиропа (по желанию)"
      ],
      "steps": [
        "Доведите воду/молоко до кипения в небольшом сотейнике.",
        "Всыпьте овсяные хлопья и корицу, уменьшите огонь до слабого.",
        "Варите на медленном огне без крышки, периодически помешивая, 18–20 минут.",
        "Выложите ложкой в миску, сверху украсьте ягодами и грецкими орехами.",
        "При желании полейте медом. Подавайте теплым."
      ]
    },
    "uk": {
      "recovery_note": "Цільнозернова вівсянка повільно вивільняє глюкозу, що запобігає різким стрибкам цукру в крові, які викликають тягу до їжі. Волоські горіхи збагачують страву омега-3 для гарного настрою, а ягоди додають антиоксиданти для відновлення мозку.",
      "ingredients": [
        "1/2 склянки вівсяної крупи (steel-cut oats)",
        "2 склянки води або несолодкого молока",
        "1/2 склянки суміші ягід (свіжих або заморожених)",
        "2 tbsp подрібнених волоських горіхів",
        "1 tsp кориці",
        "1 tsp меду або кленового сиропу (за бажанням)"
      ],
      "steps": [
        "Доведіть воду/молоко до кипіння у невеликій каструлі.",
        "Всипте овес та корицю, зменште вогонь до мінімуму.",
        "Варіть на повільному вогні без кришки, періодично помішуючи, 18–20 хвилин.",
        "Перекладіть ложкою в миску, зверху викладіть ягоди та волоські горіхи.",
        "Полийте медом за бажанням. Подавайте теплим."
      ]
    },
    "ko": {
      "recovery_note": "스틸컷 오츠는 포도당을 천천히 배출하여 식탐을 유발하는 혈당 급상승을 방지합니다. 호두는 기분 조절을 돕는 오메가-3를 더해주며, 베리류는 뇌 회복에 필요한 항산화 성분을 더해줍니다.",
      "ingredients": [
        "1/2 cup 스틸컷 오트 (steel-cut oats)",
        "2 cups 물 또는 무가당 우유",
        "1/2 cup 믹스 베리 (신선한 것 또는 냉동)",
        "2 tbsp 다진 호두",
        "1 tsp 시나몬",
        "1 tsp 꿀 또는 메이플 시럽 (선택 사항)"
      ],
      "steps": [
        "작은 냄비에 물 또는 우유를 넣고 끓입니다.",
        "oats와 cinnamon을 넣고 저은 뒤, 약불로 줄입니다.",
        "뚜껑을 연 채로 가끔 저어주며 18–20 minutes 동안 뭉근하게 끓입니다.",
        "그릇에 담고 위에 berries와 walnuts를 올립니다.",
        "기호에 따라 honey를 뿌립니다. 따뜻할 때 내놓습니다."
      ]
    },
    "fr": {
      "recovery_note": "L'avoine concassée libère le glucose lentement, évitant ainsi les pics de glycémie qui alimentent les fringales. Les noix apportent des oméga-3 pour le moral, et les baies ajoutent des antioxydants pour la régénération cérébrale.",
      "ingredients": [
        "1/2 cup d'avoine concassée (steel-cut oats)",
        "2 cups d'eau ou de lait non sucré",
        "1/2 cup de baies mélangées (fraîches ou surgelées)",
        "2 tbsp de noix hachées",
        "1 tsp de cannelle",
        "1 tsp de miel ou de sirop d'érable (optionnel)"
      ],
      "steps": [
        "Portez l'eau/le lait à ébullition dans une petite casserole.",
        "Incorporez l'avoine et la cannelle, puis réduisez le feu à doux.",
        "Laissez mijoter à découvert en remuant de temps en temps, pendant 18–20 minutes.",
        "Versez dans un bol à l'aide d'une cuillère et garnissez de baies et de noix.",
        "Arrosez d'un filet de miel si vous le souhaitez. Servez chaud."
      ]
    },
    "it": {
      "recovery_note": "L'avena tagliata a pezzi rilascia il glucosio lentamente, prevenendo i picchi di zucchero nel sangue che alimentano la fame nervosa. Le noci apportano omega-3 per il buonumore, mentre i frutti di bosco aggiungono antiossidanti per la rigenerazione cerebrale.",
      "ingredients": [
        "1/2 cup di steel-cut oats",
        "2 cups di acqua o latte non dolcificato",
        "1/2 cup di frutti di bosco misti (freschi o surgelati)",
        "2 tbsp di noci tritate",
        "1 tsp di cannella",
        "1 tsp di miele o sciroppo d'acero (opzionale)"
      ],
      "steps": [
        "Portare acqua/latte a bollore in un pentolino.",
        "Incorporare i fiocchi d'avena e la cannella, ridurre la fiamma a fuoco basso.",
        "Sobbollire senza coperchio, mescolando occasionalmente, per 18–20 minutes.",
        "Trasferire con un cucchiaio in una ciotola, guarnire con frutti di bosco e noci.",
        "Completare con un filo di miele se desiderato. Servire caldo."
      ]
    },
    "es": {
      "recovery_note": "La avena cortada libera glucosa lentamente, evitando los picos de azúcar en sangre que alimentan los antojos. Las nueces aportan omega-3 para el estado de ánimo y los frutos rojos añaden antioxidantes para la reparación cerebral.",
      "ingredients": [
        "1/2 cup steel-cut oats",
        "2 cups water o unsweetened milk",
        "1/2 cup mixed berries (frescos o congelados)",
        "2 tbsp walnuts picadas",
        "1 tsp cinnamon",
        "1 tsp honey o maple syrup (opcional)"
      ],
      "steps": [
        "Lleve el agua/leche a ebullición en una cacerola pequeña.",
        "Incorpore la avena y la cinnamon, reduzca el fuego a bajo.",
        "Cocine a fuego lento sin tapar, revolviendo ocasionalmente, de 18–20 minutos.",
        "Sirva con una cuchara en un tazón, cubra con bayas y walnuts.",
        "Rocíe con miel si lo desea. Sirva caliente."
      ]
    }
  },
  "b2": {
    "ru": {
      "recovery_note": "Яйца содержат полноценный белок и холин — оба компонента критически важны для восстановления нейромедиаторных путей, поврежденных в результате длительного употребления психоактивных веществ.",
      "ingredients": [
        "2 яйца",
        "1/4 чашки baby spinach",
        "2 помидора черри, разрезанные пополам",
        "1 tbsp тертого сыра",
        "1 tsp оливкового масла",
        "Соль, перец по вкусу"
      ],
      "steps": [
        "Взбейте яйца в миске с щепоткой соли и перца.",
        "Разогрейте оливковое масло в сковороде с антипригарным покрытием на среднем огне.",
        "Добавьте помидоры и шпинат, обжаривайте 1 минуту, пока шпинат не станет мягким.",
        "Влейте яйца и аккуратно помешивайте до готовности, примерно 2–3 минуты.",
        "Посыпьте сыром, сложите пополам и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Яйця містять повноцінний білок і холін — обидва ці компоненти мають вирішальне значення для відновлення нейромедіаторних шляхів, пошкоджених внаслідок тривалого вживання психоактивних речовин.",
      "ingredients": [
        "2 яйця",
        "1/4 склянки baby spinach",
        "2 томати чері, розрізані навпіл",
        "1 tbsp тертого сиру",
        "1 tsp оливкової олії",
        "Сіль, перець за смаком"
      ],
      "steps": [
        "Збийте яйця в мисці з дрібкою солі та перцю.",
        "Розігрійте оливкову олію в антипригарній сковорідці на середньому вогні.",
        "Додайте томати та шпинат, обсмажуйте 1 хвилину, поки шпинат не зів’яне.",
        "Влийте яйця та обережно помішуйте до готовності, приблизно 2–3 хвилини.",
        "Посипте сиром, складіть навпіл і подавайте."
      ]
    },
    "ko": {
      "recovery_note": "계란은 완전 단백질과 콜린을 제공하며, 이 두 성분은 장기적인 약물 사용으로 손상된 신경전달물질 경로를 회복하는 데 매우 중요합니다.",
      "ingredients": [
        "계란 2개",
        "베이비 시금치 1/4 cup",
        "반으로 자른 방울토마토 2개",
        "grated cheese 1 tbsp",
        "올리브 오일 1 tsp",
        "소금, 후추 약간"
      ],
      "steps": [
        "볼에 소금, 후추 한 꼬집과 함께 달걀을 넣고 휘저으세요.",
        "눌러붙지 않는 팬에 올리브 오일을 두르고 중간 불로 가열하세요.",
        "토마토와 시금치를 넣고 시금치 숨이 죽을 때까지 1분간 볶으세요.",
        "달걀물을 붓고 살짝 익을 때까지 약 2–3분간 부드럽게 저어주세요.",
        "치즈를 올리고 반으로 접어 접시에 담아내세요."
      ]
    },
    "fr": {
      "recovery_note": "Les œufs apportent des protéines complètes et de la choline, deux éléments essentiels à la réparation des voies neurotransmettrices endommagées par la consommation prolongée de substances.",
      "ingredients": [
        "2 œufs",
        "1/4 cup de jeunes pousses d'épinards",
        "2 tomates cerises, coupées en deux",
        "1 tbsp de fromage râpé",
        "1 tsp d'huile d'olive",
        "Sel, poivre au goût"
      ],
      "steps": [
        "Fouetter les œufs dans un bol avec une pincée de sel et de poivre.",
        "Faire chauffer l'olive oil dans une poêle antiadhésive à feu moyen.",
        "Ajouter les tomates et les spinach, faire sauter 1 minute jusqu'à ce que les spinach flétrissent.",
        "Verser les œufs et remuer délicatement jusqu'à ce qu'ils soient tout juste pris, environ 2–3 minutes.",
        "Garnir de fromage, plier et servir."
      ]
    },
    "it": {
      "recovery_note": "Le uova forniscono proteine complete e colina, entrambe fondamentali per riparare le vie dei neurotrasmettitori danneggiate dall'uso prolungato di sostanze.",
      "ingredients": [
        "2 uova",
        "1/4 cup di spinacini",
        "2 pomodori ciliegino, tagliati a metà",
        "1 tbsp di formaggio grattugiato",
        "1 tsp di olio d'oliva",
        "Sale, pepe quanto basta"
      ],
      "steps": [
        "Sbattere le uova in una ciotola con un pizzico di sale e pepe.",
        "Scaldare l'olio d'oliva in una padella antiaderente a fuoco medio.",
        "Aggiungere i pomodori e gli spinaci, rosolare per 1 minuto finché gli spinaci non appassiranno.",
        "Versare le uova e mescolare delicatamente fino a quando non si saranno appena rapprese, circa 2–3 minuti.",
        "Completare con il formaggio, piegare e servire."
      ]
    },
    "es": {
      "recovery_note": "Los huevos aportan proteínas completas y colina, ambos fundamentales para reparar las vías de los neurotransmisores dañadas por el consumo prolongado de sustancias.",
      "ingredients": [
        "2 huevos",
        "1/4 cup de espinaca baby",
        "2 tomates cherry, cortados por la mitad",
        "1 tbsp de queso rallado",
        "1 tsp de aceite de oliva",
        "Sal y pimienta al gusto"
      ],
      "steps": [
        "Batir los huevos en un bol con una pizca de sal y pimienta.",
        "Calentar aceite de oliva en una sartén antiadherente a fuego medio.",
        "Añadir los tomates y las espinacas, saltear 1 minuto hasta que las espinacas se marchiten.",
        "Verter los huevos y remover suavemente hasta que estén cuajados, unos 2–3 minutos.",
        "Cubrir con queso, doblar y servir."
      ]
    }
  },
  "b3": {
    "ru": {
      "recovery_note": "Живые культуры в греческом йогурте поддерживают ось «кишечник-мозг». Здоровый кишечник вырабатывает ~90% вашего серотонина — жизненно важного для регуляции настроения на ранних этапах восстановления.",
      "ingredients": [
        "3/4 cup греческого йогурта без добавок",
        "1/4 cup гранолы",
        "1/2 cup смеси ягод",
        "1 tbsp меда",
        "1 tbsp семян чиа (по желанию)"
      ],
      "steps": [
        "Выложите ложкой половину yoghurt в стакан или миску.",
        "Сформируйте слой из половины granola и ягод.",
        "Повторите слои.",
        "Полейте медом и посыпьте семенами chia.",
        "Подавайте немедленно."
      ]
    },
    "uk": {
      "recovery_note": "Живі культури в грецькому йогурті підтримують вісь «кишківник-мозок». Здоровий кишківник виробляє ~90% вашого серотоніну — життєво важливого для регуляції настрою на ранніх етапах відновлення.",
      "ingredients": [
        "3/4 cup грецького йогурту без добавок",
        "1/4 cup граноли",
        "1/2 cup суміші ягід",
        "1 tbsp меду",
        "1 tbsp насіння чіа (за бажанням)"
      ],
      "steps": [
        "Викладіть ложкою половину yoghurt у склянку або миску.",
        "Викладіть шаром половину granola та ягід.",
        "Повторіть шари.",
        "Полийте honey та посипте chia seeds.",
        "Подавайте негайно."
      ]
    },
    "ko": {
      "recovery_note": "그릭 요거트의 유익균은 장-뇌 축 건강을 돕습니다. 건강한 장은 세로토닌의 약 90%를 생성하며, 이는 회복 초기 단계의 기분 조절에 필수적입니다.",
      "ingredients": [
        "3/4 cup 플레인 Greek yoghurt",
        "1/4 cup 그래놀라",
        "1/2 cup 믹스 베리",
        "1 tbsp 꿀",
        "1 tbsp 치아씨드 (선택 사항)"
      ],
      "steps": [
        "yoghurt 절반을 숟가락으로 떠서 유리잔이나 볼에 담습니다.",
        "granola와 berries의 절반을 층층이 쌓습니다.",
        "이 과정을 한 번 더 반복하여 층을 만듭니다.",
        "honey를 뿌리고 chia seeds를 골고루 뿌립니다.",
        "즉시 내어줍니다."
      ]
    },
    "fr": {
      "recovery_note": "Les cultures vivantes du yaourt grec soutiennent l'axe intestin-cerveau. Un intestin sain produit ~90% de votre sérotonine — essentielle pour la régulation de l'humeur au début du rétablissement.",
      "ingredients": [
        "3/4 cup yaourt grec nature",
        "1/4 cup granola",
        "1/2 cup mélange de baies",
        "1 tbsp miel",
        "1 tbsp graines de chia (optionnel)"
      ],
      "steps": [
        "Déposez la moitié du yoghurt dans un verre ou un bol à l'aide d'une cuillère.",
        "Formez une couche avec la moitié du granola et des baies.",
        "Répétez les couches.",
        "Arrosez de honey et saupoudrez de graines de chia.",
        "Servez immédiatement."
      ]
    },
    "it": {
      "recovery_note": "I fermenti lattici vivi contenuti nello yogurt greco supportano l'asse intestino-cervello. Un intestino sano produce circa il 90% della serotonina, fondamentale per la regolazione dell'umore nelle prime fasi del recupero.",
      "ingredients": [
        "3/4 cup di yogurt greco bianco",
        "1/4 cup di granola",
        "1/2 cup di frutti di bosco misti",
        "1 tbsp di miele",
        "1 tbsp di semi di chia (opzionale)"
      ],
      "steps": [
        "Versare metà dello yoghurt in un bicchiere o in una ciotola con un cucchiaio.",
        "Formare uno strato con metà della granola e dei frutti di bosco.",
        "Ripetere gli strati.",
        "Guarnire con un filo di miele e cospargere con i semi di chia.",
        "Servire immediatamente."
      ]
    },
    "es": {
      "recovery_note": "Los cultivos vivos del yogur griego favorecen el eje intestino-cerebro. Un intestino sano produce ~90% de la serotonina, la cual es vital para la regulación del estado de ánimo al inicio de la recuperación.",
      "ingredients": [
        "3/4 cup yogur griego natural",
        "1/4 cup granola",
        "1/2 cup mezcla de bayas",
        "1 tbsp miel",
        "1 tbsp semillas de chía (opcional)"
      ],
      "steps": [
        "Coloque con una cuchara la mitad del yoghurt en un vaso o tazón.",
        "Forme una capa con la mitad de la granola y las bayas.",
        "Repita las capas.",
        "Rocíe con honey y espolvoree las semillas de chia.",
        "Sirva inmediatamente."
      ]
    }
  },
  "b4": {
    "ru": {
      "recovery_note": "Полезные жиры в авокадо обеспечивают стабильный приток энергии на несколько часов, уменьшая тягу к сладкому в середине утра, которая часто маскируется под желание употребить алкоголь.",
      "ingredients": [
        "2 ломтика цельнозернового sourdough",
        "1 спелый авокадо",
        "1/2 лимона, выжать сок",
        "Щепотка chilli flakes",
        "Соль, перец",
        "1 tbsp тыквенных семечек"
      ],
      "steps": [
        "Поджарьте хлеб до золотистого цвета.",
        "Разомните авокадо с лимоном, солью и перцем.",
        "Намажьте толстым слоем на тост.",
        "Посыпьте хлопьями чили и тыквенными семечками.",
        "Подавайте немедленно."
      ]
    },
    "uk": {
      "recovery_note": "Корисні жири в авокадо підтримують стабільний рівень енергії протягом декількох годин, зменшуючи тягу до солодкого в першій половині дня, яка часто маскується під бажання вжити алкоголь.",
      "ingredients": [
        "2 скибочки wholemeal sourdough",
        "1 стиглий авокадо",
        "1/2 лимона, вичавити сік",
        "Дрібка пластівців чилі",
        "Сіль, перець",
        "1 tbsp насіння гарбуза"
      ],
      "steps": [
        "Підсмажте хліб до золотистого кольору.",
        "Розімніть авокадо з lemon, сіллю та перцем.",
        "Густо намажте на тост.",
        "Посипте chilli flakes та гарбузовим насінням.",
        "Подавайте негайно."
      ]
    },
    "ko": {
      "recovery_note": "아보카도에 함유된 건강한 지방은 몇 시간 동안 안정적인 에너지를 공급하여, 흔히 술에 대한 갈망으로 오인되곤 하는 오전 시간대의 당분 섭취 욕구를 줄여줍니다.",
      "ingredients": [
        "2 slices wholemeal sourdough",
        "1 ripe avocado",
        "1/2 lemon, juiced",
        "Pinch of chilli flakes",
        "Salt, pepper",
        "1 tbsp pumpkin seeds"
      ],
      "steps": [
        "빵을 황금빛이 돌 때까지 굽습니다.",
        "아보카도를 레몬, 소금, 후추와 함께 으깹니다.",
        "구운 빵 위에 두껍게 펴 바릅니다.",
        "chilli flakes와 호박씨를 뿌립니다.",
        "즉시 제공합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les bonnes graisses de l'avocat favorisent une énergie stable pendant des heures, réduisant ainsi les envies de sucre du milieu de matinée qui se font souvent passer pour des envies d'alcool.",
      "ingredients": [
        "2 tranches de sourdough complet",
        "1 avocat mûr",
        "1/2 citron, pressé",
        "Une pincée de chilli flakes",
        "Sel, poivre",
        "1 tbsp de graines de courge"
      ],
      "steps": [
        "Faire griller le pain jusqu'à ce qu'il soit doré.",
        "Écraser l'avocat avec du lemon, du sel et du poivre.",
        "Étaler en couche épaisse sur le toast.",
        "Saupoudrer de flocons de chilli et de graines de pumpkin.",
        "Servir immédiatement."
      ]
    },
    "it": {
      "recovery_note": "I grassi sani dell'avocado sostengono un'energia costante per ore, riducendo quel desiderio di zuccheri di metà mattina che spesso si maschera da voglia di alcol.",
      "ingredients": [
        "2 fette di pane integrale sourdough",
        "1 avocado maturo",
        "1/2 limone, spremuto",
        "Un pizzico di chilli flakes",
        "Sale, pepe",
        "1 tbsp di semi di zucca"
      ],
      "steps": [
        "Tostare il pane fino a doratura.",
        "Schiacciare l'avocado con limone, sale e pepe.",
        "Spalmare generosamente sul pane tostato.",
        "Cospargere con fiocchi di peperoncino e semi di zucca.",
        "Servire immediatamente."
      ]
    },
    "es": {
      "recovery_note": "Las grasas saludables del aguacate mantienen la energía constante durante horas, reduciendo los antojos de azúcar a media mañana que a menudo se disfrazan de deseos de consumir alcohol.",
      "ingredients": [
        "2 rebanadas de sourdough integral",
        "1 aguacate maduro",
        "1/2 limón, en jugo",
        "Una pizca de chilli flakes",
        "Sal, pimienta",
        "1 tbsp de semillas de calabaza"
      ],
      "steps": [
        "Tostar el pan hasta que esté dorado.",
        "Triturar el aguacate con limón, sal y pimienta.",
        "Untar una capa gruesa sobre la tostada.",
        "Espolvorear copos de chile y semillas de calabaza.",
        "Servir inmediatamente."
      ]
    }
  },
  "b5": {
    "ru": {
      "recovery_note": "Лосось является одним из самых богатых пищевых источников омега-3 ЭПК и ДГК — в ходе клинических испытаний было доказано, что обе эти кислоты уменьшают симптомы депрессии и способствуют когнитивному восстановлению.",
      "ingredients": [
        "1 цельнозерновой bagel, разрезанный пополам",
        "2 tbsp обезжиренного сливочного сыра (light cream cheese)",
        "60g копченого лосося",
        "2 тонких ломтика красного лука",
        "2 tsp каперсов",
        "Свежий укроп, долька лимона"
      ],
      "steps": [
        "Поджарьте половинки bagel до слегка золотистого цвета.",
        "Намажьте каждую половинку cream cheese.",
        "Выложите слоями копченый лосось, лук и каперсы.",
        "Посыпьте укропом и сбрызните лимоном.",
        "Подавайте в открытом виде."
      ]
    },
    "uk": {
      "recovery_note": "Лосось є одним із найбагатших харчових джерел омега-3 ЕПК та ДГК — обох сполук, які у клінічних дослідженнях продемонстрували здатність зменшувати симптоми депресії та підтримувати когнітивне відновлення.",
      "ingredients": [
        "1 цільнозерновий бейгл, розрізаний навпіл",
        "2 tbsp нежирного вершкового сиру",
        "60g копченого лосося",
        "2 тонкі скибочки червоної цибулі",
        "2 tsp каперсів",
        "Свіжий кріп, скибочка лимона"
      ],
      "steps": [
        "Підсмажте половинки бейгла до легкої золотистої скоринки.",
        "Намажте кожну половинку cream cheese.",
        "Викладіть шарами копчений лосось, цибулю та каперси.",
        "Посипте кропом і збризніть лимоном.",
        "Подавайте у відкритому вигляді."
      ]
    },
    "ko": {
      "recovery_note": "연어는 오메가-3 EPA와 DHA가 가장 풍부한 식이 공급원 중 하나로, 임상 시험을 통해 우울 증상을 완화하고 인지 회복을 돕는 것으로 입증되었습니다.",
      "ingredients": [
        "통밀 베이글 1개, 반으로 자른 것",
        "라이트 크림치즈 2 tbsp",
        "훈제 연어 60g",
        "얇게 썬 적양파 2조각",
        "케이퍼 2 tsp",
        "신선한 딜, 레몬 조각"
      ],
      "steps": [
        "베이글 반쪽들을 가볍게 황금색이 돌 때까지 굽습니다.",
        "각 반쪽에 크림치즈를 바릅니다.",
        "훈제 연어, 양파, 케이퍼를 층층이 쌓습니다.",
        "딜을 올리고 레몬즙을 짭니다.",
        "오픈 샌드위치 형태로 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Le saumon est l'une des sources alimentaires les plus riches en oméga-3 EPA et DHA — tous deux reconnus dans des essais cliniques pour réduire les symptômes dépressifs et favoriser la récupération cognitive.",
      "ingredients": [
        "1 bagel complet, coupé en deux",
        "2 tbsp de fromage à la crème léger",
        "60g de saumon fumé",
        "2 fines tranches d'oignon rouge",
        "2 tsp de câpres",
        "Aneth frais, quartier de citron"
      ],
      "steps": [
        "Faire griller les moitiés de bagel jusqu'à ce qu'elles soient légèrement dorées.",
        "Tartiner chaque moitié avec du cream cheese.",
        "Disposer en couches le saumon fumé, l'oignon et les câpres.",
        "Garnir d'aneth et presser un citron par-dessus.",
        "Servir ouvert."
      ]
    },
    "it": {
      "recovery_note": "Il salmone è una delle fonti alimentari più ricche di omega-3 EPA e DHA, entrambi dimostrati in studi clinici per ridurre i sintomi depressivi e supportare il recupero cognitivo.",
      "ingredients": [
        "1 bagel integrale, tagliato a metà",
        "2 tbsp light cream cheese",
        "60g salmone affumicato",
        "2 fette sottili di cipolla rossa",
        "2 tsp capperi",
        "Aneto fresco, uno spicchio di limone"
      ],
      "steps": [
        "Tostare le metà del bagel fino a leggera doratura.",
        "Spalmare ogni metà con cream cheese.",
        "Disporre a strati salmone affumicato, cipolla e capperi.",
        "Guarnire con aneto e spruzzare con succo di limone.",
        "Servire aperto."
      ]
    },
    "es": {
      "recovery_note": "El salmón es una de las fuentes dietéticas más ricas en omega-3 EPA y DHA, ambos demostrados en ensayos clínicos para reducir los síntomas depresivos y favorecer la recuperación cognitiva.",
      "ingredients": [
        "1 bagel integral, por la mitad",
        "2 tbsp de queso crema light",
        "60g de salmón ahumado",
        "2 rodajas finas de cebolla roja",
        "2 tsp de alcaparras",
        "Eneldo fresco, rodaja de limón"
      ],
      "steps": [
        "Tueste las mitades del bagel hasta que estén ligeramente doradas.",
        "Unte cada mitad con cream cheese.",
        "Coloque capas de salmón ahumado, cebolla y alcaparras.",
        "Cubra con eneldo y exprima limón por encima.",
        "Sirva abierto (open-faced)."
      ]
    }
  },
  "b6": {
    "ru": {
      "recovery_note": "Бананы богаты витамином B6, магнием и триптофаном — всеми веществами, необходимыми мозгу для выработки стабилизирующего настроение серотонина.",
      "ingredients": [
        "1 спелый банан",
        "2 яйца",
        "1/2 чашки rolled oats",
        "1/2 ч. л. разрыхлителя",
        "1 ч. л. корицы",
        "Кокосовое масло для жарки"
      ],
      "steps": [
        "Смешайте до однородности банан, яйца, овес, baking powder и корицу.",
        "Разогрейте немного coconut oil в сковороде с антипригарным покрытием на среднем огне.",
        "Наливайте по 1/4 cup теста на каждый блинчик.",
        "Готовьте по 2 минуты с каждой стороны до золотистого цвета.",
        "Подавайте с ягодами и небольшим количеством кленового сиропа."
      ]
    },
    "uk": {
      "recovery_note": "Банани багаті на вітамін B6, магній і триптофан — усе це необхідно мозку для вироблення серотоніну, який стабілізує настрій.",
      "ingredients": [
        "1 стиглий банан",
        "2 яйця",
        "1/2 склянки вівсяних пластівців (rolled oats)",
        "1/2 ч. л. розпушувача (baking powder)",
        "1 ч. л. кориці",
        "Кокосова олія (Coconut oil) для смаження"
      ],
      "steps": [
        "Збийте в блендері банани, яйця, овес, розпушувач та корицю до однорідності.",
        "Розігрійте трохи coconut oil на сковорідці з антипригарним покриттям на середньому вогні.",
        "Наливайте по 1/4 cup тіста для кожного млинця.",
        "Готуйте по 2 хвилини з кожного боку до золотистого кольору.",
        "Подавайте з ягодами та полийте кленовим сиропом."
      ]
    },
    "ko": {
      "recovery_note": "바나나에는 비타민 B6, 마그네슘, 트립토판이 풍부하게 들어있으며, 이 성분들은 모두 뇌에서 기분을 안정시키는 세로토닌을 생성하는 데 꼭 필요합니다.",
      "ingredients": [
        "잘 익은 바나나 1개",
        "달걀 2개",
        "압착 귀리(rolled oats) 1/2컵",
        "베이킹파우더 1/2 tsp",
        "시나몬 1 tsp",
        "튀김용 코코넛 오일"
      ],
      "steps": [
        "바나나, 달걀, oats, baking powder, cinnamon을 부드러워질 때까지 블렌더로 섞습니다.",
        "넌스틱 팬에 coconut oil을 약간 두르고 중간 불에서 가열합니다.",
        "팬케이크 하나당 1/4 cup의 반죽을 붓습니다.",
        "양면을 각각 2분씩 황금빛이 돌 때까지 굽습니다.",
        "베리류와 maple syrup을 뿌려 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Les bananes sont riches en B6, en magnésium et en tryptophane — tous nécessaires au cerveau pour fabriquer la sérotonine, qui stabilise l'humeur.",
      "ingredients": [
        "1 banane mûre",
        "2 œufs",
        "1/2 cup de rolled oats",
        "1/2 tsp de baking powder",
        "1 tsp de cannelle",
        "Coconut oil pour la cuisson"
      ],
      "steps": [
        "Mélangez la banane, les œufs, les oats, le baking powder et la cannelle jusqu'à l'obtention d'une consistance lisse.",
        "Faites chauffer un peu de coconut oil dans une poêle antiadhésive à feu moyen.",
        "Versez 1/4 cup de pâte par pancake.",
        "Faites cuire 2 minutes par face jusqu'à ce qu'ils soient dorés.",
        "Servez avec des baies et un filet de sirop d'érable."
      ]
    },
    "it": {
      "recovery_note": "Le banane sono ricche di vitamina B6, magnesio e triptofano, tutti elementi necessari al cervello per produrre la serotonina, che stabilizza l'umore.",
      "ingredients": [
        "1 banana matura",
        "2 uova",
        "1/2 cup di fiocchi d'avena",
        "1/2 tsp di lievito in polvere",
        "1 tsp di cannella",
        "Olio di cocco per friggere"
      ],
      "steps": [
        "Frullare banana, uova, avena, baking powder e cannella fino a ottenere un composto omogeneo.",
        "Scaldare un po' di coconut oil in una padella antiaderente a fuoco medio.",
        "Versare 1/4 cup di pastella per ogni pancake.",
        "Cuocere 2 minuti per lato fino a doratura.",
        "Servire con frutti di bosco e un filo di maple syrup."
      ]
    },
    "es": {
      "recovery_note": "Los plátanos están cargados de B6, magnesio y triptófano, todos ellos necesarios para que el cerebro fabrique serotonina, que estabiliza el estado de ánimo.",
      "ingredients": [
        "1 banana madura",
        "2 huevos",
        "1/2 cup de copos de avena",
        "1/2 tsp de polvo de hornear",
        "1 tsp de canela",
        "Aceite de coco para freír"
      ],
      "steps": [
        "Licue el plátano, los huevos, la avena, el baking powder y la canela hasta obtener una mezcla suave.",
        "Caliente un poco de coconut oil en una sartén antiadherente a fuego medio.",
        "Vierta 1/4 cup de masa por cada pancake.",
        "Cocine 2 minutos por lado hasta que estén dorados.",
        "Sirva con bayas y un chorrito de maple syrup."
      ]
    }
  },
  "b7": {
    "ru": {
      "recovery_note": "Завтрак, приготовленный заранее, избавляет от необходимости принимать решения по утрам. Чиа содержит омега-3 и клетчатку, которые обеспечивают чувство сытости и стабильную энергию до самого обеда.",
      "ingredients": [
        "3 tbsp семян чиа",
        "1 cup несладкого миндального или овсяного молока",
        "1 tsp кленового сиропа",
        "1/2 tsp ванильного экстракта",
        "1/2 cup смеси ягод",
        "1 tbsp миндальных лепестков"
      ],
      "steps": [
        "Венчиком смешайте семена чиа, молоко, кленовый сироп и ваниль в банке.",
        "Снова перемешайте через 5 минут, чтобы разбить комочки.",
        "Поставьте в холодильник на ночь (или минимум на 4 часа).",
        "Сверху выложите ягоды и миндаль.",
        "Ешьте прямо из банки."
      ]
    },
    "uk": {
      "recovery_note": "Приготування сніданку заздалегідь позбавляє від необхідності приймати рішення зранку. Чиа містить омега-3 та клітковину, які забезпечують відчуття ситості та стабільності до самого обіду.",
      "ingredients": [
        "3 tbsp насіння чиа",
        "1 cup несолоного мигдального або вівсяного молока",
        "1 tsp кленового сиропу",
        "1/2 tsp екстракту ванілі",
        "1/2 cup суміші ягід",
        "1 tbsp мигдальних пластівців"
      ],
      "steps": [
        "Збийте чиа, молоко, кленовий сироп та ваніль у банці.",
        "Перемішайте ще раз через 5 min, щоб розбити грудочки.",
        "Поставте в холодильник на ніч (або принаймні на 4 hours).",
        "Зверху викладіть ягоди та мигдаль.",
        "Їжте прямо з банки."
      ]
    },
    "ko": {
      "recovery_note": "미리 준비해 두는 아침 식사는 아침 시간의 결정 피로를 없애줍니다. 치아씨드는 오메가-3와 섬유질을 제공하여 점심시간까지 포만감과 안정감을 유지해 줍니다.",
      "ingredients": [
        "3 tbsp chia seeds",
        "1 cup unsweetened almond or oat milk",
        "1 tsp maple syrup",
        "1/2 tsp vanilla extract",
        "1/2 cup mixed berries",
        "1 tbsp flaked almonds"
      ],
      "steps": [
        "병에 치아씨드, 우유, maple syrup, 바닐라를 넣고 휘저어 섞습니다.",
        "5분 후 덩어리를 풀기 위해 다시 한 번 젓습니다.",
        "밤새(또는 최소 4시간 동안) 냉장 보관합니다.",
        "위에 베리와 아몬드를 올립니다.",
        "병째로 바로 드세요."
      ]
    },
    "fr": {
      "recovery_note": "Un petit-déjeuner préparé à l'avance élimine la fatigue décisionnelle du matin. Le chia apporte des oméga-3 et des fibres qui vous rassasient et vous stabilisent jusqu'au déjeuner.",
      "ingredients": [
        "3 tbsp graines de chia",
        "1 cup lait d'amande ou d'avoine non sucré",
        "1 tsp sirop d'érable",
        "1/2 tsp extrait de vanille",
        "1/2 cup mélange de baies",
        "1 tbsp amandes effilées"
      ],
      "steps": [
        "Fouetter le chia, le lait, le sirop d'érable et la vanille dans un bocal.",
        "Remuer à nouveau après 5 min pour briser les grumeaux.",
        "Réfrigérer toute la nuit (ou au moins 4 heures).",
        "Garnir de baies et d'amandes.",
        "Manger directement dans le bocal."
      ]
    },
    "it": {
      "recovery_note": "La colazione preparata in anticipo elimina la fatica di dover prendere decisioni al mattino. I semi di chia apportano omega-3 e fibre che mantengono il senso di sazietà e i livelli di energia stabili fino a pranzo.",
      "ingredients": [
        "3 tbsp di semi di chia",
        "1 cup di latte di mandorla o avena senza zucchero",
        "1 tsp di sciroppo d'acero",
        "1/2 tsp di estratto di vaniglia",
        "1/2 cup di frutti di bosco misti",
        "1 tbsp di mandorle a scaglie"
      ],
      "steps": [
        "Sbattere i semi di chia, il latte, lo sciroppo d'acero e la vaniglia in un barattolo.",
        "Mescolare di nuovo dopo 5 min per rompere eventuali grumi.",
        "Conservare in frigorifero per tutta la notte (o almeno per 4 ore).",
        "Guarnire con frutti di bosco e mandorle.",
        "Mangiare direttamente dal barattolo."
      ]
    },
    "es": {
      "recovery_note": "El desayuno preparado con antelación elimina la fatiga por toma de decisiones matutina. La chía aporta omega-3 y fibra que te mantienen saciado y estable hasta el almuerzo.",
      "ingredients": [
        "3 tbsp semillas de chía",
        "1 cup leche de almendras o avena sin azúcar",
        "1 tsp jarabe de arce",
        "1/2 tsp extracto de vainilla",
        "1/2 cup bayas mixtas",
        "1 tbsp almendras laminadas"
      ],
      "steps": [
        "Bata la chía, la leche, el maple syrup y la vainilla en un frasco.",
        "Revuelva de nuevo después de 5 min para deshacer los grumos.",
        "Refrigere durante la noche (o al menos 4 horas).",
        "Cubra con bayas y almendras.",
        "Coma directamente del frasco."
      ]
    }
  },
  "d1": {
    "ru": {
      "recovery_note": "Еженедельное употребление жирной рыбы является одной из диетологических мер с наиболее высокой доказательной базой при расстройствах настроения — настоятельно рекомендуется в программе Recovery.",
      "ingredients": [
        "150g филе лосося",
        "1 чашка соцветий брокколи",
        "1 батат, нарезанный кубиками",
        "1 лимон, нарезанный ломтиками",
        "2 tbsp оливкового масла, травы",
        "Соль, перец"
      ],
      "steps": [
        "Разогрейте духовку до 200°C.",
        "Перемешайте овощи с оливковым маслом, солью и перцем; распределите по противню.",
        "Запекайте 10 минут.",
        "Добавьте лосось, сверху выложите лимон и травы.",
        "Запекайте еще 12–15 минут до готовности лосося. Подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Щотижнева порція жирної риби є одним із найбільш науково обґрунтованих дієтологічних методів лікування розладів настрою — настійно рекомендується в період відновлення.",
      "ingredients": [
        "150g salmon fillet",
        "1 склянка суцвіть broccoli",
        "1 солодка картопля (sweet potato), нарізана кубиками",
        "1 лимон, нарізаний скибочками",
        "2 tbsp оливкової олії, трави",
        "Сіль, перець"
      ],
      "steps": [
        "Розігрійте духовку до 200°C.",
        "Перемішайте овочі з оливковою олією, сіллю та перцем; розподіліть по деку.",
        "Запікайте 10 хвилин.",
        "Додайте лосось, зверху викладіть лимон і трави.",
        "Випікайте ще 12–15 хвилин, поки лосось не буде готовий. Подавайте до столу."
      ]
    },
    "ko": {
      "recovery_note": "일주일에 한 번 지방이 풍부한 생선을 섭취하는 것은 기분 장애에 대한 가장 확실한 증거가 있는 식단 중재법 중 하나로, 리커버리(Recovery)에서 강력히 권장됩니다.",
      "ingredients": [
        "150g salmon fillet",
        "1 cup broccoli florets",
        "고구마 1개, 깍둑썰기",
        "레몬 1개, 슬라이스",
        "2 tbsp olive oil, 허브",
        "소금, 후추"
      ],
      "steps": [
        "오븐을 200°C로 예열하세요.",
        "채소를 올리브 오일, 소금, 후추와 함께 버무린 후 트레이에 펼쳐 놓으세요.",
        "10분 동안 굽습니다.",
        "연어를 올리고 그 위에 레몬과 허브를 얹으세요.",
        "연어가 알맞게 익을 때까지 12–15분 더 굽습니다. 완성된 요리를 내놓으세요."
      ]
    },
    "fr": {
      "recovery_note": "Une portion hebdomadaire de poisson gras est l'une des interventions diététiques les plus probantes pour les troubles de l'humeur — fortement recommandée dans le cadre de la récupération.",
      "ingredients": [
        "150g salmon fillet",
        "1 cup de bouquets de brocoli",
        "1 patate douce, coupée en dés",
        "1 citron, tranché",
        "2 tbsp d'huile d'olive, herbes",
        "Sel, poivre"
      ],
      "steps": [
        "Préchauffer le four à 200°C.",
        "Mélanger les légumes avec de l'huile d'olive, du sel et du poivre ; les étaler sur une plaque.",
        "Rôtir pendant 10 minutes.",
        "Ajouter le saumon, garnir de citron et d'herbes.",
        "Cuire encore 12–15 min jusqu'à ce que le saumon soit juste cuit. Servir."
      ]
    },
    "it": {
      "recovery_note": "Una porzione settimanale di pesce azzurro è uno degli interventi dietetici con le maggiori evidenze per i disturbi dell'umore — caldamente raccomandato in Recovery.",
      "ingredients": [
        "150g salmon fillet",
        "1 cup cime di broccoli",
        "1 patata dolce, a cubetti",
        "1 limone, a fette",
        "2 tbsp olive oil, erbe aromatiche",
        "Sale, pepe"
      ],
      "steps": [
        "Preriscaldare il forno a 200°C.",
        "Condire le verdure con olio d'oliva, sale e pepe; distribuirle su una teglia.",
        "Arrostire per 10 minuti.",
        "Aggiungere il salmone, completando con limone ed erbe aromatiche.",
        "Cuocere in forno per altri 12–15 minuti finché il salmone non è appena cotto. Servire."
      ]
    },
    "es": {
      "recovery_note": "Una porción semanal de pescado azul es una de las intervenciones dietéticas con mayor evidencia para los trastornos del estado de ánimo, recomendada encarecidamente en Recovery.",
      "ingredients": [
        "150g salmon fillet",
        "1 cup floretes de brócoli",
        "1 sweet potato, en cubos",
        "1 limón, en rodajas",
        "2 tbsp aceite de oliva, hierbas",
        "Sal, pimienta"
      ],
      "steps": [
        "Precaliente el horno a 200°C.",
        "Mezcle las verduras con aceite de oliva, sal y pimienta; extiéndalas en la bandeja.",
        "Rostice durante 10 minutos.",
        "Añada el salmón, cubra con limón y hierbas.",
        "Hornee otros 12–15 min hasta que el salmón esté justo en su punto. Sirva."
      ]
    }
  },
  "d2": {
    "ru": {
      "recovery_note": "Растительные блюда, естественным образом богатые витаминами группы B и антиоксидантами, — они защищают от окислительного стресса, связанного с хроническим употреблением психоактивных веществ.",
      "ingredients": [
        "200g firm tofu, нарезанного кубиками",
        "2 чашки овощной смеси для стир-фрай (брокколи, capsicum, морковь)",
        "2 зубчика garlic, измельченных",
        "1 tbsp ginger, тертого",
        "2 tbsp soy sauce, 1 tsp sesame oil",
        "Приготовленный brown rice для подачи"
      ],
      "steps": [
        "Прижмите тофу, чтобы удалить воду; нарежьте кубиками.",
        "Обжарьте тофу на сковороде в масле до золотистого цвета со всех сторон; отложите в сторону.",
        "Обжаривайте чеснок и имбирь в течение 30 секунд.",
        "Добавьте овощи, обжаривайте 4–5 минут до состояния tender-crisp.",
        "Верните тофу, добавьте соевый соус и sesame oil. Подавайте поверх риса."
      ]
    },
    "uk": {
      "recovery_note": "Рослинні страви, природно багаті на вітаміни групи В та антиоксиданти, які захищають від окислювального стресу, пов’язаного з хронічним вживанням психоактивних речовин.",
      "ingredients": [
        "200g firm tofu, нарізаного кубиками",
        "2 чашки овочевої суміші stir-fry (броколі, capsicum, морква)",
        "2 зубчики garlic, подрібнених",
        "1 tbsp ginger, натертого",
        "2 tbsp soy sauce, 1 tsp sesame oil",
        "Приготований brown rice для подачі"
      ],
      "steps": [
        "Відіжміть тофу, щоб видалити воду; наріжте кубиками.",
        "Обсмажте тофу на олії до золотистої скоринки з усіх боків; відкладіть.",
        "Обсмажуйте часник і імбир протягом 30 секунд.",
        "Додайте овочі, обсмажуйте 4–5 хвилин до стану tender-crisp.",
        "Поверніть тофу на сковорідку, додайте соєвий соус і sesame oil. Подавайте з рисом."
      ]
    },
    "ko": {
      "recovery_note": "식물성 식단은 비타민 B군과 항산화 성분이 자연적으로 풍부하여, 만성적인 약물 사용과 관련된 산화 스트레스로부터 몸을 보호해 줍니다.",
      "ingredients": [
        "200g firm tofu, 깍둑썰기한 것",
        "2 cups 혼합 볶음용 채소 (broccoli, capsicum, carrot)",
        "2 cloves garlic, 다진 것",
        "1 tbsp ginger, 갈아낸 것",
        "2 tbsp soy sauce, 1 tsp sesame oil",
        "함께 곁들일 조리된 brown rice"
      ],
      "steps": [
        "tofu를 눌러 물기를 제거한 후 깍둑썰기합니다.",
        "팬에 기름을 두르고 tofu의 모든 면이 노릇해질 때까지 구운 뒤 따로 둡니다.",
        "garlic과 ginger를 30초간 볶습니다.",
        "채소를 넣고 아삭함이 살아있을 때까지 4–5분간 볶습니다.",
        "tofu를 다시 넣고 soy와 sesame oil을 더합니다. 밥 위에 얹어 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Des repas à base de plantes naturellement riches en vitamines B et en antioxydants — protecteurs contre le stress oxydatif associé à l'usage chronique de substances.",
      "ingredients": [
        "200g firm tofu, cubed",
        "2 cups mixed stir-fry veg (broccoli, capsicum, carrot)",
        "2 cloves garlic, minced",
        "1 tbsp ginger, grated",
        "2 tbsp soy sauce, 1 tsp sesame oil",
        "Cooked brown rice to serve"
      ],
      "steps": [
        "Presser le tofu pour extraire l'eau ; couper en dés.",
        "Faire revenir le tofu à la poêle dans l'huile jusqu'à ce qu'il soit doré de tous les côtés ; réserver.",
        "Faire sauter l'ail et le gingembre pendant 30 secondes.",
        "Ajouter les légumes, faire sauter 4–5 minutes jusqu'à ce qu'ils soient tendres mais croquants.",
        "Remettre le tofu, ajouter le soja et le sesame oil. Servir sur du riz."
      ]
    },
    "it": {
      "recovery_note": "Pasti a base vegetale naturalmente ricchi di vitamine del gruppo B e antiossidanti — protettivi contro lo stress ossidativo associato all'uso cronico di sostanze.",
      "ingredients": [
        "200g tofu sodo, a cubetti",
        "2 tazze di verdure miste per stir-fry (broccoli, capsicum, carota)",
        "2 spicchi d'aglio, tritati",
        "1 tbsp di zenzero, grattugiato",
        "2 tbsp di salsa di soia, 1 tsp di olio di sesamo",
        "Riso integrale cotto per servire"
      ],
      "steps": [
        "Pressare il tofu per rimuovere l'acqua; tagliarlo a cubetti.",
        "Friggere il tofu in padella con olio fino a quando sarà dorato su tutti i lati; mettere da parte.",
        "Soffriggere aglio e ginger per 30 secondi.",
        "Aggiungere le verdure e saltare in padella per 4–5 minutes fino a quando saranno tenere ma croccanti.",
        "Unire nuovamente il tofu, aggiungere la soia e il sesame oil. Servire sopra il riso."
      ]
    },
    "es": {
      "recovery_note": "Comidas a base de plantas naturalmente ricas en vitaminas del grupo B y antioxidantes — protectoras contra el estrés oxidativo asociado con el consumo crónico de sustancias.",
      "ingredients": [
        "200g firm tofu, en cubos",
        "2 tazas de vegetales mixtos para saltear (brócoli, pimiento, zanahoria)",
        "2 dientes de ajo, picados",
        "1 tbsp de jengibre, rallado",
        "2 tbsp de salsa de soja, 1 tsp de aceite de sésamo",
        "Arroz integral cocido para servir"
      ],
      "steps": [
        "Presione el tofu para eliminar el agua; córtelo en cubos.",
        "Fría el tofu en aceite en la sartén hasta que esté dorado por todos lados; reserve.",
        "Saltee el ajo y el jengibre durante 30 segundos.",
        "Añada los vegetales y saltee por 4–5 minutos hasta que estén tiernos pero crujientes.",
        "Incorpore el tofu nuevamente, añada la soya y el aceite de sésamo. Sirva sobre arroz."
      ]
    }
  },
  "d3": {
    "ru": {
      "recovery_note": "Бульоны длительного томления способствуют восстановлению слизистой оболочки кишечника — это важно, так как длительное употребление алкоголя нарушает целостность кишечника, что приводит к воспалениям и проблемам с настроением.",
      "ingredients": [
        "2 куриных бедра, нарезанных кубиками",
        "1 onion, 2 carrots, 2 celery, нарезанных кубиками",
        "2 картофелины, нарезанные кубиками",
        "4 cups куриного бульона",
        "Лавровый лист, тимьян, соль, перец",
        "1 tbsp оливкового масла"
      ],
      "steps": [
        "Обжарьте курицу в масле на среднем огне до золотистого цвета; выньте из сковороды.",
        "Обжаривайте лук, морковь и сельдерей в течение 5 минут.",
        "Верните курицу; добавьте картофель, бульон и травы.",
        "Тушите под крышкой 30 минут, пока курица и картофель не станут мягкими.",
        "Приправьте по вкусу и подавайте горячим."
      ]
    },
    "uk": {
      "recovery_note": "Бульйони тривалого приготування сприяють відновленню слизової оболонки кишечника — це важливо, оскільки тривале вживання алкоголю пошкоджує цілісність кишечника, що призводить до запалень і проблем із настроєм.",
      "ingredients": [
        "2 chicken thighs, нарізані кубиками",
        "1 onion, 2 carrots, 2 celery, нарізані кубиками",
        "2 potatoes, нарізані кубиками",
        "4 cups chicken stock",
        "Bay leaf, thyme, salt, pepper",
        "1 tbsp olive oil"
      ],
      "steps": [
        "Підрум'яньте курку в олії на середньо-сильному вогні; вийміть.",
        "Пасеруйте цибулю, моркву та селеру 5 хвилин.",
        "Поверніть курку; додайте картоплю, бульйон та трави.",
        "Тушкуйте під кришкою 30 хвилин, доки курка та картопля не стануть м'якими.",
        "Приправте та подавайте гарячим."
      ]
    },
    "ko": {
      "recovery_note": "천천히 끓여낸 육수는 장 벽의 회복을 돕습니다. 이는 장기적인 음주가 장 건강을 해치고 염증 및 기분 변화의 원인이 된다는 점에서 매우 중요합니다.",
      "ingredients": [
        "닭다리살 2개, 깍둑썰기",
        "양파 1개, 당근 2개, 셀러리 2개, 잘게 썰기",
        "감자 2개, 깍둑썰기",
        "닭 육수 4 cups",
        "Bay leaf, thyme, salt, pepper",
        "1 tbsp 올리브 오일"
      ],
      "steps": [
        "중상불에서 식용유를 두르고 닭고기를 갈색이 나도록 구운 뒤 꺼냅니다.",
        "양파, 당근, 셀러리를 5분간 볶습니다.",
        "닭고기를 다시 넣고 감자, stock, 허브를 넣습니다.",
        "뚜껑을 덮고 닭고기와 감자가 부드러워질 때까지 30분간 뭉근하게 끓입니다.",
        "간을 맞춘 뒤 뜨거울 때 배식합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les bouillons mijotés favorisent la réparation de la paroi intestinale — un point important car la consommation d'alcool à long terme altère l'intégrité de l'intestin, contribuant ainsi à l'inflammation et aux troubles de l'humeur.",
      "ingredients": [
        "2 haut de cuisses de poulet, coupés en dés",
        "1 oignon, 2 carottes, 2 branches de céleri, coupés en dés",
        "2 pommes de terre, coupées en dés",
        "4 cups de bouillon de poulet",
        "Feuille de laurier, thym, sel, poivre",
        "1 tbsp d'huile d'olive"
      ],
      "steps": [
        "Faire dorer le poulet dans l'huile à feu moyen-vif ; retirer du feu.",
        "Faire sauter l'oignon, la carotte et le céleri pendant 5 minutes.",
        "Remettre le poulet ; ajouter les pommes de terre, le bouillon et les herbes.",
        "Laisser mijoter à couvert pendant 30 minutes jusqu'à ce que le poulet et les pommes de terre soient tendres.",
        "Assaisonner et servir chaud."
      ]
    },
    "it": {
      "recovery_note": "I brodi a cottura lenta favoriscono la riparazione della mucosa intestinale — un aspetto importante dato che l'uso prolungato di alcol danneggia l'integrità dell'intestino, contribuendo a infiammazioni e problemi dell'umore.",
      "ingredients": [
        "2 cosce di pollo, a cubetti",
        "1 cipolla, 2 carote, 2 coste di sedano, a dadini",
        "2 patate, a cubetti",
        "4 cups chicken stock",
        "Alloro, timo, sale, pepe",
        "1 tbsp olive oil"
      ],
      "steps": [
        "Rosolare il pollo nell'olio a fuoco medio-alto; rimuovere.",
        "Soffriggere cipolla, carota e sedano per 5 minuti.",
        "Riaggiungere il pollo; unire patate, brodo ed erbe aromatiche.",
        "Sobbollire con il coperchio per 30 minuti finché il pollo e le patate non saranno teneri.",
        "Condire e servire caldo."
      ]
    },
    "es": {
      "recovery_note": "Los caldos de cocción lenta favorecen la reparación del revestimiento intestinal, algo fundamental ya que el consumo de alcohol a largo plazo daña la integridad del intestino, contribuyendo a la inflamación y a problemas del estado de ánimo.",
      "ingredients": [
        "2 chicken thighs, en cubos",
        "1 onion, 2 carrots, 2 celery, en dados",
        "2 potatoes, en cubos",
        "4 cups chicken stock",
        "Bay leaf, thyme, salt, pepper",
        "1 tbsp olive oil"
      ],
      "steps": [
        "Dore el pollo en aceite a fuego medio-alto; retire.",
        "Saltee la cebolla, la zanahoria y el apio durante 5 minutos.",
        "Regrese el pollo; añada las papas, el caldo y las hierbas.",
        "Cocine a fuego lento y tapado durante 30 minutos hasta que el pollo y las papas estén tiernos.",
        "Sazone y sirva caliente."
      ]
    }
  },
  "d4": {
    "ru": {
      "recovery_note": "Фасоль — это самая доступная здоровая еда на планете; она богата клетчаткой, белком, магнием и витаминами группы B для стабильного настроения и заряда энергии.",
      "ingredients": [
        "1 tin black beans",
        "1 tin kidney beans",
        "1 tin chopped tomatoes",
        "1 onion, 2 cloves garlic",
        "1 capsicum, diced",
        "Chilli powder, cumin, paprika, oregano"
      ],
      "steps": [
        "Обжаривайте onion, garlic и capsicum в течение 5 minutes.",
        "Добавьте специи; прогрейте 30 seconds.",
        "Добавьте tomatoes и beans (вместе с жидкостью).",
        "Варите на медленном огне без крышки 25 minutes.",
        "Подавайте с рисом или wholegrain tortillas, украсив сверху avocado."
      ]
    },
    "uk": {
      "recovery_note": "Квасоля — це найдешевший корисний продукт на планеті, багатий на клітковину, білок, магній та вітаміни групи В для стабільного настрою та енергії.",
      "ingredients": [
        "1 бляшанка чорної квасолі",
        "1 бляшанка червоної квасолі",
        "1 бляшанка подрібнених томатів",
        "1 цибуля, 2 зубчики часнику",
        "1 capsicum, нарізаний кубиками",
        "Chilli powder, cumin, paprika, oregano"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник та capsicum протягом 5 хвилин.",
        "Додайте спеції; прогрійте 30 секунд.",
        "Додайте томати та квасолю (разом із рідиною).",
        "Тушкуйте без кришки 25 хвилин.",
        "Подавайте з рисом або цільнозерновими тортильями, зверху викладіть авокадо."
      ]
    },
    "ko": {
      "recovery_note": "콩은 지구상에서 가장 저렴한 건강식품으로, 섬유질, 단백질, 마그네슘, 비타민 B가 풍부하여 안정적인 기분과 에너지를 유지해 줍니다.",
      "ingredients": [
        "1 tin 블랙빈",
        "1 tin 강낭콩 (kidney beans)",
        "1 tin 찹 토마토 (chopped tomatoes)",
        "양파 1개, 마늘 2쪽",
        "파프리카 (capsicum) 1개, 깍둑썰기",
        "칠리 파우더, 큐민, 파프리카 가루, 오레가노"
      ],
      "steps": [
        "양파, 마늘, capsicum을 5분 동안 볶습니다.",
        "향신료를 넣고 30초 동안 굽듯이 볶습니다.",
        "토마토와 콩(액체 포함)을 넣습니다.",
        "뚜껑을 열고 25분 동안 뭉근하게 끓입니다.",
        "밥 또는 통곡물 tortilla와 함께 내고, 위에 아보카도를 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les haricots sont l'aliment santé le moins cher de la planète — riches en fibres, en protéines, en magnésium et en vitamines B pour une humeur et une énergie stables.",
      "ingredients": [
        "1 boîte de black beans",
        "1 boîte de kidney beans",
        "1 boîte de chopped tomatoes",
        "1 oignon, 2 gousses d'ail",
        "1 capsicum, coupé en dés",
        "Chilli powder, cumin, paprika, origan"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail et le capsicum pendant 5 minutes.",
        "Ajouter les épices ; faire griller pendant 30 secondes.",
        "Ajouter les tomates et les beans (avec leur liquide).",
        "Laisser mijoter sans couvercle pendant 25 minutes.",
        "Servir avec du riz ou des tortillas wholegrain, garnir avec de l'avocado."
      ]
    },
    "it": {
      "recovery_note": "I fagioli sono l'alimento salutare più economico del pianeta — ricchi di fibre, proteine, magnesio e vitamine del gruppo B per un umore e un'energia costanti.",
      "ingredients": [
        "1 lattina di fagioli neri",
        "1 lattina di fagioli kidney",
        "1 lattina di pomodori a pezzi",
        "1 cipolla, 2 spicchi d'aglio",
        "1 peperone, a dadini",
        "Chilli powder, cumino, paprika, origano"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e peperone per 5 minuti.",
        "Aggiungere le spezie; tostarle per 30 secondi.",
        "Aggiungere i pomodori e i fagioli (con il loro liquido).",
        "Sobbollire senza coperchio per 25 minuti.",
        "Servire con riso o tortillas integrali, guarnendo con avocado."
      ]
    },
    "es": {
      "recovery_note": "Las legumbres son el alimento saludable más económico del planeta: están repletas de fibra, proteínas, magnesio y vitaminas del grupo B para mantener un estado de ánimo y una energía estables.",
      "ingredients": [
        "1 lata de black beans",
        "1 lata de kidney beans",
        "1 lata de chopped tomatoes",
        "1 cebolla, 2 dientes de ajo",
        "1 capsicum, picado en cubos",
        "Chilli powder, cumin, paprika, oregano"
      ],
      "steps": [
        "Saltee la cebolla, el ajo y el capsicum durante 5 minutos.",
        "Agregue las especias; tueste por 30 segundos.",
        "Agregue los tomates y los beans (con su líquido).",
        "Cocine a fuego lento sin tapar durante 25 minutos.",
        "Sirva con rice o tortillas de wholegrain, decore con avocado por encima."
      ]
    }
  },
  "d5": {
    "ru": {
      "recovery_note": "Железо и цинк в говядине жизненно важны для энергии, иммунитета и синтеза дофамина — элементов, которые часто истощаются после многих лет активного употребления алкоголя или наркотиков.",
      "ingredients": [
        "300g lean beef mince",
        "1 onion, 2 cloves garlic, 1 carrot, finely diced",
        "1 tin chopped tomatoes",
        "2 tbsp tomato paste",
        "Italian herbs, salt, pepper",
        "300g wholemeal spaghetti"
      ],
      "steps": [
        "Обжаривайте onion, garlic и carrot в течение 5 minutes.",
        "Добавьте mince; хорошо подрумяньте, разбивая комочки.",
        "Вмешайте tomato paste; готовьте 1 minute.",
        "Добавьте tomatoes и herbs. Тушите на медленном огне 20 minutes.",
        "Сварите spaghetti согласно инструкции на упаковке; слейте воду. Подавайте соус поверх пасты."
      ]
    },
    "uk": {
      "recovery_note": "Залізо та цинк у яловичині життєво необхідні для енергії, імунітету та синтезу дофаміну — вони часто виснажені після років надмірного вживання алкоголю або наркотиків.",
      "ingredients": [
        "300g нежирного яловичого фаршу",
        "1 цибулина, 2 зубчики часнику, 1 морква, дрібно нарізані",
        "1 банка подрібнених томатів",
        "2 tbsp томатної пасти",
        "Italian herbs, сіль, перець",
        "300g цільнозернових спагеті"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник та моркву протягом 5 хвилин.",
        "Додайте фарш; добре підрум’яньте, подрібнюючи його.",
        "Додайте томатну пасту; готуйте 1 хвилину.",
        "Додайте томати та трави. Тушкуйте 20 хвилин.",
        "Відваріть spaghetti згідно з інструкцією на упаковці; злийте воду. Подавайте пасту з соусом."
      ]
    },
    "ko": {
      "recovery_note": "소고기에 함유된 철분과 아연은 에너지, 면역력, 그리고 도파민 합성에 필수적이며, 이는 수년간의 과도한 음주나 약물 사용 후에 결핍되기 쉬운 영양소입니다.",
      "ingredients": [
        "300g 소고기 다짐육 (살코기)",
        "양파 1개, 마늘 2쪽, 당근 1개, 잘게 다진 것",
        "chopped tomatoes 1캔",
        "2 tbsp 토마토 페이스트",
        "Italian herbs, 소금, 후추",
        "300g 통밀 스파게티 면"
      ],
      "steps": [
        "양파, 마늘, 당근을 5분간 볶습니다.",
        "다진 고기를 넣고 덩어리를 풀어가며 갈색이 되도록 잘 익힙니다.",
        "Tomato paste를 넣고 저으며 1분간 익힙니다.",
        "토마토와 허브를 넣습니다. 20분간 뭉근하게 끓입니다.",
        "스파게티를 포장지 안내에 따라 삶은 뒤 물기를 뺍니다. 파스타 위에 소스를 얹어 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Le fer et le zinc contenus dans le bœuf sont essentiels pour l'énergie, l'immunité et la synthèse de la dopamine — souvent épuisés après des années de consommation excessive d'alcool ou de drogues.",
      "ingredients": [
        "300g lean beef mince",
        "1 oignon, 2 gousses d'ail, 1 carotte, finement désés",
        "1 boîte de tomates concassées",
        "2 tbsp de concentré de tomate",
        "Herbes Italian herbs, sel, poivre",
        "300g de spaghetti complets (wholemeal)"
      ],
      "steps": [
        "Faire revenir l'oignon, l'ail et la carotte pendant 5 minutes.",
        "Ajouter la viande hachée ; bien faire dorer en l'émiettant.",
        "Incorporer le concentré de tomate ; cuire 1 minute.",
        "Ajouter les tomates et les herbes. Laisser mijoter 20 minutes.",
        "Cuire les spaghettis selon les instructions du paquet ; égoutter. Servir la sauce sur les pâtes."
      ]
    },
    "it": {
      "recovery_note": "Il ferro e lo zinco contenuti nel manzo sono fondamentali per l'energia, le difese immunitarie e la sintesi della dopamina — spesso carenti dopo anni di abuso di alcol o droghe.",
      "ingredients": [
        "300g lean beef mince",
        "1 cipolla, 2 spicchi d'aglio, 1 carota, tagliati finemente a cubetti",
        "1 lattina di chopped tomatoes",
        "2 tbsp di concentrato di pomodoro",
        "Italian herbs, sale, pepe",
        "300g di spaghetti integrali"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e carota per 5 minuti.",
        "Aggiungere la carne macinata; rosolare bene, sgranandola.",
        "Incorporare il concentrato di pomodoro; cuocere per 1 minuto.",
        "Aggiungere i pomodori e le erbe aromatiche. Sobbollire per 20 minuti.",
        "Cuocere gli spaghetti come indicato sulla confezione; scolare. Servire il sugo sulla pasta."
      ]
    },
    "es": {
      "recovery_note": "El hierro y el zinc de la carne de res son vitales para la energía, la inmunidad y la síntesis de dopamina, que a menudo se ven mermados tras años de consumo excesivo de alcohol o drogas.",
      "ingredients": [
        "300g lean beef mince",
        "1 onion, 2 cloves garlic, 1 carrot, finamente picados",
        "1 tin chopped tomatoes",
        "2 tbsp tomato paste",
        "Italian herbs, sal, pimienta",
        "300g wholemeal spaghetti"
      ],
      "steps": [
        "Saltee la cebolla, el ajo y la zanahoria durante 5 minutos.",
        "Añada la carne picada; dore bien, deshaciendo los trozos.",
        "Incorpore la pasta de tomate; cocine por 1 minuto.",
        "Añada los tomates y las hierbas. Cocine a fuego lento durante 20 minutos.",
        "Cocine el spaghetti según el paquete; escurra. Sirva la salsa sobre la pasta."
      ]
    }
  },
  "d6": {
    "ru": {
      "recovery_note": "Заземляющее, питательное блюдо. Грибы обогащают его витаминами группы B и селеном, а само медленное помешивание превращается в медитативный ритуал.",
      "ingredients": [
        "1 стакан риса арборио",
        "300г грибов, нарезанных ломтиками",
        "2 стакана молодого шпината",
        "1 луковица, 2 зубчика чеснока",
        "4 стакана теплого овощного бульона",
        "Пармезан, сливочное масло, оливковое масло"
      ],
      "steps": [
        "Обжаривайте onion, garlic и mushrooms в течение 5 minutes.",
        "Добавьте rice; помешивайте 1 minute, чтобы рис покрылся маслом.",
        "Добавляйте stock по одному половнику за раз, помешивая, пока жидкость не впитается (20 min).",
        "Вмешайте spinach до тех пор, пока он не станет мягким.",
        "В конце добавьте butter и parmesan."
      ]
    },
    "uk": {
      "recovery_note": "Заземлююча, поживна страва. Гриби збагачують її вітамінами групи B та селеном, а сам процес повільного помішування перетворюється на медитативний ритуал.",
      "ingredients": [
        "1 склянка рису arborio",
        "300г грибів, нарізаних скибочками",
        "2 склянки baby spinach",
        "1 цибулина, 2 зубчики часнику",
        "4 склянки теплого овочевого бульйону",
        "Parmesan, вершкове масло, оливкова олія"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник та гриби протягом 5 хвилин.",
        "Додайте рис; помішуйте 1 хвилину, щоб він покрився олією.",
        "Додавайте бульйон по одному черпаку за раз, помішуючи, до повного вбирання (20 min).",
        "Вмішайте шпинат, поки він не зів’яне.",
        "Завершіть додаванням butter та parmesan."
      ]
    },
    "ko": {
      "recovery_note": "몸과 마음을 차분하게 해주는 영양 가득한 한 끼 식사입니다. 버섯은 비타민 B군과 셀레늄을 더해주며, 천천히 젓는 과정 그 자체가 명상적인 의식이 됩니다.",
      "ingredients": [
        "1 cup 아르보리오 쌀 (arborio rice)",
        "300g 버섯, 슬라이스",
        "2 cups 베이비 시금치",
        "양파 1개, 마늘 2쪽",
        "4 cups 따뜻한 야채 육수 (vegetable stock)",
        "파마산 (Parmesan), 버터, 올리브 오일"
      ],
      "steps": [
        "양파, 마늘, 양송이버섯을 5분간 볶습니다.",
        "쌀을 넣고 잘 코팅되도록 1분간 젓습니다.",
        "육수를 한 국자씩 넣으며 흡수될 때까지 저어줍니다 (20분).",
        "시금치를 넣고 숨이 죽을 때까지 젓습니다.",
        "버터와 파마산 치즈를 넣어 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un repas réconfortant et nourrissant. Les champignons apportent des vitamines B et du sélénium ; le mélange lent devient en soi un rituel méditatif.",
      "ingredients": [
        "1 cup riz arborio",
        "300g champignons, émincés",
        "2 cups pousses d'épinards",
        "1 oignon, 2 gousses d'ail",
        "4 cups bouillon de légumes chaud",
        "Parmesan, beurre, huile d'olive"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail et les champignons pendant 5 minutes.",
        "Ajouter le riz ; remuer pendant 1 minute pour bien l'enrober.",
        "Ajouter le bouillon une louche à la fois, en remuant, jusqu'à absorption (20 min).",
        "Incorporer les épinards jusqu'à ce qu'ils soient tombés.",
        "Terminer avec le beurre et le parmesan."
      ]
    },
    "it": {
      "recovery_note": "Un pasto rinvigorente e nutriente. I funghi apportano vitamine del gruppo B e selenio; la stessa lenta mescolatura diventa un rito meditativo.",
      "ingredients": [
        "1 tazza di riso arborio",
        "300g di funghi, affettati",
        "2 tazze di baby spinach",
        "1 cipolla, 2 spicchi d'aglio",
        "4 tazze di brodo vegetale caldo",
        "Parmesan, burro, olio d'oliva"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e funghi per 5 minuti.",
        "Aggiungere il riso; mescolare per 1 minuto per tostarlo.",
        "Aggiungere il brodo un mestolo alla volta, mescolando, finché non viene assorbito (20 min).",
        "Incorporare gli spinaci finché non appassiscono.",
        "Mantecare con burro e parmigiano."
      ]
    },
    "es": {
      "recovery_note": "Una comida reconfortante y nutritiva. Los champiñones aportan vitaminas del grupo B y selenio; el propio acto de remover lentamente se convierte en un ritual meditativo.",
      "ingredients": [
        "1 cup arroz arborio",
        "300g champiñones, laminados",
        "2 cups brotes de espinaca",
        "1 cebolla, 2 dientes de ajo",
        "4 cups caldo de verduras caliente",
        "Parmesano, mantequilla, aceite de oliva"
      ],
      "steps": [
        "Saltee la cebolla, el ajo y los champiñones durante 5 minutes.",
        "Añada el arroz; remueva para cubrir durante 1 minute.",
        "Añada el caldo un cucharón a la vez, removiendo, hasta que se absorba (20 min).",
        "Incorpore las espinacas hasta que se marchiten.",
        "Termine con mantequilla y parmesan."
      ]
    }
  },
  "d7": {
    "ru": {
      "recovery_note": "Полноценный белок, сложные углеводы, листовая зелень — шаблон тарелки для правильного ужина, который можно повторять сотнями способов, и он никогда не надоест.",
      "ingredients": [
        "1 куриная грудка",
        "1/2 чашки киноа",
        "2 чашки микса салатной зелени",
        "Сок 1 лимона",
        "Olive oil, паприка, соль, перец",
        "Hummus или йогуртовый соус для подачи"
      ],
      "steps": [
        "Приготовьте киноа согласно инструкции на упаковке.",
        "Приправьте курицу паприкой, солью, перцем и оливковым маслом.",
        "Обжаривайте на гриле по 4–5 min с каждой стороны до полной готовности.",
        "Нарежьте ломтиками. Выложите на тарелку киноа, зелень и курицу.",
        "Сбрызните лимоном, полейте оливковым маслом и добавьте ложку hummus."
      ]
    },
    "uk": {
      "recovery_note": "Повноцінний білок, складні вуглеводи, листова зелень — це шаблон тарілки для корисного обіду чи вечері, який можна повторювати сотнями способів, і він ніколи не набридне.",
      "ingredients": [
        "1 куряча грудка",
        "1/2 чашки quinoa",
        "2 чашки міксу зелені",
        "сік 1 лимона",
        "Olive oil, паприка, сіль, перець",
        "Hummus або йогуртовий соус для подачі"
      ],
      "steps": [
        "Приготуйте кіноа згідно з інструкцією на упаковці.",
        "Приправте курку паприкою, сіллю, перцем та оливковою олією.",
        "Готуйте на грилі по 4–5 хв з кожного боку до повної готовності.",
        "Наріжте скибочками. Викладіть на тарілку кіноа, зелень та курку.",
        "Збризніть лимоном, полийте оливковою олією та додайте ложку хумусу."
      ]
    },
    "ko": {
      "recovery_note": "완전 단백질, 복합 탄수화물, 잎채소 — 질리지 않고 수백 가지 방식으로 반복해서 활용할 수 있는 깔끔한 저녁 식단 템플릿입니다.",
      "ingredients": [
        "닭가슴살 1개",
        "퀴노아 1/2 cup",
        "믹스 그린 2 cups",
        "레몬 1개, 즙을 내어 준비",
        "Olive oil, paprika, salt, pepper",
        "곁들임용 Hummus 또는 yoghurt sauce"
      ],
      "steps": [
        "패키지 안내에 따라 quinoa를 조리합니다.",
        "chicken에 paprika, salt, pepper, olive oil로 시즈닝합니다.",
        "양면을 각각 4–5 min 동안 속까지 다 익을 때까지 굽습니다.",
        "먹기 좋게 썹니다. 접시에 quinoa, 채소, chicken을 담습니다.",
        "lemon을 짜서 뿌리고 olive oil을 두른 뒤, hummus 한 스푼을 곁들입니다."
      ]
    },
    "fr": {
      "recovery_note": "Des protéines complètes, des glucides complexes, des légumes verts à feuilles — un modèle d'assiette équilibrée que vous pouvez décliner de centaines de façons sans jamais vous lasser.",
      "ingredients": [
        "1 blanc de poulet",
        "1/2 cup de quinoa",
        "2 cups de mélange de salades",
        "1 citron, pressé",
        "Olive oil, paprika, sel, poivre",
        "Hummus ou sauce au yaourt pour servir"
      ],
      "steps": [
        "Cuisez le quinoa selon les instructions du paquet.",
        "Assaisonnez le poulet avec du paprika, du sel, du poivre et de l'olive oil.",
        "Grillez 4–5 min par côté jusqu'à ce qu'il soit bien cuit.",
        "Coupez en tranches. Dressez le quinoa, les légumes verts et le poulet dans l'assiette.",
        "Pressez du citron, versez un filet d'olive oil et ajoutez une cuillère de hummus."
      ]
    },
    "it": {
      "recovery_note": "Proteine complete, carboidrati complessi, verdure a foglia verde: uno schema per un piatto sano che puoi replicare in centinaia di modi diversi senza mai annoiarti.",
      "ingredients": [
        "1 petto di pollo",
        "1/2 tazza di quinoa",
        "2 tazze di insalata mista",
        "1 limone, spremuto",
        "Olive oil, paprika, sale, pepe",
        "Hummus o salsa allo yoghurt per servire"
      ],
      "steps": [
        "Cuocere la quinoa come indicato sulla confezione.",
        "Condire il pollo con paprika, sale, pepe e olive oil.",
        "Grigliare per 4–5 min per lato fino a cottura completa.",
        "Affettare. Impiattare la quinoa, le verdure a foglia e il pollo.",
        "Spremere del limone, versare un filo di olive oil e aggiungere un cucchiaio di hummus."
      ]
    },
    "es": {
      "recovery_note": "Proteína completa, carbohidratos complejos, vegetales de hoja verde: una plantilla de plato saludable que puedes repetir de cientos de formas sin aburrirte.",
      "ingredients": [
        "1 pechuga de pollo",
        "1/2 cup de quinoa",
        "2 cups de mezcla de brotes verdes",
        "1 limón, su jugo",
        "Olive oil, paprika, sal, pimienta",
        "Hummus o salsa de yoghurt para servir"
      ],
      "steps": [
        "Cocinar la quinoa según las instrucciones del paquete.",
        "Sazonar el pollo con paprika, sal, pimienta y olive oil.",
        "Cocinar a la parrilla de 4–5 min por cada lado hasta que esté bien cocido.",
        "Cortar en rebanadas. Servir en un plato la quinoa, vegetales verdes y el pollo.",
        "Exprimir limón, rociar con olive oil y añadir una cucharada de hummus."
      ]
    }
  },
  "d8": {
    "ru": {
      "recovery_note": "Нежирная белая рыба обеспечивает организм белком и селеном при минимальном содержании насыщенных жиров — она полезна для восстанавливающейся печени и легко усваивается.",
      "ingredients": [
        "150g трески или любого филе белой рыбы",
        "1 лимон, нарезанный ломтиками",
        "Свежий укроп, петрушка",
        "2 tbsp оливкового масла",
        "Соль, перец",
        "Приготовленная на пару зелень для подачи"
      ],
      "steps": [
        "Разогрейте духовку до 200°C.",
        "Выложите треску в форму для запекания, сверху добавьте лимон, травы, масло, соль и перец.",
        "Накройте фольгой; запекайте 12–15 минут, пока рыба не начнет расслоиться.",
        "Подавайте с приготовленной на пару зеленью или салатом.",
        "Полейте сверху соком, оставшимся в форме."
      ]
    },
    "uk": {
      "recovery_note": "Нежирна біла риба забезпечує організм білком і селеном з мінімальним вмістом насичених жирів — вона корисна для печінки, що відновлюється, і легко засвоюється.",
      "ingredients": [
        "150g філе тріски або будь-якої білої риби",
        "1 лимон, нарізаний скибочками",
        "Свіжий кріп, петрушка",
        "2 tbsp оливкової олії",
        "Сіль, перець",
        "Приготовлена на парі зелень для подачі"
      ],
      "steps": [
        "Розігрійте духовку до 200°C.",
        "Викладіть тріску у форму для запікання, зверху покладіть лимон, трави, олію, сіль та перець.",
        "Накрийте фольгою; запікайте 12–15 хвилин до готовності, поки риба не почне розпадатися на пластівці.",
        "Подавайте з приготованою на парі зеленню або салатом.",
        "Полийте зверху соком, що залишився у формі."
      ]
    },
    "ko": {
      "recovery_note": "지방이 적은 흰살생선은 포화 지방이 거의 없으면서도 단백질과 셀레늄을 보충해 줍니다. 이는 회복 중인 간에 무리를 주지 않으며 소화하기에도 편안합니다.",
      "ingredients": [
        "150g 대구 또는 흰 살 생선 필렛",
        "레몬 1개, 슬라이스",
        "신선한 딜, 파슬리",
        "2 tbsp 올리브 오일",
        "소금, 후추",
        "곁들임용 찐 채소들"
      ],
      "steps": [
        "오븐을 200°C로 예열하세요.",
        "대구(cod)를 베이킹 접시에 담고 그 위에 레몬, 허브, 오일, 소금, 후추를 올리세요.",
        "알루미늄 호일로 덮은 뒤 생선 살이 부드럽게 부서질 때까지 12–15분간 구우세요.",
        "찐 채소나 샐러드를 곁들여 내세요.",
        "팬에 남은 육즙을 스푼으로 떠서 요리 위에 뿌려주세요."
      ]
    },
    "fr": {
      "recovery_note": "Le poisson blanc maigre apporte des protéines et du sélénium avec un minimum de graisses saturées — doux pour le foie en convalescence et facile à digérer.",
      "ingredients": [
        "150g de cabillaud ou tout autre filet de poisson blanc",
        "1 citron, coupé en tranches",
        "Aneth frais, persil",
        "2 tbsp d'huile d'olive",
        "Sel, poivre",
        "Légumes verts à la vapeur pour accompagner"
      ],
      "steps": [
        "Préchauffez le four à 200°C.",
        "Placez le cabillaud dans un plat allant au four, garnissez avec du citron, des herbes, de l'huile, du sel et du poivre.",
        "Couvrez de papier aluminium ; faites cuire 12–15 minutes jusqu'à ce que la chair se détache facilement.",
        "Servez avec des légumes verts à la vapeur ou une salade.",
        "Arrosez avec le jus de cuisson."
      ]
    },
    "it": {
      "recovery_note": "Il pesce bianco magro apporta proteine e selenio con un contenuto minimo di grassi saturi — delicato sul fegato in fase di guarigione e facile da digerire.",
      "ingredients": [
        "150g di merluzzo o qualsiasi filetto di pesce bianco",
        "1 limone, affettato",
        "Aneto fresco, prezzemolo",
        "2 tbsp di olio d’oliva",
        "Sale, pepe",
        "Verdure al vapore per servire"
      ],
      "steps": [
        "Preriscaldare il forno a 200°C.",
        "Adagiare il merluzzo in una pirofila, guarnire con limone, erbe, olio, sale e pepe.",
        "Coprire con un foglio di alluminio; cuocere per 12–15 minuti fino a quando la polpa non si sfalda facilmente.",
        "Servire con verdure al vapore o insalata.",
        "Versare sopra i succhi di cottura con un cucchiaio."
      ]
    },
    "es": {
      "recovery_note": "El pescado blanco magro aporta proteínas y selenio con un mínimo de grasas saturadas, siendo suave para el hígado en recuperación y fácil de digerir.",
      "ingredients": [
        "150g de bacalao o cualquier filete de pescado blanco",
        "1 limón, en rodajas",
        "Eneldo fresco, perejil",
        "2 tbsp de aceite de oliva",
        "Sal, pimienta",
        "Verduras al vapor para servir"
      ],
      "steps": [
        "Precaliente el horno a 200°C.",
        "Coloque el bacalao en una fuente para horno, cubra con limón, hierbas, aceite, sal y pimienta.",
        "Cubra con papel de aluminio; hornee de 12 a 15 minutos hasta que se desmorone fácilmente.",
        "Sirva con verduras al vapor o ensalada.",
        "Vierta los jugos de la fuente por encima con una cuchara."
      ]
    }
  },
  "d9": {
    "ru": {
      "recovery_note": "Железо и цинк в постной говядине часто истощаются после длительного употребления алкоголя — оба этих элемента имеют решающее значение для энергии, настроения и восстановления иммунитета.",
      "ingredients": [
        "300g lean beef strips",
        "1 tbsp имбиря, 2 зубчика чеснока",
        "1 capsicum, 1 головка брокколи, 1 морковь",
        "3 tbsp соевого соуса, 1 tbsp oyster sauce",
        "1 tsp кунжутного масла, кукурузный крахмал (cornflour)",
        "Приготовленный коричневый рис"
      ],
      "steps": [
        "Перемешайте говядину с кукурузным крахмалом (cornflour) и 1 tbsp соевого соуса (soy).",
        "Обжаривайте говядину в горячем масле (oil) в течение 2 min; снимите с огня.",
        "Обжаривайте чеснок (garlic), имбирь (ginger) и овощи (vegetables) в течение 4 min.",
        "Верните говядину на сковороду, добавьте оставшиеся соусы; перемешивайте 1 min.",
        "Подавайте на подушке из коричневого риса (brown rice), сбрызнув кунжутным маслом (sesame oil)."
      ]
    },
    "uk": {
      "recovery_note": "Залізо та цинк у пісній яловичині зазвичай виснажуються після тривалого вживання алкоголю — обидва ці елементи мають вирішальне значення для відновлення енергії, настрою та імунітету.",
      "ingredients": [
        "300g нежирної яловичини, нарізаної смужками",
        "1 tbsp імбиру, 2 зубчики часнику",
        "1 болгарський перець (capsicum), 1 головка броколі, 1 морква",
        "3 tbsp соєвого соусу, 1 tbsp устричного соусу",
        "1 tsp кунжутної олії, кукурудзяний крохмаль (cornflour)",
        "Готовий коричневий рис"
      ],
      "steps": [
        "Перемішайте яловичину з кукурудзяним крохмалем та 1 tbsp соєвого соусу.",
        "Обсмажте яловичину в розпеченій олії протягом 2 min; вийміть.",
        "Обсмажте часник, імбир та овочі протягом 4 min.",
        "Поверніть яловичину на сковорідку, додайте решту соусів; перемішуйте 1 min.",
        "Подавайте на подушці з коричневого рису, злегка збризнувши sesame oil."
      ]
    },
    "ko": {
      "recovery_note": "살코기에 들어 있는 철분과 아연은 장기간의 음주 후 흔히 결핍되는 영양소로, 에너지 대사와 기분 조절, 면역력 회복에 매우 중요한 역할을 합니다.",
      "ingredients": [
        "300g lean beef strips",
        "1 tbsp 생강, 마늘 2쪽",
        "capsicum 1개, 브로콜리 1송이, 당근 1개",
        "3 tbsp 간장, 1 tbsp 굴소스",
        "1 tsp 참기름, 옥수수 전분(cornflour)",
        "조리된 현미밥"
      ],
      "steps": [
        "소고기를 옥수수 전분, soy 1 tbsp과 함께 버무립니다.",
        "달궈진 기름에 소고기를 2 min 동안 볶은 후 건져냅니다.",
        "마늘, 생강, 채소를 4 min 동안 볶습니다.",
        "소고기를 다시 넣고 남은 소스들을 추가한 뒤 1 min 동안 버무립니다.",
        "현미밥 위에 올리고 sesame oil을 살짝 뿌려 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Le fer et le zinc contenus dans le bœuf maigre sont couramment épuisés après une consommation d'alcool à long terme — deux éléments essentiels pour l'énergie, l'humeur et la récupération immunitaire.",
      "ingredients": [
        "300g de lanières de bœuf maigre",
        "1 tbsp de gingembre, 2 gousses d'ail",
        "1 poivron, 1 tête de brocoli, 1 carotte",
        "3 tbsp de sauce soja, 1 tbsp de sauce d'huître",
        "1 tsp d'huile de sésame, cornflour",
        "Riz complet cuit"
      ],
      "steps": [
        "Mélanger le bœuf avec le cornflour et 1 tbsp de soja.",
        "Faire sauter le bœuf dans l'huile chaude pendant 2 min ; retirer du feu.",
        "Faire sauter l'ail, le gingembre et les vegetables pendant 4 min.",
        "Remettre le bœuf, ajouter le reste des sauces ; mélanger pendant 1 min.",
        "Servir sur du riz brun avec un filet de sesame oil."
      ]
    },
    "it": {
      "recovery_note": "Il ferro e lo zinco presenti nel manzo magro vengono comunemente esauriti dopo un uso prolungato di alcol — entrambi sono fondamentali per l'energia, l'umore e il recupero del sistema immunitario.",
      "ingredients": [
        "300g lean beef strips",
        "1 tbsp di zenzero, 2 spicchi d'aglio",
        "1 capsicum, 1 testa di broccoli, 1 carota",
        "3 tbsp di soy sauce, 1 tbsp di oyster sauce",
        "1 tsp di olio di sesamo, cornflour",
        "Riso integrale cotto"
      ],
      "steps": [
        "Mescolare il manzo con la maizena e 1 tbsp di soia.",
        "Saltare il manzo in olio bollente per 2 min; rimuovere.",
        "Saltare aglio, zenzero e verdure per 4 min.",
        "Unire nuovamente il manzo, aggiungere le salse rimanenti; saltare per 1 min.",
        "Servire su riso integrale con un filo di olio di sesamo."
      ]
    },
    "es": {
      "recovery_note": "El hierro y el zinc de la carne de res magra suelen agotarse tras un consumo prolongado de alcohol; ambos son fundamentales para la energía, el estado de ánimo y la recuperación del sistema inmunitario.",
      "ingredients": [
        "300g lean beef strips",
        "1 tbsp jengibre, 2 dientes de ajo",
        "1 pimiento, 1 cabeza de brócoli, 1 zanahoria",
        "3 tbsp salsa de soja, 1 tbsp salsa de ostras",
        "1 tsp aceite de sésamo, maicena",
        "Arroz integral cocido"
      ],
      "steps": [
        "Mezcle la carne de res con harina de maíz y 1 tbsp de soya.",
        "Saltee la carne en aceite caliente durante 2 min; retire.",
        "Saltee el ajo, el jengibre y las verduras durante 4 min.",
        "Regrese la carne, añada el resto de las salsas; mezcle durante 1 min.",
        "Sirva sobre arroz integral con un chorrito de aceite de sésamo."
      ]
    }
  },
  "d10": {
    "ru": {
      "recovery_note": "Уют воскресного жаркого, которого хватит на два дня. Домашняя кухня возвращает тот режим и ритуалы, которые разрушает зависимость.",
      "ingredients": [
        "1.4kg целая курица",
        "4 моркови, 2 пастернака, 1 луковица, кусочками",
        "6 зубчиков чеснока, неочищенных",
        "Лимон, свежие травы (розмарин, тимьян)",
        "3 tbsp оливкового масла",
        "Соль, перец"
      ],
      "steps": [
        "Разогрейте духовку до 200°C.",
        "Приправьте курицу внутри и снаружи; нафаршируйте лимоном и травами.",
        "Смешайте овощи с маслом, солью, перцем; распределите по противню.",
        "Выложите курицу сверху; запекайте 50-60 min до прозрачности сока.",
        "Дайте отдохнуть 10 min; нарежьте и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Затишок недільної печені, якої вистачить на два дні. Домашня кухня в родинному колі відновлює розпорядок і ритуали, які руйнує залежність.",
      "ingredients": [
        "1.4kg ціла курка",
        "4 моркви, 2 пастернаки, 1 цибуля, шматочками",
        "6 зубчиків часнику, неочищених",
        "Lemon, свіжі трави (rosemary, thyme)",
        "3 tbsp оливкової олії",
        "Сіль, перець"
      ],
      "steps": [
        "Розігрійте духовку до 200°C.",
        "Приправте курку всередині та зовні; начиніть лимоном і травами.",
        "Перемішайте овочі з олією, сіллю та перцем; розподіліть у деку для запікання.",
        "Покладіть курку зверху; запікайте 50-60 хв, поки сік не стане прозорим.",
        "Залиште відпочити на 10 хв; наріжте та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "이틀 동안 든든하게 먹을 수 있는 선데이 로스트의 편안함. 가족을 위한 요리는 중독이 앗아간 일상의 규칙과 의식을 되찾아 줍니다.",
      "ingredients": [
        "1.4kg whole chicken",
        "당근 4개, 파스닙 2개, 양파 1개, 큼직하게 썬 것",
        "껍질을 벗기지 않은 garlic cloves 6알",
        "Lemon, 생 허브 (rosemary, thyme)",
        "3 tbsp olive oil",
        "Salt, pepper"
      ],
      "steps": [
        "오븐을 200°C로 예열합니다.",
        "닭고기의 안팎에 시즈닝을 하고 레몬과 허브를 채워 넣습니다.",
        "채소를 오일, 소금, 후추와 함께 버무린 뒤 로스팅 팬에 펼쳐 담습니다.",
        "그 위에 닭고기를 올리고 육즙이 투명하게 나올 때까지 50-60분간 굽습니다.",
        "10분간 휴지시킨 후, 먹기 좋게 잘라 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un réconfort de rôti du dimanche qui vous nourrit pendant deux jours. La cuisine familiale restaure la routine et le rituel que l'addiction efface.",
      "ingredients": [
        "1.4kg poulet entier",
        "4 carottes, 2 panais, 1 oignon, en morceaux",
        "6 gousses d'ail, non pelées",
        "Citron, herbes fraîches (romarin, thym)",
        "3 tbsp d'huile d'olive",
        "Sel, poivre"
      ],
      "steps": [
        "Préchauffer le four à 200°C.",
        "Assaisonner le poulet à l'intérieur et à l'extérieur ; le farcir avec le citron et les herbes.",
        "Mélanger les légumes avec l'huile, le sel et le poivre ; les répartir dans un plat à rôtir.",
        "Placer le poulet sur le dessus ; rôtir pendant 50-60 min jusqu'à ce que le jus soit clair.",
        "Laisser reposer 10 min ; découper et servir."
      ]
    },
    "it": {
      "recovery_note": "Il comfort di un arrosto della domenica che ti nutre per due giorni. La cucina casalinga ripristina la routine e il rito che la dipendenza porta via.",
      "ingredients": [
        "1.4kg pollo intero",
        "4 carote, 2 pastinache, 1 cipolla, a pezzi",
        "6 spicchi d'aglio, non sbucciati",
        "Limone, erbe aromatiche fresche (rosmarino, timo)",
        "3 tbsp olio d'oliva",
        "Sale, pepe"
      ],
      "steps": [
        "Preriscaldare il forno a 200°C.",
        "Condire il pollo all'interno e all'esterno; farcire con limone ed erbe aromatiche.",
        "Mescolare le verdure con olio, sale e pepe; distribuirle in una teglia da forno.",
        "Adagiare il pollo sopra le verdure; arrostire per 50-60 min finché i succhi non risulteranno limpidi.",
        "Lasciare riposare per 10 min; tagliare e servire."
      ]
    },
    "es": {
      "recovery_note": "El bienestar de un asado dominical que te alimenta durante dos días. La cocina de estilo familiar restaura la rutina y el ritual que la adicción arrebata.",
      "ingredients": [
        "1.4kg pollo entero",
        "4 zanahorias, 2 chirivías, 1 cebolla, en trozos",
        "6 dientes de ajo, sin pelar",
        "Limón, hierbas frescas (romero, tomillo)",
        "3 tbsp aceite de oliva",
        "Sal, pimienta"
      ],
      "steps": [
        "Precaliente el horno a 200°C.",
        "Sazone el pollo por dentro y por fuera; rellénelo con limón y hierbas.",
        "Mezcle las verduras con aceite, sal y pimienta; extiéndalas en una bandeja de asar.",
        "Coloque el pollo encima; asar durante 50-60 min hasta que los jugos salgan claros.",
        "Deje reposar 10 min; trinchado y servir."
      ]
    }
  },
  "d11": {
    "ru": {
      "recovery_note": "Настоящая находка для заготовок. Рассчитано на 6 порций — готовые ужины на неделю снижают усталость от принятия решений, которая является известным триггером срыва.",
      "ingredients": [
        "1 цукини, 1 баклажан, нарезанные ломтиками",
        "1 банка соуса marinara",
        "250g рикотты, 1 яйцо",
        "8 листов lasagne",
        "1.5 чашки тертой моцареллы",
        "Шпинат, базилик, пармезан"
      ],
      "steps": [
        "Запекайте баклажаны и цукини 15 min при 200°C.",
        "Смешайте рикотту, яйцо, шпинат и базилик.",
        "Выложите слоями в форму: соус, листы, рикотта, овощи, моцарелла; повторите.",
        "Посыпьте сверху пармезаном.",
        "Выпекайте под крышкой 30 min; без крышки 10 min до золотистого цвета."
      ]
    },
    "uk": {
      "recovery_note": "Золотий стандарт приготування страв наперед. Розраховано на 6 порцій — готові вечері на тиждень зменшують утому від прийняття рішень, що є відомим тригером рецидиву.",
      "ingredients": [
        "1 цукіні, 1 баклажан, нарізані скибочками",
        "1 банка соусу marinara",
        "250g рікоти, 1 яйце",
        "8 листів для lasagne",
        "1.5 склянки тертої mozzarella",
        "Шпинат, базилік, пармезан"
      ],
      "steps": [
        "Запікайте баклажани та цукіні 15 min при 200°C.",
        "Змішайте рікоту, яйце, шпинат та базилік.",
        "Викладіть шарами у форму: соус, листи, рікота, овочі, моцарела; повторіть.",
        "Посипте зверху пармезаном.",
        "Випікайте накритими 30 min; потім без кришки 10 min до золотистої скоринки."
      ]
    },
    "ko": {
      "recovery_note": "최고의 밀프렙 레시피입니다. 6인분 분량으로, 일주일 치 저녁 식사를 미리 준비해 두면 재발의 주요 원인인 결정 피로를 줄일 수 있습니다.",
      "ingredients": [
        "주키니 1개, 가지 1개, 슬라이스",
        "마리나라 소스 1병",
        "리코타 250g, 계란 1개",
        "라자냐 면 8장",
        "잘게 썬 모짜렐라 1.5컵",
        "시금치, 바질, 파마산 치즈"
      ],
      "steps": [
        "200°C에서 가지와 주키니를 15분 동안 굽습니다.",
        "리코타 치즈, 달걀, 시금치, 바질을 섞습니다.",
        "소스, 파스타 면, 리코타, 채소, 모짜렐라 순으로 층층이 쌓고 이 과정을 반복합니다.",
        "위에 파마산 치즈를 뿌립니다.",
        "뚜껑이나 호일을 덮어 30분 동안 굽고, 뚜껑을 열어 노릇해질 때까지 10분 더 굽습니다."
      ]
    },
    "fr": {
      "recovery_note": "Le summum de l'organisation culinaire. Donne 6 portions — avoir des dîners prêts pour la semaine réduit la fatigue décisionnelle, un déclencheur de rechute bien connu.",
      "ingredients": [
        "1 courgette, 1 aubergine, tranchées",
        "1 pot de marinara sauce",
        "250g ricotta, 1 œuf",
        "8 feuilles de lasagne",
        "1.5 cups de mozzarella râpée",
        "Épinards, basilic, parmesan"
      ],
      "steps": [
        "Rôtir l'aubergine et la courgette 15 min à 200°C.",
        "Mélanger la ricotta, l'œuf, les épinards et le basilic.",
        "Superposer dans le plat : sauce, feuilles de lasagnes, ricotta, légumes, mozzarella ; répéter.",
        "Garnir de parmesan.",
        "Cuire au four à couvert pendant 30 min ; puis à découvert pendant 10 min jusqu'à ce que ce soit doré."
      ]
    },
    "it": {
      "recovery_note": "L'oro del meal-prep. Dose per 6 porzioni — avere le cene assicurate per una settimana riduce l'affaticamento decisionale, un noto fattore scatenante per le ricadute.",
      "ingredients": [
        "1 zucchina, 1 melanzana, affettate",
        "1 barattolo di marinara sauce",
        "250g di ricotta, 1 uovo",
        "8 fogli di lasagne",
        "1.5 tazze di mozzarella grattugiata",
        "Spinaci, basilico, parmigiano"
      ],
      "steps": [
        "Arrostire le melanzane e le zucchine per 15 min a 200°C.",
        "Mescolare ricotta, uovo, spinaci e basilico.",
        "Stratificare nella teglia: salsa, sfoglie, ricotta, verdure, mozzarella; ripetere.",
        "Guarnire con parmigiano.",
        "Cuocere in forno coperto per 30 min; scoperto per 10 min fino a doratura."
      ]
    },
    "es": {
      "recovery_note": "Oro puro para el meal-prep. Rinde 6 porciones: tener las cenas aseguradas para toda la semana reduce la fatiga por toma de decisiones, un conocido detonante de recaídas.",
      "ingredients": [
        "1 zucchini, 1 eggplant, rebanadas",
        "1 frasco de marinara sauce",
        "250g ricotta, 1 huevo",
        "8 láminas de lasagne",
        "1.5 tazas de mozzarella rallado",
        "Espinacas, albahaca, parmesan"
      ],
      "steps": [
        "Asar la berenjena y el calabacín durante 15 min a 200°C.",
        "Mezclar el ricotta, el huevo, las espinacas y la albahaca.",
        "Formar capas en la fuente: salsa, láminas, ricotta, verduras, mozzarella; repetir.",
        "Cubrir con parmesano.",
        "Hornear tapado durante 30 min; destapado 10 min hasta que esté dorado."
      ]
    }
  },
  "d12": {
    "ru": {
      "recovery_note": "Среднецепочечные триглицериды (МСТ) кокоса обеспечивают мозг мгновенной энергией. Острая пища дает выброс эндорфинов без привыкания — здоровый апгрейд для получения удовольствия.",
      "ingredients": [
        "2 tbsp пасты зелёный карри",
        "1 tin кокосового молока",
        "1 cup смеси овощей (брокколи, болгарский перец, стручковый горошек)",
        "200g твердого тофу, нарезанного кубиками",
        "1 tbsp рыбного соуса (или соевого для веганского варианта)",
        "Базилик, лайм, рис жасмин"
      ],
      "steps": [
        "Обжаривайте пасту карри в 1 tbsp масла в течение 1 min.",
        "Добавьте кокосовое молоко и доведите до легкого кипения.",
        "Добавьте тофу и овощи; готовьте 8 min.",
        "Влейте рыбный соус и добавьте выжатый сок лайма.",
        "Подавайте с рисом жасмин; украсьте базиликом."
      ]
    },
    "uk": {
      "recovery_note": "Кокосові середньоланцюгові тригліцериди (MCT) забезпечують мозок миттєвою енергією. Гостра їжа дає викид ендорфінів без формування залежності — це здорове підвищення рівня задоволення.",
      "ingredients": [
        "2 tbsp пасти зеленого карі",
        "1 бляшанка кокосового молока",
        "1 склянка суміші овочів (броколі, болгарський перець, цукровий горошок)",
        "200g твердого тофу, нарізаного кубиками",
        "1 tbsp рибного соусу (або соєвого для веганів)",
        "Базилік, лайм, рис жасмин"
      ],
      "steps": [
        "Обсмажуйте пасту карі в 1 tbsp олії протягом 1 min.",
        "Додайте кокосове молоко і доведіть до легкого кипіння.",
        "Додайте тофу та овочі; готуйте 8 min.",
        "Вмішайте рибний соус і вичавіть трохи лайма.",
        "Подавайте з рисом жасмин; зверху прикрасьте базиліком."
      ]
    },
    "ko": {
      "recovery_note": "코코넛 MCT는 뇌에 즉각적인 에너지를 공급합니다. 매운 음식은 의존성 없이 엔도르핀을 자극하여 건강하게 즐거움을 더해줍니다.",
      "ingredients": [
        "2 tbsp 그린 커리 페이스트",
        "1 tin 코코넛 밀크",
        "1 cup 혼합 야채 (브로콜리, capsicum, 완두콩)",
        "200g 단단한 두부, 깍둑썰기한 것",
        "1 tbsp 피쉬 소스 (채식주의자의 경우 간장)",
        "바질, 라임, 자스민 라이스"
      ],
      "steps": [
        "1 tbsp의 식용유에 커리 페이스트를 넣고 1분간 볶습니다.",
        "코코넛 밀크를 붓고 가볍게 끓어오를 때까지 가열합니다.",
        "두부와 채소를 넣고 8분간 익힙니다.",
        "피쉬 소스를 넣고 저은 뒤 라임즙을 짭니다.",
        "자스민 라이스 위에 얹어 내고 바질을 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les TCM de la noix de coco fournissent une énergie cérébrale immédiate. Les aliments épicés procurent une poussée d'endorphines sans dépendance — une amélioration hédonique saine.",
      "ingredients": [
        "2 tbsp de pâte de curry vert",
        "1 boîte de lait de coco",
        "1 cup de légumes variés (brocoli, poivron, pois gourmands)",
        "200g de tofu ferme, coupé en dés",
        "1 tbsp de sauce poisson (ou soja pour la version vegan)",
        "Basilic, lime, riz jasmin"
      ],
      "steps": [
        "Faire frire la pâte de curry dans 1 tbsp d'huile pendant 1 min.",
        "Ajouter le lait de coco et porter à un léger frémissement.",
        "Ajouter le tofu et les légumes ; cuire 8 min.",
        "Incorporer la sauce poisson et un filet de lime.",
        "Servir sur du riz jasmin ; garnir de basilic."
      ]
    },
    "it": {
      "recovery_note": "Gli MCT del cocco forniscono energia immediata al cervello. Il cibo piccante regala una sferzata di endorfine senza creare dipendenza: un sano miglioramento edonico.",
      "ingredients": [
        "2 tbsp pasta di curry verde",
        "1 lattina di latte di cocco",
        "1 cup di verdure miste (broccoli, capsicum, taccole)",
        "200g di tofu compatto, a cubetti",
        "1 tbsp di salsa di pesce (o soia per i vegani)",
        "Basilico, lime, riso jasmine"
      ],
      "steps": [
        "Soffriggere la pasta di curry in 1 tbsp di olio per 1 min.",
        "Aggiungere il latte di cocco e portare a leggero bollore.",
        "Aggiungere il tofu e le verdure; cuocere per 8 min.",
        "Incorporare la salsa di pesce e una spruzzata di lime.",
        "Servire su riso jasmine; guarnire con basilico."
      ]
    },
    "es": {
      "recovery_note": "Los MCT de coco proporcionan energía inmediata para el cerebro. La comida picante aporta ráfagas de endorfinas sin generar dependencia: una mejora hedónica saludable.",
      "ingredients": [
        "2 tbsp pasta de curry verde",
        "1 lata de leche de coco",
        "1 taza de vegetales mixtos (brócoli, capsicum, snow peas)",
        "200g firm tofu, en cubos",
        "1 tbsp fish sauce (o soya para opción vegana)",
        "Albahaca, lima, arroz jasmine"
      ],
      "steps": [
        "Freír la pasta de curry en 1 tbsp de aceite durante 1 min.",
        "Añadir la leche de coco y llevar a un hervor suave.",
        "Añadir el tofu y las verduras; cocinar 8 min.",
        "Incorporar la fish sauce y un chorrito de lima.",
        "Servir sobre jasmine rice; decorar con albahaca."
      ]
    }
  },
  "d13": {
    "ru": {
      "recovery_note": "Омега-3 ЭПК и ДГК из лосося способствуют лечению депрессии, что подтверждено весомыми клиническими доказательствами — это одно из самых эффективных блюд, на котором можно строить свой рацион в течение недели.",
      "ingredients": [
        "2 филе лосося",
        "3 tbsp соевого соуса, 1 tbsp меда",
        "1 tsp имбиря, тертого",
        "1 cup коричневого риса",
        "Edamame, морковь, огурец",
        "Семена кунжута, зеленый лук"
      ],
      "steps": [
        "Взбейте соевый соус, мед и имбирь; смажьте полученной смесью лосось.",
        "Запекайте при 200°C в течение 12-14 минут до готовности, пока рыба не начнет расслоиться.",
        "Отварите рис согласно инструкции на упаковке.",
        "Разложите рис по мискам; сверху выложите лосось и овощи.",
        "Украсьте семенами кунжута и зеленым луком."
      ]
    },
    "uk": {
      "recovery_note": "Омега-3 ЕПК і ДГК з лосося допомагають у лікуванні депресії, що підтверджено вагомими клінічними доказами — це одна з найефективніших страв, на основі якої варто будувати свій тижневий раціон.",
      "ingredients": [
        "2 філе лосося",
        "3 tbsp соєвого соусу, 1 tbsp меду",
        "1 tsp імбиру, натертого",
        "1 cup коричневого рису",
        "Едамаме, морква, огірок",
        "Насіння кунжуту, зелена цибуля"
      ],
      "steps": [
        "Збийте соєвий соус, мед і імбир; змастіть цією сумішшю лосось.",
        "Запікайте при 200°C протягом 12-14 хв, поки риба не почне легко розділятися на шматочки.",
        "Приготуйте рис відповідно до інструкції на упаковці.",
        "Розкладіть рис у миски; зверху викладіть лосось і овочі.",
        "Прикрасьте кунжутом і зеленою цибулею."
      ]
    },
    "ko": {
      "recovery_note": "연어에 함유된 오메가-3 EPA 및 DHA는 우울증 치료를 돕는다는 강력한 임상적 근거가 있으며, 이는 일주일 식단에 포함하기에 가장 효과적인 식사 중 하나입니다.",
      "ingredients": [
        "2 salmon fillets",
        "3 tbsp soy sauce, 1 tbsp honey",
        "1 tsp ginger, grated",
        "1 cup brown rice",
        "Edamame, carrots, cucumber",
        "Sesame seeds, spring onion"
      ],
      "steps": [
        "간장, 꿀, 생강을 섞은 뒤 연어 표면에 바릅니다.",
        "200°C로 예열된 오븐에서 살이 부드럽게 부서질 때까지 12-14분간 굽습니다.",
        "포장지 지침에 따라 밥을 짓습니다.",
        "그릇에 밥을 담고 그 위에 연어와 채소를 올립니다.",
        "참깨와 쪽파를 고명으로 뿌려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les oméga-3 EPA et DHA du saumon soutiennent le traitement de la dépression avec des preuves cliniques solides — l'un des repas les plus efficaces autour duquel vous pouvez organiser votre semaine.",
      "ingredients": [
        "2 filets de saumon",
        "3 tbsp de sauce soja, 1 tbsp de miel",
        "1 tsp de gingembre, râpé",
        "1 cup de riz complet",
        "Edamame, carottes, concombre",
        "Graines de sésame, oignon vert"
      ],
      "steps": [
        "Fouetter le soja, le miel et le gingembre ; badigeonner sur le saumon.",
        "Cuire au four à 200°C pendant 12-14 min jusqu'à ce qu'il s'effeuille facilement.",
        "Cuire le riz selon les instructions du paquet.",
        "Répartir le riz dans des bols ; garnir avec le saumon et les légumes.",
        "Garnir de graines de sésame et d'oignon vert."
      ]
    },
    "it": {
      "recovery_note": "Gli Omega-3 EPA e DHA del salmone supportano il trattamento della depressione con forti prove cliniche: uno dei pasti a più alto impatto su cui basare la propria settimana.",
      "ingredients": [
        "2 filetti di salmone",
        "3 tbsp di salsa di soia, 1 tbsp di miele",
        "1 tsp di zenzero grattugiato",
        "1 cup di riso integrale",
        "Edamame, carote, cetriolo",
        "Semi di sesamo, cipollotto"
      ],
      "steps": [
        "Sbattere soia, miele e zenzero; spennellare sul salmone.",
        "Cuocere in forno a 200°C per 12-14 min fino a quando la consistenza risulterà a scaglie.",
        "Cuocere il riso come indicato sulla confezione.",
        "Disporre il riso nelle ciotole; completare con il salmone e le verdure.",
        "Guarnire con semi di sesamo e cipollotto."
      ]
    },
    "es": {
      "recovery_note": "El omega-3 EPA y DHA del salmón ayuda en el tratamiento de la depresión con una sólida evidencia clínica; es una de las comidas de mayor impacto sobre las que puedes estructurar tu semana.",
      "ingredients": [
        "2 salmon fillets",
        "3 tbsp soy sauce, 1 tbsp honey",
        "1 tsp ginger, rallado",
        "1 cup brown rice",
        "Edamame, zanahorias, pepino",
        "Sesame seeds, spring onion"
      ],
      "steps": [
        "Batir la soja, la miel y el jengibre; pincelar sobre el salmon.",
        "Hornear a 200°C durante 12-14 min hasta que se desmorone fácilmente.",
        "Cocinar el arroz según el paquete.",
        "Organizar el arroz en cuencos; cubrir con el salmon y los vegetales.",
        "Decorar con semillas de sésamo y spring onion."
      ]
    }
  },
  "d14": {
    "ru": {
      "recovery_note": "Витамин С в болгарском перце способствует восстановлению надпочечников — ваша система реагирования на стресс нуждается в серьезной поддержке в первый год трезвости.",
      "ingredients": [
        "4 крупных capsicums",
        "300g нежирного говяжьего или индюшиного фарша",
        "1 cup вареного бурого риса",
        "1 onion, garlic, 1 tin томатов",
        "1 cup тертого сыра",
        "Italian herbs"
      ],
      "steps": [
        "Разрежьте capsicums пополам и удалите семена.",
        "Обжарьте фарш с луком и чесноком до золотистого цвета.",
        "Добавьте рис, томаты и зелень, перемешайте.",
        "Выложите смесь ложкой в половинки capsicum; сверху посыпьте сыром.",
        "Выпекайте при 180°C в течение 30 min до мягкости и золотистого цвета."
      ]
    },
    "uk": {
      "recovery_note": "Вітамін С у болгарському перці підтримує відновлення надниркових залоз — ваша стресова система потребує серйозної перебудови в перший рік тверезості.",
      "ingredients": [
        "4 великих солодких перці (capsicums)",
        "300g нежирного яловичого або індичого фаршу",
        "1 склянка вареного коричневого рису",
        "1 цибулина, часник, 1 бляшанка томатів",
        "1 склянка тертого сиру",
        "Italian herbs"
      ],
      "steps": [
        "Розріжте болгарський перець навпіл і видаліть насіння.",
        "Підрум'яньте фарш із цибулею та часником.",
        "Додайте рис, томати та зелень.",
        "Ложкою викладіть суміш у половинки перцю; зверху посипте сиром.",
        "Випікайте при 180°C протягом 30 min до м'якості та золотистої скоринки."
      ]
    },
    "ko": {
      "recovery_note": "피망에 함유된 비타민 C는 부신 회복을 돕습니다. 금주 첫해에는 스트레스 조절 체계에 집중적인 재건이 필요합니다.",
      "ingredients": [
        "큰 파프리카 4개",
        "300g 소고기 또는 칠면조 다짐육 (lean beef or turkey mince)",
        "익힌 현미 1 cup",
        "양파 1개, 마늘, 1 tin tomatoes",
        "갈은 치즈 1 cup",
        "Italian herbs"
      ],
      "steps": [
        "capsicums를 반으로 자르고 씨를 제거합니다.",
        "다진 고기를 onion, garlic과 함께 갈색이 되도록 볶습니다.",
        "rice, tomatoes, herbs를 넣고 젓습니다.",
        "혼합물을 capsicum 절반 부분에 숟가락으로 떠 넣고 위에 cheese를 올립니다.",
        "부드러워지고 황금빛이 돌 때까지 180°C에서 30 min 동안 굽습니다."
      ]
    },
    "fr": {
      "recovery_note": "La vitamine C contenue dans les poivrons favorise la récupération des surrénales — votre système de gestion du stress a besoin d'une reconstruction sérieuse durant la première année de sobriété.",
      "ingredients": [
        "4 gros poivrons",
        "300g de bœuf haché maigre ou de dinde hachée",
        "1 tasse de riz brun cuit",
        "1 oignon, de l’ail, 1 boîte de tomates",
        "1 tasse de fromage râpé",
        "Herbes Italian herbs"
      ],
      "steps": [
        "Couper les capsicums en deux et retirer les graines.",
        "Faire revenir la viande hachée avec l'oignon et l'ail.",
        "Incorporer le riz, les tomates et les herbes.",
        "Répartir le mélange à la cuillère dans les moitiés de capsicum ; garnir de fromage.",
        "Cuire au four à 180°C pendant 30 min jusqu'à ce qu'ils soient tendres et dorés."
      ]
    },
    "it": {
      "recovery_note": "La vitamina C nei peperoni favorisce il recupero delle ghiandole surrenali: il tuo sistema di gestione dello stress ha bisogno di una profonda ricostruzione durante il primo anno di sobrietà.",
      "ingredients": [
        "4 peperoni grandi",
        "300g di carne macinata magra di manzo o tacchino",
        "1 tazza di riso integrale cotto",
        "1 cipolla, aglio, 1 lattina di pomodori",
        "1 tazza di formaggio grattugiato",
        "Erbe aromatiche Italian herbs"
      ],
      "steps": [
        "Tagliare a metà i capsicums e rimuovere i semi.",
        "Rosolare il mince con cipolla e aglio.",
        "Incorporare il riso, i tomatoes e le erbe.",
        "Riempire le metà dei capsicums con il composto; completare con il formaggio.",
        "Cuocere in forno a 180°C per 30 min fino a quando non saranno teneri e dorati."
      ]
    },
    "es": {
      "recovery_note": "La vitamina C de los pimientos favorece la recuperación de las glándulas suprarrenales; tu sistema de respuesta al estrés necesita una reconstrucción profunda durante el primer año de sobriedad.",
      "ingredients": [
        "4 capsicums grandes",
        "300g de carne picada magra de res o pavo",
        "1 taza de arroz integral cocido",
        "1 cebolla, ajo, 1 lata de tomates",
        "1 taza de queso rallado",
        "Hierbas Italian herbs"
      ],
      "steps": [
        "Cortar los capsicums por la mitad y quitar las semillas.",
        "Dorar la mince con la cebolla y el ajo.",
        "Incorporar el rice, los tomatoes y las herbs.",
        "Rellenar las mitades de capsicum con la mezcla; cubrir con cheese.",
        "Hornear a 180°C durante 30 min hasta que estén tiernos y dorados."
      ]
    }
  },
  "d15": {
    "ru": {
      "recovery_note": "Грибы — это природная аптека витамина D, жизненно важного для иммунной системы и настроения, дефицит которого часто наблюдается при длительном употреблении психоактивных веществ.",
      "ingredients": [
        "500g mixed mushrooms, нарезанных ломтиками",
        "1 onion, 2 зубчика garlic",
        "1 cup vegetable stock",
        "1/2 cup sour cream или yoghurt",
        "1 tbsp Dijon mustard, paprika",
        "Wholemeal pasta или rice"
      ],
      "steps": [
        "Обжаривайте лук 3 min, добавьте чеснок и грибы; готовьте 8 min.",
        "Вмешайте горчицу, паприку, бульон; тушите на медленном огне 8 min.",
        "Снимите с огня; добавьте сметану.",
        "Отварите пасту согласно инструкции на упаковке.",
        "Подавайте соус поверх пасты, посыпав петрушкой."
      ]
    },
    "uk": {
      "recovery_note": "Гриби — це природна аптека вітаміну D, життєво необхідного для імунної системи та настрою, дефіцит якого часто виникає при тривалому вживанні психоактивних речовин.",
      "ingredients": [
        "500g асорті грибів, нарізаних скибочками",
        "1 цибуля, 2 зубчики garlic",
        "1 склянка vegetable stock",
        "1/2 склянки сметани або йогурту",
        "1 tbsp Dijon mustard, паприка",
        "Wholemeal pasta або рис"
      ],
      "steps": [
        "Обсмажуйте цибулю протягом 3 min, додайте часник і гриби; готуйте 8 min.",
        "Вмішайте гірчицю, паприку, бульйон; тушкуйте на повільному вогні 8 min.",
        "Зніміть з вогню; вмішайте сметану.",
        "Відваріть пасту згідно з інструкцією на упаковці.",
        "Подавайте соус із пастою, посипавши петрушкою."
      ]
    },
    "ko": {
      "recovery_note": "버섯은 대자연의 비타민 D 약국과 같습니다. 면역 체계와 기분 조절에 필수적이지만, 장기간의 약물 복용 시에는 결핍되기 쉬운 영양소입니다.",
      "ingredients": [
        "500g mixed mushrooms, 슬라이스",
        "양파 1개, 마늘 2쪽",
        "vegetable stock 1컵",
        "sour cream 또는 요거트 1/2컵",
        "1 tbsp Dijon mustard, 파프리카",
        "통밀 파스타 또는 쌀"
      ],
      "steps": [
        "양파를 3 min 동안 볶다가 마늘과 버섯을 넣고 8 min 동안 더 익힙니다.",
        "머스타드, 파프리카 가루, 육수를 넣고 저어준 뒤 8 min 동안 끓입니다.",
        "불을 끄고 사워크림을 넣어 섞습니다.",
        "포장지 지침에 따라 파스타를 삶습니다.",
        "파스타 위에 소스를 붓고 파슬리를 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Les champignons sont la pharmacie naturelle en vitamine D — essentielle pour le système immunitaire et le moral, souvent déficiente lors d'une consommation de substances à long terme.",
      "ingredients": [
        "500g de champignons mélangés, émincés",
        "1 oignon, 2 gousses d'ail",
        "1 tasse de bouillon de légumes",
        "1/2 tasse de crème aigre ou de yaourt",
        "1 tbsp de moutarde de Dijon, paprika",
        "Pâtes complètes ou riz"
      ],
      "steps": [
        "Faire sauter l'oignon pendant 3 min, ajouter l'ail et les champignons ; cuire 8 min.",
        "Incorporer la moutarde, le paprika, le bouillon ; laisser mijoter 8 min.",
        "Retirer du feu ; incorporer la crème aigre.",
        "Cuire les pâtes selon les instructions du paquet.",
        "Servir la sauce sur les pâtes avec du persil."
      ]
    },
    "it": {
      "recovery_note": "I funghi sono la farmacia di vitamina D della natura — vitali per il sistema immunitario e l'umore, spesso carenti nel consumo di sostanze a lungo termine.",
      "ingredients": [
        "500g funghi misti, affettati",
        "1 cipolla, 2 spicchi d'aglio",
        "1 tazza di brodo vegetale",
        "1/2 tazza di panna acida o yoghurt",
        "1 tbsp di senape di Dijon, paprika",
        "Pasta integrale o riso"
      ],
      "steps": [
        "Soffriggere la cipolla per 3 min, aggiungere l'aglio e i funghi; cuocere per 8 min.",
        "Incorporare la senape, la paprika e il brodo; sobbollire per 8 min.",
        "Togliere dal fuoco; incorporare la panna acida.",
        "Cuocere la pasta come da confezione.",
        "Servire la salsa sopra la pasta con il prezzemolo."
      ]
    },
    "es": {
      "recovery_note": "Los hongos son la farmacia de vitamina D de la naturaleza, vitales para el sistema inmunológico y el estado de ánimo, y a menudo deficientes en el consumo de sustancias a largo plazo.",
      "ingredients": [
        "500g mixed mushrooms, en rebanadas",
        "1 onion, 2 dientes de garlic",
        "1 cup vegetable stock",
        "1/2 cup sour cream o yoghurt",
        "1 tbsp Dijon mustard, paprika",
        "Wholemeal pasta o rice"
      ],
      "steps": [
        "Saltee la cebolla 3 min, añada el ajo y los champiñones; cocine 8 min.",
        "Incorpore la mostaza, el pimentón, el caldo; cocine a fuego lento 8 min.",
        "Retire del fuego; incorpore la crema agria.",
        "Cocine la pasta según el paquete.",
        "Sirva la salsa sobre la pasta con perejil."
      ]
    }
  },
  "d16": {
    "ru": {
      "recovery_note": "Блюда, которые готовятся сами по себе, крайне важны для трезвых вечеров — заранее запланированные ужины сокращают количество свободного времени, когда тяга проявляется сильнее всего.",
      "ingredients": [
        "600g куриных бедрышек, нарезанных кубиками",
        "1 cup греческого йогурта",
        "3 tbsp tikka paste",
        "1 луковица, чеснок, имбирь",
        "1 tin нарезанных томатов",
        "Рис Basmati, наан, свежий кориандр"
      ],
      "steps": [
        "Маринуйте курицу в йогурте и пасте tikka 30 min.",
        "Выложите слоями лук, чеснок, имбирь в медленноварку; добавьте курицу и томаты.",
        "Готовьте на слабом огне (low) 4 hours.",
        "Тщательно перемешайте; проверьте приправы.",
        "Подавайте с рисом, naan и кориандром."
      ]
    },
    "uk": {
      "recovery_note": "Страви за принципом «приготував і забув» мають вирішальне значення для тверезих вечорів — заздалегідь сплановані вечері скорочують кількість вільного часу, коли тяга стає найсильнішою.",
      "ingredients": [
        "600g курячого стегна, нарізаного кубиками",
        "1 cup грецького йогурту",
        "3 tbsp tikka paste",
        "1 цибулина, часник, імбир",
        "1 tin подрібнених томатів",
        "Basmati rice, naan, свіжий коріандр"
      ],
      "steps": [
        "Маринуйте курку в йогурті та пасті tikka протягом 30 min.",
        "Викладіть шарами цибулю, часник, імбир у повільноварку; додайте курку та томати.",
        "Готуйте на низькій потужності (low) протягом 4 hours.",
        "Добре перемішайте; перевірте кількість спецій.",
        "Подавайте з рисом, naan та коріандром."
      ]
    },
    "ko": {
      "recovery_note": "미리 준비해 두는 식사는 차분한 저녁 시간을 보내기 위해 매우 중요합니다. 저녁 식사를 미리 정해두면 갈망이 가장 강하게 찾아오는 시간에 계획 없는 여유 시간을 줄일 수 있습니다.",
      "ingredients": [
        "600g chicken thigh, 깍둑썰기한 것",
        "1 cup Greek yoghurt",
        "3 tbsp tikka paste",
        "양파 1개, 마늘, 생강",
        "chopped tomatoes 1캔",
        "Basmati rice, naan, 신선한 고수"
      ],
      "steps": [
        "닭고기를 요거트와 tikka paste에 30분 동안 마리네이드합니다.",
        "슬로우 쿠커에 양파, 마늘, 생강을 층층이 쌓고 닭고기와 토마토를 넣습니다.",
        "low 단계에서 4시간 동안 조리합니다.",
        "잘 저어준 뒤 간을 확인합니다.",
        "밥, naan, 고수와 함께 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Les repas à mijoter sans surveillance sont essentiels pour les soirées sobres — les dîners prévus à l'avance réduisent le temps non structuré où les envies sont les plus fortes.",
      "ingredients": [
        "600g chicken thigh, en cubes",
        "1 cup Greek yoghurt",
        "3 tbsp tikka paste",
        "1 oignon, ail, gingembre",
        "1 boîte de chopped tomatoes",
        "Basmati rice, naan, coriandre fraîche"
      ],
      "steps": [
        "Faire mariner le poulet dans du yaourt et de la tikka paste pendant 30 min.",
        "Disposer l'oignon, l'ail et le gingembre en couches dans la mijoteuse ; ajouter le poulet et les tomates.",
        "Cuire à feu doux pendant 4 hours.",
        "Bien mélanger ; vérifier l'assaisonnement.",
        "Servir avec du riz, du naan et de la coriandre."
      ]
    },
    "it": {
      "recovery_note": "I pasti pronti senza pensieri sono fondamentali per le serate sobrie: le cene già programmate riducono il tempo non strutturato in cui le voglie colpiscono più duramente.",
      "ingredients": [
        "600g di cosce di pollo, a cubetti",
        "1 tazza di yogurt greco",
        "3 cucchiai di tikka paste",
        "1 cipolla, aglio, zenzero",
        "1 lattina di pomodori a pezzi",
        "Riso Basmati, naan, coriandolo fresco"
      ],
      "steps": [
        "Marinare il pollo nello yogurt e nella tikka paste per 30 min.",
        "Disporre a strati cipolla, aglio e zenzero nello slow cooker; aggiungere il pollo e i pomodori.",
        "Cuocere su low per 4 ore.",
        "Mescolare bene; regolare di condimento.",
        "Servire con riso, naan e coriandolo."
      ]
    },
    "es": {
      "recovery_note": "Las comidas de preparación anticipada son fundamentales para las noches de sobriedad; las cenas comprometidas de antemano reducen el tiempo sin estructura cuando los antojos atacan con más fuerza.",
      "ingredients": [
        "600g chicken thigh, en cubos",
        "1 cup Greek yoghurt",
        "3 tbsp tikka paste",
        "1 onion, garlic, ginger",
        "1 tin chopped tomatoes",
        "Basmati rice, naan, fresh coriander"
      ],
      "steps": [
        "Marinar el pollo en yoghurt y tikka paste durante 30 min.",
        "Colocar capas de onion, garlic y ginger en la slow cooker; añadir el pollo y los tomatoes.",
        "Cocinar en low durante 4 hours.",
        "Remover bien; rectificar el sazón.",
        "Servir con rice, naan y coriander."
      ]
    }
  },
  "d17": {
    "ru": {
      "recovery_note": "Низкая гликемическая нагрузка обеспечивает более стабильное настроение и прилив энергии в течение вечера — меньше шансов для резких скачков сахара, которые ошибочно принимаются за чувство голода.",
      "ingredients": [
        "300g нежирного фарша из индейки или говядины",
        "4 средних zucchinis, нарезанных спиралью",
        "1 банка marinara sauce",
        "1 луковица, чеснок, морковь",
        "Italian herbs, пармезан",
        "Olive oil, соль, перец"
      ],
      "steps": [
        "Обжаривайте лук, чеснок и морковь 5 min.",
        "Добавьте фарш; обжаривайте до золотистого цвета 5 min.",
        "Влейте соус marinara и добавьте травы; томите на медленном огне 12 min.",
        "Обжаривайте лапшу из цукини в масле 2 min.",
        "Выложите соус на лапшу и посыпьте сыром parmesan."
      ]
    },
    "uk": {
      "recovery_note": "Нижче глікемічне навантаження означає стабільніший настрій та енергію протягом вечора — менше шансів на різкі перепади рівня цукру, які помилково сприймаються як відчуття голоду.",
      "ingredients": [
        "300g нежирного фаршу з індички або яловичини",
        "4 середніх цукіні, нарізаних спіраллю",
        "1 банка соусу marinara",
        "1 цибуля, часник, морква",
        "Italian herbs, пармезан",
        "Оливкова олія, сіль, перець"
      ],
      "steps": [
        "Пасеруйте цибулю, часник та моркву протягом 5 min.",
        "Додайте фарш; обсмажуйте до коричневого кольору 5 min.",
        "Вмішайте соус marinara та трави; тушкуйте на повільному вогні 12 min.",
        "Обсмажте локшину з цукіні в олії 2 min.",
        "Викладіть соус та parmesan поверх локшини."
      ]
    },
    "ko": {
      "recovery_note": "낮은 당부하지수는 저녁 내내 기분과 에너지를 안정적으로 유지해 줍니다. 이는 가짜 식탐을 유발하는 급격한 혈당 저하 현상을 방지해 줍니다.",
      "ingredients": [
        "300g lean turkey 또는 beef mince",
        "중간 크기 zucchinis 4개, 스파이럴라이즈",
        "marinara sauce 1병",
        "onion 1개, garlic, carrot",
        "Italian herbs, parmesan",
        "Olive oil, salt, pepper"
      ],
      "steps": [
        "양파, 마늘, 당근을 5 min 동안 볶습니다.",
        "다진 고기를 넣고 5 min 동안 노릇하게 익힙니다.",
        "marinara 소스와 허브를 넣고 저어준 뒤 12 min 동안 뭉근히 끓입니다.",
        "오일을 두른 팬에 zucchini noodles를 넣고 2 min 동안 볶습니다.",
        "면 위에 소스와 parmesan 치즈를 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Une charge glycémique plus faible signifie une humeur et une énergie plus stables tout au long de la soirée — moins de risques de chutes de sucre qui imitent les fringales.",
      "ingredients": [
        "300g de dinde ou de bœuf haché maigre",
        "4 courgettes moyennes, spiralisées",
        "1 pot de sauce marinara",
        "1 oignon, ail, carotte",
        "Italian herbs, parmesan",
        "Huile d'olive, sel, poivre"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail et la carotte pendant 5 min.",
        "Ajouter la viande hachée ; faire dorer 5 min.",
        "Incorporer la sauce marinara et les herbes ; laisser mijoter 12 min.",
        "Faire sauter les nouilles de courgettes (zucchini noodles) dans l'huile pendant 2 min.",
        "Garnir les nouilles avec la sauce et le parmesan."
      ]
    },
    "it": {
      "recovery_note": "Un carico glicemico più basso garantisce un umore e un'energia più stabili durante la serata, riducendo le probabilità di cali di zuccheri che simulano il senso di fame.",
      "ingredients": [
        "300g di carne macinata magra di tacchino o manzo",
        "4 zucchine medie, spiralizzate",
        "1 barattolo di marinara sauce",
        "1 cipolla, aglio, carota",
        "Italian herbs, parmigiano",
        "Olio d'oliva, sale, pepe"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e carota per 5 min.",
        "Aggiungere il macinato; rosolare per 5 min.",
        "Incorporare la marinara e le erbe; cuocere a fuoco lento per 12 min.",
        "Saltare gli zucchini noodles nell'olio per 2 min.",
        "Guarnire i noodles con la salsa e il parmigiano."
      ]
    },
    "es": {
      "recovery_note": "Una carga glucémica más baja significa un estado de ánimo y una energía más estables durante la noche, con menos posibilidades de sufrir bajones de azúcar que simulen antojos.",
      "ingredients": [
        "300g lean turkey o beef mince",
        "4 zucchinis medianos, spiralised",
        "1 frasco de marinara sauce",
        "1 onion, garlic, carrot",
        "Italian herbs, parmesan",
        "Olive oil, salt, pepper"
      ],
      "steps": [
        "Saltee la cebolla, el ajo y la zanahoria durante 5 min.",
        "Añada la carne picada; dore durante 5 min.",
        "Incorpore la marinara y las hierbas; cocine a fuego lento durante 12 min.",
        "Saltee los fideos de calabacín en aceite durante 2 min.",
        "Cubra los fideos con la salsa y el parmesan."
      ]
    }
  },
  "d18": {
    "ru": {
      "recovery_note": "Вегетарианский ужин, богатый белком и создающий праздничное настроение — доказательство того, что",
      "ingredients": [
        "200г halloumi, нарезанного ломтиками",
        "1 чашка вареного quinoa",
        "2 чашки салатной смеси (mixed leaves)",
        "1 чашка помидоров черри",
        "1 огурец, мята",
        "Лимон, оливковое масло, семена граната"
      ],
      "steps": [
        "Обжарьте halloumi на сухой сковороде по 1 min с каждой стороны до золотистого цвета.",
        "Смешайте quinoa, листья салата, tomatoes, cucumber и mint.",
        "Взбейте lemon juice и olive oil.",
        "Выложите салат на тарелку, сверху добавьте halloumi.",
        "Посыпьте pomegranate seeds; подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Вегетаріанська вечеря, що містить багато білка та створює святковий настрій — доказ того, що",
      "ingredients": [
        "200g halloumi, нарізаного скибочками",
        "1 cup вареного кіноа",
        "2 cups міксу салатного листя",
        "1 cup томатів черрі",
        "1 огірок, м'ята",
        "Лимон, оливкова олія, зерна граната"
      ],
      "steps": [
        "Обсмажте halloumi на сухій сковорідці по 1 min з кожного боку до золотистого кольору.",
        "Перемішайте quinoa, листя салату, томати, огірок та mint.",
        "Збийте лимонний сік та olive oil.",
        "Викладіть салат на тарілку, зверху покладіть halloumi.",
        "Посипте зернами граната; подавайте."
      ]
    },
    "ko": {
      "recovery_note": "충분한 단백질을 섭취할 수 있으면서도 축제 분위기를 내주는 채식 저녁 식사입니다 — 다음이 그 증거입니다",
      "ingredients": [
        "200g halloumi, 슬라이스",
        "익힌 퀴노아 1 cup",
        "믹스 채소 2 cups",
        "방울토마토 1 cup",
        "오이 1개, 민트",
        "레몬, 올리브 오일, 석류 씨앗"
      ],
      "steps": [
        "기름을 두르지 않은 팬에 halloumi를 넣고 양면을 황금색이 될 때까지 각 1 min씩 굽습니다.",
        "quinoa, 잎채소, tomatoes, cucumber, mint를 가볍게 섞습니다.",
        "lemon juice와 olive oil을 휘저어 섞습니다.",
        "접시에 샐러드를 담고 그 위에 halloumi를 올립니다.",
        "pomegranate seeds를 뿌려 완성합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un dîner végétarien qui apporte une dose sérieuse de protéines tout en ayant un air de fête — la preuve que",
      "ingredients": [
        "200g halloumi, tranché",
        "1 cup de quinoa cuit",
        "2 cups de jeunes pousses mélangées",
        "1 cup de tomates cerises",
        "1 concombre, menthe",
        "Citron, huile d'olive, graines de grenade"
      ],
      "steps": [
        "Faire griller le halloumi dans une poêle à sec 1 min par côté jusqu'à ce qu'il soit doré.",
        "Mélanger le quinoa, les feuilles, les tomates, le concombre et la menthe.",
        "Fouetter le jus de citron et l'olive oil.",
        "Dresser la salade dans les assiettes, garnir avec le halloumi.",
        "Parsemer de graines de grenade ; servir."
      ]
    },
    "it": {
      "recovery_note": "Una cena vegetariana che apporta una buona dose di proteine e ha un'aria festosa — la prova che",
      "ingredients": [
        "200g halloumi, affettato",
        "1 tazza di quinoa cotta",
        "2 tazze di foglie miste",
        "1 tazza di pomodori ciliegino",
        "1 cetriolo, menta",
        "Limone, olio d'oliva, semi di melograno"
      ],
      "steps": [
        "Grigliare l'halloumi in una padella asciutta per 1 min per lato fino a doratura.",
        "Mescolare quinoa, foglie, pomodori, cetriolo e menta.",
        "Sbattere succo di limone e olive oil.",
        "Impiattare l'insalata e completare con l'halloumi.",
        "Cospargere con semi di melograno; servire."
      ]
    },
    "es": {
      "recovery_note": "Una cena vegetariana que aporta una buena dosis de proteínas y se siente festiva — la prueba de que",
      "ingredients": [
        "200g halloumi, en rodajas",
        "1 cup de quinoa cocida",
        "2 cups de hojas mixtas",
        "1 cup de tomates cherry",
        "1 pepino, menta",
        "Limón, aceite de oliva, semillas de granada"
      ],
      "steps": [
        "Asar el halloumi en una sartén seca 1 min por cada lado hasta que esté dorado.",
        "Mezclar quinoa, hojas, tomates, pepino y mint.",
        "Batir el jugo de limón y el olive oil.",
        "Emplatar la ensalada y colocar encima el halloumi.",
        "Espolvorear semillas de granada; servir."
      ]
    }
  },
  "es1": {
    "ru": {
      "recovery_note": "Праздничное блюдо на одной сковороде — доказательство того, что семейные обеды могут стать главным событием трезвых воскресений.",
      "ingredients": [
        "1.5 чашки риса для паэльи или круглозерного риса",
        "300g куриных бедрышек, нарезанных кубиками",
        "200g креветок",
        "1 луковица, болгарский перец, чеснок",
        "3 чашки бульона, шафран",
        "Лимон, петрушка, оливковое масло (olive oil)"
      ],
      "steps": [
        "Обжарьте курицу в сковороде для паэльи.",
        "Добавьте лук, capsicum и чеснок; готовьте 5 min.",
        "Всыпьте рис и влейте шафрановый бульон (saffron stock).",
        "Варите на медленном огне 15 min, не помешивая.",
        "Добавьте креветки в последние 5 min; дайте блюду отдохнуть перед подачей."
      ]
    },
    "uk": {
      "recovery_note": "Святкова страва в одній сковорідці — доказ того, що сімейні обіди можуть стати головною подією тверезих неділь.",
      "ingredients": [
        "1.5 склянки рису для паельї або короткозернистого рису",
        "300 г курячого стегна, нарізаного кубиками",
        "200 г креветок",
        "1 цибуля, болгарський перець (capsicum), часник",
        "3 склянки бульйону (stock), шафран",
        "Лимон, петрушка, оливкова олія"
      ],
      "steps": [
        "Обсмажте курку в сковороді для паельї.",
        "Додайте цибулю, capsicum та часник; готуйте 5 min.",
        "Всипте рис і влийте бульйон із saffron.",
        "Тушкуйте 15 min на повільному вогні, не помішуючи.",
        "Додайте креветки в останні 5 min; дайте страві відпочити перед подачею."
      ]
    },
    "ko": {
      "recovery_note": "가족과 함께하는 식사가 술 없는 일요일의 하이라이트가 될 수 있음을 증명해 주는 특별한 축하용 원팬 요리입니다.",
      "ingredients": [
        "1.5 cups 파에야 쌀 또는 단립종 쌀",
        "300g chicken thigh, 깍둑썰기한 것",
        "200g prawns",
        "onion 1개, capsicum, garlic",
        "3 cups stock, saffron",
        "Lemon, parsley, olive oil"
      ],
      "steps": [
        "paella pan에서 닭고기를 갈색이 나도록 굽습니다.",
        "onion, capsicum, garlic을 넣고 5 min 동안 익힙니다.",
        "rice와 saffron stock을 넣고 젓습니다.",
        "젓지 않은 상태로 15 min 동안 뭉근하게 끓입니다.",
        "마지막 5 min 동안 prawns를 넣고, 서빙하기 전에 휴지시킵니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat festif à faire dans une seule poêle — la preuve que les repas en famille peuvent être le moment fort des dimanches sans alcool.",
      "ingredients": [
        "1.5 cups de riz à paella ou de riz à grain court",
        "300g de haut de cuisse de poulet, coupé en dés",
        "200g de crevettes",
        "1 oignon, poivron, ail",
        "3 cups de bouillon, safran",
        "Citron, persil, huile d'olive"
      ],
      "steps": [
        "Faire dorer le poulet dans la poêle à paella.",
        "Ajouter l'oignon, le capsicum et l'ail ; cuire 5 min.",
        "Incorporer le riz et le bouillon au safran.",
        "Mijoter 15 min sans remuer.",
        "Ajouter les crevettes les 5 min restantes ; laisser reposer avant de servir."
      ]
    },
    "it": {
      "recovery_note": "Un piatto unico per le occasioni speciali: la dimostrazione che i pasti in famiglia possono essere il momento culminante delle domeniche analcoliche.",
      "ingredients": [
        "1,5 cups di riso per paella o a chicco corto",
        "300g di cosce di pollo, a cubetti",
        "200g di gamberi",
        "1 cipolla, peperone, aglio",
        "3 cups di brodo, zafferano",
        "Limone, prezzemolo, olio d'oliva"
      ],
      "steps": [
        "Rosolare il pollo nella padella per paella.",
        "Aggiungere cipolla, capsicum e aglio; cuocere per 5 min.",
        "Incorporare il riso e il brodo allo zafferano.",
        "Sobbollire per 15 min senza mescolare.",
        "Aggiungere i gamberi negli ultimi 5 min; lasciare riposare prima di servire."
      ]
    },
    "es": {
      "recovery_note": "Un plato festivo hecho en una sola sartén que demuestra que las comidas familiares pueden ser lo mejor de los domingos sin alcohol.",
      "ingredients": [
        "1.5 cups de arroz para paella o de grano corto",
        "300g de contramuslo de pollo, en cubos",
        "200g de langostinos",
        "1 cebolla, pimiento (capsicum), ajo",
        "3 cups de caldo, azafrán (saffron)",
        "Limón, perejil, aceite de oliva"
      ],
      "steps": [
        "Dore el pollo en la paellera.",
        "Añada la cebolla, el capsicum y el ajo; cocine por 5 min.",
        "Incorpore el arroz y el saffron stock.",
        "Cocine a fuego lento durante 15 min sin revolver.",
        "Añada los prawns los últimos 5 min; deje reposar antes de servir."
      ]
    }
  },
  "es2": {
    "ru": {
      "recovery_note": "Увлажняющий и богатый антиоксидантами — идеальный вариант для жаркого дня, когда алкоголь уже не в радость",
      "ingredients": [
        "1kg спелых помидоров",
        "1 огурец, 1 болгарский перец (capsicum)",
        "1 зубчик чеснока, 1/2 луковицы",
        "3 tbsp оливкового масла, 2 tbsp уксуса",
        "Соль, ледяная вода"
      ],
      "steps": [
        "Крупно нарежьте все овощи.",
        "Смешайте в блендере с garlic, oil, vinegar и salt.",
        "Добавьте ice water для достижения желаемой консистенции.",
        "Процедите для получения шелковистой текстуры.",
        "Охлаждайте 1 hour; подавайте холодным."
      ]
    },
    "uk": {
      "recovery_note": "Зволожує та насичує антиоксидантами — ідеально для спекотного дня, коли алкоголь уже набрид",
      "ingredients": [
        "1kg стиглих томатів",
        "1 огірок, 1 capsicum",
        "1 зубчик часнику, 1/2 цибулини",
        "3 tbsp оливкової олії, 2 tbsp оцту",
        "Сіль, крижана вода"
      ],
      "steps": [
        "Грубо наріжте всі овочі.",
        "Змішайте в блендері з garlic, oil, vinegar, salt.",
        "Додайте ice water для бажаної консистенції.",
        "Процідіть для шовковистої текстури.",
        "Охолоджуйте 1 hour; подавайте холодним."
      ]
    },
    "ko": {
      "recovery_note": "수분과 항산화 성분이 가득해 술이 내키지 않는 뜨거운 오후에 즐기기 좋습니다",
      "ingredients": [
        "1kg 잘 익은 토마토",
        "오이 1개, 피망 1개",
        "마늘 1쪽, 양파 1/2개",
        "올리브 오일 3 tbsp, 식초 2 tbsp",
        "소금, 얼음물"
      ],
      "steps": [
        "모든 채소를 거칠게 다집니다.",
        "garlic, oil, vinegar, salt와 함께 갈아줍니다.",
        "원하는 농도가 되도록 ice water를 추가합니다.",
        "부드러운 식감을 위해 체에 거릅니다.",
        "1 hour 동안 차갑게 식힌 후 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Hydratant et riche en antioxydants — parfait pour les après-midi chauds quand on a envie d'autre chose que de l'alcool",
      "ingredients": [
        "1kg de tomates mûres",
        "1 concombre, 1 poivron",
        "1 gousse d'ail, 1/2 oignon",
        "3 tbsp d'huile d'olive, 2 tbsp de vinaigre",
        "Sel, eau glacée"
      ],
      "steps": [
        "Hacher grossièrement tous les légumes.",
        "Mixer avec l'ail, l'huile, le vinaigre et le sel.",
        "Ajouter de l'eau glacée pour obtenir la consistance désirée.",
        "Filtrer pour obtenir une texture soyeuse.",
        "Réfrigérer 1 heure ; servir froid."
      ]
    },
    "it": {
      "recovery_note": "Idratante e ricco di antiossidanti — perfetto per i pomeriggi caldi quando non si ha voglia di alcolici",
      "ingredients": [
        "1kg di pomodori maturi",
        "1 cetriolo, 1 peperone",
        "1 spicchio d'aglio, 1/2 cipolla",
        "3 cucchiai di olio d'oliva, 2 cucchiai di aceto",
        "Sale, acqua ghiacciata"
      ],
      "steps": [
        "Tritare grossolanamente tutte le verdure.",
        "Frullare con aglio, olio, aceto, sale.",
        "Aggiungere acqua ghiacciata per la consistenza desiderata.",
        "Filtrare per una consistenza setosa.",
        "Raffreddare per 1 ora; servire freddo."
      ]
    },
    "es": {
      "recovery_note": "Hidratante y lleno de antioxidantes, perfecto para las tardes calurosas cuando el alcohol ya sobra",
      "ingredients": [
        "1kg de tomates maduros",
        "1 pepino, 1 pimiento",
        "1 diente de ajo, 1/2 cebolla",
        "3 tbsp de aceite de oliva, 2 tbsp de vinagre",
        "Sal, agua con hielo"
      ],
      "steps": [
        "Picar groseramente todas las verduras.",
        "Licuar con el ajo, aceite, vinagre y sal.",
        "Añadir agua helada para obtener la consistencia deseada.",
        "Colar para lograr una textura sedosa.",
        "Enfriar por 1 hora; servir frío."
      ]
    }
  },
  "es3": {
    "ru": {
      "recovery_note": "Блюдо из простых продуктов, которые всегда под рукой, на 4 порции — испанская домашняя кухня, максимально экономная и сытная.",
      "ingredients": [
        "4 картофелины, тонко нарезанные",
        "1 большая луковица, нарезанная кольцами",
        "6 яиц",
        "Olive oil, соль"
      ],
      "steps": [
        "Медленно обжаривайте картофель и onion в масле 20 min до мягкости.",
        "Слейте масло; смешайте с взбитыми яйцами и salt.",
        "Вылейте на горячую сковороду; готовьте 5 min.",
        "Переверните с помощью тарелки; готовьте еще 3 min.",
        "Подавайте теплым или холодным."
      ]
    },
    "uk": {
      "recovery_note": "Страва з продуктів, що завжди під рукою, на 4 особи — іспанська домашня кухня, максимально економна та поживна.",
      "ingredients": [
        "4 картоплини, нарізані тонкими скибочками",
        "1 велика цибулина, нарізана кільцями",
        "6 яєць",
        "Olive oil, сіль"
      ],
      "steps": [
        "Повільно обсмажуйте картоплю та цибулю в олії протягом 20 min до м'якості.",
        "Злийте зайву олію; змішайте зі збитими яйцями та сіллю.",
        "Вилийте на гарячу сковорідку; готуйте 5 min.",
        "Переверніть за допомогою тарілки; готуйте ще 3 min.",
        "Подавайте теплим або холодним."
      ]
    },
    "ko": {
      "recovery_note": "식재료 보관함에 늘 있는 재료로 만드는 4인분 식사 — 가장 경제적이면서도 만족스러운 스페인 가정식 요리입니다.",
      "ingredients": [
        "감자 4개, 얇게 썬 것",
        "큰 양파 1개, 채 썬 것",
        "계란 6개",
        "Olive oil, 소금"
      ],
      "steps": [
        "감자와 양파를 oil에 넣고 부드러워질 때까지 20 min 동안 천천히 볶습니다.",
        "기름기를 빼고 풀어둔 eggs와 salt를 섞습니다.",
        "달궈진 팬에 붓고 5 min 동안 익힙니다.",
        "접시를 이용해 뒤집은 뒤 3 min 더 익힙니다.",
        "따뜻하게 또는 차갑게 내놓습니다."
      ]
    },
    "fr": {
      "recovery_note": "Un repas à base de produits du placard pour 4 personnes — la cuisine familiale espagnole dans ce qu'elle a de plus économique et de plus satisfaisant.",
      "ingredients": [
        "4 pommes de terre, coupées en fines tranches",
        "1 gros oignon, émincé",
        "6 œufs",
        "Olive oil, sel"
      ],
      "steps": [
        "Faire frire lentement les pommes de terre et l'oignon dans l'huile pendant 20 min jusqu'à ce qu'ils soient tendres.",
        "Égoutter ; mélanger avec les œufs battus et le salt.",
        "Verser dans une poêle chaude ; cuire 5 min.",
        "Retourner à l'aide d'une assiette ; cuire encore 3 min.",
        "Servir chaud ou froid."
      ]
    },
    "it": {
      "recovery_note": "Un pasto preparato con ingredienti base della dispensa che sfama 4 persone — la cucina casalinga spagnola nella sua forma più economica e soddisfacente.",
      "ingredients": [
        "4 patate, tagliate a fette sottili",
        "1 cipolla grande, affettata",
        "6 uova",
        "Olive oil, sale"
      ],
      "steps": [
        "Friggere lentamente le patate e la cipolla in olio per 20 min fino a quando non saranno tenere.",
        "Scolare; mescolare con le uova sbattute e il sale.",
        "Versare in una padella calda; cuocere per 5 min.",
        "Girare con un piatto; cuocere per altri 3 min.",
        "Servire caldo o freddo."
      ]
    },
    "es": {
      "recovery_note": "Una comida con ingredientes básicos de la despensa para 4 personas — cocina casera española en su versión más económica y satisfactoria.",
      "ingredients": [
        "4 papas, finamente rebanadas",
        "1 cebolla grande, rebanada",
        "6 huevos",
        "Aceite de oliva, sal"
      ],
      "steps": [
        "Freír lentamente las patatas y la onion en aceite durante 20 min hasta que estén blandas.",
        "Escurrir; mezclar con los huevos batidos y salt.",
        "Verter en la sartén caliente; cocinar 5 min.",
        "Dar la vuelta con un plato; cocinar 3 min más.",
        "Servir caliente o frío."
      ]
    }
  },
  "es4": {
    "ru": {
      "recovery_note": "Классика испанских тапас — небольшие общие тарелки создают тот самый ритуал общения, которым всегда славились бары.",
      "ingredients": [
        "4 картофеля, нарезанного кубиками",
        "1 tin tomatoes",
        "1 tsp паприки, 1/2 tsp хлопьев чили",
        "2 зубчика чеснока",
        "Olive oil, соль, майонез"
      ],
      "steps": [
        "Запекайте картофель при 220°C в течение 25 мин до хрустящей корочки.",
        "Обжарьте чеснок; добавьте томаты, паприку и chilli.",
        "Варите на медленном огне 10 мин.",
        "Полейте картофель соусом bravas.",
        "Подавайте с mayo отдельно."
      ]
    },
    "uk": {
      "recovery_note": "Класика іспанських тапас — невеликі тарілки для спільного споживання створюють той соціальний ритуал, який колись забезпечували бари.",
      "ingredients": [
        "4 картоплини, нарізані кубиками",
        "1 банка томатів",
        "1 tsp паприки, 1/2 tsp пластівців чилі",
        "2 зубчики часнику",
        "Olive oil, сіль, mayo"
      ],
      "steps": [
        "Запікайте картоплю при 220°C протягом 25 хв до хрусткої скоринки.",
        "Обсмажте часник; додайте томати, paprika та chilli.",
        "Тушкуйте на повільному вогні 10 хв.",
        "Полийте картоплю соусом bravas.",
        "Подавайте з mayo збоку."
      ]
    },
    "ko": {
      "recovery_note": "스페인의 전형적인 타파스 요리입니다. 작게 나누어 먹는 접시들이 과거 바에서 즐기던 소셜 리추얼을 만들어냅니다.",
      "ingredients": [
        "감자 4개, 깍둑썰기",
        "캔 토마토 1개",
        "1 tsp paprika, 1/2 tsp chilli flakes",
        "마늘 2쪽",
        "Olive oil, 소금, mayo"
      ],
      "steps": [
        "감자를 220°C에서 25 min 동안 바삭해질 때까지 굽습니다.",
        "마늘을 볶다가 토마토, paprika, chilli를 넣습니다.",
        "10 min 동안 뭉근하게 끓입니다.",
        "감자 위에 bravas sauce를 뿌립니다.",
        "mayo를 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un classique des tapas espagnoles — de petites assiettes à partager qui recréent le rituel social que les bars offraient autrefois.",
      "ingredients": [
        "4 pommes de terre, coupées en dés",
        "1 boîte de tomates",
        "1 tsp paprika, 1/2 tsp flocons de piment",
        "2 gousses d'ail",
        "Olive oil, sel, mayo"
      ],
      "steps": [
        "Rôtir les pommes de terre à 220°C pendant 25 min jusqu'à ce qu'elles soient croustillantes.",
        "Faire revenir l'ail ; ajouter les tomates, le paprika et le chilli.",
        "Laisser mijoter 10 min.",
        "Arroser les pommes de terre de sauce bravas.",
        "Servir avec de la mayo à part."
      ]
    },
    "it": {
      "recovery_note": "Un classico delle tapas spagnole: piccoli piatti da condividere creano il rito sociale tipico dei bar di una volta.",
      "ingredients": [
        "4 patate, tagliate a cubetti",
        "1 latta di pomodori",
        "1 tsp di paprika, 1/2 tsp di fiocchi di peperoncino",
        "2 spicchi d'aglio",
        "Olio d'oliva, sale, mayo"
      ],
      "steps": [
        "Arrostire le patate a 220°C per 25 min finché non diventano croccanti.",
        "Soffriggere l'aglio; aggiungere i pomodori, la paprika e il chilli.",
        "Sobbollire per 10 min.",
        "Versare la salsa bravas sulle patate.",
        "Servire con mayo a parte."
      ]
    },
    "es": {
      "recovery_note": "Un clásico de las tapas españolas: los platos pequeños para compartir recrean el ritual social que solían ofrecer los bares.",
      "ingredients": [
        "4 papas, en cubos",
        "1 tin de tomates",
        "1 tsp de pimentón, 1/2 tsp de hojuelas de chile",
        "2 dientes de ajo",
        "Aceite de oliva, sal, mayo"
      ],
      "steps": [
        "Asar las patatas a 220°C durante 25 min hasta que estén crujientes.",
        "Saltear el ajo; añadir los tomates, el pimentón y el chilli.",
        "Cocinar a fuego lento durante 10 min.",
        "Rociar la salsa bravas sobre las patatas.",
        "Servir con mayo a un lado."
      ]
    }
  },
  "es5": {
    "ru": {
      "recovery_note": "Чеснок поддерживает здоровье сердечно-сосудистой системы — это важно, так как длительное употребление психоактивных веществ создает нагрузку на сердце и кровообращение.",
      "ingredients": [
        "600g куриных бедер",
        "8 зубчиков чеснока, нарезанных ломтиками",
        "1/4 cup оливкового масла",
        "1 tsp паприки, сушеный чили",
        "Лимон, петрушка, соль"
      ],
      "steps": [
        "Обжарьте курицу в масле по 8 min с каждой стороны.",
        "Добавьте чеснок, паприку, чили; готовьте 3 min.",
        "Выжмите лимон; накройте крышкой и тушите на медленном огне 10 min.",
        "Посыпьте петрушкой.",
        "Подавайте с хлебом, чтобы вымакивать сок."
      ]
    },
    "uk": {
      "recovery_note": "Часник підтримує здоров'я серцево-судинної системи — це важливо, оскільки тривале вживання психоактивних речовин дає навантаження на серце та кровообіг.",
      "ingredients": [
        "600g курячих стегон",
        "8 зубчиків часнику, нарізаних скибочками",
        "1/4 склянки оливкової олії",
        "1 tsp паприки, сушений чилі",
        "Лимон, петрушка, сіль"
      ],
      "steps": [
        "Обсмажте курку в олії по 8 min з кожного боку до золотистої скоринки.",
        "Додайте часник, paprika та chilli; готуйте 3 min.",
        "Вичавіть сік лимона; накрийте кришкою та тушкуйте на повільному вогні 10 min.",
        "Посипте зверху петрушкою.",
        "Подавайте з хлібом, щоб вмочати його в сік."
      ]
    },
    "ko": {
      "recovery_note": "마늘은 심혈관 건강을 지원합니다. 장기간의 약물 복용은 심장과 혈액 순환에 무리를 줄 수 있기 때문에 이는 매우 중요한 부분입니다.",
      "ingredients": [
        "600g chicken thighs",
        "마늘 8알, 슬라이스",
        "1/4 cup 올리브 오일",
        "1 tsp 파프리카 가루, 건조 고추",
        "레몬, 파슬리, 소금"
      ],
      "steps": [
        "닭고기를 기름에 넣고 각 면당 8 min 동안 노릇하게 굽습니다.",
        "garlic, paprika, chilli를 넣고 3 min 동안 조리합니다.",
        "lemon을 짜서 넣은 후, 뚜껑을 덮고 10 min 동안 끓입니다.",
        "위에 parsley를 올립니다.",
        "육즙을 적셔 먹을 수 있도록 bread와 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "L'ail favorise la santé cardiovasculaire — un point important car la consommation de substances à long terme sollicite le cœur et la circulation.",
      "ingredients": [
        "600g chicken thighs",
        "8 gousses d'ail, émincées",
        "1/4 cup d'huile d'olive",
        "1 tsp de paprika, piment séché",
        "Citron, persil, sel"
      ],
      "steps": [
        "Faire dorer le poulet dans l'huile 8 min par côté.",
        "Ajouter l'ail, le paprika et le chilli ; cuire 3 min.",
        "Presser le citron ; couvrir et laisser mijoter 10 min.",
        "Garnir de persil.",
        "Servir avec du pain pour éponger le jus."
      ]
    },
    "it": {
      "recovery_note": "L'aglio favorisce la salute cardiovascolare — un aspetto importante poiché l'uso prolungato di sostanze affatica il cuore e la circolazione.",
      "ingredients": [
        "600g sovraicosce di pollo",
        "8 spicchi d'aglio, affettati",
        "1/4 cup olio d'oliva",
        "1 tsp paprika, peperoncino secco",
        "Limone, prezzemolo, sale"
      ],
      "steps": [
        "Rosolare il pollo in olio per 8 min per lato.",
        "Aggiungere aglio, paprika, chilli; cuocere per 3 min.",
        "Spremere il limone; coprire e sobbollire per 10 min.",
        "Guarnire con prezzemolo.",
        "Servire con pane per raccogliere i succhi."
      ]
    },
    "es": {
      "recovery_note": "El ajo favorece la salud cardiovascular, algo importante ya que el consumo de sustancias a largo plazo estresa el corazón y la circulación.",
      "ingredients": [
        "600g chicken thighs",
        "8 dientes de ajo, laminados",
        "1/4 cup de aceite de oliva",
        "1 tsp de pimentón, chile seco",
        "Limón, perejil, sal"
      ],
      "steps": [
        "Dore el pollo en aceite 8 min por cada lado.",
        "Agregue el ajo, la paprika y el chilli; cocine por 3 min.",
        "Exprima el limón; tape y cocine a fuego lento durante 10 min.",
        "Cubra con perejil.",
        "Sirva con pan para absorber los jugos."
      ]
    }
  },
  "es6": {
    "ru": {
      "recovery_note": "Средство испанской бабушки от любых недугов — с высоким содержанием фолиевой кислоты, которая способствует выработке нейромедиаторов.",
      "ingredients": [
        "1 чашка коричневой чечевицы",
        "1 луковица, 2 зубчика чеснока",
        "1 морковь, 1 capsicum, 1 картофелина",
        "1 жестяная банка томатов",
        "Лавровый лист, паприка, кумин"
      ],
      "steps": [
        "Обжаривайте onion, garlic, carrot, capsicum 5 min.",
        "Добавьте lentils, potato, tomatoes, spices и 4 cups water.",
        "Томите на медленном огне 30 min до мягкости чечевицы.",
        "Приправьте по вкусу; удалите bay leaf.",
        "Подавайте с хрустящим хлебом."
      ]
    },
    "uk": {
      "recovery_note": "Засіб іспанської бабусі від будь-яких недуг — з високим вмістом фолатів, які підтримують вироблення нейромедіаторів.",
      "ingredients": [
        "1 склянка коричневої сочевиці",
        "1 цибулина, 2 зубчики часнику",
        "1 морква, 1 болгарський перець, 1 картоплина",
        "1 банка томатів",
        "Bay leaf, paprika, cumin"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник, моркву та солодкий перець 5 min.",
        "Додайте сочевицю, картоплю, помідори, спеції та 4 склянки води.",
        "Варіть на повільному вогні 30 min, поки сочевиця не стане м'якою.",
        "Приправте за смаком; дістаньте лавровий лист.",
        "Подавайте з хрустким хлібом."
      ]
    },
    "ko": {
      "recovery_note": "어떤 병이든 낫게 해준다는 스페인 할머니의 비법 요리입니다 — 신경전달물질 생성을 돕는 엽산이 풍부하게 함유되어 있습니다.",
      "ingredients": [
        "1 cup 브라운 렌틸콩",
        "1 onion, 2 garlic cloves",
        "1 carrot, 1 capsicum, 1 potato",
        "1 tin 토마토",
        "Bay leaf, paprika, cumin"
      ],
      "steps": [
        "양파, 마늘, 당근, capsicum을 5 min 동안 볶습니다.",
        "렌틸콩, 감자, 토마토, 향신료, 물 4 cups를 넣습니다.",
        "렌틸콩이 부드러워질 때까지 30 min 동안 뭉근하게 끓입니다.",
        "간을 맞추고 bay leaf를 제거합니다.",
        "바삭한 빵과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un remède de grand-mère espagnole pour tous vos maux — riche en folate, ce qui favorise la production de neurotransmetteurs.",
      "ingredients": [
        "1 cup lentilles brunes",
        "1 oignon, 2 gousses d'ail",
        "1 carotte, 1 capsicum, 1 pomme de terre",
        "1 conserve de tomates",
        "Feuille de laurier, paprika, cumin"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail, la carotte et le capsicum pendant 5 min.",
        "Ajouter les lentilles, la pomme de terre, les tomates, les épices et 4 cups water.",
        "Laisser mijoter 30 min jusqu'à ce que les lentilles soient tendres.",
        "Assaisonner ; retirer la feuille de laurier.",
        "Servir avec du pain croustillant."
      ]
    },
    "it": {
      "ingredients": [
        "1 cup brown lentils",
        "1 cipolla, 2 spicchi d'aglio",
        "1 carota, 1 peperone, 1 patata",
        "1 barattolo di pomodori pelati",
        "Bay leaf, paprika, cumin"
      ],
      "steps": [
        "Soffriggere cipolla, aglio, carota e peperone per 5 min.",
        "Aggiungere lenticchie, patate, pomodori, spezie e 4 cups d'acqua.",
        "Sobbollire per 30 min finché le lenticchie non saranno tenere.",
        "Condire; rimuovere la foglia di alloro.",
        "Servire con pane croccante."
      ],
      "recovery_note": "Il rimedio di una nonna spagnola per qualsiasi malanno — ricco di acido folico che favorisce la produzione di neurotrasmettitori."
    },
    "es": {
      "recovery_note": "El remedio de una abuela española para cualquier mal; con un alto contenido en folato, que favorece la producción de neurotransmisores.",
      "ingredients": [
        "1 cup lentejas marrones",
        "1 cebolla, 2 dientes de ajo",
        "1 zanahoria, 1 pimiento, 1 patata",
        "1 lata de tomates",
        "Hoja de laurel, pimentón, comino"
      ],
      "steps": [
        "Sofreír la cebolla, el ajo, la zanahoria y el capsicum por 5 min.",
        "Añadir las lentejas, la patata, los tomates, las especias y 4 cups water.",
        "Cocinar a fuego lento durante 30 min hasta que las lentejas estén tiernas.",
        "Salpimentar; retirar la hoja de laurel.",
        "Servir con pan crujiente."
      ]
    }
  },
  "es7": {
    "ru": {
      "recovery_note": "Испанский ответ рататую — овощное, сытное и очень снисходительное к начинающим кулинарам блюдо.",
      "ingredients": [
        "1 цукини, 1 баклажан, нарезанные кубиками",
        "2 capsicums, 1 луковица, нарезанные ломтиками",
        "1 tin томатов",
        "Olive oil, чеснок, паприка, соль",
        "Яйца для подачи (по желанию)"
      ],
      "steps": [
        "Обжаривайте onion и capsicum 5 min.",
        "Добавьте eggplant и zucchini; готовьте 10 min.",
        "Вмешайте tomatoes, garlic и paprika.",
        "Тушите на медленном огне 15 min.",
        "Сверху выложите fried egg по желанию."
      ]
    },
    "uk": {
      "recovery_note": "Іспанська відповідь рататую — овочева, ситна та дуже поблажлива до кухарів-початківців страва.",
      "ingredients": [
        "1 цукіні, 1 баклажан, нарізані кубиками",
        "2 солодких перці (capsicums), 1 цибуля, нарізані скибочками",
        "1 бляшанка томатів (tin tomatoes)",
        "Olive oil, часник, paprika, сіль",
        "Яйця для подачі зверху (опціонально)"
      ],
      "steps": [
        "Обсмажуйте onion та capsicum 5 min.",
        "Додайте eggplant та zucchini; готуйте 10 min.",
        "Додайте tomatoes, garlic, paprika та перемішайте.",
        "Тушкуйте на повільному вогні 15 min.",
        "За бажанням подавайте з fried egg зверху."
      ]
    },
    "ko": {
      "recovery_note": "라따뚜이의 스페인식 버전으로, 채소의 풍미가 돋보이며 포만감이 크고 요리 초보자들도 부담 없이 만들 수 있는 메뉴입니다.",
      "ingredients": [
        "쥬키니 1개, 가지 1개, 깍둑썰기",
        "피망 2개, 양파 1개, 채썰기",
        "토마토 통조림 1캔",
        "올리브 오일, 마늘, 파프리카 가루, 소금",
        "토핑용 달걀 (선택 사항)"
      ],
      "steps": [
        "양파와 capsicum을 5 min 동안 볶습니다.",
        "가지와 zucchini를 넣고 10 min 동안 익힙니다.",
        "토마토, 마늘, paprika를 넣고 젓습니다.",
        "15 min 동안 뭉근하게 끓입니다.",
        "원한다면 위에 달걀 프라이를 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "La version espagnole de la ratatouille — riche en légumes, rassasiante et très accessible pour les cuisiniers débutants.",
      "ingredients": [
        "1 courgette, 1 aubergine, coupées en dés",
        "2 poivrons, 1 oignon, émincés",
        "1 boîte de tomates",
        "Olive oil, ail, paprika, sel",
        "Œufs pour garnir (facultatif)"
      ],
      "steps": [
        "Faire revenir l'oignon et le capsicum pendant 5 min.",
        "Ajouter l'aubergine et la zucchini ; cuire 10 min.",
        "Incorporer les tomates, l'ail et le paprika.",
        "Faire mijoter 15 min.",
        "Garnir d'un œuf au plat si désiré."
      ]
    },
    "it": {
      "recovery_note": "La risposta spagnola alla ratatouille: un piatto a base di verdure, saziante e decisamente facile da preparare anche per i cuochi principianti.",
      "ingredients": [
        "1 zucchina, 1 melanzana, tagliate a cubetti",
        "2 peperoni, 1 cipolla, affettati",
        "1 tin tomatoes",
        "Olive oil, aglio, paprika, sale",
        "Uova per guarnire (opzionale)"
      ],
      "steps": [
        "Sauté onion, capsicum 5 min.",
        "Aggiungi le melanzane e le zucchine; cuoci per 10 min.",
        "Aggiungi i pomodori, l'aglio e la paprika mescolando bene.",
        "Simmer 15 min.",
        "Guarnire con un uovo fritto, se desiderato."
      ]
    },
    "es": {
      "recovery_note": "La respuesta española a la ratatouille: centrada en las verduras, saciante y muy flexible para cocineros principiantes.",
      "ingredients": [
        "1 zucchini, 1 eggplant, cubed",
        "2 capsicums, 1 onion, sliced",
        "1 lata de tomates",
        "Aceite de oliva, ajo, pimentón, sal",
        "Huevos para decorar (opcional)"
      ],
      "steps": [
        "Saltear la cebolla y el capsicum durante 5 min.",
        "Añadir la berenjena y el zucchini; cocinar 10 min.",
        "Incorporar los tomates, el ajo y la paprika.",
        "Cocinar a fuego lento durante 15 min.",
        "Decorar con un huevo frito si se desea."
      ]
    }
  },
  "es8": {
    "ru": {
      "ingredients": [
        "1 банка нута, промыть",
        "500г молодого шпината",
        "4 зубчика чеснока, нарезанных ломтиками",
        "1 ч. л. зиры, 1 ч. л. паприки",
        "Оливковое масло, соль, хересный уксус"
      ],
      "steps": [
        "Обжаривайте чеснок в масле 1 min.",
        "Добавьте cumin и paprika; подсушите до появления аромата.",
        "Добавьте нут и 1/4 cup воды; тушите на медленном огне 5 min.",
        "Вмешайте шпинат до его увядания.",
        "Завершите приготовление, добавив sherry vinegar."
      ],
      "recovery_note": "Железо из шпината плюс белок из нута за 20 минут — это блюдо, благодаря которому растительное питание кажется мощным, а не ограничивающим."
    },
    "uk": {
      "recovery_note": "Залізо зі шпинату плюс білок із нуту за 20 хвилин — саме та страва, завдяки якій рослинне харчування відчувається сповненим сили, а не обмежень.",
      "ingredients": [
        "1 бляшанка chickpeas, промитих",
        "500g baby spinach",
        "4 зубчики garlic, нарізаних скибочками",
        "1 tsp cumin, 1 tsp paprika",
        "Olive oil, salt, sherry vinegar"
      ],
      "steps": [
        "Обсмажуйте часник в олії 1 min.",
        "Додайте кумин та паприку; підсмажте.",
        "Додайте нут та 1/4 cup води; тушкуйте 5 min.",
        "Додайте шпинат і помішуйте, поки він не зів’яне.",
        "Наприкінці додайте sherry vinegar."
      ]
    },
    "ko": {
      "recovery_note": "시금치의 철분과 병아리콩의 단백질을 20분 만에 담아냈습니다. 채식이 제한적인 식단이 아니라 활력 넘치는 식사임을 느끼게 해주는 메뉴입니다.",
      "ingredients": [
        "병아리콩 1 tin, 헹궈서 준비",
        "500g baby spinach",
        "마늘 4 cloves, 슬라이스",
        "1 tsp cumin, 1 tsp paprika",
        "Olive oil, 소금, sherry vinegar"
      ],
      "steps": [
        "마늘을 오일에 1 min 동안 볶습니다.",
        "cumin과 paprika를 넣고 굽듯이 볶습니다.",
        "chickpeas와 물 1/4 cup을 넣고 5 min 동안 끓입니다.",
        "spinach를 넣고 숨이 죽을 때까지 젓습니다.",
        "sherry vinegar를 넣어 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Du fer provenant des épinards et des protéines de pois chiches en 20 minutes — le genre de repas qui rend l'alimentation végétale puissante et non restrictive.",
      "ingredients": [
        "1 boîte de pois chiches, rincés",
        "500g baby spinach",
        "4 gousses d'ail, tranchées",
        "1 tsp cumin, 1 tsp paprika",
        "Huile d'olive, sel, vinaigre de xérès"
      ],
      "steps": [
        "Faire revenir l'ail dans l'huile pendant 1 min.",
        "Ajouter le cumin et le paprika ; faire griller.",
        "Ajouter les pois chiches et 1/4 cup d'eau ; faire mijoter 5 min.",
        "Incorporer les épinards jusqu'à ce qu'ils tombent.",
        "Finir avec le vinaigre de xérès."
      ]
    },
    "it": {
      "recovery_note": "Il ferro degli spinaci e le proteine dei ceci in soli 20 minuti: il tipo di pasto che rende l’alimentazione a base vegetale un’esperienza rigenerante, non una restrizione.",
      "ingredients": [
        "1 lattina di ceci, risciacquati",
        "500g baby spinach",
        "4 spicchi d'aglio, affettati",
        "1 tsp cumino, 1 tsp paprika",
        "Olio d'oliva, sale, sherry vinegar"
      ],
      "steps": [
        "Soffriggere l'aglio nell'olio per 1 min.",
        "Aggiungere il cumin e la paprika; tostare.",
        "Aggiungere i ceci e 1/4 cup di acqua; sobbollire per 5 min.",
        "Incorporare gli spinaci finché non appassiscono.",
        "Rifinire con sherry vinegar."
      ]
    },
    "es": {
      "recovery_note": "Hierro de las espinacas más proteína de los garbanzos en 20 minutos — el tipo de comida que hace que la alimentación basada en plantas se sienta poderosa, no restrictiva.",
      "ingredients": [
        "1 lata de garbanzos, enjuagados",
        "500g baby spinach",
        "4 dientes de ajo, rebanados",
        "1 tsp comino, 1 tsp pimentón",
        "Aceite de oliva, sal, vinagre de Jerez"
      ],
      "steps": [
        "Saltee el ajo en aceite 1 min.",
        "Añada el cumin y la paprika; tueste.",
        "Añada los garbanzos y 1/4 cup de agua; cocine a fuego lento 5 min.",
        "Incorpore las espinacas hasta que se marchiten.",
        "Termine con sherry vinegar."
      ]
    }
  },
  "es9": {
    "ru": {
      "recovery_note": "Испанский завтрак за 5 минут, который обеспечит вас полифенолами, ликопином и полезными жирами — начните день правильно, пока ваша сила воли на пике.",
      "ingredients": [
        "4 ломтика sourdough",
        "1 зубчик чеснока",
        "2 спелых томата",
        "Оливковое масло Extra virgin",
        "Морская соль"
      ],
      "steps": [
        "Поджарьте хлеб.",
        "Натрите каждый ломтик зубчиком garlic.",
        "Разрежьте томаты пополам и вотрите мякоть в хлеб.",
        "Сбрызните оливковым маслом.",
        "Посыпьте sea salt; подавайте."
      ]
    },
    "uk": {
      "recovery_note": "5-хвилинний іспанський сніданок, який забезпечує організм поліфенолами, лікопіном і корисними жирами — почніть день правильно, поки ваша сила волі на піку.",
      "ingredients": [
        "4 скибочки sourdough",
        "1 зубчик часнику",
        "2 стиглих томати",
        "Extra virgin olive oil",
        "Морська сіль"
      ],
      "steps": [
        "Підсмажте хліб.",
        "Натріть кожну скибочку зубчиком часнику.",
        "Розріжте помідори навпіл і втріть м’якоть у хліб.",
        "Злегка полийте оливковою олією.",
        "Посипте морською сіллю; подавайте."
      ]
    },
    "ko": {
      "recovery_note": "폴리페놀, 라이코펜, 그리고 유익한 지방을 선사하는 5분 완성 스페인식 아침 식사입니다. 의지력이 가장 충만한 시간에 기분 좋게 하루를 시작해 보세요.",
      "ingredients": [
        "사워도우 4 슬라이스",
        "마늘 1 쪽",
        "잘 익은 토마토 2개",
        "엑스트라 버진 올리브 오일",
        "바다 소금"
      ],
      "steps": [
        "빵을 굽습니다.",
        "각 슬라이스에 garlic clove를 문지릅니다.",
        "토마토를 반으로 자르고 과육을 빵에 문지릅니다.",
        "olive oil을 뿌립니다.",
        "sea salt를 뿌려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un petit-déjeuner espagnol en 5 minutes qui apporte des polyphénols, du lycopène et de bonnes graisses — commencez la journée du bon pied quand votre volonté est à son apogée.",
      "ingredients": [
        "4 tranches de sourdough",
        "1 gousse d'ail",
        "2 tomates mûres",
        "Huile d'olive extra vierge",
        "Sea salt"
      ],
      "steps": [
        "Griller le pain.",
        "Frotter chaque tranche avec une gousse d'ail.",
        "Couper les tomates en deux et frotter la pulpe sur le pain.",
        "Arroser d'un filet d'olive oil.",
        "Saupoudrer de sea salt ; servir."
      ]
    },
    "it": {
      "recovery_note": "Una colazione spagnola pronta in 5 minuti che apporta polifenoli, licopene e grassi buoni — inizia la giornata nel modo giusto quando la forza di volontà è al massimo.",
      "ingredients": [
        "4 fette di pane sourdough",
        "1 spicchio d'aglio",
        "2 pomodori maturi",
        "Olio extra vergine di oliva",
        "Sale marino"
      ],
      "steps": [
        "Tostare il pane.",
        "Strofinare ogni fetta con lo spicchio di aglio.",
        "Dimezzare i pomodori e strofinare la polpa sul pane.",
        "Irorare con olive oil.",
        "Cospargere con sea salt; servire."
      ]
    },
    "es": {
      "recovery_note": "Un desayuno español de 5 minutos que aporta polifenoles, licopeno y grasas saludables: comienza el día de la mejor manera cuando la fuerza de voluntad está en su punto máximo.",
      "ingredients": [
        "4 rebanadas de sourdough",
        "1 diente de ajo",
        "2 tomates maduros",
        "Aceite de oliva virgen extra",
        "Sal marina"
      ],
      "steps": [
        "Tostar el pan.",
        "Frotar cada rebanada con un diente de ajo.",
        "Cortar los tomates por la mitad y frotar la pulpa en el pan.",
        "Rociar con aceite de oliva.",
        "Espolvorear con sea salt; servir."
      ]
    }
  },
  "es10": {
    "ru": {
      "recovery_note": "Обед на скорую руку за 10 минут — подобные привычки становятся тем каркасом, который помогает сохранять трезвость.",
      "ingredients": [
        "Смесь салатных листьев",
        "2 помидора, 1/2 огурца, 1/4 луковицы",
        "1 вареное яйцо, нарезанное ломтиками",
        "1 банка тунца или нута",
        "Оливки, оливковое масло, уксус, соль"
      ],
      "steps": [
        "Перемешайте листья с овощами.",
        "Сверху выложите яйцо и тунец или нут.",
        "Добавьте оливки.",
        "Взбейте оливковое масло, уксус и соль.",
        "Сбрызните заправкой и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Обід на швидку руку, який готується за 10 хвилин — саме такі звички стають основою, що оберігає тверезість.",
      "ingredients": [
        "Салатний мікс",
        "2 томати, 1/2 огірка, 1/4 цибулі",
        "1 варене яйце, нарізане скибочками",
        "1 консервна банка тунця або нуту",
        "Оливки, olive oil, оцет, сіль"
      ],
      "steps": [
        "Перемішайте листя з овочами.",
        "Зверху викладіть яйце та тунець або нут.",
        "Додайте оливки.",
        "Збийте оливкову олію, оцет та сіль.",
        "Полийте заправкою та подавайте до столу."
      ]
    },
    "ko": {
      "recovery_note": "10분이면 완성되는 단골 점심 메뉴 — 이런 습관들은 단주를 지켜주는 든든한 버팀목이 됩니다.",
      "ingredients": [
        "Mixed lettuce",
        "토마토 2개, 오이 1/2개, 양파 1/4개",
        "삶은 계란 1개, 슬라이스",
        "참치캔 1개 또는 chickpeas",
        "Olives, olive oil, vinegar, salt"
      ],
      "steps": [
        "잎채소와 채소들을 가볍게 버무립니다.",
        "그 위에 달걀과 tuna 또는 병아리콩을 올립니다.",
        "올리브를 추가합니다.",
        "olive oil, 식초, 소금을 휘저어 섞습니다.",
        "드레싱을 뿌려 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un déjeuner incontournable prêt en 10 minutes — des habitudes comme celles-ci deviennent la structure qui protège la sobriété.",
      "ingredients": [
        "Laitue mélangée",
        "2 tomates, 1/2 concombre, 1/4 d'oignon",
        "1 œuf dur, tranché",
        "1 boîte de thon ou de pois chiches",
        "Olives, huile d'olive, vinaigre, sel"
      ],
      "steps": [
        "Mélanger les feuilles avec les légumes.",
        "Garnir avec l'œuf et le thon ou les pois chiches.",
        "Ajouter les olives.",
        "Fouetter l'huile d'olive, le vinaigre et le sel.",
        "Arroser et servir."
      ]
    },
    "it": {
      "recovery_note": "Un pranzo veloce che si prepara in 10 minuti — abitudini come questa diventano la struttura che protegge la sobrietà.",
      "ingredients": [
        "Insalata mista",
        "2 pomodori, 1/2 cetriolo, 1/4 di cipolla",
        "1 uovo sodo, affettato",
        "1 scatoletta di tonno o ceci",
        "Olive, olio d'oliva, aceto, sale"
      ],
      "steps": [
        "Mescolare le foglie con le verdure.",
        "Guarnire con l'uovo e il tonno o i ceci.",
        "Aggiungere le olive.",
        "Sbattere l'olio d'oliva, l'aceto e il sale.",
        "Condire e servire."
      ]
    },
    "es": {
      "recovery_note": "Un almuerzo rápido que se prepara en 10 minutos — hábitos como estos se convierten en la estructura que protege la sobriedad.",
      "ingredients": [
        "Mezcla de lechugas",
        "2 tomates, 1/2 pepino, 1/4 cebolla",
        "1 huevo hervido, rebanado",
        "1 lata de atún o garbanzos",
        "Olivas, aceite de oliva, vinagre, sal"
      ],
      "steps": [
        "Mezcle las hojas con los vegetales.",
        "Cubra con el huevo y el atún o los garbanzos.",
        "Añada las aceitunas.",
        "Bata el aceite de oliva, el vinagre y la sal.",
        "Rocíe y sirva."
      ]
    }
  },
  "fr1": {
    "ru": {
      "recovery_note": "Классическое овощное блюдо, которое доказывает",
      "ingredients": [
        "1 баклажан, 1 цукини, нарезанные кубиками",
        "1 capsicum, 1 луковица, нарезанные ломтиками",
        "4 зубчика чеснока, 1 банка томатов",
        "Herbes de Provence, оливковое масло",
        "Соль, перец, базилик"
      ],
      "steps": [
        "Обжаривайте onion, garlic, capsicum в течение 5 min.",
        "Добавьте eggplant и zucchini; готовьте 10 min.",
        "Примешайте tomatoes и herbs.",
        "Тушите на медленном огне 20 min.",
        "Посыпьте basil; подавайте с bread или rice."
      ]
    },
    "uk": {
      "recovery_note": "Класична овочева страва, яка доводить",
      "ingredients": [
        "1 баклажан, 1 цукіні, нарізані кубиками",
        "1 capsicum, 1 цибулина, нарізані скибочками",
        "4 зубчики часнику, 1 бляшанка томатів",
        "Herbes de Provence, оливкова олія",
        "Сіль, перець, базилік"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник та capsicum 5 хв.",
        "Додайте баклажан і цукіні; готуйте 10 хв.",
        "Додайте томати та зелень.",
        "Тушкуйте на повільному вогні 20 хв.",
        "Посипте зверху базиліком; подавайте з хлібом або рисом."
      ]
    },
    "ko": {
      "recovery_note": "채소가 중심이 되는 정석적인 요리로, 그 가치를 증명하는",
      "ingredients": [
        "가지 1개, 주키니 호박 1개, 깍둑썰기",
        "캡시컴 1개, 양파 1개, 채썰기",
        "마늘 4쪽, 토마토 통조림 1캔",
        "Herbes de Provence, 올리브 오일",
        "소금, 후추, 바질"
      ],
      "steps": [
        "양파, 마늘, capsicum을 5 min 동안 볶습니다.",
        "가지와 zucchini를 넣고 10 min 동안 익힙니다.",
        "토마토와 허브를 넣고 저어줍니다.",
        "20 min 동안 뭉근하게 끓입니다.",
        "바질을 고명으로 올린 뒤 빵이나 밥과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un classique axé sur les légumes qui prouve que",
      "ingredients": [
        "1 aubergine, 1 courgette, coupées en dés",
        "1 poivron, 1 oignon, émincés",
        "4 gousses d'ail, 1 conserve de tomates",
        "Herbes de Provence, olive oil",
        "Sel, poivre, basilic"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail et le capsicum pendant 5 min.",
        "Ajouter l'aubergine et la courgette ; cuire 10 min.",
        "Incorporer les tomates et les herbes.",
        "Mijoter 20 min.",
        "Garnir de basilic ; servir avec du pain ou du riz."
      ]
    },
    "it": {
      "recovery_note": "Un classico a base di verdure che dimostra che",
      "ingredients": [
        "1 melanzana, 1 zucchina, a cubetti",
        "1 peperone, 1 cipolla, affettati",
        "4 spicchi d'aglio, 1 tin tomatoes",
        "Herbes de Provence, olio d'oliva",
        "Sale, pepe, basilico"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e capsicum per 5 min.",
        "Aggiungere melanzane e zucchine; cuocere per 10 min.",
        "Incorporare i pomodori e le erbe aromatiche.",
        "Sobbollire per 20 min.",
        "Guarnire con basilico; servire con pane o riso."
      ]
    },
    "es": {
      "recovery_note": "Un clásico centrado en los vegetales que demuestra que",
      "ingredients": [
        "1 berenjena, 1 calabacín, en cubos",
        "1 capsicum, 1 cebolla, en rodajas",
        "4 dientes de ajo, 1 lata de tomates",
        "Herbes de Provence, aceite de oliva",
        "Sal, pimienta, albahaca"
      ],
      "steps": [
        "Saltear la cebolla, el ajo y el capsicum durante 5 min.",
        "Añadir la berenjena y el calabacín; cocinar 10 min.",
        "Incorporar los tomates y las hierbas.",
        "Cocinar a fuego lento durante 20 min.",
        "Cubrir con albahaca; servir con pan o arroz."
      ]
    }
  },
  "fr2": {
    "ru": {
      "recovery_note": "Сложный салат, который вы собираете с любовью — неспешное приготовление само по себе становится своего рода медитацией.",
      "ingredients": [
        "1 банка тунца или 1 филе приготовленного лосося",
        "2 вареных яйца, разрезанных пополам",
        "200g стручковой фасоли, бланшированной",
        "6 baby potatoes, отваренных",
        "Оливки, томаты, салат латук",
        "Vinaigrette"
      ],
      "steps": [
        "Отварите яйца и картофель; бланшируйте фасоль.",
        "Разложите листья салата на блюде.",
        "Сверху выложите картофель, фасоль, яйца и тунец.",
        "Добавьте оливки и помидоры.",
        "Сбрызните винегретной заправкой."
      ]
    },
    "uk": {
      "recovery_note": "Вишуканий салат, який ви створюєте з турботою — повільне збирання стає особливою формою медитації.",
      "ingredients": [
        "1 консерва тунця або 1 готове філе лосося",
        "2 варені яйця, розрізані навпіл",
        "200g стручкової квасолі, бланшованої",
        "6 baby potatoes, відварених",
        "Оливки, томати, салат",
        "Vinaigrette"
      ],
      "steps": [
        "Відваріть яйця та картоплю; бланшуйте квасолю.",
        "Викладіть листя на тарілку.",
        "Зверху покладіть картоплю, квасолю, яйця та тунець.",
        "Додайте оливки та томати.",
        "Полийте соусом vinaigrette."
      ]
    },
    "ko": {
      "recovery_note": "정성 들여 만드는 콤포즈드 샐러드 — 천천히 재료를 쌓아가는 과정 그 자체가 하나의 명상이 됩니다.",
      "ingredients": [
        "참치 1캔 또는 조리된 연어 필레 1개",
        "삶은 달걀 2개, 절반으로 자른 것",
        "살짝 데친 그린빈 200g",
        "삶은 알감자 6개",
        "올리브, 토마토, 상추",
        "Vinaigrette"
      ],
      "steps": [
        "달걀과 감자를 삶고, 콩은 데칩니다.",
        "접시 위에 잎채소를 깔아줍니다.",
        "그 위에 감자, 콩, 달걀, tuna를 올립니다.",
        "올리브와 토마토를 더합니다.",
        "vinaigrette를 골고루 뿌립니다."
      ]
    },
    "fr": {
      "recovery_note": "Une salade composée que vous dressez avec soin — cet assemblage lent est une forme de méditation en soi.",
      "ingredients": [
        "1 boîte de thon ou 1 filet de saumon cuit",
        "2 œufs durs, coupés en deux",
        "200g de haricots verts, blanchis",
        "6 baby potatoes, bouillies",
        "Olives, tomates, laitue",
        "Vinaigrette"
      ],
      "steps": [
        "Faire bouillir les œufs et les pommes de terre ; blanchir les haricots.",
        "Disposer les feuilles sur un plat.",
        "Garnir avec les pommes de terre, les haricots, les œufs et le thon.",
        "Ajouter les olives et les tomates.",
        "Arroser de vinaigrette."
      ]
    },
    "it": {
      "recovery_note": "Un'insalata composta da costruire con cura: l'assemblaggio lento è una vera e propria forma di meditazione.",
      "ingredients": [
        "1 scatoletta di tonno o 1 filetto di salmone cotto",
        "2 uova sode, tagliate a metà",
        "200g fagiolini, sbollentati",
        "6 baby potatoes, bollite",
        "Olive, pomodori, lattuga",
        "Vinaigrette"
      ],
      "steps": [
        "Bollire le uova e le patate; sbollentare i fagiolini.",
        "Disporre le foglie su un piatto da portata.",
        "Guarnire con patate, fagiolini, uova, tonno.",
        "Aggiungere olive e pomodori.",
        "Condire con un filo di vinaigrette."
      ]
    },
    "es": {
      "recovery_note": "Una ensalada compuesta que se construye con cuidado; el montaje pausado es su propia forma de meditación.",
      "ingredients": [
        "1 lata de tuna o 1 filete de salmón cocido",
        "2 huevos duros, cortados por la mitad",
        "200g de judías verdes, escaldadas",
        "6 baby potatoes, hervidas",
        "Olivas, tomates, lechuga",
        "Vinaigrette"
      ],
      "steps": [
        "Hervir los huevos y las patatas; blanquear las judías.",
        "Disponer las hojas en una fuente.",
        "Cubrir con las patatas, las judías, los huevos y el tuna.",
        "Añadir las aceitunas y los tomates.",
        "Rociar con vinagreta."
      ]
    }
  },
  "fr3": {
    "ru": {
      "recovery_note": "Французская классика без вина — доказательство того, что французская кухня может сохранять свой неповторимый вкус даже в «трезвом» исполнении.",
      "ingredients": [
        "4 куриных бедра",
        "1 банка томатов",
        "1 луковица, 4 зубчика чеснока",
        "1/2 чашки оливок",
        "Herbes de Provence, оливковое масло",
        "Соль, перец, базилик"
      ],
      "steps": [
        "Обжарьте курицу в масле по 5 min с каждой стороны.",
        "Добавьте лук и чеснок; готовьте 3 min.",
        "Добавьте томаты, оливки и травы.",
        "Тушите на медленном огне 25 min.",
        "Украсьте базиликом; подавайте с рисом или хлебом."
      ]
    },
    "uk": {
      "recovery_note": "Французька класика без вина — доказ того, що безалкогольна французька їжа все одно має той самий неповторний французький смак.",
      "ingredients": [
        "4 курячих стегна",
        "1 банка томатів",
        "1 цибулина, 4 зубчики часнику",
        "1/2 чашки оливок",
        "Herbes de Provence, оливкова олія",
        "Сіль, перець, базилік"
      ],
      "steps": [
        "Підсмажте курку в олії по 5 min з кожного боку до золотистої скоринки.",
        "Додайте цибулю та часник; готуйте 3 min.",
        "Додайте томати, оливки та трави.",
        "Тушкуйте на повільному вогні 25 min.",
        "Посипте базиліком; подавайте з рисом або хлібом."
      ]
    },
    "ko": {
      "recovery_note": "와인이 들어가지 않은 프랑스 정통 요리 — 술을 넣지 않은 프랑스 음식이 얼마나 프랑스 요리다운 맛을 내는지 증명해 줍니다.",
      "ingredients": [
        "4 chicken thighs",
        "1 tin tomatoes",
        "1 onion, 4 garlic cloves",
        "1/2 cup olives",
        "Herbes de Provence, olive oil",
        "Salt, pepper, basil"
      ],
      "steps": [
        "기름을 두르고 닭고기를 각 면당 5 min 동안 노릇하게 굽습니다.",
        "양파와 마늘을 넣고 3 min 동안 익힙니다.",
        "토마토, 올리브, 허브를 추가합니다.",
        "25 min 동안 뭉근하게 끓입니다.",
        "바질을 고명으로 올리고 쌀밥이나 빵과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un classique français sans vin — la preuve que la cuisine française sobre garde un goût indéniablement français.",
      "ingredients": [
        "4 hauts de cuisse de poulet",
        "1 boîte de tomates",
        "1 oignon, 4 gousses d'ail",
        "1/2 cup d'olives",
        "Herbes de Provence, huile d'olive",
        "Sel, poivre, basilic"
      ],
      "steps": [
        "Faire dorer le poulet dans l'huile 5 min par face.",
        "Ajouter l'oignon et l'ail ; cuire 3 min.",
        "Ajouter les tomates, les olives et les herbes.",
        "Faire mijoter 25 min.",
        "Garnir de basilic ; servir avec du riz ou du pain."
      ]
    },
    "it": {
      "recovery_note": "Un classico francese senza vino — la prova che la cucina francese analcolica ha ancora un sapore inconfondibilmente francese.",
      "ingredients": [
        "4 cosce di pollo",
        "1 latta di pomodori",
        "1 cipolla, 4 spicchi d'aglio",
        "1/2 cup di olive",
        "Herbes de Provence, olio d'oliva",
        "Sale, pepe, basilico"
      ],
      "steps": [
        "Rosolare il pollo nell'olio per 5 min per lato.",
        "Aggiungere la cipolla e l'aglio; cuocere per 3 min.",
        "Aggiungere i pomodori, le olive e le erbe aromatiche.",
        "Sobbollire per 25 min.",
        "Guarnire con basilico; servire con riso o pane."
      ]
    },
    "es": {
      "recovery_note": "Un clásico francés sin vino: demuestra que la cocina francesa sobria sigue teniendo un sabor inconfundiblemente francés.",
      "ingredients": [
        "4 chicken thighs",
        "1 lata de tomates",
        "1 cebolla, 4 garlic cloves",
        "1/2 cup de aceitunas",
        "Herbes de Provence, olive oil",
        "Salt, pepper, albahaca"
      ],
      "steps": [
        "Dore el pollo en aceite 5 min por cada lado.",
        "Agregue la cebolla y el ajo; cocine 3 min.",
        "Agregue los tomates, las aceitunas y las hierbas.",
        "Cocine a fuego lento 25 min.",
        "Decore con albahaca; sirva con arroz o pan."
      ]
    }
  },
  "fr4": {
    "ru": {
      "recovery_note": "Терпение при карамелизации лука — это своего рода урок восстановления в миниатюре: то, что кажется медленным процессом, на самом деле является трансформацией.",
      "ingredients": [
        "4 крупные луковицы, тонко нарезанные",
        "4 чашки говяжьего или овощного бульона (beef or vegetable stock)",
        "2 tbsp сливочного масла",
        "1 tbsp соуса Worcestershire sauce",
        "4 ломтика багета (baguette)",
        "Сыр Gruyère cheese"
      ],
      "steps": [
        "Медленно карамелизируйте лук в butter 30 min.",
        "Добавьте бульон и Worcestershire; варите на медленном огне 15 min.",
        "Подсушите ломтики багета.",
        "Разлейте суп по тарелкам; сверху выложите хлеб и сыр.",
        "Запекайте на гриле, пока сыр не расплавится."
      ]
    },
    "uk": {
      "recovery_note": "Терплячість під час карамелізації цибулі — це урок відновлення в мініатюрі: те, що здається повільним, насправді є трансформацією.",
      "ingredients": [
        "4 великі цибулини, нарізані тонкими скибочками",
        "4 cups яловичого або овочевого бульйону",
        "2 tbsp вершкового масла",
        "1 tbsp Worcestershire sauce",
        "4 скибочки baguette",
        "Сир Gruyère"
      ],
      "steps": [
        "Повільно карамелізуйте цибулю у вершковому маслі протягом 30 min.",
        "Додайте бульйон та Worcestershire; варіть на повільному вогні 15 min.",
        "Підсмажте скибочки baguette.",
        "Розлийте суп у миски; зверху викладіть хліб та сир.",
        "Готуйте на грилі, поки сир не розплавиться."
      ]
    },
    "ko": {
      "recovery_note": "양파를 카라멜라이징하며 기다리는 과정은 회복의 과정을 축소해 놓은 것과 같습니다. 느리게만 보이는 그 시간은 사실 변화가 일어나는 과정입니다.",
      "ingredients": [
        "얇게 썬 큰 양파 4개",
        "소고기 또는 채소 육수 4컵",
        "버터 2 tbsp",
        "Worcestershire sauce 1 tbsp",
        "바게트 슬라이스 4개",
        "Gruyère cheese"
      ],
      "steps": [
        "양파를 butter에 30 min 동안 천천히 카라멜라이징합니다.",
        "stock과 Worcestershire 소스를 넣고 15 min 동안 끓입니다.",
        "바게트 슬라이스를 굽습니다.",
        "수프를 그릇에 담고 그 위에 빵과 치즈를 올립니다.",
        "치즈가 녹을 때까지 그릴에 굽습니다."
      ]
    },
    "fr": {
      "recovery_note": "La patience nécessaire pour caraméliser des oignons est une leçon de rétablissement en miniature — ce qui semble lent est en réalité une transformation.",
      "ingredients": [
        "4 gros oignons, finement émincés",
        "4 cups de bouillon de bœuf ou de légumes",
        "2 tbsp de beurre",
        "1 tbsp de Worcestershire sauce",
        "4 tranches de baguette",
        "Gruyère"
      ],
      "steps": [
        "Caraméliser les oignons lentement dans du beurre pendant 30 min.",
        "Ajouter le bouillon et la Worcestershire ; laisser mijoter 15 min.",
        "Griller des tranches de baguette.",
        "Verser la soupe dans des bols à la louche ; garnir avec le pain et le fromage.",
        "Griller jusqu'à ce que le fromage soit fondu."
      ]
    },
    "it": {
      "recovery_note": "La pazienza nel caramellizzare le cipolle è una lezione di guarigione in miniatura: ciò che sembra lentezza è in realtà trasformazione.",
      "ingredients": [
        "4 cipolle grandi, tagliate sottilmente",
        "4 tazze di brodo di carne o vegetale",
        "2 tbsp di burro",
        "1 tbsp di salsa Worcestershire",
        "4 fette di baguette",
        "Formaggio Gruyère"
      ],
      "steps": [
        "Caramellare le cipolle lentamente nel burro per 30 min.",
        "Aggiungere il brodo e la Worcestershire; sobbollire per 15 min.",
        "Tostare le fette di baguette.",
        "Versare la zuppa nelle ciotole con un mestolo; coprire con pane e formaggio.",
        "Grigliare finché il formaggio non si scioglie."
      ]
    },
    "es": {
      "recovery_note": "Tener paciencia al caramelizar cebollas es una lección de recuperación en miniatura: lo que parece lento es, en realidad, una transformación.",
      "ingredients": [
        "4 cebollas grandes, finamente rebanadas",
        "4 cups de caldo de res o vegetal",
        "2 tbsp de mantequilla",
        "1 tbsp de Worcestershire sauce",
        "4 rebanadas de baguette",
        "Queso Gruyère"
      ],
      "steps": [
        "Caramelice las cebollas lentamente en butter durante 30 min.",
        "Añada el caldo y Worcestershire; cocine a fuego lento 15 min.",
        "Tueste las rebanadas de baguette.",
        "Sirva la sopa en tazones; cubra con pan y queso.",
        "Cocine al grill hasta que el queso se derrita."
      ]
    }
  },
  "fr5": {
    "ru": {
      "recovery_note": "Высокобелковая, сытная французская классика — подавайте с зеленым салатом для сбалансированного обеда, который даст чувство сытости на несколько часов.",
      "ingredients": [
        "1 готовое песочное тесто (shortcrust pastry)",
        "4 яйца, 1 cup сливок",
        "150g бекона, нарезанного",
        "1 cup тертого сыра Gruyère",
        "Соль, перец, мускатный орех"
      ],
      "steps": [
        "Выложите тесто в форму для тарта и прижмите к краям.",
        "Обжарьте бекон до хрустящей корочки.",
        "Взбейте яйца, cream, соль и nutmeg.",
        "Распределите бекон и сыр по тесту.",
        "Залейте яичной смесью; выпекайте при 180°C в течение 30 min."
      ]
    },
    "uk": {
      "recovery_note": "Високобілкова ситна французька класика — подавайте із зеленим салатом для збалансованого обіду, що дасть відчуття ситості на довгі години.",
      "ingredients": [
        "1 готове пісочне тісто",
        "4 яйця, 1 cup вершків",
        "150g бекону, нарізаного",
        "1 cup тертого Gruyère",
        "Сіль, перець, мускатний горіх"
      ],
      "steps": [
        "Викладіть тісто у форму для тарта, притискаючи до дна та стінок.",
        "Підсмажте бекон до хрусткої скоринки.",
        "Збийте яйця, вершки, сіль та мускатний горіх.",
        "Розподіліть бекон та сир по тісту.",
        "Залийте яєчною сумішшю; випікайте при 180°C протягом 30 хвилин."
      ]
    },
    "ko": {
      "recovery_note": "단백질이 풍부하고 포만감이 높은 프랑스 전통 요리 — 그린 샐러드와 곁들이면 몇 시간 동안 든든함이 지속되는 균형 잡힌 점심 식사가 됩니다.",
      "ingredients": [
        "시판용 shortcrust pastry 1개",
        "달걀 4개, cream 1컵",
        "다진 bacon 150g",
        "갈아놓은 Gruyère 1컵",
        "소금, 후추, nutmeg"
      ],
      "steps": [
        "반죽을 타르트 틀에 넣고 눌러줍니다.",
        "베이컨을 바삭해질 때까지 굽습니다.",
        "달걀, 크림, 소금, nutmeg를 휘저어 섞습니다.",
        "베이컨과 치즈를 반죽 위에 골고루 뿌립니다.",
        "달걀 혼합물을 붓고 180°C에서 30분 동안 굽습니다."
      ]
    },
    "fr": {
      "recovery_note": "Un classique français rassasiant et riche en protéines — à déguster avec une salade verte pour un déjeuner équilibré qui vous calera pendant des heures.",
      "ingredients": [
        "1 pâte brisée prête à l'emploi",
        "4 eggs, 1 cup cream",
        "150g bacon, haché",
        "1 cup Gruyère râpé",
        "Sel, poivre, noix de muscade"
      ],
      "steps": [
        "Pressez la pâte dans un moule à tarte.",
        "Faites cuire le bacon jusqu'à ce qu'il soit croustillant.",
        "Fouettez les œufs, la cream, le salt et la nutmeg.",
        "Répartissez le bacon et le fromage sur la pâte.",
        "Versez le mélange d'œufs ; faites cuire à 180°C pendant 30 min."
      ]
    },
    "it": {
      "recovery_note": "Un classico francese proteico e saziante — servilo con un'insalata verde per un pranzo equilibrato che ti sazierà per ore.",
      "ingredients": [
        "1 pasta frolla pronta",
        "4 uova, 1 cup di panna",
        "150g di bacon, tritato",
        "1 cup di Gruyère grattugiato",
        "Sale, pepe, noce moscata"
      ],
      "steps": [
        "Premere la pasta in una teglia da crostata.",
        "Cuocere il bacon fino a renderlo croccante.",
        "Sbattere le uova, la panna, il sale e la noce moscata.",
        "Cospargere il bacon e il formaggio nella pasta.",
        "Versare il composto di uova; cuocere a 180°C per 30 min."
      ]
    },
    "es": {
      "recovery_note": "Un clásico francés saciante y alto en proteínas: disfrútalo con una ensalada verde para un almuerzo equilibrado que te mantendrá satisfecho durante horas.",
      "ingredients": [
        "1 masa quebrada pre-made",
        "4 huevos, 1 cup de crema",
        "150g de bacon, picado",
        "1 cup de Gruyère rallado",
        "Sal, pimienta, nuez moscada"
      ],
      "steps": [
        "Presione la masa en un molde para tarta.",
        "Cocine el tocino hasta que esté crujiente.",
        "Bata los huevos, la crema, la sal y la nuez moscada.",
        "Esparza el tocino y el queso sobre la masa.",
        "Vierta la mezcla de huevo; hornee a 180°C durante 30 min."
      ]
    }
  },
  "fr6": {
    "ru": {
      "recovery_note": "Универсальная основа — готовьте большую порцию в воскресенье, добавляйте разные начинки каждое утро в будни.",
      "ingredients": [
        "1 cup муки",
        "2 яйца",
        "1 1/2 cups молока",
        "2 tbsp растопленного сливочного масла",
        "Pinch соли",
        "Начинки: ветчина, сыр, яйца ИЛИ фрукты, мед"
      ],
      "steps": [
        "Взбейте тесто до однородности; дайте отдохнуть 30 min.",
        "Разогрейте сковороду; смажьте сливочным маслом.",
        "Налейте тонким слоем; готовьте по 1 min с каждой стороны.",
        "Наполните солеными или сладкими ингредиентами.",
        "Сложите и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Універсальна основа — готуйте велику порцію в неділю та додавайте різне наповнення щоранку в будні.",
      "ingredients": [
        "1 склянка борошна",
        "2 яйця",
        "1 1/2 склянки молока",
        "2 tbsp розтопленого вершкового масла",
        "Дрібка солі",
        "Начинки: шинка, сир, яйця АБО фрукти, мед"
      ],
      "steps": [
        "Збивайте тісто до однорідності; залиште відпочити на 30 min.",
        "Розігрійте сковорідку; змастіть вершковим маслом.",
        "Налийте тонким шаром; готуйте по 1 min з кожного боку.",
        "Наповніть несолоними або солодкими інгредієнтами.",
        "Складіть і подавайте."
      ]
    },
    "ko": {
      "recovery_note": "다용도 베이스 — 일요일에 대량으로 조리해두고, 평일 아침마다 속재료를 다르게 채워보세요.",
      "ingredients": [
        "1 cup 밀가루",
        "2 eggs",
        "1 1/2 cups 우유",
        "2 tbsp 녹인 butter",
        "소금 한 꼬집",
        "속재료: ham, cheese, eggs 또는 과일, honey"
      ],
      "steps": [
        "반죽이 매끄러워질 때까지 휘저은 다음, 30 min 동안 휴지시킵니다.",
        "팬을 가열한 뒤 버터를 붓으로 바릅니다.",
        "반죽을 얇게 붓고 한 면당 1 min씩 익힙니다.",
        "짭짤하거나 달콤한 재료들로 속을 채웁니다.",
        "접어서 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Base polyvalente — cuisinez en quantité le dimanche, garnissez différemment chaque matin de la semaine.",
      "ingredients": [
        "1 cup farine",
        "2 œufs",
        "1 1/2 cups lait",
        "2 tbsp beurre fondu",
        "Pincée de sel",
        "Garnitures : jambon, fromage, œufs OU fruits, miel"
      ],
      "steps": [
        "Fouetter la pâte jusqu'à ce qu'elle soit lisse ; laisser reposer 30 min.",
        "Chauffer une poêle ; badigeonner avec du beurre.",
        "Verser une fine couche ; cuire 1 min par côté.",
        "Garnir d'ingrédients salés ou sucrés.",
        "Plier et servir."
      ]
    },
    "it": {
      "recovery_note": "Base versatile: preparala in grandi quantità la domenica e farciscila in modo diverso ogni mattina della settimana.",
      "ingredients": [
        "1 cup di farina",
        "2 uova",
        "1 1/2 cups di latte",
        "2 tbsp di burro fuso",
        "Un pizzico di sale",
        "Farciture: prosciutto, formaggio, uova OPPURE frutta, miele"
      ],
      "steps": [
        "Sbattere la pastella fino a renderla liscia; lasciare riposare per 30 min.",
        "Scaldare una padella; spennellare con del burro.",
        "Versare uno strato sottile; cuocere per 1 min per lato.",
        "Farcire con ingredienti salati o dolci.",
        "Piegare e servire."
      ]
    },
    "es": {
      "recovery_note": "Base versátil: cocina en cantidad el domingo y rellena de forma diferente cada mañana de la semana.",
      "ingredients": [
        "1 cup harina",
        "2 eggs",
        "1 1/2 cups leche",
        "2 tbsp mantequilla derretida",
        "Pinch sal",
        "Rellenos: jamón, queso, huevos O fruta, miel"
      ],
      "steps": [
        "Batir la masa hasta que esté suave; dejar reposar 30 min.",
        "Calentar una sartén; untar con mantequilla.",
        "Verter una capa fina; cocinar 1 min por cada lado.",
        "Rellenar con ingredientes salados o dulces.",
        "Doblar y servir."
      ]
    }
  },
  "fr7": {
    "ru": {
      "recovery_note": "Салат ресторанного качества за 20 минут дома — экономия денег и отсутствие суеты, которая сопровождает походы в заведения.",
      "ingredients": [
        "Frisée или эндивий кудрявый",
        "4 rashers бекона",
        "2 яйца",
        "1 tbsp Dijon, уксус, масло",
        "1 зубчик чеснока",
        "Croutons"
      ],
      "steps": [
        "Обжарьте бекон до хрустящей корочки.",
        "Готовьте яйца пашот в течение 3 min.",
        "Взбейте Dijon, уксус и масло для винегретной заправки.",
        "Перемешайте листья салата с винегретной заправкой.",
        "Выложите сверху бекон, гренки и яйцо пашот."
      ]
    },
    "uk": {
      "recovery_note": "Салат ресторанного рівня за 20 хвилин удома — заощаджуйте гроші та уникайте черг, що бувають у закладах.",
      "ingredients": [
        "Салат Фризе або кучерявий ендивій",
        "4 скибочки bacon",
        "2 яйця",
        "1 tbsp Dijon, оцет, олія",
        "1 зубчик часнику",
        "Croutons"
      ],
      "steps": [
        "Смажте бекон до хрусткої скоринки.",
        "Готуйте яйця пашот 3 min.",
        "Збийте Dijon, оцет та олію для вінегретної заправки.",
        "Перемішайте листя салату з вінегретною заправкою.",
        "Зверху викладіть бекон, крутони та яйце пашот."
      ]
    },
    "ko": {
      "recovery_note": "집에서 20분 만에 완성하는 레스토랑 수준의 샐러드 — 외식할 때의 번거로움을 피하고 비용도 절약해 보세요.",
      "ingredients": [
        "프리제 또는 커리 엔다이브",
        "베이컨 4 rashers",
        "계란 2개",
        "1 tbsp 디종 머스터드, 식초, 오일",
        "마늘 1쪽",
        "크루통"
      ],
      "steps": [
        "베이컨을 바삭해질 때까지 굽습니다.",
        "계란을 3 min 동안 수란으로 만듭니다.",
        "Dijon, 식초, 오일을 휘저어 vinaigrette를 만듭니다.",
        "채소 잎을 vinaigrette와 함께 버무립니다.",
        "베이컨, 크루통, 수란을 위에 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Une salade de qualité restaurant en 20 minutes à la maison — pour faire des économies et éviter les contraintes liées aux sorties au restaurant.",
      "ingredients": [
        "Frisée ou chicorée frisée",
        "4 tranches de bacon",
        "2 œufs",
        "1 tbsp Dijon, vinaigre, huile",
        "1 gousse d'ail",
        "Croutons"
      ],
      "steps": [
        "Cuire le bacon jusqu'à ce qu'il soit croustillant.",
        "Pocher les œufs pendant 3 min.",
        "Fouetter la Dijon, le vinaigre et l'huile pour la vinaigrette.",
        "Mélanger les feuilles avec la vinaigrette.",
        "Garnir avec le bacon, les croûtons et l'œuf poché."
      ]
    },
    "it": {
      "recovery_note": "Insalata di qualità da ristorante in 20 minuti a casa — risparmiando denaro ed evitando lo stress che deriva dal mangiare fuori.",
      "ingredients": [
        "Frisée o indivia riccia",
        "4 rashers bacon",
        "2 uova",
        "1 tbsp Dijon, aceto, olio",
        "1 spicchio d'aglio",
        "Croutons"
      ],
      "steps": [
        "Cuocere il bacon fino a renderlo croccante.",
        "Cuocere le uova in camicia per 3 min.",
        "Sbattere Dijon, aceto e olio per la vinaigrette.",
        "Condire le foglie con la vinaigrette.",
        "Completare con bacon, crostini e l'uovo in camicia."
      ]
    },
    "es": {
      "recovery_note": "Ensalada de calidad de restaurante en 20 minutos en casa — ahorrando dinero y evitando el bullicio que conlleva salir a comer.",
      "ingredients": [
        "Frisée o escarola rizada",
        "4 rashers bacon",
        "2 huevos",
        "1 tbsp Dijon, vinagre, aceite",
        "1 diente de ajo",
        "Croutons"
      ],
      "steps": [
        "Cocine el tocino hasta que esté crujiente.",
        "Escalfe los huevos por 3 min.",
        "Batir Dijon, vinagre y aceite para la vinagreta.",
        "Mezclar las hojas con la vinagreta.",
        "Cubrir con el tocino, los crutones y el huevo escalfado."
      ]
    }
  },
  "fr8": {
    "ru": {
      "recovery_note": "Классика французского стрит-фуда, которая удовлетворяет тягу к соленому, жирному и пикантному, избавляя от необходимости искать кебаб поздно ночью.",
      "ingredients": [
        "4 ломтика цельнозернового хлеба",
        "4 ломтика ветчины",
        "100g тертого Gruyère",
        "2 tbsp сливочного масла",
        "2 tbsp муки, 1 cup молока",
        "Соль, мускатный орех"
      ],
      "steps": [
        "Приготовьте бешамель: сливочное масло, мука, молоко, соль, мускатный орех, 5 min.",
        "Намажьте хлеб соусом бешамель.",
        "Добавьте ветчину и сыр; закройте.",
        "Обжаривайте на сковороде по 3 min с каждой стороны.",
        "Подавайте горячим."
      ]
    },
    "uk": {
      "recovery_note": "Класика французької вуличної їжі, яка задовольняє потребу в поєднанні солі, жиру та насиченого смаку без необхідності шукати нічний кебаб.",
      "ingredients": [
        "4 скибочки цільнозернового хліба",
        "4 скибочки ham",
        "100g тертого Gruyère",
        "2 tbsp вершкового масла",
        "2 tbsp борошна, 1 cup молока",
        "Сіль, мускатний горіх"
      ],
      "steps": [
        "Приготуйте бешамель: вершкове масло, борошно, молоко, сіль, мускатний горіх, 5 min.",
        "Намажте хліб соусом бешамель.",
        "Додайте шинку та сир; закрийте сендвіч.",
        "Підсмажте на сковорідці по 3 min з кожного боку.",
        "Подавайте гарячим."
      ]
    },
    "ko": {
      "recovery_note": "늦은 밤 먹는 케밥 대신 짠맛, 지방, 감칠맛의 조화로 쾌락 중추를 충족시켜 줄 프랑스의 클래식한 길거리 음식입니다.",
      "ingredients": [
        "4 slices wholegrain bread",
        "4 slices ham",
        "100g grated Gruyère",
        "2 tbsp butter",
        "2 tbsp flour, 1 cup milk",
        "Salt, nutmeg"
      ],
      "steps": [
        "베샤멜 소스 만들기: 버터, 밀가루, 우유, 소금, 육두구를 넣고 5 min 동안 조리합니다.",
        "빵 위에 베샤멜 소스를 펴 바릅니다.",
        "햄과 치즈를 올리고 빵을 덮습니다.",
        "팬에서 각 면당 3 min씩 굽습니다.",
        "뜨거울 때 제공합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un grand classique de la street-food française qui comble les envies de gras, de sel et de saveurs sans avoir à passer par le kebab de fin de soirée.",
      "ingredients": [
        "4 tranches de pain complet",
        "4 tranches de jambon",
        "100g de Gruyère râpé",
        "2 tbsp de beurre",
        "2 tbsp de farine, 1 cup de lait",
        "Sel, noix de muscade"
      ],
      "steps": [
        "Préparer la béchamel : beurre, farine, lait, sel, muscade, 5 min.",
        "Tartiner le pain avec la béchamel.",
        "Ajouter le jambon et le fromage ; fermer.",
        "Toaster à la poêle 3 min par côté.",
        "Servir chaud."
      ]
    },
    "it": {
      "recovery_note": "Un classico dello street food francese che appaga la voglia di salato, grasso e saporito senza dover ricorrere a un kebab a tarda notte.",
      "ingredients": [
        "4 fette di pane integrale",
        "4 fette di prosciutto",
        "100g di Gruyère grattugiato",
        "2 tbsp di burro",
        "2 tbsp di farina, 1 cup di latte",
        "Sale, noce moscata"
      ],
      "steps": [
        "Preparare la besciamella: burro, farina, latte, sale, noce moscata, 5 min.",
        "Spalmare il pane con la besciamella.",
        "Aggiungere il prosciutto e il formaggio; chiudere.",
        "Tostare in padella 3 min per lato.",
        "Servire caldo."
      ]
    },
    "es": {
      "recovery_note": "Un clásico de la comida callejera francesa que satisface los circuitos de recompensa de sal, grasa y sabor sin necesidad del kebab nocturno.",
      "ingredients": [
        "4 rebanadas de pan integral",
        "4 lonchas de jamón",
        "100g de Gruyère rallado",
        "2 tbsp de mantequilla",
        "2 tbsp de harina, 1 cup de leche",
        "Sal, nuez moscada"
      ],
      "steps": [
        "Preparar la bechamel: mantequilla, harina, leche, sal, nuez moscada, 5 min.",
        "Untar el pan con la bechamel.",
        "Añadir el jamón y el queso; cerrar.",
        "Tostar en la sartén 3 min por cada lado.",
        "Servir caliente."
      ]
    }
  },
  "fr9": {
    "ru": {
      "recovery_note": "Ужин из 5 ингредиентов, который выглядит изысканно — та самая маленькая победа, возвращающая самоуважение на ранних этапах выздоровления.",
      "ingredients": [
        "1 лист слоеного теста",
        "4 спелых помидора, нарезанных ломтиками",
        "2 tbsp Dijon mustard",
        "100g тертого сыра",
        "Оливковое масло, базилик, соль"
      ],
      "steps": [
        "Раскатайте тесто на противне; сделайте надрезы по периметру, отступив 1cm от края.",
        "Смажьте Dijon внутреннюю часть теста, не заходя за границы.",
        "Выложите слоями томаты; посыпьте сыром.",
        "Сбрызните оливковым маслом; выпекайте при 200°C в течение 30 min.",
        "Перед подачей украсьте базиликом."
      ]
    },
    "uk": {
      "recovery_note": "Вечеря з 5 інгредієнтів, яка виглядає вишукано — саме та маленька перемога, що повертає самоповагу на ранніх етапах тверезості.",
      "ingredients": [
        "1 лист листкового тіста",
        "4 стиглих томати, нарізаних скибочками",
        "2 tbsp Dijon mustard",
        "100g тертого сиру",
        "Olive oil, базилік, сіль"
      ],
      "steps": [
        "Розкачайте тісто на деку; зробіть надрізи по краях на відстані 1cm.",
        "Змастіть Dijon всередині країв.",
        "Викладіть помідори шарами; посипте сиром.",
        "Збризніть оливковою олією; випікайте при 200°C протягом 30 min.",
        "Перед подачею прикрасьте базиліком."
      ]
    },
    "ko": {
      "recovery_note": "단 5가지 재료로 완성하는 근사한 저녁 식사 — 단주 초기에 자존감을 회복시켜 줄 소소하지만 확실한 성취입니다.",
      "ingredients": [
        "1 sheet puff pastry",
        "얇게 썬 완숙 토마토 4개",
        "2 tbsp Dijon mustard",
        "100g grated cheese",
        "Olive oil, basil, salt"
      ],
      "steps": [
        "트레이 위에 페이스트리 반죽을 펴고, 가장자리 1cm 부분에 칼집을 내세요.",
        "칼집 안쪽 영역에 Dijon 머스터드를 펴 바르세요.",
        "토마토를 겹쳐서 올린 후 치즈를 뿌리세요.",
        "올리브 오일을 뿌리고 200°C에서 30분 동안 굽습니다.",
        "서빙하기 전에 바질을 고명으로 올리세요."
      ]
    },
    "fr": {
      "recovery_note": "Un dîner avec seulement 5 ingrédients qui a de l'allure — le genre de petite victoire qui permet de regagner l'estime de soi au début de la sobriété.",
      "ingredients": [
        "1 rouleau de pâte feuilletée",
        "4 tomates bien mûres, tranchées",
        "2 tbsp de moutarde de Dijon",
        "100g de fromage râpé",
        "Huile d'olive, basilic, sel"
      ],
      "steps": [
        "Étalez la pâte sur une plaque ; marquez une bordure de 1cm.",
        "Étalez la Dijon à l'intérieur de la bordure.",
        "Disposez les tomates en couches ; saupoudrez de fromage.",
        "Arrosez d'huile d'olive ; faites cuire à 200°C pendant 30 min.",
        "Garnissez de basilic avant de servir."
      ]
    },
    "it": {
      "recovery_note": "Una cena con soli 5 ingredienti che ha un aspetto raffinato — quel tipo di piccola vittoria che ricostruisce il rispetto per se stessi nei primi tempi della sobrietà.",
      "ingredients": [
        "1 rotolo di pasta sfoglia",
        "4 pomodori maturi, a fette",
        "2 tbsp di senape di Dijon",
        "100g di formaggio grattugiato",
        "Olio d'oliva, basilico, sale"
      ],
      "steps": [
        "Stendere la pasta su una teglia; incidere un bordo di 1cm.",
        "Spalmare la Dijon all'interno del bordo.",
        "Stratificare i pomodori; spolverare con il formaggio.",
        "Versare un filo d'olio d'oliva; cuocere a 200°C per 30 min.",
        "Guarnire con basilico prima di servire."
      ]
    },
    "es": {
      "recovery_note": "Una cena de 5 ingredientes con un toque elegante: el tipo de pequeña victoria que reconstruye la autoestima al inicio de la sobriedad.",
      "ingredients": [
        "1 lámina de puff pastry",
        "4 tomates maduros, rebanados",
        "2 tbsp de mostaza Dijon",
        "100g de queso rallado",
        "Aceite de oliva, albahaca, sal"
      ],
      "steps": [
        "Extienda la masa sobre una bandeja; marque un borde de 1cm.",
        "Unte la Dijon dentro del borde.",
        "Coloque los tomates en capas; espolvoree el queso.",
        "Rocíe con aceite de oliva; hornee a 200°C durante 30 min.",
        "Cubra con albahaca antes de servir."
      ]
    }
  },
  "fr10": {
    "ru": {
      "recovery_note": "Землистые, согревающие вкусы и глубокое удовлетворение умами — грибы также являются источником витамина D, дефицит которого часто возникает после долгих лет, проведенных в помещении.",
      "ingredients": [
        "500g mushrooms, нарезанных ломтиками",
        "1 onion, 2 garlic cloves",
        "4 cups stock",
        "1/2 cup cream",
        "2 tbsp butter, тимьян, соль"
      ],
      "steps": [
        "Обжаривайте лук и garlic в butter 5 минут.",
        "Добавьте mushrooms и thyme; готовьте 10 минут.",
        "Добавьте stock; варите на медленном огне 10 минут.",
        "Измельчите блендером до однородности; вмешайте cream.",
        "Приправьте по вкусу и подавайте с bread."
      ]
    },
    "uk": {
      "recovery_note": "Землисті, глибокі смаки та задоволення від умамі — гриби також є джерелом вітаміну D, дефіцит якого часто виникає після тривалого перебування в приміщенні.",
      "ingredients": [
        "500g mushrooms, нарізаних скибками",
        "1 onion, 2 garlic cloves",
        "4 cups stock",
        "1/2 cup cream",
        "2 tbsp butter, чебрець, сіль"
      ],
      "steps": [
        "Пасеруйте цибулю та часник у butter 5 min.",
        "Додайте гриби та thyme; готуйте 10 min.",
        "Додайте stock; тушкуйте на повільному вогні 10 min.",
        "Збийте до однорідності; вмішайте cream.",
        "Приправте та подавайте з хлібом."
      ]
    },
    "ko": {
      "recovery_note": "흙 내음 가득한 풍미와 깊은 감칠맛을 선사하는 버섯은 실내 생활로 인해 부족해지기 쉬운 비타민 D를 보충해 줍니다.",
      "ingredients": [
        "500g mushrooms, 슬라이스",
        "onion 1개, garlic cloves 2알",
        "stock 4컵",
        "cream 1/2컵",
        "butter 2 tbsp, thyme, salt"
      ],
      "steps": [
        "양파와 마늘을 butter에 5 min 동안 볶습니다.",
        "버섯과 thyme을 넣고 10 min 동안 익힙니다.",
        "육수를 붓고 10 min 동안 끓입니다.",
        "부드럽게 갈아준 뒤 cream을 넣고 섞습니다.",
        "간을 맞추고 빵과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Des saveurs terreuses et apaisantes et une satisfaction umami — les champignons apportent également de la vitamine D, dont on manque souvent après des années passées à l'intérieur.",
      "ingredients": [
        "500g mushrooms, émincés",
        "1 onion, 2 gousses de garlic",
        "4 cups de stock",
        "1/2 cup de cream",
        "2 tbsp de butter, thyme, salt"
      ],
      "steps": [
        "Faire revenir l'oignon et l'ail dans le butter pendant 5 min.",
        "Ajouter les champignons et le thyme ; cuire 10 min.",
        "Ajouter le stock ; faire mijoter 10 min.",
        "Mixer jusqu'à l'obtention d'une texture lisse ; incorporer la cream.",
        "Assaisonner et servir avec du pain."
      ]
    },
    "it": {
      "recovery_note": "Sapori terrosi e radicanti e soddisfazione umami — i funghi forniscono anche vitamina D, spesso carente dopo anni trascorsi al chiuso.",
      "ingredients": [
        "500g funghi, affettati",
        "1 cipolla, 2 spicchi d'aglio",
        "4 tazze di brodo",
        "1/2 tazza di panna",
        "2 tbsp burro, timo, sale"
      ],
      "steps": [
        "Soffriggere la cipolla e l'aglio nel burro per 5 min.",
        "Aggiungere i funghi e il timo; cuocere per 10 min.",
        "Aggiungere il brodo; sobbollire per 10 min.",
        "Frullare fino a ottenere un composto omogeneo; incorporare la panna.",
        "Condire e servire con il pane."
      ]
    },
    "es": {
      "recovery_note": "Sabores terrosos y reconfortantes y una satisfacción umami: los champiñones también aportan vitamina D, que suele ser deficiente tras años en interiores.",
      "ingredients": [
        "500g mushrooms, rebanados",
        "1 onion, 2 garlic cloves",
        "4 cups stock",
        "1/2 cup cream",
        "2 tbsp butter, tomillo, sal"
      ],
      "steps": [
        "Saltee la cebolla y el ajo en butter durante 5 min.",
        "Añada los champiñones y el thyme; cocine por 10 min.",
        "Añada el stock; cocine a fuego lento 10 min.",
        "Licúe hasta que esté suave; incorpore la cream.",
        "Sazone y sirva con pan."
      ]
    }
  },
  "it1": {
    "ru": {
      "recovery_note": "Самая простая итальянская классика и основной продукт средиземноморского рациона с доказанной пользой — доступно, практично и по-домашнему уютно.",
      "ingredients": [
        "400g spaghetti",
        "1 банка томатов San Marzano",
        "4 зубчика чеснока, нарезанных ломтиками",
        "1/4 чашки оливкового масла",
        "Свежий базилик, соль",
        "Пармезан (по желанию)"
      ],
      "steps": [
        "Сварите пасту согласно инструкции на упаковке.",
        "Обжаривайте чеснок в масле 1 min.",
        "Добавьте томаты; варите на медленном огне 15 min.",
        "Перемешайте с готовой пастой.",
        "Украсьте базиликом."
      ]
    },
    "uk": {
      "recovery_note": "Найпростіша італійська класика та найперевіреніша основа середземноморського раціону — доступна, легка у приготуванні та затишна.",
      "ingredients": [
        "400g spaghetti",
        "1 бляшанка томатів San Marzano",
        "4 зубчики часнику, нарізані слайсами",
        "1/4 склянки оливкової олії",
        "Свіжий базилік, сіль",
        "Пармезан за бажанням"
      ],
      "steps": [
        "Приготуйте пасту згідно з інструкцією на упаковці.",
        "Обсмажте часник в олії протягом 1 min.",
        "Додайте томати; тушкуйте на повільному вогні 15 min.",
        "Перемішайте з готовою пастою.",
        "Посипте зверху базиліком."
      ]
    },
    "ko": {
      "recovery_note": "가장 단순한 이탈리아의 클래식이자 지중해 식단의 핵심인 최고의 요리입니다. 저렴한 재료로 누구나 반복해서 만들 수 있는 편안한 맛을 선사합니다.",
      "ingredients": [
        "400g spaghetti",
        "1 tin San Marzano tomatoes",
        "마늘 4쪽, 슬라이스",
        "1/4 cup olive oil",
        "생 바질, 소금",
        "Parmesan (선택 사항)"
      ],
      "steps": [
        "포장지 지침에 따라 파스타를 삶습니다.",
        "오일에 마늘을 1 min 동안 볶습니다.",
        "토마토를 넣고 15 min 동안 뭉근하게 끓입니다.",
        "삶은 파스타를 넣고 버무립니다.",
        "바질을 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Le plus simple des classiques italiens et l'aliment de base méditerranéen par excellence — abordable, facile à refaire, réconfortant.",
      "ingredients": [
        "400g spaghetti",
        "1 boîte de tomates San Marzano",
        "4 gousses d'ail, tranchées",
        "1/4 cup d'huile d'olive",
        "Basilic frais, sel",
        "Parmesan (optionnel)"
      ],
      "steps": [
        "Cuire les pâtes selon les instructions du paquet.",
        "Faire sauter l'ail dans l'huile pendant 1 min.",
        "Ajouter les tomates ; laisser mijoter 15 min.",
        "Mélanger avec les pâtes cuites.",
        "Garnir de basilic."
      ]
    },
    "it": {
      "recovery_note": "Il classico italiano più semplice e l'alimento base della dieta mediterranea con le maggiori evidenze scientifiche: economico, replicabile, confortante.",
      "ingredients": [
        "400g spaghetti",
        "1 latta di pomodori San Marzano",
        "4 spicchi d'aglio, affettati",
        "1/4 cup di olio d'oliva",
        "Basilico fresco, sale",
        "Parmigiano opzionale"
      ],
      "steps": [
        "Cuocere la pasta secondo la confezione.",
        "Soffriggere l'aglio in olio per 1 min.",
        "Aggiungere i pomodori; cuocere a fuoco lento per 15 min.",
        "Mescolare con la pasta cotta.",
        "Guarnire con basilico."
      ]
    },
    "es": {
      "recovery_note": "El clásico italiano más sencillo y el alimento básico mediterráneo con mayor evidencia: económico, repetible y reconfortante.",
      "ingredients": [
        "400g spaghetti",
        "1 lata de tomates San Marzano",
        "4 dientes de ajo, rebanados",
        "1/4 cup de aceite de oliva",
        "Albahaca fresca, sal",
        "Parmesan opcional"
      ],
      "steps": [
        "Cocine la pasta según el paquete.",
        "Saltee el ajo en aceite 1 min.",
        "Añada los tomates; cocine a fuego lento 15 min.",
        "Mezcle con la pasta cocida.",
        "Cubra con albahaca."
      ]
    }
  },
  "it2": {
    "ru": {
      "recovery_note": "Медленное помешивание ризотто — это медитативный ритуал, практика осознанности, итогом которой становится ужин.",
      "ingredients": [
        "1 чашка риса арборио",
        "500г грибов, нарезанных ломтиками",
        "1 луковица, 2 зубчика чеснока",
        "4 чашки теплого овощного бульона",
        "Пармезан, сливочное масло, оливковое масло"
      ],
      "steps": [
        "Обжаривайте onion и mushrooms 8 min.",
        "Добавьте rice; обжаривайте 1 min.",
        "Добавляйте stock по одному половнику за раз, помешивая.",
        "Через 18 min rice станет кремообразным.",
        "Вмешайте butter и Parmesan."
      ]
    },
    "uk": {
      "recovery_note": "Повільне помішування різотто — це медитативний ритуал, усвідомленість, нагородою за яку стає вечеря.",
      "ingredients": [
        "1 склянка рису arborio",
        "500г грибів, нарізаних скибочками",
        "1 цибулина, 2 зубчики часнику",
        "4 склянки теплого vegetable stock",
        "Parmesan, вершкове масло, оливкова олія"
      ],
      "steps": [
        "Обсмажуйте цибулю та гриби 8 min.",
        "Додайте рис; підсмажуйте 1 min.",
        "Додавайте бульйон по одному черпаку за раз, помішуючи.",
        "Через 18 min рис стане кремовим.",
        "Вмішайте вершкове масло та Parmesan."
      ]
    },
    "ko": {
      "recovery_note": "리조또를 천천히 젓는 과정은 명상의 시간과도 같습니다. 요리를 마칠 때쯤이면 마음의 평온과 저녁 식사를 동시에 얻게 될 것입니다.",
      "ingredients": [
        "1 cup arborio rice",
        "500g mushrooms, sliced",
        "1 onion, 2 garlic cloves",
        "4 cups warm vegetable stock",
        "Parmesan, butter, olive oil"
      ],
      "steps": [
        "양파와 버섯을 8 min 동안 볶습니다.",
        "쌀을 넣고 1 min 동안 토스트하듯 볶습니다.",
        "육수를 한 국자씩 넣으며 저어줍니다.",
        "18 min 후에 쌀이 크림처럼 부드러워집니다.",
        "버터와 Parmesan 치즈를 넣고 섞어줍니다."
      ]
    },
    "fr": {
      "recovery_note": "Le remuage lent du risotto est un rituel méditatif — une pleine conscience avec un dîner à la clé.",
      "ingredients": [
        "1 cup riz arborio",
        "500g champignons, émincés",
        "1 oignon, 2 gousses d'ail",
        "4 cups bouillon de légumes chaud",
        "Parmesan, beurre, huile d'olive"
      ],
      "steps": [
        "Faire sauter l'oignon et les champignons pendant 8 min.",
        "Ajouter le riz ; torréfier 1 min.",
        "Ajouter le bouillon une louche à la fois, en remuant.",
        "Après 18 min, le riz est crémeux.",
        "Incorporer le beurre et le Parmesan."
      ]
    },
    "it": {
      "recovery_note": "Mescolare lentamente il risotto è un rito meditativo: consapevolezza con la cena alla fine.",
      "ingredients": [
        "1 tazza di riso arborio",
        "500g di funghi, affettati",
        "1 cipolla, 2 spicchi d'aglio",
        "4 tazze di brodo vegetale caldo",
        "Parmigiano, burro, olio d'oliva"
      ],
      "steps": [
        "Soffriggere la cipolla e i funghi per 8 min.",
        "Aggiungere il riso; tostare per 1 min.",
        "Aggiungere il brodo un mestolo alla volta, mescolando.",
        "Dopo 18 min il riso risulterà cremoso.",
        "Mantecare con burro e Parmesan."
      ]
    },
    "es": {
      "recovery_note": "El remover lentamente el risotto es un ritual meditativo: atención plena con una cena al final.",
      "ingredients": [
        "1 cup arroz arborio",
        "500g champiñones, laminados",
        "1 cebolla, 2 dientes de ajo",
        "4 cups caldo de verduras tibio",
        "Parmesan, mantequilla, aceite de oliva"
      ],
      "steps": [
        "Saltear la cebolla y los mushrooms 8 min.",
        "Añadir el arroz; tostar 1 min.",
        "Añadir el stock un cucharón a la vez, removiendo.",
        "Después de 18 min el arroz estará cremoso.",
        "Incorporar la mantequilla y el Parmesan."
      ]
    }
  },
  "it3": {
    "ru": {
      "recovery_note": "Восемь различных овощей в одной миске — антиоксидантное разнообразие способствует восстановлению мозга после длительного повреждения психоактивными веществами.",
      "ingredients": [
        "1 луковица, 2 моркови, 2 сельдерея, нарезанные кубиками",
        "2 зубчика чеснока, 1 цукини, 1 картофелина",
        "1 банка томатов, 1 банка фасоли",
        "1/2 чашки мелкой пасты",
        "6 чашек бульона, травы"
      ],
      "steps": [
        "Обжаривайте лук, морковь, сельдерей и чеснок 5 min.",
        "Добавьте остальные овощи, томаты, бульон и травы.",
        "Варите на медленном огне 20 min.",
        "Добавьте фасоль и пасту; варите еще 10 min.",
        "Посыпьте сверху сыром пармезан."
      ]
    },
    "uk": {
      "recovery_note": "Вісім різних овочів в одній тарілці — антиоксидантне розмаїття сприяє відновленню мозку після тривалого пошкодження речовинами.",
      "ingredients": [
        "1 цибулина, 2 моркви, 2 селери, нарізані кубиками",
        "2 зубчики часнику, 1 цукіні, 1 картоплина",
        "1 бляшанка томатів, 1 бляшанка квасолі",
        "1/2 чашки дрібної пасти",
        "6 чашок stock, трави"
      ],
      "steps": [
        "Обсмажуйте цибулю, моркву, селеру та часник протягом 5 min.",
        "Додайте решту овочів, томати, stock та трави.",
        "Тушкуйте на повільному вогні 20 min.",
        "Додайте квасолю та pasta; готуйте ще 10 min.",
        "Посипте зверху parmesan."
      ]
    },
    "ko": {
      "recovery_note": "한 그릇에 담긴 8가지 채소의 항산화 성분은 장기간의 약물 손상 후 뇌 회복을 돕습니다.",
      "ingredients": [
        "양파 1개, 당근 2개, 셀러리 2개, 깍둑썰기",
        "마늘 2쪽, 주키니 1개, 감자 1개",
        "토마토 통조림 1캔, 콩 통조림 1캔",
        "숏 파스타 1/2컵",
        "육수 6컵, 허브"
      ],
      "steps": [
        "양파, 당근, 셀러리, 마늘을 5 min 동안 볶습니다.",
        "나머지 채소, 토마토, 육수(stock), 허브를 넣습니다.",
        "20 min 동안 뭉근하게 끓입니다.",
        "콩과 파스타를 넣고 10 min 더 조리합니다.",
        "파마산(parmesan) 치즈를 위에 뿌려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Huit légumes différents dans un seul bol — cette variété d'antioxydants favorise la réparation cérébrale après des dommages liés à une consommation de substances à long terme.",
      "ingredients": [
        "1 oignon, 2 carottes, 2 céleris, coupés en dés",
        "2 gousses d'ail, 1 courgette, 1 pomme de terre",
        "1 conserve de tomates, 1 conserve de haricots",
        "1/2 cup de petites pâtes",
        "6 cups de bouillon, herbes"
      ],
      "steps": [
        "Faire sauter l'oignon, la carotte, le céleri et l'ail pendant 5 min.",
        "Ajouter le reste des légumes, les tomates, le bouillon et les herbes.",
        "Laisser mijoter 20 min.",
        "Ajouter les haricots et les pâtes ; cuire encore 10 min.",
        "Garnir de parmesan."
      ]
    },
    "it": {
      "recovery_note": "Otto verdure diverse in una sola ciotola: la varietà di antiossidanti favorisce la rigenerazione cerebrale dopo i danni causati dall'uso prolungato di sostanze.",
      "ingredients": [
        "1 cipolla, 2 carote, 2 coste di sedano, a dadini",
        "2 spicchi d'aglio, 1 zucchina, 1 patata",
        "1 lattina di pomodori, 1 lattina di fagioli",
        "1/2 cup di pasta piccola",
        "6 cups di brodo, erbe aromatiche"
      ],
      "steps": [
        "Soffriggere cipolla, carota, sedano e aglio per 5 min.",
        "Aggiungere le restanti verdure, i pomodori, il brodo e le erbe aromatiche.",
        "Sobbollire per 20 min.",
        "Aggiungere i fagioli e la pasta; cuocere per altri 10 min.",
        "Guarnire con parmesan."
      ]
    },
    "es": {
      "recovery_note": "Ocho verduras diferentes en un solo bol: la variedad de antioxidantes favorece la reparación cerebral tras el daño causado por sustancias a largo plazo.",
      "ingredients": [
        "1 cebolla, 2 zanahorias, 2 apios, en cubos",
        "2 dientes de ajo, 1 calabacín, 1 patata",
        "1 lata de tomates, 1 lata de judías",
        "1/2 taza de pasta pequeña",
        "6 tazas de caldo, hierbas"
      ],
      "steps": [
        "Sofreír la cebolla, la zanahoria, el apio y el ajo durante 5 min.",
        "Añadir el resto de las verduras, los tomates, el stock y las hierbas.",
        "Cocinar a fuego lento durante 20 min.",
        "Añadir los frijoles y la pasta; cocinar 10 min más.",
        "Cubrir con queso parmesan."
      ]
    }
  },
  "it4": {
    "ru": {
      "recovery_note": "Классическое римское блюдо в правильном исполнении — высокое содержание белка, сытость и доказательство того, что комфортная еда способствует восстановлению, а не препятствует ему.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta или бекона",
        "4 яичных желтка, 1 целое яйцо",
        "1 cup тертого Pecorino",
        "Черный перец, соль"
      ],
      "steps": [
        "Отварите пасту; зарезервируйте 1/2 cup воды от варки.",
        "Обжарьте pancetta на сковороде до хрустящей корочки.",
        "Взбейте яйца и Pecorino.",
        "Снимите сковороду с огня и смешайте горячую пасту с pancetta.",
        "Влейте яичную смесь и воду от пасты, помешивая до образования кремового соуса."
      ]
    },
    "uk": {
      "recovery_note": "Римська класика у правильному виконанні — з високим вмістом білка, поживна, вона доводить, що комфортна їжа є частиною відновлення, а не суперечить йому.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta або бекону",
        "4 яєчних жовтки, 1 ціле яйце",
        "1 cup тертого Pecorino",
        "Чорний перець, сіль"
      ],
      "steps": [
        "Відваріть пасту; залиште 1/2 склянки води, в якій вона варилася.",
        "Підсмажте панчетту на сковороді до хрусткої скоринки.",
        "Збийте яйця та сир Pecorino.",
        "Зніміть сковорідку з вогню та змішайте гарячу пасту з панчеттою.",
        "Влийте яєчну суміш і воду від пасти, постійно помішуючи до утворення кремового соусу."
      ]
    },
    "ko": {
      "recovery_note": "제대로 만든 로마의 고전 요리 — 고단백에 만족감까지 더해진 이 음식은 소울 푸드가 회복을 방해하는 것이 아니라 그 과정의 일부라는 점을 보여줍니다.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta 또는 bacon",
        "계란 노른자 4개, 전란 1개",
        "갈아낸 Pecorino 1컵",
        "후추, 소금"
      ],
      "steps": [
        "파스타를 삶고 면수 1/2 cup을 따로 보관해 둡니다.",
        "팬에 pancetta를 넣고 바삭하게 굽습니다.",
        "달걀과 Pecorino 치즈를 잘 섞어 휘푑니다.",
        "불을 끈 상태에서 뜨거운 파스타 면을 pancetta와 함께 버무립니다.",
        "크리미한 소스가 되도록 달걀 혼합물과 면수를 넣고 잘 섞어줍니다."
      ]
    },
    "fr": {
      "recovery_note": "Un classique romain revisité — riche en protéines, rassasiant, et la preuve que le réconfort fait partie intégrante du rétablissement, sans s'y opposer.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta ou bacon",
        "4 jaunes d'œufs, 1 œuf entier",
        "1 cup de Pecorino râpé",
        "Poivre noir, sel"
      ],
      "steps": [
        "Cuisez les pâtes ; réservez 1/2 cup d'eau de cuisson.",
        "Faites dorer la pancetta dans une poêle jusqu'à ce qu'elle soit croustillante.",
        "Fouettez les œufs et le Pecorino.",
        "Mélangez les pâtes chaudes avec la pancetta hors du feu.",
        "Incorporez le mélange d'œufs et l'eau des pâtes pour obtenir une sauce crémeuse."
      ]
    },
    "it": {
      "recovery_note": "Un classico romano fatto a regola d'arte: proteico, appagante e la prova che il comfort food fa parte del percorso di guarigione, non è contro di esso.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta o bacon",
        "4 tuorli d'uovo, 1 uovo intero",
        "1 cup di Pecorino grattugiato",
        "Pepe nero, sale"
      ],
      "steps": [
        "Cuocere la pasta; conservare 1/2 cup di acqua di cottura.",
        "Rendere croccante la pancetta in padella.",
        "Sbattere le uova e il Pecorino.",
        "Saltare la pasta calda con la pancetta fuori dal fuoco.",
        "Incorporare il composto di uova e l'acqua della pasta per una salsa cremosa."
      ]
    },
    "es": {
      "recovery_note": "Un clásico romano bien hecho: alto en proteínas, saciante y una muestra de que la comida reconfortante es parte de la recuperación, no algo opuesto a ella.",
      "ingredients": [
        "400g spaghetti",
        "150g pancetta o bacon",
        "4 yemas de huevo, 1 huevo entero",
        "1 taza de Pecorino rallado",
        "Pimienta negra, sal"
      ],
      "steps": [
        "Cocine la pasta; reserve 1/2 cup del agua de cocción.",
        "Dore la pancetta en una sartén hasta que esté crujiente.",
        "Batas los huevos y el Pecorino.",
        "Mezcle la pasta caliente con la pancetta fuera del fuego.",
        "Incorpore la mezcla de huevo y el agua de la pasta para obtener una salsa cremosa."
      ]
    }
  },
  "it5": {
    "ru": {
      "recovery_note": "Вечер пиццы дома заменяет пиццу с пивом в пабе — небольшая перемена, которая еженедельно защищает вашу трезвость.",
      "ingredients": [
        "Тесто для пиццы (покупное или домашнее)",
        "1/2 чашки томатного соуса passata",
        "200g свежей моцареллы, нарезанной ломтиками",
        "Свежий базилик",
        "Olive oil, соль"
      ],
      "steps": [
        "Разогрейте духовку до 240°C.",
        "Раскатайте тесто на присыпанной мукой поверхности.",
        "Распределите passata; добавьте моцареллу.",
        "Выпекайте 10–12 минут, пока корочка не станет хрустящей.",
        "Сверху выложите базилик и сбрызните оливковым маслом."
      ]
    },
    "uk": {
      "recovery_note": "Вечір піци вдома замість піци з пивом у пабі — це невелика зміна, що щотижня оберігає вашу тверезість.",
      "ingredients": [
        "Тісто для піци (магазинне або домашнє)",
        "1/2 cup томатної passata",
        "200g свіжої mozzarella, нарізаної скибочками",
        "Свіжий basil",
        "Olive oil, сіль"
      ],
      "steps": [
        "Розігрійте духовку до 240°C.",
        "Розкачайте тісто на присипаній борошном поверхні.",
        "Розподіліть passata; додайте mozzarella.",
        "Випікайте 10-12 хв до золотої скоринки.",
        "Прикрасьте базиліком та оливковою олією."
      ]
    },
    "ko": {
      "recovery_note": "집에서 즐기는 피자 나이트는 펍에서의 피맥을 대신해 주며, 매주 당신의 단주를 지켜주는 작은 변화가 됩니다.",
      "ingredients": [
        "피자 도우 (시판용 또는 수제)",
        "1/2 cup 토마토 passata",
        "200g 생 모짜렐라, 슬라이스",
        "신선한 바질",
        "올리브 오일, 소금"
      ],
      "steps": [
        "오븐을 240°C로 예열하세요.",
        "밀가루를 뿌린 조리대 위에서 반죽을 미세요.",
        "passata를 펴 바른 뒤 mozzarella를 추가하세요.",
        "크러스트가 바삭해질 때까지 10-12분간 구우세요.",
        "basil과 올리브 오일을 토핑으로 올리세요."
      ]
    },
    "fr": {
      "recovery_note": "Une soirée pizza à la maison remplace la pizza-bière au pub — un petit changement qui protège votre sobriété chaque semaine.",
      "ingredients": [
        "Pâte à pizza (achetée en magasin ou faite maison)",
        "1/2 cup tomato passata",
        "200g de mozzarella fraîche, tranchée",
        "Basilic frais",
        "Huile d'olive, sel"
      ],
      "steps": [
        "Préchauffez le four à 240°C.",
        "Étalez la pâte sur une surface farinée.",
        "Étalez la passata ; ajoutez la mozzarella.",
        "Faites cuire 10-12 min jusqu'à ce que la croûte soit croustillante.",
        "Garnissez de basilic et d'huile d'olive."
      ]
    },
    "it": {
      "recovery_note": "La serata pizza a casa sostituisce pizza e birra al pub — un piccolo cambiamento che protegge la tua sobrietà ogni settimana.",
      "ingredients": [
        "Impasto per pizza (comprato o fatto in casa)",
        "1/2 cup di passata di pomodoro",
        "200g mozzarella fresca, a fette",
        "Basilico fresco",
        "Olio d'oliva, sale"
      ],
      "steps": [
        "Preriscaldare il forno a 240°C.",
        "Stendere l'impasto su una superficie infarinata.",
        "Stendere la passata; aggiungere la mozzarella.",
        "Cuocere in forno per 10-12 min fino a quando la crosta non sarà croccante.",
        "Guarnire con basilico e olio d'oliva."
      ]
    },
    "es": {
      "recovery_note": "La noche de pizza en casa reemplaza a la pizza con cerveza en el pub: un pequeño cambio que protege tu sobriedad cada semana.",
      "ingredients": [
        "Masa de pizza (comprada o casera)",
        "1/2 cup de passata de tomate",
        "200g de mozzarella fresca, en rodajas",
        "Albahaca fresca",
        "Aceite de oliva, sal"
      ],
      "steps": [
        "Precaliente el horno a 240°C.",
        "Extienda la masa sobre una superficie enharinada.",
        "Distribuya la passata; añada la mozzarella.",
        "Hornee de 10 a 12 min hasta que la corteza esté crujiente.",
        "Cubra con albahaca y aceite de oliva."
      ]
    }
  },
  "it6": {
    "ru": {
      "recovery_note": "10-минутная итальянская закуска, демонстрирующая гостеприимство без использования алкоголя — идеальный вариант для вечеринок с безалкогольными напитками.",
      "ingredients": [
        "4 ломтика sourdough, поджаренных",
        "4 спелых томата, нарезанных кубиками",
        "2 зубчика чеснока",
        "Свежий базилик",
        "Extra virgin olive oil, соль"
      ],
      "steps": [
        "Обжарьте хлеб до золотистого цвета.",
        "Натрите зубчиком чеснока, пока он теплый.",
        "Смешайте помидоры, базилик, масло и соль.",
        "Выложите ложкой на хлеб.",
        "Подавайте немедленно."
      ]
    },
    "uk": {
      "recovery_note": "Італійська закуска за 10 хвилин, що демонструє гостинність без алкоголю — ідеально для вечірок у тверезому форматі.",
      "ingredients": [
        "4 скибочки sourdough, підсмажені",
        "4 стиглих томати, нарізаних кубиками",
        "2 зубчики часнику",
        "Свіжий базилік",
        "Extra virgin olive oil, сіль"
      ],
      "steps": [
        "Підсмажте хліб до золотистого кольору.",
        "Натріть зубчиком часнику, поки хліб теплий.",
        "Змішайте томати, basil, олію та сіль.",
        "Викладіть ложкою на тост.",
        "Подавайте негайно."
      ]
    },
    "ko": {
      "recovery_note": "알코올 없이도 환대의 마음을 전할 수 있는 10분 완성 이탈리안 에피타이저 — 술 없는 저녁 파티에 완벽합니다.",
      "ingredients": [
        "4 slices sourdough, toasted",
        "4 ripe tomatoes, diced",
        "2 garlic cloves",
        "Fresh basil",
        "Extra virgin olive oil, salt"
      ],
      "steps": [
        "빵을 황금빛이 돌 때까지 굽습니다.",
        "빵이 따뜻할 때 마늘 쪽을 문지릅니다.",
        "토마토, 바질, 오일, 소금을 섞습니다.",
        "구운 빵 위에 숟가락으로 얹습니다.",
        "즉시 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un apéritif italien prêt en 10 minutes qui incarne l'hospitalité sans alcool — idéal pour des dîners sobres.",
      "ingredients": [
        "4 tranches de sourdough, grillées",
        "4 tomates bien mûres, coupées en dés",
        "2 gousses d'ail",
        "Basilic frais",
        "Huile d'olive extra vierge, sel"
      ],
      "steps": [
        "Faire griller le pain jusqu'à ce qu'il soit doré.",
        "Frotter avec une gousse d'ail pendant qu'il est chaud.",
        "Mélanger les tomates, le basilic, l'huile et le sel.",
        "Déposer sur le pain grillé à l'aide d'une cuillère.",
        "Servir immédiatement."
      ]
    },
    "it": {
      "recovery_note": "Un antipasto italiano pronto in 10 minuti che esprime ospitalità senza l'uso di alcol — perfetto per cene analcoliche.",
      "ingredients": [
        "4 fette di sourdough, tostate",
        "4 pomodori maturi, tagliati a dadini",
        "2 spicchi d'aglio",
        "Basilico fresco",
        "Olio extravergine di oliva, sale"
      ],
      "steps": [
        "Tostare il pane fino a doratura.",
        "Strofinare con lo spicchio d'aglio mentre è ancora caldo.",
        "Mescolare pomodori, basilico, olio e sale.",
        "Distribuire il composto sul pane tostato con un cucchiaio.",
        "Servire immediatamente."
      ]
    },
    "es": {
      "recovery_note": "Un aperitivo italiano de 10 minutos que demuestra hospitalidad sin alcohol, perfecto para cenas sobrias.",
      "ingredients": [
        "4 rebanadas de sourdough, tostadas",
        "4 tomates maduros, en cubos",
        "2 dientes de ajo",
        "Albahaca fresca",
        "Aceite de oliva virgen extra, sal"
      ],
      "steps": [
        "Tueste el pan hasta que esté dorado.",
        "Frote con el diente de ajo mientras esté caliente.",
        "Mezcle los tomates, la albahaca, el aceite y la sal.",
        "Sirva con una cuchara sobre la tostada.",
        "Sirva inmediatamente."
      ]
    }
  },
  "it7": {
    "ru": {
      "recovery_note": "Ореховое песто богато омега-3 — это полезная для мозга вариация классического итальянского рецепта.",
      "ingredients": [
        "400g пасты",
        "2 чашки свежего базилика",
        "1/2 чашки кедровых орехов (или грецких орехов)",
        "2 зубчика чеснока",
        "1/2 чашки Parmesan",
        "1/2 чашки оливкового масла"
      ],
      "steps": [
        "Отварите пасту согласно инструкции на упаковке.",
        "Измельчите в блендере базилик, орехи, чеснок, Parmesan и масло.",
        "Отлейте 1/4 cup воды, в которой варилась паста.",
        "Смешайте пасту с песто и сохраненной водой.",
        "Посыпьте сверху дополнительной порцией Parmesan."
      ]
    },
    "uk": {
      "recovery_note": "Песто з волоських горіхів багате на омега-3 — це корисна для мозку варіація італійської класики.",
      "ingredients": [
        "400g макаронів",
        "2 чашки свіжого базиліку",
        "1/2 чашки кедрових горіхів (або волоських горіхів)",
        "2 зубчики часнику",
        "1/2 чашки Parmesan",
        "1/2 чашки оливкової олії"
      ],
      "steps": [
        "Відваріть пасту згідно з інструкцією на упаковці.",
        "Збийте у блендері базилік, горіхи, часник, Parmesan та олію.",
        "Залиште 1/4 cup води, у якій варилася паста.",
        "Перемішайте пасту з песто та водою.",
        "Посипте зверху додатковим Parmesan."
      ]
    },
    "ko": {
      "recovery_note": "호두 페스토는 오메가-3가 풍부하여 두뇌 건강에 도움을 주는 이탈리아 클래식 요리의 변주입니다.",
      "ingredients": [
        "400g pasta",
        "2 cups fresh basil",
        "1/2 cup pine nuts (또는 walnuts)",
        "2 garlic cloves",
        "1/2 cup Parmesan",
        "1/2 cup olive oil"
      ],
      "steps": [
        "포장지 지침에 따라 파스타를 삶습니다.",
        "바질, 견과류, 마늘, Parmesan 치즈, 오일을 블렌더로 갑니다.",
        "파스타 면수 1/4 cup을 따로 남겨둡니다.",
        "파스타를 페스토, 면수와 함께 버무립니다.",
        "위에 추가 Parmesan 치즈를 얹습니다."
      ]
    },
    "fr": {
      "recovery_note": "Le pesto aux noix est riche en oméga-3 — une variante bénéfique pour le cerveau de ce grand classique italien.",
      "ingredients": [
        "400g pasta",
        "2 cups de basilic frais",
        "1/2 cup de pignons de pin (ou noix)",
        "2 gousses d'ail",
        "1/2 cup de Parmesan",
        "1/2 cup d'huile d'olive"
      ],
      "steps": [
        "Cuisez les pâtes selon les instructions du paquet.",
        "Mixez le basilic, les noix, l'ail, le Parmesan et l'huile.",
        "Réservez 1/4 cup d'eau de cuisson des pâtes.",
        "Mélangez les pâtes avec le pesto et l'eau.",
        "Garnissez avec un supplément de Parmesan."
      ]
    },
    "it": {
      "recovery_note": "Il pesto di noci è ricco di omega-3: una variante per il benessere del cervello del grande classico italiano.",
      "ingredients": [
        "400g pasta",
        "2 tazze di basilico fresco",
        "1/2 tazza di pinoli (o noci)",
        "2 spicchi d'aglio",
        "1/2 tazza di Parmigiano",
        "1/2 tazza di olio d'oliva"
      ],
      "steps": [
        "Cuocere la pasta secondo le istruzioni sulla confezione.",
        "Frullare basilico, noci, aglio, Parmesan e olio.",
        "Mettere da parte 1/4 cup di acqua di cottura.",
        "Mescolare la pasta con il pesto e l'acqua.",
        "Guarnire con dell'altro Parmesan."
      ]
    },
    "es": {
      "recovery_note": "El pesto de nueces es rico en omega-3, una variante para la salud cerebral del clásico italiano.",
      "ingredients": [
        "400g pasta",
        "2 tazas de albahaca fresca",
        "1/2 taza de piñones (o nueces)",
        "2 dientes de ajo",
        "1/2 taza de Parmesan",
        "1/2 taza de aceite de oliva"
      ],
      "steps": [
        "Cocine la pasta según el paquete.",
        "Licúe la albahaca, las nueces, el ajo, el Parmesan y el aceite.",
        "Reserve 1/4 cup del agua de la pasta.",
        "Mezcle la pasta con el pesto y el agua.",
        "Cubra con Parmesan adicional."
      ]
    }
  },
  "it8": {
    "ru": {
      "recovery_note": "Древние злаки содержат больше питательных веществ, чем очищенные — особенно клетчатки и витаминов группы B для стабильной энергии.",
      "ingredients": [
        "1 стакан farro или перловой крупы",
        "1 огурец, 1 capsicum, нарезанные кубиками",
        "1 стакан томатов черри, разрезанных пополам",
        "1/2 стакана фета",
        "Оливки, базилик, лимон, масло"
      ],
      "steps": [
        "Приготовьте farro согласно инструкции на упаковке; дайте остыть.",
        "Соедините с нарезанными кубиками овощами.",
        "Добавьте фета и оливки.",
        "Взбейте лимон и масло.",
        "Перемешайте; сверху украсьте базиликом."
      ]
    },
    "uk": {
      "recovery_note": "Стародавні злаки містять більше поживних речовин, ніж рафіновані — зокрема клітковину та вітаміни групи B для стабільної енергії.",
      "ingredients": [
        "1 cup полби (фарро) або перлової крупи",
        "1 cucumber, 1 capsicum, нарізані кубиками",
        "1 cup cherry tomatoes, розрізаних навпіл",
        "1/2 cup feta",
        "Olives, basil, lemon, oil"
      ],
      "steps": [
        "Відваріть фарро відповідно до інструкції на упаковці; охолодіть.",
        "Змішайте з нарізаними кубиками овочами.",
        "Додайте фету та оливки.",
        "Збийте лимонний сік та олію.",
        "Перемішайте; зверху посипте базиліком."
      ]
    },
    "ko": {
      "recovery_note": "고대 곡물은 정제된 곡물보다 더 많은 영양소를 함유하고 있으며, 특히 식이섬유와 비타민 B군이 풍부하여 지속적인 에너지를 공급해 줍니다.",
      "ingredients": [
        "1 cup 파로(farro) 또는 펄 바리(pearl barley)",
        "오이 1개, 캡시컴(capsicum) 1개, 깍둑썰기",
        "방울토마토 1 cup, 반으로 자른 것",
        "페타 치즈 1/2 cup",
        "올리브, 바질, 레몬, 오일"
      ],
      "steps": [
        "패키지 안내에 따라 farro를 조리한 후 식힙니다.",
        "깍둑썰기한 채소와 섞습니다.",
        "feta 치즈와 올리브를 넣습니다.",
        "레몬즙과 오일을 휘저어 섞습니다.",
        "가볍게 버무린 뒤 basil을 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les céréales anciennes contiennent plus de nutriments que les céréales raffinées — en particulier des fibres et des vitamines B pour une énergie constante.",
      "ingredients": [
        "1 cup farro ou pearl barley",
        "1 concombre, 1 capsicum, coupé en dés",
        "1 cup de tomates cerises, coupées en deux",
        "1/2 cup de feta",
        "Olives, basilic, citron, huile"
      ],
      "steps": [
        "Cuire le farro selon les instructions du paquet ; laisser refroidir.",
        "Mélanger avec les légumes coupés en dés.",
        "Ajouter la feta et les olives.",
        "Fouetter le citron et l'huile.",
        "Mélanger le tout ; garnir de basilic."
      ]
    },
    "it": {
      "recovery_note": "I cereali antichi contengono più nutrienti rispetto a quelli raffinati, in particolare fibre e vitamine del gruppo B per un'energia costante.",
      "ingredients": [
        "1 cup di farro o orzo perlato",
        "1 cetriolo, 1 capsicum, a dadini",
        "1 cup di pomodori cherry, dimezzati",
        "1/2 cup di feta",
        "Olive, basilico, limone, olio"
      ],
      "steps": [
        "Cuocere il farro seguendo le istruzioni della confezione; lasciare raffreddare.",
        "Unire alle verdure tagliate a dadini.",
        "Aggiungere feta e olive.",
        "Sbattere limone e olio.",
        "Mescolare; guarnire con basilico."
      ]
    },
    "es": {
      "recovery_note": "Los cereales antiguos contienen más nutrientes que los refinados, especialmente fibra y vitaminas del grupo B para una energía constante.",
      "ingredients": [
        "1 cup farro o cebada perlada",
        "1 pepino, 1 capsicum, en cubos",
        "1 cup tomates cherry, cortados a la mitad",
        "1/2 cup feta",
        "Olivas, albahaca, limón, aceite"
      ],
      "steps": [
        "Cocine el farro según las instrucciones del paquete; deje enfriar.",
        "Combine con vegetales cortados en cubitos.",
        "Agregue el queso feta y las aceitunas.",
        "Bata el limón y el aceite.",
        "Mezcle todo; decore con albahaca por encima."
      ]
    }
  },
  "it9": {
    "ru": {
      "recovery_note": "Богатое железом красное мясо плюс томатный соус — обед в воскресном стиле на 4 персоны, которого хватит еще на два дня в качестве готовых обедов.",
      "ingredients": [
        "500g нежирного фарша",
        "1 яйцо, 1/2 чашки панировочных сухарей",
        "1/4 чашки тертого Parmesan",
        "1 луковица, чеснок",
        "1 банка томатов, базилик, орегано"
      ],
      "steps": [
        "Смешайте мясной фарш, яйцо, панировочные сухари и Parmesan; сформируйте шарики.",
        "Обжарьте фрикадельки в масле 5 min.",
        "Обжарьте лук и чеснок; добавьте помидоры и травы.",
        "Верните фрикадельки в сковороду; тушите на медленном огне 20 min.",
        "Подавайте с пастой или полентой."
      ]
    },
    "uk": {
      "recovery_note": "Багате на залізо червоне м’ясо з томатним соусом — страва в недільному стилі, якої вистачить на 4 порції та ще на два дні залишків.",
      "ingredients": [
        "500g нежирного фаршу",
        "1 яйце, 1/2 склянки панірувальних сухарів",
        "1/4 склянки тертого Parmesan",
        "1 цибулина, часник",
        "1 банка томатів, базилік, орегано"
      ],
      "steps": [
        "Змішайте фарш, яйце, панірувальні сухарі та Parmesan; сформуйте кульки.",
        "Обсмажте фрикадельки в олії протягом 5 min.",
        "Обсмажте цибулю та часник; додайте томати та трави.",
        "Поверніть фрикадельки; тушкуйте 20 min.",
        "Подавайте з пастою або polenta."
      ]
    },
    "ko": {
      "recovery_note": "철분이 풍부한 붉은 육류에 토마토 소스를 더한 선데이 스타일의 요리로, 4인 가족이 넉넉히 즐길 수 있으며 이틀 동안 남은 음식을 보관해 두기에도 좋습니다.",
      "ingredients": [
        "500g lean mince",
        "달걀 1개, 빵가루 1/2 cup",
        "갈아놓은 Parmesan 1/4 cup",
        "양파 1개, 마늘",
        "토마토 통조림 1캔, 바질, 오레가노"
      ],
      "steps": [
        "다진 고기, 달걀, 빵가루, Parmesan 치즈를 섞어 완자를 만듭니다.",
        "팬에 기름을 두르고 미트볼을 5 min 동안 노릇하게 굽습니다.",
        "양파와 마늘을 볶다가 토마토와 허브를 넣습니다.",
        "미트볼을 다시 넣고 20 min 동안 뭉근하게 끓입니다.",
        "파스타나 polenta를 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "De la viande rouge riche en fer accompagnée d'une sauce tomate — un repas dominical pour 4 personnes qui se conserve pendant deux jours pour les restes.",
      "ingredients": [
        "500g lean mince",
        "1 œuf, 1/2 cup de chapelure",
        "1/4 cup de Parmesan râpé",
        "1 oignon, ail",
        "1 boîte de tomates, basilic, origan"
      ],
      "steps": [
        "Mélanger la viande hachée, l'œuf, la chapelure, le Parmesan ; former des boulettes.",
        "Faire dorer les boulettes dans l'huile pendant 5 min.",
        "Faire revenir l'oignon et l'ail ; ajouter les tomates et les herbes.",
        "Remettre les boulettes ; faire mijoter 20 min.",
        "Servir avec des pâtes ou de la polenta."
      ]
    },
    "it": {
      "recovery_note": "Carne rossa ricca di ferro e salsa di pomodoro: un pasto in stile domenicale per 4 persone che si conserva per due giorni come avanzo.",
      "ingredients": [
        "500g di macinato magro",
        "1 uovo, 1/2 tazza di pangrattato",
        "1/4 di tazza di parmigiano grattugiato",
        "1 cipolla, aglio",
        "1 lattina di pomodori, basilico, origano"
      ],
      "steps": [
        "Mescolare il macinato, l'uovo, il pangrattato, il Parmesan; formare delle polpette.",
        "Rosolare le polpette nell'olio per 5 min.",
        "Soffriggere cipolla e aglio; aggiungere i pomodori e le erbe.",
        "Unire nuovamente le polpette; cuocere a fuoco lento per 20 min.",
        "Servire con pasta o polenta."
      ]
    },
    "es": {
      "recovery_note": "Carne roja rica en hierro con salsa de tomate — una comida estilo dominical que rinde para 4 personas y se conserva durante dos días de sobras.",
      "ingredients": [
        "500g lean mince",
        "1 huevo, 1/2 cup de pan rallado",
        "1/4 cup de parmesano rallado",
        "1 cebolla, ajo",
        "1 lata de tomates, albahaca, orégano"
      ],
      "steps": [
        "Mezcle la carne picada, el huevo, el pan rallado y el Parmesan; forme bolas.",
        "Dore las albóndigas en aceite durante 5 min.",
        "Saltee la cebolla y el ajo; añada los tomates y las hierbas.",
        "Regrese las albóndigas a la sartén; cocine a fuego lento 20 min.",
        "Sirva con pasta o polenta."
      ]
    }
  },
  "it10": {
    "ru": {
      "recovery_note": "Три ингредиента, блюдо ресторанного уровня — доказательство того, что качество важнее сложности, как в кулинарии, так и в процессе восстановления.",
      "ingredients": [
        "1 шарик свежей моцареллы буффало",
        "3 спелых томата, нарезанных ломтиками",
        "Свежие листья базилика",
        "Оливковое масло Extra virgin",
        "Морская соль, бальзамический соус (balsamic glaze)"
      ],
      "steps": [
        "Нарежьте моцареллу и томаты толстыми ломтиками.",
        "Выложите их на тарелку, чередуя друг с другом.",
        "Проложите листья базилика между ломтиками.",
        "Сбрызните маслом и бальзамическим уксусом.",
        "Посыпьте морской солью и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Три інгредієнти, страва ресторанної якості — доказ того, що якість перевершує складність як у їжі, так і у відновленні.",
      "ingredients": [
        "1 кулька свіжої моцарели buffalo",
        "3 стиглих томати, нарізаних скибочками",
        "Свіже листя базиліку",
        "Extra virgin olive oil",
        "Морська сіль, balsamic glaze"
      ],
      "steps": [
        "Наріжте моцарелу та томати товстими скибочками.",
        "Викладіть їх на тарілку, чергуючи між собою.",
        "Вставте листя базиліку між скибочками.",
        "Полийте олією та бальзамічним оцтом.",
        "Посипте морською сіллю; подавайте до столу."
      ]
    },
    "ko": {
      "recovery_note": "세 가지 재료로 완성한 레스토랑 수준의 요리 — 음식에서나 회복에서나, 복잡함보다 중요한 것은 품질이라는 것을 증명해 줍니다.",
      "ingredients": [
        "1 ball fresh buffalo mozzarella",
        "슬라이스한 잘 익은 토마토 3개",
        "신선한 바질 잎",
        "Extra virgin olive oil",
        "Sea salt, balsamic glaze"
      ],
      "steps": [
        "모차렐라와 토마토를 두껍게 썹니다.",
        "접시에 두 재료를 번갈아 가며 놓습니다.",
        "슬라이스 사이에 바질을 끼워 넣습니다.",
        "오일과 발사믹을 뿌립니다.",
        "바다 소금을 뿌려 내놓습니다."
      ]
    },
    "fr": {
      "recovery_note": "Trois ingrédients, une assiette digne d'un restaurant — la preuve que la qualité l'emporte sur la complexité, tant en cuisine qu'en rétablissement.",
      "ingredients": [
        "1 boule de mozzarella de bufflonne fraîche",
        "3 tomates mûres, tranchées",
        "Feuilles de basilic frais",
        "Huile d'olive extra vierge",
        "Sea salt, balsamic glaze"
      ],
      "steps": [
        "Coupez la mozzarella et les tomates en tranches épaisses.",
        "Alternez-les sur une assiette.",
        "Glissez du basilic entre les tranches.",
        "Arrosez d'huile et de vinaigre balsamique.",
        "Saupoudrez de sel de mer ; servez."
      ]
    },
    "it": {
      "recovery_note": "Tre ingredienti, un piatto degno di un ristorante — la prova che la qualità batte la complessità, nel cibo come nel Recupero.",
      "ingredients": [
        "1 palla di mozzarella di bufala fresca",
        "3 pomodori maturi, affettati",
        "Foglie di basilico fresco",
        "Olio extra vergine di oliva",
        "Sale marino, glassa alla glassa balsamica"
      ],
      "steps": [
        "Affettare la mozzarella e i pomodori spessi.",
        "Alternarli su un piatto.",
        "Inserire il basilico tra le fette.",
        "Condire con un filo d'olio e balsamico.",
        "Spolverare con sale marino; servire."
      ]
    },
    "es": {
      "recovery_note": "Tres ingredientes, un plato de calidad de restaurante; demuestra que la calidad supera a la complejidad, tanto en la cocina como en la recuperación.",
      "ingredients": [
        "1 bola de mozzarella de búfala fresca",
        "3 tomates maduros, rebanados",
        "Hojas de albahaca fresca",
        "Aceite de oliva virgen extra",
        "Sal de mar, reducción de balsámico (balsamic glaze)"
      ],
      "steps": [
        "Corte la mozzarella y los tomates en rodajas gruesas.",
        "Intercale las rodajas en un plato.",
        "Coloque hojas de albahaca entre las rodajas.",
        "Rocíe con aceite y balsámico.",
        "Espolvoree con sal marina y sirva."
      ]
    }
  },
  "kr1": {
    "ru": {
      "recovery_note": "Полноценный прием пищи в одной тарелке — белки, клетчатка, полезные жиры и сложные углеводы, которые стабилизируют настроение и обеспечивают энергией на несколько часов.",
      "ingredients": [
        "2 чашки готового риса",
        "1 морковь, нарезанная соломкой",
        "1 цукини, нарезанный ломтиками",
        "1 чашка шпината, бланшированного",
        "4 яйца, 200g полосок нежирной говядины",
        "Соевый соус, кунжутное масло, gochujang"
      ],
      "steps": [
        "Обжарьте каждый овощ по отдельности с sesame oil и солью.",
        "Замаринуйте говядину в соевом соусе и сахаре; обжаривайте 3 min.",
        "Пожарьте яйца в виде глазуньи.",
        "Выложите в миски слоями рис, овощи, говядину и яйцо.",
        "Сверху добавьте gochujang; перемешайте прямо за столом."
      ]
    },
    "uk": {
      "recovery_note": "Повноцінна страва в одній тарілці — білок, клітковина, корисні жири та складні вуглеводи, які стабілізують настрій та енергію на довгі години.",
      "ingredients": [
        "2 склянки приготованого рису",
        "1 морква, нарізана соломкою",
        "1 цукіні, нарізаний скибочками",
        "1 склянка шпинату, бланшованого",
        "4 яйця, 200g нежирних смужок яловичини",
        "Соєвий соус, кунжутна олія, gochujang"
      ],
      "steps": [
        "Обсмажте кожен овоч окремо з додаванням sesame oil та солі.",
        "Замаринуйте яловичину в соєвому соусі та цукрі; обсмажуйте 3 min.",
        "Підсмажте яйця так, щоб жовток залишився рідким (sunny-side up).",
        "Викладіть шарами рис, овочі, яловичину та яйце в глибокі миски.",
        "Додайте зверху gochujang; перемішайте безпосередньо перед вживанням."
      ]
    },
    "ko": {
      "recovery_note": "단백질, 식이섬유, 건강한 지방, 그리고 장시간 동안 기분과 에너지를 안정시켜 주는 복합 탄수화물까지 한 그릇에 모두 담아낸 완벽한 식사입니다.",
      "ingredients": [
        "2 cups 익힌 밥",
        "1 carrot, 채썰기",
        "1 zucchini, 편썰기",
        "1 cup spinach, 데침",
        "4 eggs, 200g lean beef strips",
        "Soy, sesame oil, gochujang"
      ],
      "steps": [
        "각 채소를 참기름과 소금을 넣고 따로 볶습니다.",
        "소고기를 간장과 설탕에 재운 뒤 3분간 볶습니다.",
        "달걀을 써니사이드업(sunny-side up)으로 프라이합니다.",
        "그릇에 밥, 채소, 소고기, 달걀을 순서대로 쌓습니다.",
        "고추장을 올리고 식탁에서 비벼 먹습니다."
      ]
    },
    "fr": {
      "recovery_note": "Un repas complet dans un seul bol — des protéines, des fibres, de bons lipides et des glucides complexes qui stabilisent l'humeur et l'énergie pendant des heures.",
      "ingredients": [
        "2 cups de riz cuit",
        "1 carotte, en julienne",
        "1 courgette, tranchée",
        "1 cup d'épinards, blanchis",
        "4 œufs, 200g de fines lanières de bœuf",
        "Soja, huile de sésame, gochujang"
      ],
      "steps": [
        "Sauter chaque légume séparément avec de l'huile de sésame et du sel.",
        "Faire mariner le bœuf dans du soja et du sucre ; faire sauter 3 min.",
        "Faire frire les œufs au plat (sunny-side up).",
        "Disposer le riz, les légumes, le bœuf et l'œuf en couches dans des bols.",
        "Garnir de gochujang ; mélanger à table."
      ]
    },
    "it": {
      "recovery_note": "Un pasto completo in un'unica ciotola — proteine, fibre, grassi sani e carboidrati complessi che stabilizzano l'umore e l'energia per ore.",
      "ingredients": [
        "2 cups di riso cotto",
        "1 carota, a julienne",
        "1 zucchina, a fette",
        "1 cup di spinaci, sbollentati",
        "4 uova, 200g di straccetti di manzo magro",
        "Soia, olio di sesamo, gochujang"
      ],
      "steps": [
        "Soffriggere ogni verdura separatamente con sesame oil e sale.",
        "Marinare il manzo in soia e zucchero; saltare in padella per 3 min.",
        "Friggere le uova all'occhio di bue.",
        "Disporre a strati riso, verdure, manzo e uovo nelle ciotole.",
        "Guarnire con gochujang; mescolare a tavola."
      ]
    },
    "es": {
      "recovery_note": "Una comida completa en un solo bol: proteína, fibra, grasas saludables y carbohidratos complejos que estabilizan el estado de ánimo y la energía durante horas.",
      "ingredients": [
        "2 tazas de arroz cocido",
        "1 zanahoria, en juliana",
        "1 calabacín, rebanado",
        "1 taza de espinacas, blanqueadas",
        "4 huevos, 200g de tiras de carne de res magra",
        "Soya, aceite de sésamo, gochujang"
      ],
      "steps": [
        "Saltee cada verdura por separado con aceite de sésamo y sal.",
        "Marine la carne de res en soja y azúcar; saltee durante 3 min.",
        "Fría los huevos al estilo sunny-side up.",
        "Coloque capas de arroz, verduras, carne de res y huevo en tazones.",
        "Cubra con gochujang; mezcle en la mesa."
      ]
    }
  },
  "kr2": {
    "ru": {
      "recovery_note": "Кимчи обеспечивает серьезную порцию пробиотиков — процветающий микробиом кишечника является одним из важнейших факторов устойчивости настроения.",
      "ingredients": [
        "2 cups вареного риса",
        "1 cup kimchi, нарезанного",
        "2 пера зеленого лука",
        "2 яйца",
        "Sesame oil, soy sauce",
        "Nori sheet (опционально)"
      ],
      "steps": [
        "Разогрейте масло; обжаривайте зеленый лук 1 мин.",
        "Добавьте kimchi; готовьте 2 мин.",
        "Добавьте рис; перемешайте.",
        "Отодвиньте содержимое в сторону; приготовьте яйца, постоянно помешивая (scramble).",
        "Сбрызните кунжутным маслом и соевым соусом; сверху посыпьте nori."
      ]
    },
    "uk": {
      "recovery_note": "Кімчі містить значну кількість пробіотиків — процвітаючий мікробіом кишечника є одним із найсильніших показників стійкості настрою.",
      "ingredients": [
        "2 cups вареного рису",
        "1 cup kimchi, подрібненого",
        "2 spring onions",
        "2 яйця",
        "Sesame oil, soy sauce",
        "Nori sheet (за бажанням)"
      ],
      "steps": [
        "Розігрійте олію; обсмажуйте spring onion 1 хв.",
        "Додайте kimchi; готуйте 2 хв.",
        "Додайте рис; перемішайте до з’єднання.",
        "Відсуньте все вбік; приготуйте всередині scramble eggs.",
        "Збризніть sesame oil та соєвим соусом; зверху викладіть nori."
      ]
    },
    "ko": {
      "recovery_note": "김치는 풍부한 프로바이오틱스를 제공하며, 건강한 장내 미생물 생태계는 정서적 회복 탄력성을 예측하는 가장 강력한 지표 중 하나입니다.",
      "ingredients": [
        "2 cups 익힌 밥",
        "1 cup kimchi, 다진 것",
        "2 spring onions",
        "2 eggs",
        "Sesame oil, soy sauce",
        "Nori sheet (선택 사항)"
      ],
      "steps": [
        "기름을 두르고 달군 뒤, 파를 넣고 1분간 볶습니다.",
        "김치를 넣고 2분간 더 볶습니다.",
        "밥을 넣고 잘 섞이도록 저어줍니다.",
        "팬 한쪽으로 밀어둔 뒤, 빈 공간에 달걀을 넣어 스크램블합니다.",
        "참기름과 간장을 두르고 김가루를 올려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Le kimchi apporte une dose importante de probiotiques — un microbiome intestinal sain est l'un des indicateurs les plus fiables de la résilience émotionnelle.",
      "ingredients": [
        "2 cups de riz cuit",
        "1 cup de kimchi, haché",
        "2 oignons nouveaux",
        "2 œufs",
        "Huile de sésame, sauce soja",
        "Feuille de Nori (facultatif)"
      ],
      "steps": [
        "Faire chauffer l'huile ; faire sauter les spring onion 1 min.",
        "Ajouter le kimchi ; cuire 2 min.",
        "Ajouter le riz ; mélanger pour combiner.",
        "Pousser sur le côté ; brouiller les eggs à l'intérieur.",
        "Arroser de sesame oil et de soy ; garnir de nori."
      ]
    },
    "it": {
      "recovery_note": "Il kimchi apporta una notevole carica probiotica: un microbioma intestinale sano è uno dei fattori più determinanti per la resilienza dell'umore.",
      "ingredients": [
        "2 tazze di riso cotto",
        "1 tazza di kimchi, tritato",
        "2 cipollotti",
        "2 uova",
        "Olio di sesamo, salsa di soia",
        "Nori sheet (opzionale)"
      ],
      "steps": [
        "Scaldare l'olio; soffriggere lo spring onion per 1 min.",
        "Aggiungere il kimchi; cuocere per 2 min.",
        "Aggiungere il riso; saltare per amalgamare.",
        "Spostare lateralmente; strapazzare le uova all'interno.",
        "Versare un filo di olio di sesamo e soy; guarnire con nori."
      ]
    },
    "es": {
      "recovery_note": "El kimchi aporta una carga considerable de probióticos; un microbioma intestinal saludable es uno de los indicadores más sólidos de la resiliencia del estado de ánimo.",
      "ingredients": [
        "2 tazas de arroz cocido",
        "1 taza de kimchi, picado",
        "2 cebolletas (spring onions)",
        "2 huevos",
        "Aceite de sésamo, salsa de soja",
        "Alga Nori (opcional)"
      ],
      "steps": [
        "Calentar el aceite; saltear la cebolleta 1 min.",
        "Añadir el kimchi; cocinar 2 min.",
        "Añadir el arroz; remover para combinar.",
        "Empujar hacia un lado; revolver los huevos dentro.",
        "Rociar con aceite de sésamo y soja; cubrir con nori."
      ]
    }
  },
  "kr3": {
    "ru": {
      "recovery_note": "Богатая железом говядина в сочетании с натуральной сладостью грушевого маринада доказывает, что сладко-соленый вкус не требует рафинированного сахара для истинного наслаждения.",
      "ingredients": [
        "500g beef sirloin, тонко нарезанной",
        "4 tbsp соевого соуса, 2 tbsp коричневого сахара",
        "2 tbsp кунжутного масла, 4 зубчика чеснока",
        "1 pear, натертая",
        "Зеленый лук, семена кунжута, рис"
      ],
      "steps": [
        "Взбейте соевый соус, сахар, кунжутное масло, чеснок и тертую грушу.",
        "Маринуйте говядину минимум 20 min.",
        "Раскалите сковороду; обжаривайте говядину порциями по 2 min.",
        "Посыпьте сверху зеленым луком и кунжутом.",
        "Подавайте с рисом и листьями салата."
      ]
    },
    "uk": {
      "recovery_note": "Багата на залізо яловичина в поєднанні з природною солодкістю грушевого маринаду доводить, що пікантно-солодкий смак не потребує рафінованого цукру, щоб дарувати задоволення.",
      "ingredients": [
        "500g beef sirloin, тонко нарізаної",
        "4 tbsp соєвого соусу, 2 tbsp коричневого цукру",
        "2 tbsp кунжутної олії, 4 зубчики часнику",
        "1 груша, натерта",
        "Spring onions, насіння кунжуту, рис"
      ],
      "steps": [
        "Збийте соєвий соус, цукор, кунжутну олію, часник та терту грушу.",
        "Маринуйте яловичину щонайменше 20 min.",
        "Розігрійте сковорідку дуже сильно; обсмажуйте яловичину порціями по 2 min.",
        "Посипте зверху зеленою цибулею та кунжутом.",
        "Подавайте з рисом та листям салату."
      ]
    },
    "ko": {
      "recovery_note": "철분이 풍부한 소고기에 배를 갈아 넣은 천연의 단맛을 더했습니다. 정제 설탕 없이도 입맛을 사로잡는 완벽한 단짠의 조화를 경험해 보세요.",
      "ingredients": [
        "500g 소고기 등심, 얇게 썬 것",
        "간장 4 tbsp, 황설탕 2 tbsp",
        "참기름 2 tbsp, 마늘 4알",
        "배 1개, 갈아서 준비",
        "쪽파, 참깨, 밥"
      ],
      "steps": [
        "soy, sugar, sesame oil, garlic, grated pear를 잘 휘저어 섞습니다.",
        "소고기를 최소 20 min 동안 재워둡니다.",
        "팬을 매우 뜨겁게 달군 뒤, 소고기를 나누어 넣으며 2 min 동안 익힙니다.",
        "위에 spring onions와 sesame를 뿌립니다.",
        "밥, lettuce wraps와 함께 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Le bœuf riche en fer allié à la douceur naturelle d'une marinade à la poire prouve que l'équilibre sucré-salé n'a pas besoin de sucre raffiné pour être savoureux.",
      "ingredients": [
        "500g beef sirloin, finement tranché",
        "4 tbsp soja, 2 tbsp de sucre brun",
        "2 tbsp d'huile de sésame, 4 gousses d'ail",
        "1 poire, râpée",
        "Oignons verts, graines de sésame, riz"
      ],
      "steps": [
        "Fouetter le soja, le sucre, l'huile de sésame, l'ail et la poire râpée.",
        "Faire mariner le bœuf pendant 20 min minimum.",
        "Chauffer une poêle à feu très vif ; cuire le bœuf en plusieurs fois pendant 2 min.",
        "Garnir d'oignons nouveaux et de sésame.",
        "Servir avec du riz et des feuilles de laitue."
      ]
    },
    "it": {
      "recovery_note": "Il manzo ricco di ferro unito alla naturale dolcezza della marinata di pere dimostra che l'equilibrio tra dolce e salato non ha bisogno di zuccheri raffinati per appagare il palato.",
      "ingredients": [
        "500g di controfiletto di manzo, tagliato a fette sottili",
        "4 cucchiai di soia, 2 cucchiai di zucchero di canna",
        "2 cucchiai di olio di sesamo, 4 spicchi d'aglio",
        "1 pera, grattugiata",
        "Cipollotti, semi di sesamo, riso"
      ],
      "steps": [
        "Sbattere soia, zucchero, olio di sesamo, aglio e pera grattugiata.",
        "Marinare il manzo per almeno 20 min.",
        "Scaldare la padella a fuoco altissimo; cuocere il manzo in più riprese per 2 min.",
        "Guarnire con cipollotti e sesamo.",
        "Servire con riso e involtini di lattuga."
      ]
    },
    "es": {
      "recovery_note": "La carne de ternera rica en hierro junto con el dulzor natural del marinado de pera demuestra que lo salado y dulce no necesita azúcar refinada para satisfacer el paladar.",
      "ingredients": [
        "500g beef sirloin, finamente rebanado",
        "4 tbsp soy, 2 tbsp azúcar morena",
        "2 tbsp sesame oil, 4 dientes de ajo",
        "1 pera, rallada",
        "Spring onions, semillas de sésamo, arroz"
      ],
      "steps": [
        "Batir la soja, el azúcar, el aceite de sésamo, el ajo y la pera rallada.",
        "Marinar la carne de res durante 20 min como mínimo.",
        "Calentar una sartén a fuego muy fuerte; cocinar la carne en tandas durante 2 min.",
        "Decorar con cebolletas y sésamo.",
        "Servir con arroz y wraps de lechuga."
      ]
    }
  },
  "kr4": {
    "ru": {
      "recovery_note": "Ферментированная соевая паста — это источник умами и пробиотиков, вкусный способ поддержать здоровье кишечника в будние дни.",
      "ingredients": [
        "3 tbsp дендян (соевая паста)",
        "1 цукини, 1 картофель, 1 луковица",
        "300g твердого тофу, нарезанного кубиками",
        "1 перец чили, грибы",
        "4 cups воды, 2 зубчика чеснока"
      ],
      "steps": [
        "Смешайте doenjang с водой; доведите до кипения.",
        "Добавьте картофель, лук, грибы и варите 10 min.",
        "Добавьте цукини, тофу, чеснок, чили; варите 5 min.",
        "Отрегулируйте вкус приправами.",
        "Подавайте с рисом."
      ]
    },
    "uk": {
      "recovery_note": "Ферментована соєва паста забезпечує смак умамі та містить пробіотики — це смачний спосіб підтримати здоров’я кишківника у будні дні.",
      "ingredients": [
        "3 ст. л. doenjang (соєва паста)",
        "1 цукіні, 1 картопля, 1 цибуля",
        "300г твердого тофу, нарізаного кубиками",
        "1 перець чилі, гриби",
        "4 склянки води, 2 зубчики часнику"
      ],
      "steps": [
        "Змішайте doenjang з водою; доведіть до кипіння на повільному вогні.",
        "Додайте картоплю, цибулю, гриби та готуйте 10 min.",
        "Додайте цукіні, тофу, часник, чилі; готуйте 5 min.",
        "Відрегулюйте кількість спецій за смаком.",
        "Подавайте з рисом."
      ]
    },
    "ko": {
      "recovery_note": "발효된 된장은 감칠맛과 프로바이오틱스를 제공하여 평일 저녁 식사에서 장 건강을 챙길 수 있는 풍미 가득한 방법입니다.",
      "ingredients": [
        "3 tbsp 된장 (doenjang)",
        "애호박 1개, 감자 1개, 양파 1개",
        "300g 단단한 두부, 깍둑썰기한 것",
        "고추 1개, 버섯",
        "물 4컵, 마늘 2쪽"
      ],
      "steps": [
        "된장과 물을 섞고 끓어오를 때까지 가열합니다.",
        "감자, 양파, 버섯을 넣고 10 min 동안 끓입니다.",
        "애호박, 두부, 마늘, 고추를 넣고 5 min 동안 더 끓입니다.",
        "간을 조절합니다.",
        "밥과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "La pâte de soja fermentée apporte de l'umami et des probiotiques — une façon savoureuse de favoriser la santé intestinale en semaine.",
      "ingredients": [
        "3 tbsp doenjang (pâte de soja fermentée)",
        "1 courgette, 1 pomme de terre, 1 oignon",
        "300g de tofu ferme, coupé en dés",
        "1 piment, champignons",
        "4 tasses d'eau, 2 gousses d'ail"
      ],
      "steps": [
        "Mélanger le doenjang avec l'eau ; porter à frémissement.",
        "Ajouter la pomme de terre, l'oignon et les mushrooms pendant 10 min.",
        "Ajouter la courgette, le tofu, l'ail et le chilli ; cuire 5 min.",
        "Ajuster l'assaisonnement.",
        "Servir avec du riz."
      ]
    },
    "it": {
      "recovery_note": "La pasta di soia fermentata apporta umami e probiotici: un modo saporito per sostenere la salute dell'intestino durante le cene infrasettimanali.",
      "ingredients": [
        "3 tbsp doenjang (pasta di soia)",
        "1 zucchina, 1 patata, 1 cipolla",
        "300g firm tofu, a cubetti",
        "1 peperoncino, funghi",
        "4 cups acqua, 2 spicchi d'aglio"
      ],
      "steps": [
        "Unire il doenjang con l'acqua; portare a ebollizione.",
        "Aggiungere patata, cipolla, funghi per 10 min.",
        "Aggiungere zucchina, tofu, aglio, peperoncino; cuocere per 5 min.",
        "Regolare di condimento.",
        "Servire con riso."
      ]
    },
    "es": {
      "recovery_note": "La pasta de soja fermentada aporta umami y probióticos: una forma sabrosa de cuidar la salud intestinal durante la semana.",
      "ingredients": [
        "3 tbsp doenjang (soybean paste)",
        "1 calabacín, 1 patata, 1 cebolla",
        "300g firm tofu, en cubos",
        "1 chile, champiñones",
        "4 tazas de agua, 2 dientes de ajo"
      ],
      "steps": [
        "Combine doenjang con agua; lleve a fuego lento.",
        "Añada la papa, la cebolla y los champiñones por 10 min.",
        "Añada el calabacín, el tofu, el ajo y el chile; cocine por 5 min.",
        "Ajuste la sazón.",
        "Sirva con arroz."
      ]
    }
  },
  "kr5": {
    "ru": {
      "recovery_note": "Праздничная корейская лапша без алкоголя — доказательство того, что традиционные блюда для торжеств прекрасно адаптируются для трезвого стола.",
      "ingredients": [
        "200g стеклянной лапши из сладкого картофеля",
        "1 capsicum, 1 морковь, нарезанные соломкой",
        "1 чашка шпината, грибы",
        "2 яйца",
        "Соевый соус, кунжутное масло, сахар, чеснок"
      ],
      "steps": [
        "Замочите лапшу в горячей воде на 10 min; слейте воду.",
        "Обжарьте каждый овощ отдельно в кунжутном масле (sesame oil).",
        "Приготовьте яичницу-болтунью (scrambled egg).",
        "Перемешайте лапшу с соевым соусом (soy), кунжутным маслом (sesame) и сахаром (sugar).",
        "Соедините все ингредиенты; посыпьте семенами кунжута (sesame seeds)."
      ]
    },
    "uk": {
      "recovery_note": "Святкова корейська локшина без алкоголю — доказ того, що традиційні святкові страви чудово адаптуються для безалкогольного столу.",
      "ingredients": [
        "200g крохмальної локшини з батату (sweet potato glass noodles)",
        "1 болгарський перець (capsicum), 1 морква, нарізані соломкою (julienned)",
        "1 чашка шпинату, гриби",
        "2 яйця",
        "Соєвий соус (soy), кунжутна олія (sesame oil), цукор, часник"
      ],
      "steps": [
        "Замочіть локшину в гарячій воді на 10 min; злийте воду.",
        "Обсмажте кожен овоч окремо в sesame oil.",
        "Приготуйте збите яйце (scrambled egg).",
        "Перемішайте локшину з соєвим соусом, sesame та цукром.",
        "З’єднайте все разом; посипте sesame seeds."
      ]
    },
    "ko": {
      "recovery_note": "술 없이 즐기는 잔치국수 — 명절 음식이 술 없는 식탁에서도 얼마나 훌륭하게 어우러지는지 보여줍니다.",
      "ingredients": [
        "200g 고구마 당면",
        "피망 1개, 당근 1개, 채 썰어서 준비",
        "시금치 1컵, 버섯",
        "계란 2개",
        "간장, 참기름, 설탕, 마늘"
      ],
      "steps": [
        "당면을 뜨거운 물에 10 min 동안 담가 불린 후 물기를 뺍니다.",
        "각 채소를 sesame oil에 각각 따로 볶습니다.",
        "scrambled egg를 만듭니다.",
        "당면을 soy, sesame, sugar와 함께 버무립니다.",
        "모든 재료를 섞고 sesame seeds를 뿌립니다."
      ]
    },
    "fr": {
      "recovery_note": "Nouilles coréennes festives sans alcool — la preuve que les plats de célébration culturels s'adaptent magnifiquement aux tables sobres.",
      "ingredients": [
        "200g de vermicelles de patate douce (glass noodles)",
        "1 poivron, 1 carotte, coupés en julienne",
        "1 tasse d'épinards, des champignons",
        "2 œufs",
        "Soy, sesame oil, sucre, ail"
      ],
      "steps": [
        "Faites tremper les nouilles dans l'eau chaude pendant 10 min ; égouttez.",
        "Faites sauter chaque légume séparément dans de l'huile de sésame.",
        "Préparez des œufs brouillés.",
        "Mélangez les nouilles avec du soja, du sésame et du sucre.",
        "Mélangez le tout ; saupoudrez de graines de sésame."
      ]
    },
    "it": {
      "recovery_note": "Tagliatelle coreane festive senza alcol: la dimostrazione che i piatti delle celebrazioni culturali si adattano splendidamente a tavole sobrie.",
      "ingredients": [
        "200g di vermicelli di fecola di patate dolci (glass noodles)",
        "1 peperone, 1 carota, tagliati a julienne",
        "1 tazza di spinaci, funghi",
        "2 uova",
        "Soia, olio di sesamo, zucchero, aglio"
      ],
      "steps": [
        "Mettere in ammollo i noodles in acqua calda per 10 min; scolare.",
        "Saltare ogni verdura separatamente in sesame oil.",
        "Cuocere l'uovo strapazzato.",
        "Condire i noodles con soy, sesame, sugar.",
        "Unire tutto; cospargere con sesame seeds."
      ]
    },
    "es": {
      "recovery_note": "Fideos coreanos festivos sin alcohol — demuestra que los platos tradicionales de celebración se adaptan de maravilla a las mesas sin alcohol.",
      "ingredients": [
        "200g sweet potato glass noodles",
        "1 pimiento, 1 zanahoria, en juliana",
        "1 taza de espinacas, champiñones",
        "2 huevos",
        "Soya, aceite de sésamo, azúcar, ajo"
      ],
      "steps": [
        "Remoje los fideos en agua caliente por 10 min; escurra.",
        "Saltee cada vegetal por separado en sesame oil.",
        "Cocine huevo revuelto.",
        "Mezcle los fideos con soy, sesame, sugar.",
        "Combine todo; espolvoree sesame seeds."
      ]
    }
  },
  "kr6": {
    "ru": {
      "recovery_note": "Традиционное корейское блюдо для дождливого дня — осознанное питание, которое пришло на смену зависимости и пошло во благо.",
      "ingredients": [
        "1 cup мука, 1/4 cup кукурузный крахмал",
        "1 cup ледяная вода",
        "1 яйцо, 1 пучок зеленый лук",
        "1 чили, соус для макания из сои и уксуса"
      ],
      "steps": [
        "Взбейте муку, кукурузный крахмал, воду и яйцо.",
        "Выложите зеленый лук на сковороду; залейте тестом.",
        "Готовьте 4 min до золотистого цвета.",
        "Переверните; готовьте еще 3 min.",
        "Подавайте с соусом для макания."
      ]
    },
    "uk": {
      "recovery_note": "Традиційна корейська страва для дощового дня — емоційне харчування, вирване з лап залежності та спрямоване в правильне русло.",
      "ingredients": [
        "1 cup борошна, 1/4 cup кукурудзяного крохмалю",
        "1 cup крижаної води",
        "1 яйце, 1 пучок зеленої цибулі",
        "1 чилі, соус для вмочування із сої та оцту"
      ],
      "steps": [
        "Збийте борошно, кукурудзяний крохмаль, воду та яйце.",
        "Викладіть зелену цибулю на сковорідку; залийте зверху batter.",
        "Готуйте 4 min до золотої скоринки.",
        "Переверніть; готуйте ще 3 min.",
        "Подавайте з соусом для вмочування."
      ]
    },
    "ko": {
      "recovery_note": "비 오는 날 생각나는 한국의 전통 음식 — 중독에서 벗어나 정서적 위안을 주는 건강한 식습관으로 승화시켰습니다.",
      "ingredients": [
        "1 cup flour, 1/4 cup cornflour",
        "1 cup ice water",
        "1 egg, 1 bunch spring onions",
        "1 chilli, soy and vinegar dipping sauce"
      ],
      "steps": [
        "밀가루, 옥수수 전분, 물, 달걀을 휘저어 섞습니다.",
        "팬에 쪽파를 깔고 그 위에 반죽을 붓습니다.",
        "황금색이 될 때까지 4분 동안 익힙니다.",
        "뒤집어서 3분 더 익힙니다.",
        "디핑 소스와 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat traditionnel coréen des jours de pluie — une cuisine émotionnelle réappropriée face à l'addiction et mise à profit.",
      "ingredients": [
        "1 cup farine, 1/4 cup cornflour",
        "1 cup eau glacée",
        "1 œuf, 1 botte de spring onions",
        "1 piment, sauce dip au soja et vinaigre"
      ],
      "steps": [
        "Fouetter la farine, la maïzena, l'eau et l'œuf.",
        "Disposer les oignons nouveaux dans la poêle ; verser la pâte par-dessus.",
        "Cuire 4 min jusqu'à ce que ce soit doré.",
        "Retourner ; cuire encore 3 min.",
        "Servir avec la sauce d'accompagnement."
      ]
    },
    "it": {
      "recovery_note": "Un piatto tradizionale coreano per le giornate di pioggia: la fame emotiva sottratta alla dipendenza e messa a frutto.",
      "ingredients": [
        "1 cup farina, 1/4 cup amido di mais (cornflour)",
        "1 cup acqua ghiacciata",
        "1 uovo, 1 mazzetto di cipollotti (spring onions)",
        "1 peperoncino (chilli), salsa d'accompagnamento alla soia e aceto (soy and vinegar dipping sauce)"
      ],
      "steps": [
        "Sbattere farina, amido di mais, acqua e uovo.",
        "Disporre i cipollotti in padella; versarvi sopra la pastella.",
        "Cuocere per 4 min fino a doratura.",
        "Girare; cuocere per altri 3 min.",
        "Servire con la salsa di accompagnamento."
      ]
    },
    "es": {
      "recovery_note": "Una comida coreana tradicional para los días de lluvia: el placer de comer emocionalmente recuperado de la adicción y puesto en buen uso.",
      "ingredients": [
        "1 cup harina, 1/4 cup harina de maíz",
        "1 cup agua helada",
        "1 huevo, 1 manojo de cebolletas",
        "1 chile, salsa de soja y vinagre para mojar"
      ],
      "steps": [
        "Batir la harina, cornflour, agua y el huevo.",
        "Colocar las spring onions en la sartén; verter el batter por encima.",
        "Cocinar 4 min hasta que esté dorado.",
        "Voltear; cocinar 3 min más.",
        "Servir con dipping sauce."
      ]
    }
  },
  "kr7": {
    "ru": {
      "recovery_note": "Огурец на 96% состоит из воды — увлажнение предотвращает головную боль и раздражительность, которые часто маскируются под тягу к еде.",
      "ingredients": [
        "2 огурца, нарезанных ломтиками",
        "1 tbsp gochugaru (корейский перец чили в хлопьях)",
        "1 tbsp соевого соуса, 1 tsp сахара",
        "1 tbsp рисового уксуса, семена кунжута",
        "2 зубчика чеснока"
      ],
      "steps": [
        "Нарежьте огурцы; посолите на 10 min, затем слейте жидкость.",
        "Взбейте соевый соус, сахар, уксус, gochugaru и чеснок.",
        "Перемешайте с огурцами.",
        "Посыпьте кунжутом.",
        "Подавайте немедленно или в охлажденном виде."
      ]
    },
    "uk": {
      "recovery_note": "Огірок на 96% складається з води — зволоження запобігає головному болю та дратівливості, які часто маскуються під відчуття голоду.",
      "ingredients": [
        "2 огірки, нарізані скибочками",
        "1 tbsp gochugaru (корейський перець чилі пластівцями)",
        "1 tbsp соєвого соусу, 1 tsp цукру",
        "1 tbsp рисового оцту, насіння кунжуту",
        "2 зубчики часнику"
      ],
      "steps": [
        "Наріжте огірки скибочками; посоліть на 10 min, потім злийте рідину.",
        "Збийте соєвий соус, цукор, оцет, gochugaru та часник.",
        "Перемішайте з огірками.",
        "Посипте насінням кунжуту.",
        "Подавайте негайно або охолодженим."
      ]
    },
    "ko": {
      "recovery_note": "오이는 96%가 수분으로 이루어져 있습니다 — 충분한 수분 섭취는 종종 식탐으로 오해받곤 하는 두통과 짜증을 예방해 줍니다.",
      "ingredients": [
        "오이 2개, 슬라이스",
        "고춧가루 (Korean chilli flakes) 1 tbsp",
        "간장 1 tbsp, 설탕 1 tsp",
        "쌀식초 1 tbsp, 참깨",
        "마늘 2쪽"
      ],
      "steps": [
        "오이를 썰고 소금에 10분간 절인 뒤 물기를 제거합니다.",
        "간장, 설탕, 식초, gochugaru, 마늘을 넣고 휘저어 섞습니다.",
        "양념에 오이를 넣고 버무립니다.",
        "참깨를 뿌립니다.",
        "즉시 서빙하거나 차갑게 보관하여 드세요."
      ]
    },
    "fr": {
      "recovery_note": "Le concombre est composé à 96% d'eau — l'hydratation prévient les maux de tête et l'irritabilité qui se font souvent passer pour des fringales.",
      "ingredients": [
        "2 concombres, tranchés",
        "1 tbsp gochugaru (Korean chilli flakes)",
        "1 tbsp soy, 1 tsp sucre",
        "1 tbsp rice vinegar, graines de sésame",
        "2 gousses d'ail"
      ],
      "steps": [
        "Couper les concombres en rondelles ; saler pendant 10 min, puis égoutter.",
        "Fouetter le soja, le sucre, le vinaigre, le gochugaru et l'ail.",
        "Mélanger avec le concombre.",
        "Saupoudrer de graines de sésame.",
        "Servir immédiatement ou frais."
      ]
    },
    "it": {
      "recovery_note": "Il cetriolo è composto per il 96% d'acqua — l'idratazione previene il mal di testa e l'irritabilità che spesso si manifestano sotto forma di voglie improvvise.",
      "ingredients": [
        "2 cetrioli, affettati",
        "1 tbsp gochugaru (fiocchi di peperoncino coreano)",
        "1 tbsp di soia, 1 tsp di zucchero",
        "1 tbsp di aceto di riso, semi di sesamo",
        "2 spicchi d'aglio"
      ],
      "steps": [
        "Affettare i cetrioli; salare per 10 min, poi scolare.",
        "Mescolare con una frusta soia, zucchero, aceto, gochugaru, aglio.",
        "Condire i cetrioli con il composto.",
        "Cospargere con semi di sesamo.",
        "Servire immediatamente o freddo."
      ]
    },
    "es": {
      "recovery_note": "El pepino tiene un 96% de agua; la hidratación previene el dolor de cabeza y la irritabilidad que a menudo se disfrazan de antojos.",
      "ingredients": [
        "2 pepinos, rebanados",
        "1 tbsp gochugaru (Korean chilli flakes)",
        "1 tbsp soya, 1 tsp azúcar",
        "1 tbsp vinagre de arroz, semillas de sésamo",
        "2 dientes de ajo"
      ],
      "steps": [
        "Rebane los pepinos; sale por 10 min, luego escurra.",
        "Bata la soya, el azúcar, el vinagre, el gochugaru y el ajo.",
        "Mezcle con el pepino.",
        "Espolvoree las semillas de sésamo.",
        "Sirva inmediatamente o frío."
      ]
    }
  },
  "kr8": {
    "ru": {
      "recovery_note": "Традиционное восстанавливающее средство — костный бульон длительного приготовления способствует заживлению кишечника, часто поврежденного многолетним употреблением алкоголя.",
      "ingredients": [
        "1 целая курица или 4 куриных окорочка",
        "1 луковица, 4 зубчика чеснока",
        "Ginger, зеленый лук",
        "1 стакан клейкого риса (glutinous rice)",
        "2 зизифуса (jujubes) (по желанию)"
      ],
      "steps": [
        "Поместите курицу с луком, чесноком, имбирем и jujubes в кастрюлю.",
        "Залейте водой; варите на медленном огне 50 min.",
        "Добавьте промытый рис в последние 30 min.",
        "Разберите курицу на волокна; верните в бульон.",
        "Украсьте зеленым луком; добавляйте специи при подаче на стол."
      ]
    },
    "uk": {
      "recovery_note": "Традиційний засіб для відновлення — бульйон тривалого приготування сприяє загоєнню кишечника, який часто зазнає пошкоджень внаслідок багаторічного вживання алкоголю.",
      "ingredients": [
        "1 ціла курка або 4 курячі ніжки",
        "1 цибуля, 4 зубчики часнику",
        "Імбир, зелена цибуля",
        "1 cup рису сорту glutinous rice",
        "2 jujubes (за бажанням)"
      ],
      "steps": [
        "Покладіть курку з цибулею, часником, імбиром та jujubes у каструлю.",
        "Залийте водою; тушкуйте на повільному вогні 50 min.",
        "Додайте промитий рис на останні 30 min.",
        "Подрібніть курку; поверніть її у бульйон.",
        "Посипте зверху зеленою цибулею; додайте спеції за смаком вже за столом."
      ]
    },
    "ko": {
      "recovery_note": "전통적인 회복식인 이 슬로우 쿠커 육수는 수년간의 음주로 손상된 장 건강 회복을 돕습니다.",
      "ingredients": [
        "통닭 1마리 또는 닭다리 4개",
        "양파 1개, 마늘 4쪽",
        "Ginger, spring onions",
        "찹쌀 1 cup",
        "jujubes 2개 (선택 사항)"
      ],
      "steps": [
        "냄비에 닭고기, onion, garlic, ginger, jujubes를 넣습니다.",
        "재료가 잠길 정도로 물을 붓고 50 min 동안 끓입니다.",
        "마지막 30 min 동안 씻어둔 쌀을 넣습니다.",
        "닭고기를 잘게 찢어 다시 육수에 넣습니다.",
        "spring onions를 고명으로 올리고 식탁에서 기호에 맞게 간을 합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un fortifiant traditionnel — le bouillon mijoté favorise la guérison intestinale, souvent endommagée par des années de consommation d'alcool.",
      "ingredients": [
        "1 poulet entier ou 4 cuisses de poulet",
        "1 oignon, 4 gousses d'ail",
        "Gingembre, oignons nouveaux",
        "1 cup de riz gluant",
        "2 jujubes (optionnel)"
      ],
      "steps": [
        "Placer le poulet avec l'oignon, l'ail, le gingembre et les jujubes dans une marmite.",
        "Couvrir d'eau ; laisser mijoter 50 min.",
        "Ajouter le riz rincé durant les 30 min restantes.",
        "Effilocher le poulet ; remettre dans le bouillon.",
        "Garnir d'oignons verts ; assaisonner à table."
      ]
    },
    "it": {
      "recovery_note": "Un ricostituente tradizionale: il brodo a cottura lenta favorisce la guarigione dell'intestino, spesso danneggiato da anni di consumo di alcol.",
      "ingredients": [
        "1 pollo intero o 4 cosce di pollo",
        "1 cipolla, 4 spicchi d’aglio",
        "Ginger, cipollotti",
        "1 cup di riso glutinoso",
        "2 jujubes (opzionale)"
      ],
      "steps": [
        "Mettere il pollo in una pentola con onion, garlic, ginger e jujubes.",
        "Coprire con acqua; cuocere a fuoco lento per 50 min.",
        "Aggiungere il riso sciacquato negli ultimi 30 min.",
        "Sfilacciare il pollo; rimetterlo nel brodo.",
        "Guarnire con spring onions; condire a tavola."
      ]
    },
    "es": {
      "recovery_note": "Un tónico tradicional: el caldo a fuego lento favorece la recuperación intestinal, a menudo dañada por años de consumo de alcohol.",
      "ingredients": [
        "1 pollo entero o 4 piernas de pollo",
        "1 cebolla, 4 dientes de ajo",
        "Ginger, cebolletas",
        "1 cup de arroz glutinoso",
        "2 jujubes (opcional)"
      ],
      "steps": [
        "Coloque el chicken con onion, garlic, ginger, y jujubes en una olla.",
        "Cubra con agua; cocine a fuego lento durante 50 min.",
        "Añada el arroz enjuagado durante los últimos 30 min.",
        "Deshebre el chicken; devuélvalo al caldo.",
        "Cubra con spring onions; sazone en la mesa."
      ]
    }
  },
  "kr9": {
    "ru": {
      "recovery_note": "Корейская уличная еда дома — заменяет ночные походы за фастфудом ритуалом приготовления пищи, которым можно насладиться в моменте и с полным осознанием.",
      "ingredients": [
        "400g корейских рисовых клецок (tteok)",
        "2 tbsp gochujang",
        "1 tbsp gochugaru, 1 tbsp соевого соуса",
        "1 tbsp сахара, 1 зубчик чеснока",
        "2 чашки бульона (stock), зеленый лук, кунжут"
      ],
      "steps": [
        "Замочите рисовые клецки, если они сухие.",
        "Смешайте соус с бульоном; доведите до кипения.",
        "Добавьте рисовые клецки; варите на медленном огне 10 min до загустения.",
        "Часто помешивайте, чтобы предотвратить прилипание.",
        "Посыпьте сверху кунжутом и зеленым луком."
      ]
    },
    "uk": {
      "recovery_note": "Корейська вулична їжа вдома — замініть нічні походи за закусками після вечірок кулінарним ритуалом, яким можна насолодитися з повною присутністю.",
      "ingredients": [
        "400g корейських рисових коржиків (tteok)",
        "2 tbsp gochujang",
        "1 tbsp gochugaru, 1 tbsp соєвого соусу",
        "1 tbsp цукру, 1 зубчик часнику",
        "2 cups бульйону, зелена цибуля, кунжут"
      ],
      "steps": [
        "Замочіть рисові коржики, якщо вони сухі.",
        "Змішайте соус із бульйоном; доведіть до кипіння.",
        "Додайте рисові коржики; тушкуйте 10 min, поки соус не загусне.",
        "Часто помішуйте, щоб запобігти прилипанню.",
        "Посипте зверху кунжутом та зеленою цибулею."
      ]
    },
    "ko": {
      "recovery_note": "집에서 즐기는 한국 길거리 음식 — 늦은 밤 술에 취해 간식을 사러 나가는 대신, 온전히 집중하며 즐길 수 있는 요리 리추얼로 대신해 보세요.",
      "ingredients": [
        "400g Korean rice cakes (tteok)",
        "2 tbsp gochujang",
        "1 tbsp gochugaru, 1 tbsp soy",
        "1 tbsp sugar, 1 garlic clove",
        "2 cups stock, spring onions, sesame"
      ],
      "steps": [
        "떡이 말라있다면 물에 불려주세요.",
        "소스와 육수를 섞은 뒤 끓여주세요.",
        "떡을 넣고 소스가 걸쭉해질 때까지 10분간 졸여주세요.",
        "눌어붙지 않도록 자주 저어주세요.",
        "참깨와 파를 고명으로 올려 마무리하세요."
      ]
    },
    "fr": {
      "recovery_note": "La street food coréenne à la maison — remplacez vos virées nocturnes pour des snacks alcoolisés par un rituel culinaire dont vous pourrez profiter en pleine conscience.",
      "ingredients": [
        "400g de gâteaux de riz coréens (tteok)",
        "2 tbsp de gochujang",
        "1 tbsp de gochugaru, 1 tbsp de sauce soja",
        "1 tbsp de sucre, 1 gousse d'ail",
        "2 cups de bouillon, oignons nouveaux, sésame"
      ],
      "steps": [
        "Faire tremper les gâteaux de riz s'ils sont secs.",
        "Mélanger la sauce avec le bouillon ; porter à ébullition.",
        "Ajouter les gâteaux de riz ; faire mijoter 10 min jusqu'à épaississement.",
        "Remuer fréquemment pour éviter qu'ils ne collent.",
        "Garnir de graines de sésame et d'oignons nouveaux."
      ]
    },
    "it": {
      "recovery_note": "Cibo di strada coreano a casa — sostituisce le corse notturne fuori per uno spuntino post-serata con un rituale culinario da godersi in piena consapevolezza.",
      "ingredients": [
        "400g di gnocchi di riso coreani (tteok)",
        "2 tbsp di gochujang",
        "1 tbsp di gochugaru, 1 tbsp di soia",
        "1 tbsp di zucchero, 1 spicchio d'aglio",
        "2 tazze di brodo, cipollotti, sesamo"
      ],
      "steps": [
        "Immergere gli rice cakes se sono secchi.",
        "Unire la salsa con il brodo; portare a ebollizione.",
        "Aggiungere gli rice cakes; sobbollire per 10 min finché non si addensa.",
        "Mescolare frequentemente per evitare che si attacchino.",
        "Guarnire con sesamo e cipollotti."
      ]
    },
    "es": {
      "recovery_note": "Comida callejera coreana en casa: sustituye los antojos nocturnos tras salir de fiesta con un ritual de cocina que puedes disfrutar con plena consciencia.",
      "ingredients": [
        "400g de pasteles de arroz coreanos (tteok)",
        "2 tbsp de gochujang",
        "1 tbsp de gochugaru, 1 tbsp de soja",
        "1 tbsp de azúcar, 1 diente de ajo",
        "2 tazas de caldo, cebolletas, sésamo"
      ],
      "steps": [
        "Remoje los pasteles de arroz si están secos.",
        "Combine la salsa con el caldo; lleve a ebullición.",
        "Añada los pasteles de arroz; cocine a fuego lento durante 10 min hasta que espese.",
        "Revuelva frecuentemente para evitar que se peguen.",
        "Cubra con sésamo y cebolletas."
      ]
    }
  },
  "kr10": {
    "ru": {
      "recovery_note": "Рулет из омлета, который выглядит впечатляюще и содержит полноценный белок — отличный способ обрести уверенность для начинающего кулинара.",
      "ingredients": [
        "4 яйца",
        "2 пера зеленого лука, мелко нарезанных",
        "1 морковь, нарезанная мелкими кубиками",
        "1 tbsp молока, соль",
        "Масло для сковороды"
      ],
      "steps": [
        "Взбейте яйца с milk, salt и овощами.",
        "Налейте тонким слоем на сковороду, смазанную маслом; готовьте 1 min.",
        "Сверните в рулет, пока масса еще мягкая.",
        "Отодвиньте на край; долейте еще яичной смеси; дайте приготовиться, затем оберните вокруг готового рулета.",
        "Нарежьте кружочками."
      ]
    },
    "uk": {
      "recovery_note": "Рулет із омлету, який має вражаючий вигляд і містить повноцінний білок — чудовий спосіб додати впевненості кухареві-початківцю.",
      "ingredients": [
        "4 яйця",
        "2 стебла зеленої цибулі, дрібно нарізані",
        "1 морква, нарізана дрібними кубиками",
        "1 tbsp молока, сіль",
        "Олія для сковорідки"
      ],
      "steps": [
        "Збийте яйця з milk, salt та овочами.",
        "Налийте тонким шаром на змащену олією сковорідку; готуйте 1 min.",
        "Згорніть у рулет, поки маса ще м'яка.",
        "Відсуньте набік; долийте ще яєчної суміші; дайте приготуватися, а потім обгорніть навколо готового рулету.",
        "Наріжте кружальцями."
      ]
    },
    "ko": {
      "recovery_note": "비주얼도 훌륭하고 완전 단백질까지 챙길 수 있는 달걀말이입니다. 초보 요리사에게 자신감을 불어넣어 줄 메뉴입니다.",
      "ingredients": [
        "달걀 4개",
        "잘게 썬 쪽파 2대",
        "곱게 다진 당근 1개",
        "우유 1 tbsp, 소금",
        "팬용 Oil"
      ],
      "steps": [
        "달걀을 우유, 소금, 채소와 함께 휘저어 섞습니다.",
        "기름을 두른 팬에 얇게 붓고 1분간 익힙니다.",
        "달걀이 아직 부드러울 때 돌돌 맙니다.",
        "한쪽으로 밀어 놓은 뒤 달걀물을 더 붓고, 익으면 기존에 말아둔 달걀 위로 겹쳐서 맙니다.",
        "동그란 모양으로 일정하게 썹니다."
      ]
    },
    "fr": {
      "recovery_note": "Une omelette roulée à l'aspect impressionnant qui apporte des protéines complètes — un véritable gage de confiance pour un cuisinier encore débutant.",
      "ingredients": [
        "4 œufs",
        "2 oignons nouveaux, finement hachés",
        "1 carotte, finement coupée en dés",
        "1 tbsp de lait, sel",
        "Huile pour la poêle"
      ],
      "steps": [
        "Fouetter les œufs avec le lait, le sel et les légumes.",
        "Verser une fine couche dans une poêle huilée ; cuire 1 min.",
        "Enrouler pendant que le mélange est encore tendre.",
        "Pousser sur le côté ; verser plus d'œuf ; laisser cuire puis rouler par-dessus le rouleau existant.",
        "Couper en rondelles."
      ]
    },
    "it": {
      "recovery_note": "Una frittata arrotolata dall'aspetto d'effetto che fornisce proteine complete: un'iniezione di fiducia per chi ha iniziato a cucinare da poco.",
      "ingredients": [
        "4 uova",
        "2 cipollotti, tritati finemente",
        "1 carota, tagliata a dadini piccoli",
        "1 tbsp latte, sale",
        "Olio per la padella"
      ],
      "steps": [
        "Sbattere le uova con latte, sale e verdure.",
        "Versare uno strato sottile in una padella oliata; cuocere per 1 min.",
        "Arrotolare mentre è ancora morbido.",
        "Spingere di lato; versare altro uovo; lasciare cuocere, quindi arrotolare sopra il rotolo esistente.",
        "Tagliare a fette rotonde."
      ]
    },
    "es": {
      "recovery_note": "Una tortilla enrollada que luce impresionante y aporta una proteína completa: un refuerzo de confianza para un cocinero aún novato.",
      "ingredients": [
        "4 huevos",
        "2 cebolletas, finamente picadas",
        "1 zanahoria, finamente picada",
        "1 tbsp leche, sal",
        "Aceite para la sartén"
      ],
      "steps": [
        "Batir los huevos con la leche, la sal y los vegetales.",
        "Verter una capa fina en una sartén aceitada; cocinar por 1 min.",
        "Enrollar mientras aún esté tierno.",
        "Empujar hacia un lado; verter más huevo; dejar cocinar y luego enrollar sobre el rollo existente.",
        "Cortar en rodajas."
      ]
    }
  },
  "l1": {
    "ru": {
      "recovery_note": "Идеальное противовоспалительное блюдо: полноценный растительный белок, сложные углеводы, полезные жиры и клетчатка, которые поддерживают стабильный уровень сахара в крови в течение всего дня.",
      "ingredients": [
        "1/2 cup готового киноа",
        "1/2 cup консервированного нута, промытого",
        "1 cup смеси листовой зелени",
        "1/2 cup запеченного сладкого картофеля",
        "1/4 avocado, нарезанного ломтиками",
        "2 tbsp tahini, 1 tbsp лимонного сока, вода"
      ],
      "steps": [
        "Приготовьте киноа согласно инструкции на упаковке или используйте остатки.",
        "Смешайте нут и нарезанный кубиками сладкий картофель с оливковым маслом; запекайте при 200°C в течение 15 минут.",
        "Взбейте тахини, лимонный сок и воду до получения текучей консистенции.",
        "Выложите слоями зелень, киноа, нут, сладкий картофель и авокадо в миску.",
        "Полейте заправкой из тахини и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Ідеальна протизапальна тарілка: повноцінний рослинний білок, складні вуглеводи, корисні жири та клітковина, що підтримує стабільний рівень цукру в крові протягом дня.",
      "ingredients": [
        "1/2 чашки готового кіноа",
        "1/2 чашки консервованого нуту, промитого",
        "1 чашка міксу листової зелені",
        "1/2 чашки запеченої солодкої картоплі (батату)",
        "1/4 авокадо, нарізаного скибочками",
        "2 tbsp тахіні, 1 tbsp лимонного соку, вода"
      ],
      "steps": [
        "Приготуйте кіноа згідно з інструкцією на упаковці або використайте залишки.",
        "Перемішайте нут та нарізану кубиками солодку картоплю з оливковою олією; запікайте при 200°C протягом 15 хвилин.",
        "Збийте тахіні, лимонний сік і воду до консистенції, що ллється.",
        "Викладіть шарами зелень, кіноа, нут, солодку картоплю та авокадо в миску.",
        "Полийте заправкою з тахіні та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "완벽한 항염증 식단입니다. 완전한 식물성 단백질, 복합 탄수화물, 건강한 지방, 그리고 오후 내내 혈당을 안정적으로 유지해 주는 식이섬유가 포함되어 있습니다.",
      "ingredients": [
        "익힌 퀴노아 1/2 cup",
        "헹군 병아리콩 통조림 1/2 cup",
        "혼합 잎채소 1 cup",
        "구운 고구마 1/2 cup",
        "슬라이스한 아보카도 1/4",
        "tahini 2 tbsp, 레몬즙 1 tbsp, 물"
      ],
      "steps": [
        "패키지 안내에 따라 quinoa를 조리하거나 남은 것을 사용합니다.",
        "chickpeas와 깍둑썰기한 고구마를 olive oil과 버무린 후, 200°C에서 15분간 로스트합니다.",
        "tahini, 레몬즙, 물을 부드럽게 흐를 정도의 농도가 될 때까지 휘저어 섞습니다.",
        "볼에 채소, quinoa, chickpeas, 고구마, avocado를 층층이 담습니다.",
        "tahini 드레싱을 뿌려 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Une assiette anti-inflammatoire parfaite : des protéines végétales complètes, des glucides complexes, des graisses saines et des fibres qui maintiennent une glycémie stable tout au long de l'après-midi.",
      "ingredients": [
        "1/2 cup quinoa cuit",
        "1/2 cup pois chiches en conserve, rincés",
        "1 cup mélange de légumes à feuilles vertes",
        "1/2 cup patate douce rôtie",
        "1/4 avocat, tranché",
        "2 tbsp tahini, 1 tbsp jus de citron, eau"
      ],
      "steps": [
        "Cuire le quinoa selon les instructions du paquet ou utiliser des restes.",
        "Mélanger les pois chiches et les patates douces coupées en dés avec de l'huile d'olive ; rôtir à 200°C pendant 15 mins.",
        "Fouetter le tahini, le jus de citron et l'eau jusqu'à l'obtention d'une consistance liquide.",
        "Disposer les légumes verts, le quinoa, les pois chiches, la patate douce et l'avocat en couches dans un bol.",
        "Arroser avec la vinaigrette au tahini et servir."
      ]
    },
    "it": {
      "recovery_note": "Un piatto antinfiammatorio perfetto: proteine vegetali complete, carboidrati complessi, grassi sani e fibre che mantengono stabili i livelli di zucchero nel sangue per tutto il pomeriggio.",
      "ingredients": [
        "1/2 cup quinoa cotta",
        "1/2 cup ceci in scatola, risciacquati",
        "1 cup foglie verdi miste",
        "1/2 cup patata dolce arrostita",
        "1/4 avocado, affettato",
        "2 tbsp tahini, 1 tbsp succo di limone, acqua"
      ],
      "steps": [
        "Cuocere la quinoa come indicato sulla confezione o utilizzare quella avanzata.",
        "Condire i ceci e la patata dolce a cubetti con olio d'oliva; arrostire a 200°C per 15 min.",
        "Mescolare con una frusta tahini, succo di limone e acqua fino a ottenere una consistenza fluida.",
        "Disporre a strati verdure a foglia, quinoa, ceci, patata dolce e avocado in una ciotola.",
        "Condire con il dressing alla tahini e servire."
      ]
    },
    "es": {
      "recovery_note": "Un plato antiinflamatorio perfecto: proteína vegetal completa, carbohidratos complejos, grasas saludables y fibra que mantiene estables los niveles de azúcar en sangre durante toda la tarde.",
      "ingredients": [
        "1/2 cup quinoa cocida",
        "1/2 cup garbanzos de lata, enjuagados",
        "1 cup mezcla de hojas verdes",
        "1/2 cup camote asado",
        "1/4 aguacate, rebanado",
        "2 tbsp tahini, 1 tbsp lemon juice, agua"
      ],
      "steps": [
        "Cocine la quinoa según el paquete o use las sobras.",
        "Mezcle los garbanzos y el camote en dados con aceite de oliva; asar a 200°C por 15 mins.",
        "Batir el tahini, el jugo de limón y el agua hasta que se pueda verter.",
        "Coloque capas de verduras verdes, quinoa, garbanzos, camote y aguacate en un bol.",
        "Rocíe con el aderezo de tahini y sirva."
      ]
    }
  },
  "l2": {
    "ru": {
      "recovery_note": "Высокое содержание белка и растворимой клетчатки обеспечивает мягкий инсулиновый отклик. Омега-3 жирные кислоты в тунце клинически ассоциируются с уменьшением тяги к еде и улучшением настроения.",
      "ingredients": [
        "1 банка тунца в оливковом масле, без жидкости",
        "1 банка фасоли cannellini, промытой",
        "1 cup помидоров черри, разрезанных пополам",
        "1/4 красного лука, мелко нарезанного",
        "2 tbsp оливкового масла, 1 tbsp винного уксуса",
        "Свежая петрушка, соль, перец"
      ],
      "steps": [
        "Смешайте тунец, бобы, томаты и лук в миске.",
        "Взбейте оливковое масло и уксус; приправьте.",
        "Полейте салат и аккуратно перемешайте.",
        "Посыпьте петрушкой.",
        "Подавайте на листьях салата или с хрустящим хлебом."
      ]
    },
    "uk": {
      "recovery_note": "Високий вміст білка та розчинної клітковини забезпечує м’яку інсулінову відповідь. Омега-3 у тунці клінічно асоціюються зі зменшенням тяги до їжі та покращенням настрою.",
      "ingredients": [
        "1 банка тунця в оливковій олії, відцідженого",
        "1 банка квасолі cannellini, промитої",
        "1 склянка томатів чері, розрізаних навпіл",
        "1/4 червоної цибулі, дрібно нарізаної",
        "2 tbsp оливкової олії, 1 tbsp червоного винного оцту",
        "Свіжа петрушка, сіль, перець"
      ],
      "steps": [
        "Змішайте тунець, квасолю, помідори та цибулю в мисці.",
        "Збийте оливкову олію та оцет; додайте спеції.",
        "Полийте салат заправкою та обережно перемішайте.",
        "Посипте зверху петрушкою.",
        "Подавайте на листі салату або з хрустким хлібом."
      ]
    },
    "ko": {
      "recovery_note": "고단백질과 수용성 식이섬유는 인슐린 반응을 완만하게 유지해 줍니다. 참치에 함유된 오메가-3는 식탐 감소 및 기분 개선과 임상적으로 관련이 있습니다.",
      "ingredients": [
        "1 tin 올리브 오일 참치, 기름기를 뺀 것",
        "1 tin cannellini beans, 헹군 것",
        "1 cup 방울토마토, 절반으로 자른 것",
        "1/4 적양파, 얇게 채 썬 것",
        "2 tbsp 올리브 오일, 1 tbsp red wine vinegar",
        "신선한 파슬리, 소금, 후추"
      ],
      "steps": [
        "볼에 tuna, 콩, 토마토, 양파를 넣고 섞습니다.",
        "올리브 오일과 식초를 휘저어 섞은 뒤 시즈닝합니다.",
        "드레싱을 샐러드 위에 붓고 가볍게 버무립니다.",
        "파슬리를 고명으로 올립니다.",
        "샐러드 잎 채소 위에 얹어 내거나 바삭한 빵과 함께 곁들입니다."
      ]
    },
    "fr": {
      "recovery_note": "Une teneur élevée en protéines et en fibres solubles permet de maintenir une réponse insulinique modérée. Les oméga-3 contenus dans le thon sont cliniquement associés à une réduction des fringales et à une amélioration de l'humeur.",
      "ingredients": [
        "1 boîte de thon à l'huile d'olive, égoutté",
        "1 boîte de haricots cannellini, rincés",
        "1 cup de tomates cerises, coupées en deux",
        "1/4 d'oignon rouge, finement émincé",
        "2 tbsp d'huile d'olive, 1 tbsp de vinaigre de vin rouge",
        "Persil frais, sel, poivre"
      ],
      "steps": [
        "Mélanger le thon, les haricots, les tomates et l'oignon dans un bol.",
        "Fouetter l'huile d'olive et le vinaigre ; assaisonner.",
        "Verser sur la salade et mélanger délicatement.",
        "Garnir de persil.",
        "Servir sur des feuilles de salade ou avec du pain croustillant."
      ]
    },
    "it": {
      "recovery_note": "L'alto contenuto proteico e le fibre solubili mantengono moderata la risposta insulinica. Gli omega-3 contenuti nel tonno sono clinicamente associati a una riduzione del desiderio di cibo e a un miglioramento dell'umore.",
      "ingredients": [
        "1 scatoletta di tuna in olive oil, sgocciolato",
        "1 lattina di cannellini beans, sciacquati",
        "1 cup di cherry tomatoes, tagliati a metà",
        "1/4 di red onion, affettata finemente",
        "2 tbsp di olive oil, 1 tbsp di red wine vinegar",
        "Prezzemolo fresco, salt, pepper"
      ],
      "steps": [
        "Unire tonno, fagioli, pomodori e cipolla in una ciotola.",
        "Sbattere olio d'oliva e aceto; condire.",
        "Versare sull'insalata e mescolare delicatamente.",
        "Completare con il prezzemolo.",
        "Servire su un letto di foglie o con del pane croccante."
      ]
    },
    "es": {
      "recovery_note": "El alto contenido de proteínas + la fibra soluble mantienen una respuesta a la insulina moderada. Los omega-3 del atún están clínicamente asociados con la reducción de los antojos y la mejora del estado de ánimo.",
      "ingredients": [
        "1 lata de tuna en olive oil, escurrida",
        "1 lata de cannellini beans, enjuagados",
        "1 taza de cherry tomatoes, cortados por la mitad",
        "1/4 de cebolla roja, finamente rebanada",
        "2 tbsp de olive oil, 1 tbsp de red wine vinegar",
        "Perejil fresco, sal, pimienta"
      ],
      "steps": [
        "Combine el atún, los frijoles, los tomates y la cebolla en un bol.",
        "Bata el olive oil y el vinagre; sazone.",
        "Vierta sobre la ensalada y mezcle suavemente.",
        "Cubra con perejil.",
        "Sirva sobre hojas verdes o con pan crujiente."
      ]
    }
  },
  "l3": {
    "ru": {
      "recovery_note": "Чечевица содержит железо, фолиевую кислоту и медленные углеводы, помогая справиться с усталостью, которая часто сопровождает первые этапы отказа от алкоголя. Рассчитано на 4 порции; хорошо переносит заморозку.",
      "ingredients": [
        "1 cup коричневой или зеленой чечевицы",
        "1 onion, нарезанный кубиками",
        "2 carrots, нарезанные кубиками",
        "2 celery stalks, нарезанные кубиками",
        "4 cups овощного бульона",
        "1 tin нарезанных томатов, 1 tsp кумина, 1 bay leaf"
      ],
      "steps": [
        "Обжаривайте лук, морковь и сельдерей в масле в течение 5 minutes.",
        "Добавьте чечевицу, томаты, бульон, cumin и лавровый лист.",
        "Доведите до кипения, затем варите на медленном огне 25–30 minutes до мягкости чечевицы.",
        "Приправьте солью и перцем.",
        "Подавайте с ломтиком цельнозернового хлеба."
      ]
    },
    "uk": {
      "recovery_note": "Сочевиця містить залізо, фолієву кислоту та повільні вуглеводи — це допомагає подолати втому, яка часто супроводжує перші етапи тверезості. Розраховано на 4 servings; добре підходить для заморожування.",
      "ingredients": [
        "1 чашка коричневої або зеленої сочевиці",
        "1 цибулина, нарізана кубиками",
        "2 моркви, нарізані кубиками",
        "2 стебла селери, нарізані кубиками",
        "4 чашки vegetable stock",
        "1 бляшанка подрібнених томатів, 1 tsp кумину, 1 лавровий лист"
      ],
      "steps": [
        "Обсмажуйте цибулю, моркву та селеру в олії протягом 5 minutes.",
        "Додайте сочевицю, томати, stock, кумин та лавровий лист.",
        "Доведіть до кипіння, потім тушкуйте на повільному вогні 25–30 minutes до м'якості сочевиці.",
        "Приправте сіллю та перцем.",
        "Подавайте зі скибочкою цільнозернового хліба."
      ]
    },
    "ko": {
      "recovery_note": "렌틸콩은 철분, 엽산, 그리고 서서히 타오르는 탄수화물을 공급하여 초기 금주 단계에서 흔히 동반되는 피로감을 해소해 줍니다. 4인분 기준이며 냉동 보관하기 좋습니다.",
      "ingredients": [
        "갈색 또는 녹색 렌틸콩 1 cup",
        "잘게 썬 양파 1개",
        "잘게 썬 당근 2개",
        "잘게 썬 셀러리 2줄기",
        "vegetable stock 4 cups",
        "캔 형태의 chopped tomatoes 1개, 큐민 1 tsp, 월계수 잎 1장"
      ],
      "steps": [
        "양파, 당근, 셀러리를 오일에 넣고 5분 동안 볶습니다.",
        "렌틸콩, 토마토, stock, cumin, bay leaf를 넣습니다.",
        "끓어오르면 불을 줄이고 렌틸콩이 부드러워질 때까지 25–30분 동안 뭉근하게 끓입니다.",
        "소금과 후추로 간을 합니다.",
        "통밀빵(wholemeal bread) 한 조각을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Les lentilles apportent du fer, des folates et des glucides à diffusion lente — remédiant ainsi à la fatigue qui accompagne souvent le début de la sobriété. Pour 4 portions ; se congèle bien.",
      "ingredients": [
        "1 cup de lentilles brunes ou vertes",
        "1 oignon, coupé en dés",
        "2 carottes, coupées en dés",
        "2 branches de céleri, coupées en dés",
        "4 cups de bouillon de légumes",
        "1 boîte de tomates concassées, 1 tsp de cumin, 1 feuille de laurier"
      ],
      "steps": [
        "Faire sauter l'oignon, la carotte et le céleri dans l'huile pendant 5 minutes.",
        "Ajouter les lentilles, les tomates, le bouillon, le cumin et la feuille de laurier.",
        "Porter à ébullition, puis laisser mijoter 25–30 minutes jusqu'à ce que les lentilles soient tendres.",
        "Assaisonner avec du sel et du poivre.",
        "Servir avec une tranche de pain complet."
      ]
    },
    "it": {
      "recovery_note": "Le lenticchie forniscono ferro, acido folico e carboidrati a lento rilascio, contrastando la spossatezza che spesso accompagna i primi tempi della sobrietà. Dosi per 4 porzioni; si congela bene.",
      "ingredients": [
        "1 cup di lenticchie marroni o verdi",
        "1 cipolla, dadini",
        "2 carote, a dadini",
        "2 coste di sedano, a dadini",
        "4 cups di vegetable stock",
        "1 tin di chopped tomatoes, 1 tsp di cumino, 1 foglia di alloro"
      ],
      "steps": [
        "Soffriggere cipolla, carota e sedano in olio per 5 minuti.",
        "Aggiungere lenticchie, pomodori, brodo, cumino e foglia di alloro.",
        "Portare a bollore, poi sobbollire per 25–30 minuti finché le lenticchie non saranno tenere.",
        "Condire con sale e pepe.",
        "Servire con una fetta di pane integrale."
      ]
    },
    "es": {
      "recovery_note": "Las lentejas aportan hierro, folato y carbohidratos de liberación lenta, combatiendo la fatiga que suele acompañar a las primeras etapas de la sobriedad. Rinde para 4 servings; se congela bien.",
      "ingredients": [
        "1 taza de lentejas marrones o verdes",
        "1 cebolla, picada en cubitos",
        "2 zanahorias, picadas en cubitos",
        "2 tallos de apio, picados en cubitos",
        "4 tazas de caldo de verduras (vegetable stock)",
        "1 lata de tomates picados, 1 cucharadita de comino, 1 hoja de laurel"
      ],
      "steps": [
        "Saltee la cebolla, la zanahoria y el apio en aceite durante 5 minutos.",
        "Añada las lentejas, los tomates, el caldo, el comino y la hoja de laurel.",
        "Lleve a ebullición, luego cocine a fuego lento durante 25–30 minutos hasta que las lentejas estén tiernas.",
        "Sazone con sal y pimienta.",
        "Sirva con una rebanada de pan integral."
      ]
    }
  },
  "l4": {
    "ru": {
      "recovery_note": "Нежирная курица является источником полноценного белка, необходимого для восстановления печени и синтеза нейромедиаторов после длительного употребления психоактивных веществ.",
      "ingredients": [
        "1 chicken breast, нарезанная ломтиками",
        "1 wholemeal wrap",
        "2 cups салата romaine, нашинкованного",
        "2 tbsp light Caesar dressing",
        "2 tbsp parmesan, стружка",
        "1 tsp olive oil, соль, перец"
      ],
      "steps": [
        "Приправьте курицу; обжаривайте на гриле по 3–4 минуты с каждой стороны до полной готовности.",
        "Нарежьте полосками.",
        "Смешайте салат с заправкой.",
        "Выложите курицу, салат и parmesan на лепешку (wrap).",
        "Плотно сверните, разрежьте пополам и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Нежирна курятина є джерелом повноцінного білка, необхідного для відновлення печінки та синтезу нейромедіаторів після тривалого вживання психоактивних речовин.",
      "ingredients": [
        "1 куряча грудка, нарізана скибочками",
        "1 wholemeal wrap",
        "2 чашки салату romaine, подрібненого",
        "2 tbsp light Caesar dressing",
        "2 tbsp пармезану, нарізаного пластівцями",
        "1 tsp оливкової олії, сіль, перець"
      ],
      "steps": [
        "Приправте курку; смажте на грилі по 3–4 хвилини з кожного боку до повної готовності.",
        "Наріжте смужками.",
        "Перемішайте листя салату з заправкою.",
        "Викладіть курку, салат і parmesan на тортилью.",
        "Щільно згорніть, розріжте навпіл і подавайте."
      ]
    },
    "ko": {
      "recovery_note": "지방이 적은 닭고기는 장기간의 약물 복용 후 간 회복과 신경전달물질 합성에 필수적인 완전 단백질을 제공합니다.",
      "ingredients": [
        "닭가슴살 1개, 슬라이스",
        "통밀 wrap 1개",
        "로메인 상추 2 cups, 채 썰기",
        "light Caesar dressing 2 tbsp",
        "파마산 치즈 2 tbsp, 얇게 깎기",
        "올리브 오일 1 tsp, 소금, 후추"
      ],
      "steps": [
        "치킨에 양념을 한 뒤, 속까지 다 익을 때까지 한 면당 3–4분씩 굽습니다.",
        "길쭉한 스트립 모양으로 썹니다.",
        "레터스를 드레싱과 함께 버무립니다.",
        "랩 위에 치킨, 레터스, parmesan 치즈를 쌓아 올립니다.",
        "단단하게 말아 절반으로 자른 뒤 제공합니다."
      ]
    },
    "fr": {
      "recovery_note": "Le poulet maigre fournit des protéines complètes essentielles à la réparation du foie et à la synthèse des neurotransmetteurs après une consommation prolongée de substances.",
      "ingredients": [
        "1 blanc de poulet, émincé",
        "1 wholemeal wrap",
        "2 cups de laitue romaine, râpée",
        "2 tbsp de sauce Caesar légère",
        "2 tbsp de parmesan, en copeaux",
        "1 tsp d'huile d'olive, sel, poivre"
      ],
      "steps": [
        "Assaisonner le poulet ; griller 3–4 minutes par côté jusqu'à ce qu'il soit bien cuit.",
        "Couper en lanières.",
        "Mélanger la laitue avec la vinaigrette.",
        "Empiler le poulet, la laitue et le parmesan sur le wrap.",
        "Rouler serré, couper en deux, servir."
      ]
    },
    "it": {
      "recovery_note": "Il pollo magro fornisce proteine complete essenziali per la riparazione del fegato e la sintesi dei neurotrasmettitori dopo l'uso prolungato di sostanze.",
      "ingredients": [
        "1 petto di pollo, affettato",
        "1 wrap integrale",
        "2 tazze di lattuga romana, sminuzzata",
        "2 tbsp di Caesar dressing leggero",
        "2 tbsp di parmigiano, a scaglie",
        "1 tsp di olio d'oliva, sale, pepe"
      ],
      "steps": [
        "Condire il pollo; grigliare 3–4 minuti per lato fino a cottura completa.",
        "Tagliare a strisce.",
        "Mescolare la lattuga con il condimento.",
        "Disporre il pollo, la lattuga e il parmesan sulla wrap.",
        "Arrotolare strettamente, tagliare a metà e servire."
      ]
    },
    "es": {
      "recovery_note": "El pollo magro proporciona proteínas completas esenciales para la reparación del hígado y la síntesis de neurotransmisores tras el consumo de sustancias a largo plazo.",
      "ingredients": [
        "1 pechuga de pollo, rebanada",
        "1 wholemeal wrap",
        "2 tazas de lechuga romana, rallada",
        "2 tbsp de aderezo Caesar light",
        "2 tbsp de parmesano, en virutas",
        "1 tsp de aceite de oliva, sal, pimienta"
      ],
      "steps": [
        "Sazone el pollo; áselo a la parrilla de 3 a 4 minutos por cada lado hasta que esté bien cocido.",
        "Córtelo en tiras.",
        "Mezcle la lechuga con el aderezo.",
        "Coloque el pollo, la lechuga y el parmesan sobre el wrap.",
        "Enróllelo firmemente, córtelo a la mitad y sirva."
      ]
    }
  },
  "l5": {
    "ru": {
      "recovery_note": "Средиземноморский тип питания является наиболее изученной диетой в исследованиях психического здоровья — неоднократно доказано, что он снижает выраженность симптомов депрессии и тревоги.",
      "ingredients": [
        "1 банка chickpeas, обсушенных",
        "1 огурец, нарезанный кубиками",
        "1 чашка cherry tomatoes, разрезанных пополам",
        "50g feta, раскрошенного",
        "10 kalamata olives",
        "Olive oil, лимонный сок, орегано"
      ],
      "steps": [
        "Смешайте нут, огурцы, помидоры и оливки в миске.",
        "Сверху выложите сыр feta.",
        "Взбейте оливковое масло, лимонный сок и орегано; залейте смесью салат.",
        "Аккуратно перемешайте.",
        "Подавайте немедленно или охладите 30 min для более насыщенного вкуса."
      ]
    },
    "uk": {
      "recovery_note": "Середземноморський тип харчування є найбільш вивченою дієтою в дослідженнях психічного здоров'я — вона неодноразово демонструвала здатність полегшувати симптоми депресії та тривоги.",
      "ingredients": [
        "1 банка chickpeas, проціджених",
        "1 огірок, нарізаний кубиками",
        "1 склянка томатів cherry, розрізаних навпіл",
        "50g feta, розкришеної",
        "10 оливок kalamata",
        "Olive oil, лимонний сік, орегано"
      ],
      "steps": [
        "Змішайте нут, огірок, томати та оливки в мисці.",
        "Зверху викладіть фету.",
        "Збийте оливкову олію, лимонний сік та орегано; полийте зверху.",
        "Обережно перемішайте.",
        "Подавайте негайно або охолодіть 30 min для більш насиченого смаку."
      ]
    },
    "ko": {
      "recovery_note": "지중해식 식단은 정신 건강 연구에서 가장 많이 연구된 식단으로, 우울증과 불안 증상을 낮춰준다는 사실이 반복적으로 입증되었습니다.",
      "ingredients": [
        "병아리콩 1 tin, 물기를 뺀 것",
        "오이 1개, 깍둑썰기한 것",
        "방울토마토 1 cup, 반으로 자른 것",
        "페타 치즈 50g, 잘게 부순 것",
        "kalamata olives 10알",
        "올리브 오일, 레몬 주스, 오레가노"
      ],
      "steps": [
        "볼에 병아리콩, 오이, 토마토, 올리브를 넣고 섞습니다.",
        "그 위에 페타 치즈를 올립니다.",
        "올리브 오일, 레몬 주스, 오레가노를 휘저어 섞은 뒤 위에 붓습니다.",
        "가볍게 버무립니다.",
        "즉시 서빙하거나 더 깊은 맛을 위해 30 min 동안 차갑게 둡니다."
      ]
    },
    "fr": {
      "recovery_note": "Le modèle méditerranéen est le régime alimentaire le plus étudié dans la recherche sur la santé mentale — il a été démontré à plusieurs reprises qu'il réduit les symptômes de la dépression et de l'anxiété.",
      "ingredients": [
        "1 boîte de pois chiches, égouttés",
        "1 concombre, coupé en dés",
        "1 tasse de tomates cerises, coupées en deux",
        "50g de feta, émiettée",
        "10 olives kalamata",
        "Huile d’olive, jus de citron, origan"
      ],
      "steps": [
        "Mélanger les pois chiches, le concombre, les tomates et les olives dans un bol.",
        "Garnir de feta.",
        "Fouetter l'huile d'olive, le jus de citron et l'origan ; verser sur le mélange.",
        "Mélanger délicatement.",
        "Servir immédiatement ou réfrigérer 30 min pour des saveurs plus intenses."
      ]
    },
    "it": {
      "recovery_note": "Il modello mediterraneo è la dieta più studiata nella ricerca sulla salute mentale, avendo dimostrato ripetutamente di ridurre i sintomi di depressione e ansia.",
      "ingredients": [
        "1 lattina di ceci, sgocciolati",
        "1 cetriolo, tagliato a dadini",
        "1 tazza di pomodori cherry, tagliati a metà",
        "50g feta, sbriciolata",
        "10 kalamata olives",
        "Olive oil, succo di limone, origano"
      ],
      "steps": [
        "Unire i ceci, il cetriolo, i pomodori e le olive in una ciotola.",
        "Completare con la feta.",
        "Sbattere l'olio d'oliva, il succo di limone e l'origano; versare sopra.",
        "Mescolare delicatamente.",
        "Servire immediatamente o lasciare raffreddare per 30 min per un sapore più intenso."
      ]
    },
    "es": {
      "recovery_note": "El patrón mediterráneo es la dieta más estudiada en la investigación sobre salud mental — habiendo demostrado repetidamente que reduce los síntomas de depresión y ansiedad.",
      "ingredients": [
        "1 lata de garbanzos, escurridos",
        "1 pepino, cortado en cubos",
        "1 cup de tomates cherry, cortados por la mitad",
        "50g de queso feta, desmenuzado",
        "10 aceitunas kalamata",
        "Aceite de oliva, jugo de limón, orégano"
      ],
      "steps": [
        "Combine los garbanzos, el pepino, los tomates y las aceitunas en un bol.",
        "Cubra con el queso feta.",
        "Bata el aceite de oliva, el jugo de limón y el orégano; vierta por encima.",
        "Mezcle suavemente.",
        "Sirva inmediatamente o refrigere por 30 min para un sabor más intenso."
      ]
    }
  },
  "l6": {
    "ru": {
      "recovery_note": "Богатый омега-3 лосось в сочетании со сложными углеводами и клетчаткой — это сбалансированное блюдо, которое обеспечивает стабильный приток энергии без резких спадов, часто провоцирующих тягу к еде.",
      "ingredients": [
        "120g лосося категории sashimi-grade, нарезанного кубиками",
        "1/2 cup коричневого риса, приготовленного",
        "1/4 авокадо, нарезанного ломтиками",
        "1/4 cup эдамаме",
        "1/4 огурца, нарезанного кубиками",
        "Soy sauce, sesame oil, sesame seeds"
      ],
      "steps": [
        "Отварите коричневый рис и дайте ему немного остыть.",
        "Перемешайте лосось с 1 tsp соевого соуса и кунжутного масла (sesame oil).",
        "Выложите рис слоем в миску.",
        "Разложите сверху лосось, авокадо, эдамаме (edamame) и огурец.",
        "Сбрызните соевым соусом и посыпьте семенами кунжута (sesame seeds)."
      ]
    },
    "uk": {
      "recovery_note": "Багатий на омега-3 лосось у поєднанні зі складними вуглеводами та клітковиною — це збалансована страва, яка підтримує рівень енергії без різких перепадів, що часто провокують відчуття голоду.",
      "ingredients": [
        "120g лосося сорту сашимі, нарізаного кубиками",
        "1/2 cup коричневого рису, приготованого",
        "1/4 авокадо, нарізаного скибочками",
        "1/4 cup едамаме",
        "1/4 огірка, нарізаного кубиками",
        "Soy sauce, sesame oil, sesame seeds"
      ],
      "steps": [
        "Відваріть коричневий рис і дайте йому трохи охолонути.",
        "Змішайте лосось з 1 tsp соєвого соусу та кунжутною олією.",
        "Викладіть рис у миску шаром.",
        "Зверху розкладіть лосось, авокадо, едамаме та огірок.",
        "Полийте соєвим соусом і посипте насінням кунжуту."
      ]
    },
    "ko": {
      "recovery_note": "오메가-3가 풍부한 연어에 복합 탄수화물과 식이섬유를 더했습니다. 갈망을 유발하는 급격한 혈당 저하 없이 에너지를 지속시켜 주는 균형 잡힌 식단입니다.",
      "ingredients": [
        "120g sashimi-grade salmon, 깍둑썰기",
        "1/2 cup brown rice, 조리됨",
        "1/4 avocado, 슬라이스",
        "1/4 cup edamame",
        "1/4 cucumber, 깍둑썰기",
        "Soy sauce, sesame oil, sesame seeds"
      ],
      "steps": [
        "현미밥을 지어 약간 식혀둡니다.",
        "연어를 1 tsp의 간장, 참기름과 함께 버무립니다.",
        "그릇에 밥을 층층이 담습니다.",
        "그 위에 연어, 아보카도, edamame, 오이를 가지런히 올립니다.",
        "간장을 뿌리고 참깨를 흩뿌려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Du saumon riche en oméga-3 associé à des glucides complexes et des fibres — un repas équilibré qui maintient l'énergie sans le contrecoup qui déclenche souvent les fringales.",
      "ingredients": [
        "120g de saumon de qualité sashimi, coupé en dés",
        "1/2 cup de riz complet, cuit",
        "1/4 d'avocat, tranché",
        "1/4 cup d'edamame",
        "1/4 de concombre, coupé en dés",
        "Sauce soja, huile de sésame, graines de sésame"
      ],
      "steps": [
        "Faites cuire le riz complet et laissez-le refroidir légèrement.",
        "Mélangez le saumon avec 1 tsp de soja et d'huile de sésame.",
        "Disposez le riz en couches dans un bol.",
        "Disposez le saumon, l'avocat, l'edamame et le concombre par-dessus.",
        "Arrosez de soja et saupoudrez de graines de sésame."
      ]
    },
    "it": {
      "recovery_note": "Salmone ricco di omega-3 con l'aggiunta di carboidrati complessi e fibre: un pasto equilibrato che sostiene l'energia senza i cali che spesso scatenano le voglie improvvise di cibo.",
      "ingredients": [
        "120g sashimi-grade salmon, a cubetti",
        "1/2 cup riso integrale, cotto",
        "1/4 avocado, a fette",
        "1/4 cup edamame",
        "1/4 cetriolo, a cubetti",
        "Soy sauce, olio di sesamo, semi di sesamo"
      ],
      "steps": [
        "Cuocere il riso integrale e lasciarlo raffreddare leggermente.",
        "Condire il salmone con 1 tsp di soia e olio di sesamo.",
        "Disporre il riso a strati in una ciotola.",
        "Sistemare sopra il salmone, l'avocado, gli edamame e il cetriolo.",
        "Condire con un filo di soia e cospargere con semi di sesamo."
      ]
    },
    "es": {
      "recovery_note": "Salmón rico en omega-3 más carbohidratos complejos y fibra: una comida equilibrada que mantiene la energía sin el bajón que suele provocar antojos.",
      "ingredients": [
        "120g sashimi-grade salmon, en cubos",
        "1/2 cup brown rice, cocido",
        "1/4 avocado, rebanado",
        "1/4 cup edamame",
        "1/4 cucumber, en cubos",
        "Soy sauce, sesame oil, sesame seeds"
      ],
      "steps": [
        "Cocine el arroz integral y deje que se enfríe un poco.",
        "Mezcle el salmón con 1 tsp de soja y sesame oil.",
        "Coloque una capa de arroz en un bol.",
        "Disponga el salmón, el aguacate, el edamame y el pepino encima.",
        "Rocíe con soja y espolvoree sesame seeds."
      ]
    }
  },
  "l7": {
    "ru": {
      "recovery_note": "Богатый клетчаткой обед из растительных продуктов, который поддерживает разнообразие микробиома кишечника — важный фактор стабильности настроения в процессе восстановления.",
      "ingredients": [
        "1 wholemeal wrap",
        "3 tbsp хумуса",
        "1/2 цукини, нарезанного ломтиками",
        "1/2 capsicum, нарезанного ломтиками",
        "1/2 красного лука, нарезанного ломтиками",
        "Шпинат, оливковое масло, соль, перец"
      ],
      "steps": [
        "Перемешайте овощи с olive oil, солью и перцем.",
        "Запекайте при 200°C в течение 18–20 минут до мягкости.",
        "Намажьте hummus на тортилью (wrap).",
        "Сверху выложите запеченные овощи и spinach.",
        "Плотно сверните рулетом и разрежьте."
      ]
    },
    "uk": {
      "recovery_note": "Багатий на клітковину обід на рослинній основі, що підтримує різноманітність мікробіому кишечника — важливий показник стабільності настрою в процесі відновлення.",
      "ingredients": [
        "1 цільнозерновий wrap",
        "3 tbsp хумусу",
        "1/2 цукіні, нарізаного скибочками",
        "1/2 capsicum, нарізаного скибочками",
        "1/2 червоної цибулі, нарізаної скибочками",
        "Шпинат, olive oil, сіль, перець"
      ],
      "steps": [
        "Перемішайте овочі з olive oil, сіллю та перцем.",
        "Запікайте при 200°C протягом 18–20 хвилин до м'якості.",
        "Намажте hummus на wrap.",
        "Зверху викладіть запечені овочі та spinach.",
        "Щільно загорніть і розріжте."
      ]
    },
    "ko": {
      "recovery_note": "장내 미생물 군집의 다양성을 높여주는 식이섬유가 풍부한 채소 중심의 점심 식사입니다. 이는 회복기 정서 안정의 강력한 예측 지표가 됩니다.",
      "ingredients": [
        "1 wholemeal wrap",
        "3 tbsp hummus",
        "1/2 zucchini, sliced",
        "1/2 capsicum, sliced",
        "1/2 red onion, sliced",
        "Spinach, olive oil, salt, pepper"
      ],
      "steps": [
        "채소를 올리브 오일, salt, pepper와 함께 버무립니다.",
        "200°C에서 18–20분 동안 부드러워질 때까지 굽습니다.",
        "랩 위에 hummus를 펴 바릅니다.",
        "구운 채소와 spinach를 위에 올립니다.",
        "단단하게 말아서 자릅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un déjeuner riche en fibres et axé sur les végétaux qui favorise la diversité du microbiome intestinal — un indicateur clé de la stabilité de l'humeur durant le rétablissement.",
      "ingredients": [
        "1 wrap complet",
        "3 tbsp houmous",
        "1/2 courgette, tranchée",
        "1/2 poivron, tranché",
        "1/2 oignon rouge, tranché",
        "Épinards, huile d'olive, sel, poivre"
      ],
      "steps": [
        "Mélanger les légumes avec de l'huile d'olive, du sel et du poivre.",
        "Rôtir à 200°C pendant 18–20 minutes jusqu'à ce qu'ils soient tendres.",
        "Étaler le houmous sur le wrap.",
        "Garnir avec les légumes rôtis et les épinards.",
        "Rouler fermement et trancher."
      ]
    },
    "it": {
      "recovery_note": "Un pranzo a base vegetale ricco di fibre che favorisce la diversità del microbioma intestinale — un forte indicatore della stabilità dell'umore nel percorso di Recovery.",
      "ingredients": [
        "1 wholemeal wrap",
        "3 tbsp hummus",
        "1/2 zucchina, affettata",
        "1/2 capsicum, affettato",
        "1/2 cipolla rossa, affettata",
        "Spinaci, olio d'oliva, sale, pepe"
      ],
      "steps": [
        "Condire le verdure con olive oil, sale e pepe.",
        "Arrostire a 200°C per 18–20 minuti fino a quando saranno tenere.",
        "Spalmare l'hummus sulla piadina.",
        "Guarnire con le verdure arrostite e gli spinaci.",
        "Arrotolare strettamente e tagliare a fette."
      ]
    },
    "es": {
      "recovery_note": "Un almuerzo rico en fibra y centrado en vegetales que favorece la diversidad del microbioma intestinal, un indicador clave de la estabilidad del estado de ánimo en la recuperación.",
      "ingredients": [
        "1 wholemeal wrap",
        "3 tbsp hummus",
        "1/2 zucchini, rebanado",
        "1/2 capsicum, rebanado",
        "1/2 red onion, rebanada",
        "Spinach, olive oil, salt, pepper"
      ],
      "steps": [
        "Mezcle las verduras con olive oil, salt y pepper.",
        "Hornee a 200°C durante 18–20 minutos hasta que estén tiernas.",
        "Extienda el hummus sobre el wrap.",
        "Cubra con las verduras asadas y spinach.",
        "Enrolle firmemente y corte."
      ]
    }
  },
  "l8": {
    "ru": {
      "recovery_note": "Индейка богата триптофаном, предшественником серотонина — в сочетании со сложными углеводами она помогает сохранять спокойствие и концентрацию в течение дня.",
      "ingredients": [
        "2 ломтика цельнозернового хлеба",
        "4 ломтика запеченной индейки",
        "1/4 авокадо, размятого",
        "1 лист салата",
        "2 ломтика помидора",
        "Горчица, соль, перец"
      ],
      "steps": [
        "Намажьте размятый авокадо на один ломтик хлеба.",
        "Намажьте горчицу на другой.",
        "Выложите слоями индейку, листья салата и помидор.",
        "Добавьте специи по вкусу и закройте сэндвич.",
        "Разрежьте по диагонали и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Індичка багата на триптофан, попередник серотоніну — у поєднанні зі складними вуглеводами вона сприяє спокійній концентрації протягом дня.",
      "ingredients": [
        "2 скибочки цільнозернового хліба",
        "4 скибочки запеченої індички",
        "1/4 авокадо, розім'ятого",
        "1 листок латука",
        "2 скибочки помідора",
        "Гірчиця, сіль, перець"
      ],
      "steps": [
        "Намажте розім’яте авокадо на одну скибку хліба.",
        "Намажте гірчицю на іншу скибку.",
        "Викладіть шарами індичку, салат та помідор.",
        "Приправте за смаком; закрийте сендвіч.",
        "Розріжте по діагоналі та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "칠면조에는 세로토닌의 전구체인 트립토판이 풍부하여, 복합 탄수화물과 함께 섭취하면 오후 내내 차분한 집중력을 유지하는 데 도움이 됩니다.",
      "ingredients": [
        "통곡물 식빵 2 slices",
        "로스트 터키 4 slices",
        "으깬 아보카도 1/4개",
        "상추 1 leaf",
        "토마토 2 slices",
        "머스타드, 소금, 후추"
      ],
      "steps": [
        "빵 한 조각에 으깬 아보카도를 펴 바릅니다.",
        "다른 한 조각에는 머스터드를 펴 바릅니다.",
        "터키, 상추, 토마토를 층층이 쌓습니다.",
        "양념을 하고 샌드위치를 덮습니다.",
        "대각선으로 잘라 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "La dinde est riche en tryptophane, un précurseur de la sérotonine — consommée avec des glucides complexes, elle favorise une concentration calme tout au long de l'après-midi.",
      "ingredients": [
        "2 tranches de pain complet",
        "4 tranches de dinde rôtie",
        "1/4 d'avocat, écrasé",
        "1 feuille de laitue",
        "2 tranches de tomate",
        "Moutarde, sel, poivre"
      ],
      "steps": [
        "Étaler l'avocat écrasé sur une tranche de pain.",
        "Étaler de la moutarde sur l'autre.",
        "Superposer la dinde, la laitue et la tomate.",
        "Assaisonner ; fermer le sandwich.",
        "Couper en diagonale et servir."
      ]
    },
    "it": {
      "recovery_note": "Il tacchino è ricco di triptofano, un precursore della serotonina — se consumato insieme a carboidrati complessi, favorisce una concentrazione distesa durante tutto il pomeriggio.",
      "ingredients": [
        "2 fette di pane integrale",
        "4 fette di fesa di tacchino arrosto",
        "1/4 di avocado, schiacciato",
        "1 foglia di lattuga",
        "2 fette di pomodoro",
        "Mustard, sale, pepe"
      ],
      "steps": [
        "Spalmare l'avocado schiacciato su una fetta di pane.",
        "Spalmare la senape sull'altra.",
        "Disporre a strati il tacchino, la lattuga e il pomodoro.",
        "Condire; chiudere il sandwich.",
        "Tagliare in diagonale e servire."
      ]
    },
    "es": {
      "recovery_note": "El pavo es rico en triptófano, un precursor de la serotonina; consumido junto con carbohidratos complejos, favorece un enfoque tranquilo durante toda la tarde.",
      "ingredients": [
        "2 rebanadas de pan integral",
        "4 rebanadas de pavo asado",
        "1/4 de aguacate, triturado",
        "1 hoja de lechuga",
        "2 rebanadas de tomate",
        "Mostaza, sal, pimienta"
      ],
      "steps": [
        "Unte el aguacate machacado sobre una rebanada de pan.",
        "Unte mostaza en la otra.",
        "Coloque capas de pavo, lechuga y tomate.",
        "Condimente; cierre el sándwich.",
        "Corte en diagonal y sirva."
      ]
    }
  },
  "l9": {
    "ru": {
      "recovery_note": "Уютная еда без переедания — ликопин из томатов поддерживает здоровье мозга, а кальций из сыра способствует стабильности нервной системы.",
      "ingredients": [
        "1 банка нарезанных томатов (chopped tomatoes)",
        "1 луковица, нарезанная кубиками",
        "2 зубчика чеснока",
        "1 cup овощного бульона",
        "1/2 cup свежего базилика",
        "2 ломтика цельнозернового хлеба (wholegrain bread), cheddar, butter"
      ],
      "steps": [
        "Обжаривайте onion и garlic 5 минут.",
        "Добавьте tomatoes, stock, basil; варите на медленном огне 15 min.",
        "Измельчите блендером до однородности; добавьте специи.",
        "Смажьте bread маслом, наполните cheese, обжаривайте на сковороде до золотистого цвета с обеих сторон.",
        "Подавайте sandwich вместе с soup."
      ]
    },
    "uk": {
      "recovery_note": "Затишна їжа без переїдання — лікопен з томатів підтримує здоров'я мозку, а кальцій із сиру сприяє стабільності нервової системи.",
      "ingredients": [
        "1 бляшанка нарізаних томатів",
        "1 цибулина, нарізана кубиками",
        "2 зубчики часнику",
        "1 cup овочевого бульйону",
        "1/2 cup свіжого базиліку",
        "2 скибочки wholegrain bread, cheddar, butter"
      ],
      "steps": [
        "Обсмажуйте цибулю та часник 5 хвилин.",
        "Додайте томати, stock, базилік; тушкуйте на повільному вогні 15 min.",
        "Збийте блендером до однорідності; додайте спеції за смаком.",
        "Намажте хліб маслом, наповніть сиром, обсмажуйте на сковороді до золотистої скоринки з обох боків.",
        "Подавайте сендвіч разом із супом."
      ]
    },
    "ko": {
      "recovery_note": "폭식 걱정 없는 컴포트 푸드 — 토마토의 라이코펜 성분은 뇌 건강을 지원하며, 치즈의 칼슘은 신경계 안정에 도움을 줍니다.",
      "ingredients": [
        "1 tin chopped tomatoes",
        "1 onion, diced",
        "2 cloves garlic",
        "1 cup vegetable stock",
        "1/2 cup fresh basil",
        "2 slices wholegrain bread, cheddar, butter"
      ],
      "steps": [
        "양파와 마늘을 5분 동안 볶습니다.",
        "토마토, 육수, 바질을 넣고 15분 동안 뭉근하게 끓입니다.",
        "부드러워질 때까지 블렌더로 갈아준 뒤 간을 맞춥니다.",
        "빵에 버터를 바르고 치즈를 채운 뒤, 양면이 노릇해질 때까지 팬에서 굽습니다.",
        "샌드위치를 수프와 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat réconfortant sans excès — le lycopène des tomates soutient la santé cérébrale, tandis que le calcium du fromage favorise la stabilité du système nerveux.",
      "ingredients": [
        "1 boîte de tomates concassées",
        "1 oignon, coupé en dés",
        "2 gousses d'ail",
        "1 cup de bouillon de légumes",
        "1/2 cup de basilic frais",
        "2 tranches de pain complet, cheddar, beurre"
      ],
      "steps": [
        "Faire sauter l'oignon et l'ail pendant 5 minutes.",
        "Ajouter les tomates, le stock et le basilic ; faire mijoter 15 min.",
        "Mixer jusqu'à l'obtention d'une texture lisse ; assaisonner.",
        "Beurrer le pain, garnir de fromage et griller à la poêle jusqu'à ce que les deux côtés soient dorés.",
        "Servir le sandwich avec la soupe."
      ]
    },
    "it": {
      "recovery_note": "Comfort food senza abbuffate: il licopene dei pomodori sostiene la salute del cervello, il calcio del formaggio favorisce la stabilità del sistema nervoso.",
      "ingredients": [
        "1 lattina di pomodori a pezzi",
        "1 cipolla, tagliata a dadini",
        "2 spicchi d'aglio",
        "1 cup di brodo vegetale",
        "1/2 cup di basilico fresco",
        "2 fette di pane wholegrain, cheddar, burro"
      ],
      "steps": [
        "Rosolare la cipolla e l'aglio per 5 minuti.",
        "Aggiungere i pomodori, il brodo e il basilico; sobbollire per 15 min.",
        "Frullare fino a ottenere un composto omogeneo; condire.",
        "Imburrare il pane, farcire con il formaggio e grigliare in padella fino a doratura su entrambi i lati.",
        "Servire il sandwich insieme alla zuppa."
      ]
    },
    "es": {
      "recovery_note": "Comida reconfortante sin excesos: el licopeno de los tomates favorece la salud cerebral, mientras que el calcio del queso ayuda a la estabilidad del sistema nervioso.",
      "ingredients": [
        "1 lata de chopped tomatoes",
        "1 cebolla, picada en cubos",
        "2 dientes de ajo",
        "1 cup de caldo de verduras",
        "1/2 cup de albahaca fresca",
        "2 rebanadas de pan wholegrain, cheddar, mantequilla"
      ],
      "steps": [
        "Saltear la cebolla y el ajo durante 5 minutos.",
        "Añadir los tomates, el stock y la albahaca; cocinar a fuego lento 15 min.",
        "Licuar hasta que esté suave; sazonar.",
        "Untar mantequilla al pan, rellenar con queso y asar en la sartén hasta que ambos lados estén dorados.",
        "Servir el sándwich junto con la sopa."
      ]
    }
  },
  "l10": {
    "ru": {
      "recovery_note": "Яйца содержат холин и витамин B12 — оба этих вещества часто истощаются при длительном употреблении психоактивных веществ и необходимы для когнитивного восстановления.",
      "ingredients": [
        "3 яйца, сваренных вкрутую",
        "2 tbsp Greek yoghurt",
        "1 tsp Dijon mustard",
        "1 tbsp шнитт-лука, измельченного",
        "2 ломтика цельнозернового хлеба",
        "Листья салата, соль, перец"
      ],
      "steps": [
        "Отварите яйца в течение 8 минут; охладите и очистите.",
        "Разомните с yoghurt, горчицей, шнитт-луком, солью и перцем.",
        "Выложите слоями на хлеб с листьями салата.",
        "Закройте, разрежьте и подавайте.",
        "Хорошо сочетается с хрустящими овощными палочками."
      ]
    },
    "uk": {
      "recovery_note": "Яйця містять холін та вітамін B12, запаси яких зазвичай вичерпуються при тривалому вживанні психоактивних речовин і які є критично важливими для відновлення когнітивних функцій.",
      "ingredients": [
        "3 яйця, зварені вкруту",
        "2 tbsp грецького йогурту",
        "1 tsp гірчиці Dijon",
        "1 tbsp шніт-цибулі, подрібненої",
        "2 скибочки цільнозернового хліба",
        "Салат, сіль, перець"
      ],
      "steps": [
        "Відваріть яйця протягом 8 хвилин; охолодіть та очистіть.",
        "Розімніть із yoghurt, гірчицею, шніт-цибулею, сіллю та перцем.",
        "Викладіть шаром на хліб разом із листям салату.",
        "Закрийте, розріжте та подавайте.",
        "Добре смакує з хрусткими овочевими паличками."
      ]
    },
    "ko": {
      "recovery_note": "계란은 콜린과 B12를 제공하는데, 이 영양소들은 장기적인 약물 사용 시 흔히 결핍되며 인지 기능 회복에 필수적입니다.",
      "ingredients": [
        "완숙 계란 3개",
        "Greek yoghurt 2 tbsp",
        "Dijon mustard 1 tsp",
        "다진 쪽파 1 tbsp",
        "통곡물 식빵 2 slices",
        "상추, 소금, 후추"
      ],
      "steps": [
        "달걀을 8 minutes 동안 삶은 후, 식혀서 껍질을 벗기세요.",
        "달걀을 yoghurt, mustard, chives, salt, pepper와 함께 으깨세요.",
        "빵 위에 lettuce와 함께 층을 쌓으세요.",
        "빵을 덮고, 자른 뒤 내놓으세요.",
        "아삭한 야채 스틱과 잘 어울립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les œufs apportent de la choline et de la vitamine B12, deux nutriments qui s'épuisent fréquemment lors d'une consommation prolongée de substances et qui sont essentiels à la récupération cognitive.",
      "ingredients": [
        "3 œufs durs",
        "2 tbsp de yaourt grec",
        "1 tsp de moutarde de Dijon",
        "1 tbsp de ciboulette, hachée",
        "2 tranches de pain complet",
        "Laitue, sel, poivre"
      ],
      "steps": [
        "Faire bouillir les œufs pendant 8 minutes ; laisser refroidir et écailler.",
        "Écraser avec du yoghurt, de la moutarde, de la ciboulette, du sel et du poivre.",
        "Disposer en couches sur du pain avec de la laitue.",
        "Fermer, trancher et servir.",
        "Se marie bien avec des bâtonnets de légumes croquants."
      ]
    },
    "it": {
      "recovery_note": "Le uova forniscono colina e vitamina B12, entrambe comunemente carenti in caso di uso prolungato di sostanze ed essenziali per il recupero cognitivo.",
      "ingredients": [
        "3 uova sode",
        "2 tbsp Greek yoghurt",
        "1 tsp senape di Dijon",
        "1 tbsp erba cipollina, tritata",
        "2 fette di pane integrale",
        "Lattuga, sale, pepe"
      ],
      "steps": [
        "Bollire le uova per 8 minuti; raffreddare e sbucciare.",
        "Schiacciare con yoghurt, senape, erba cipollina, sale e pepe.",
        "Disporre a strati sul pane con la lattuga.",
        "Chiudere, tagliare e servire.",
        "Si abbina bene con bastoncini di verdure croccanti."
      ]
    },
    "es": {
      "recovery_note": "Los huevos aportan colina y B12, las cuales suelen agotarse por el consumo de sustancias a largo plazo y son esenciales para la recuperación cognitiva.",
      "ingredients": [
        "3 huevos duros",
        "2 tbsp Greek yoghurt",
        "1 tsp Dijon mustard",
        "1 tbsp cebollino, picado",
        "2 rebanadas de pan integral",
        "Lechuga, sal, pimienta"
      ],
      "steps": [
        "Hervir los huevos 8 minutos; enfriar y pelar.",
        "Triturar con yogur, mostaza, cebollino, sal y pimienta.",
        "Colocar en capas sobre el pan con lechuga.",
        "Cerrar, cortar y servir.",
        "Combina bien con bastoncitos de vegetales crujientes."
      ]
    }
  },
  "l11": {
    "ru": {
      "recovery_note": "Постный белок с мягким дофаминовым эффектом благодаря насыщенному вкусу умами — сытно и без резких скачков сахара в крови.",
      "ingredients": [
        "300g куриного фарша",
        "1 tbsp имбиря, тертого",
        "2 зубчика чеснока, измельченных",
        "2 tbsp соевого соуса, 1 tsp меда",
        "1 морковь, тертая",
        "Листья салата Iceberg, семена кунжута"
      ],
      "steps": [
        "Обжаривайте куриный фарш на сковороде в течение 5 min.",
        "Добавьте чеснок и имбирь; готовьте 1 min.",
        "Влейте соевый соус, мед, добавьте морковь; готовьте еще 3 min.",
        "Выложите ложкой в лодочки из листьев салата.",
        "Посыпьте семенами кунжута и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Нежирний білок із м’яким стимулюванням дофаміну завдяки насиченому смаку умамі — насичує без різких перепадів рівня цукру в крові.",
      "ingredients": [
        "300g курячого фаршу",
        "1 tbsp імбиру, натертого",
        "2 зубчики garlic, подрібнених",
        "2 tbsp soy sauce, 1 tsp меду",
        "1 морква, натерта",
        "Листя Iceberg lettuce, насіння кунжуту"
      ],
      "steps": [
        "Обсмажте курячий фарш на сковороді протягом 5 min.",
        "Додайте часник та імбир; готуйте 1 min.",
        "Вмішайте соєвий соус, мед і моркву; готуйте ще 3 min.",
        "Викладіть ложкою в листя салату.",
        "Посипте кунжутом і подавайте."
      ]
    },
    "ko": {
      "recovery_note": "감칠맛 나는 풍미로 기분 좋은 도파민을 선사하며, 혈당 수치의 급격한 변화 없이 든든한 만족감을 주는 저지방 단백질 식단입니다.",
      "ingredients": [
        "300g chicken mince",
        "1 tbsp 생강, 갈아서 준비",
        "마늘 2쪽, 다져서 준비",
        "2 tbsp 간장, 1 tsp 꿀",
        "당근 1개, 채썰어서 준비",
        "Iceberg lettuce 잎, 참깨"
      ],
      "steps": [
        "팬에 닭고기 다짐육을 넣고 5분 동안 노릇하게 굽습니다.",
        "마늘과 생강을 넣고 1분 동안 익힙니다.",
        "간장, 꿀, 당근을 넣고 저어가며 3분 더 익힙니다.",
        "양상추 컵에 한 스푼씩 나누어 담습니다.",
        "참깨를 고명으로 올린 뒤 완성합니다."
      ]
    },
    "fr": {
      "recovery_note": "Des protéines maigres avec un léger boost de dopamine grâce au profil aromatique umami — rassasiant sans provoquer de chute de glycémie.",
      "ingredients": [
        "300g chicken mince",
        "1 tbsp gingembre, râpé",
        "2 gousses d'ail, hachées",
        "2 tbsp soy sauce, 1 tsp miel",
        "1 carotte, râpée",
        "Feuilles de laitue Iceberg, graines de sésame"
      ],
      "steps": [
        "Faire dorer le poulet haché dans une poêle pendant 5 min.",
        "Ajouter l'ail et le gingembre ; cuire 1 min.",
        "Incorporer le soja, le miel et la carotte ; cuire encore 3 min.",
        "Répartir à la cuillère dans des feuilles de laitue.",
        "Garnir de graines de sésame ; servir."
      ]
    },
    "it": {
      "recovery_note": "Proteine magre con una leggera spinta di dopamina grazie al profilo saporito dell'umami — soddisfacente senza causare picchi glicemici.",
      "ingredients": [
        "300g chicken mince",
        "1 tbsp zenzero grattugiato",
        "2 spicchi d'aglio tritati",
        "2 tbsp salsa di soia, 1 tsp miele",
        "1 carota grattugiata",
        "Foglie di lattuga Iceberg, semi di sesamo"
      ],
      "steps": [
        "Rosolare il macinato di pollo in padella per 5 min.",
        "Aggiungere aglio e zenzero; cuocere per 1 min.",
        "Incorporare soia, miele e carota; cuocere per altri 3 min.",
        "Distribuire il composto con un cucchiaio in foglie di lattuga.",
        "Guarnire con semi di sesamo e servire."
      ]
    },
    "es": {
      "recovery_note": "Proteína magra con un suave impulso de dopamina gracias a su perfil de sabor umami: satisfactorio sin provocar caídas de azúcar en sangre.",
      "ingredients": [
        "300g chicken mince",
        "1 tbsp jengibre, rallado",
        "2 dientes de ajo, picados",
        "2 tbsp soy sauce, 1 tsp honey",
        "1 zanahoria, rallada",
        "Hojas de lechuga Iceberg, semillas de sésamo"
      ],
      "steps": [
        "Dore la carne picada de pollo en la sartén durante 5 min.",
        "Añada el ajo y el jengibre; cocine 1 min.",
        "Incorpore la soja, la miel y la zanahoria; cocine 3 min más.",
        "Sirva con una cuchara en cogollos de lechuga.",
        "Cubra con semillas de sésamo y sirva."
      ]
    }
  },
  "l12": {
    "ru": {
      "recovery_note": "Растительный белок и клетчатка стабилизируют уровень сахара в крови в течение дня. Мексиканский вкусовой профиль дарит яркие впечатления, не оказывая при этом излишнего стимулирующего эффекта.",
      "ingredients": [
        "1 банка черной фасоли, промытой",
        "1 cup кукурузы (замороженной, размороженной)",
        "1 capsicum, нарезанный кубиками",
        "1/4 красного лука, мелко нарезанного",
        "1 lime, сок",
        "Olive oil, кориандр, кумин, соль"
      ],
      "steps": [
        "Смешайте фасоль, кукурузу, capsicum и лук в миске.",
        "Взбейте сок лайма, оливковое масло, кумин и соль.",
        "Полейте салат заправкой и перемешайте.",
        "Посыпьте сверху свежим кориандром.",
        "Подавайте немедленно или охладите в течение 1 часа."
      ]
    },
    "uk": {
      "recovery_note": "Рослинний білок і клітковина стабілізують рівень цукру в крові протягом дня. Мексиканський смаковий профіль захоплює, але при цьому не діє збудливо.",
      "ingredients": [
        "1 бляшанка чорної квасолі, промитої",
        "1 склянка кукурудзи (замороженої, розмороженої)",
        "1 capsicum, нарізаний кубиками",
        "1/4 червоної цибулі, дрібно нарізаної",
        "1 лайм, вичавлений сік",
        "Olive oil, коріандр, кумін, сіль"
      ],
      "steps": [
        "Змішайте квасолю, кукурудзу, болгарський перець та цибулю в мисці.",
        "Збийте сік лайма, оливкову олію, кумин і сіль.",
        "Полийте салат заправкою та перемішайте.",
        "Посипте зверху свіжим коріандром.",
        "Подавайте негайно або охолодіть протягом 1 hour."
      ]
    },
    "ko": {
      "recovery_note": "식물성 단백질과 식이섬유가 오후 내내 혈당을 안정적으로 유지해 줍니다. 멕시코풍의 맛은 자극적이지 않으면서도 입맛을 돋워줍니다.",
      "ingredients": [
        "검은콩 1 tin, 헹군 것",
        "옥수수 1 cup (냉동, 해동된 것)",
        "capsicum 1개, 깍둑썰기한 것",
        "적양파 1/4개, 잘게 다진 것",
        "라임 1개, 즙을 낸 것",
        "Olive oil, coriander, cumin, salt"
      ],
      "steps": [
        "볼에 beans, corn, capsicum, onion을 넣고 섞습니다.",
        "lime juice, olive oil, cumin, salt를 휘퍼로 잘 저어 섞습니다.",
        "드레싱을 샐러드 위에 붓고 가볍게 버무립니다.",
        "신선한 coriander를 고명으로 올립니다.",
        "즉시 서빙하거나 1시간 동안 냉장 보관합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les protéines végétales et les fibres stabilisent la glycémie tout au long de l'après-midi. Le profil aromatique mexicain est savoureux sans être stimulant.",
      "ingredients": [
        "1 boîte de black beans, rincés",
        "1 cup de corn (surgelé, dégelé)",
        "1 capsicum, coupé en dés",
        "1/4 d'oignon rouge, finement haché",
        "1 lime, pressée",
        "Olive oil, coriander, cumin, salt"
      ],
      "steps": [
        "Mélanger les haricots, le maïs, le capsicum et l'oignon dans un bol.",
        "Fouetter le jus de lime, l'olive oil, le cumin et le sel.",
        "Verser sur la salade ; mélanger délicatement.",
        "Garnir de coriandre fraîche.",
        "Servir immédiatement ou réfrigérer pendant 1 hour."
      ]
    },
    "it": {
      "recovery_note": "Le proteine vegetali e le fibre stabilizzano la glicemia per tutto il pomeriggio. Il profilo aromatico messicano è stimolante senza risultare eccessivo.",
      "ingredients": [
        "1 lattina di fagioli neri, sciacquata",
        "1 cup di mais (surgelato, scongelato)",
        "1 capsicum, tagliato a dadini",
        "1/4 di cipolla rossa, tritata finemente",
        "1 lime, spremuto",
        "Olive oil, coriandolo, cumino, sale"
      ],
      "steps": [
        "Unire fagioli, mais, capsicum e cipolla in una ciotola.",
        "Sbattere succo di lime, olive oil, cumino e sale.",
        "Versare sull'insalata; mescolare.",
        "Guarnire con coriandolo fresco.",
        "Servire immediatamente o refrigerare per 1 hour."
      ]
    },
    "es": {
      "recovery_note": "La proteína vegetal y la fibra estabilizan el azúcar en sangre durante la tarde. El perfil de sabor mexicano es emocionante sin resultar estimulante.",
      "ingredients": [
        "1 lata de black beans, enjuagados",
        "1 cup de maíz (congelado, descongelado)",
        "1 capsicum, picado en cubitos",
        "1/4 de cebolla roja, finamente picada",
        "1 lima, su jugo",
        "Olive oil, coriander, cumin, salt"
      ],
      "steps": [
        "Combine los frijoles, el maíz, el pimiento y la cebolla en un bol.",
        "Bata el jugo de lima, el aceite de oliva, el comino y la sal.",
        "Vierta sobre la ensalada; mezcle bien.",
        "Cubra con cilantro fresco.",
        "Sirva inmediatamente o refrigere durante 1 hour."
      ]
    }
  },
  "l13": {
    "ru": {
      "recovery_note": "Сладкий картофель обеспечивает мягкую, устойчивую энергию за счет углеводов, а также содержит бета-каротин — оба эти компонента защищают восстанавливающуюся нервную систему.",
      "ingredients": [
        "1 крупный сладкий картофель, нарезанный кубиками",
        "1 банка черной фасоли, без жидкости",
        "1 tsp зиры (кумина), паприки, чили",
        "4 маленькие кукурузные тортильи",
        "1/4 авокадо, нарезанного ломтиками",
        "Лайм, кориандр, сальса"
      ],
      "steps": [
        "Перемешайте сладкий картофель с маслом и специями; запекайте при 200°C в течение 20 минут.",
        "Подогрейте фасоль с дополнительными специями в течение 3 минут.",
        "Разогрейте тортильи на сухой сковороде.",
        "Выложите слой сладкого картофеля, фасоли и авокадо в тортильи.",
        "Сверху посыпьте лаймом, кориандром и добавьте сальсу."
      ]
    },
    "uk": {
      "recovery_note": "Солодка картопля забезпечує м’яку та стабільну енергію вуглеводів, а також містить бета-каротин — обидва ці компоненти мають захисну дію для нервової системи, що відновлюється.",
      "ingredients": [
        "1 велика солодка картопля (батат), нарізана кубиками",
        "1 бляшанка black beans, відціджених",
        "1 tsp cumin, paprika, chilli",
        "4 малі кукурудзяні tortillas",
        "1/4 avocado, нарізаного скибочками",
        "Lime, coriander, salsa"
      ],
      "steps": [
        "Перемішайте батат з олією та спеціями; запікайте при 200°C протягом 20 хв.",
        "Розігрійте квасолю з додатковими спеціями протягом 3 хв.",
        "Розігрійте тортильї на сухій сковорідці.",
        "Викладіть шарами батат, квасолю та авокадо в тортильї.",
        "Посипте зверху лаймом, коріандром та додайте salsa."
      ]
    },
    "ko": {
      "recovery_note": "고구마는 완만한 속도로 지속적인 탄수화물 에너지를 공급할 뿐만 아니라 베타카로틴을 함유하고 있어, 회복 중인 신경계를 보호하는 데 도움을 줍니다.",
      "ingredients": [
        "큼직한 고구마 1개, 깍둑썰기",
        "검은콩 통조림 1캔, 물기 제거",
        "큐민, 파프리카, 칠리 가루 1 tsp씩",
        "작은 옥수수 또띠아 4개",
        "아보카도 1/4개, 슬라이스",
        "라임, 고수, 살사"
      ],
      "steps": [
        "고구마를 오일, 향신료와 함께 버무려 200°C에서 20분간 굽습니다.",
        "추가 향신료와 함께 콩을 3분간 데웁니다.",
        "마른 팬에 또띠아를 데웁니다.",
        "또띠아 위에 고구마, 콩, 아보카도를 층층이 올립니다.",
        "라임, 고수, 살사를 얹어 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "La patate douce fournit une énergie glucidique douce et durable ainsi que du bêta-carotène, tous deux protecteurs pour le système nerveux en phase de récupération.",
      "ingredients": [
        "1 grande patate douce, coupée en dés",
        "1 boîte de black beans, égouttée",
        "1 tsp cumin, paprika, chilli",
        "4 petites corn tortillas",
        "1/4 avocat, tranché",
        "Lime, coriandre, salsa"
      ],
      "steps": [
        "Mélanger la patate douce avec l'huile et les épices ; rôtir à 200°C pendant 20 min.",
        "Réchauffer les haricots avec des épices supplémentaires pendant 3 min.",
        "Chauffer les tortillas dans une poêle à sec.",
        "Garnir les tortillas avec la patate douce, les haricots et l'avocat.",
        "Garnir avec du citron vert, de la coriandre et de la salsa."
      ]
    },
    "it": {
      "recovery_note": "La patata dolce fornisce un'energia moderata e prolungata derivante dai carboidrati, oltre al beta-carotene: entrambi elementi protettivi per il sistema nervoso in fase di recupero.",
      "ingredients": [
        "1 patata dolce grande, tagliata a cubetti",
        "1 tin fagioli neri, sgocciolati",
        "1 tsp cumin, paprika, chilli",
        "4 piccole tortillas di mais",
        "1/4 avocado, a fette",
        "Lime, coriandolo, salsa"
      ],
      "steps": [
        "Mescolare le patate dolci con olio e spezie; arrostire a 200°C per 20 min.",
        "Scaldare i fagioli con spezie extra per 3 min.",
        "Scaldare le tortillas in una padella asciutta.",
        "Farcire le tortillas con strati di patate dolci, fagioli e avocado.",
        "Guarnire con lime, coriandolo e salsa."
      ]
    },
    "es": {
      "recovery_note": "El boniato aporta energía de carbohidratos de liberación lenta y sostenida, además de betacaroteno; ambos son protectores para el sistema nervioso en recuperación.",
      "ingredients": [
        "1 batata grande, en cubos",
        "1 lata de frijoles negros, escurridos",
        "1 tsp de comino, pimentón, chile",
        "4 tortillas de maíz pequeñas",
        "1/4 de aguacate, en rebanadas",
        "Lima, cilantro, salsa"
      ],
      "steps": [
        "Mezcle el sweet potato con aceite y especias; rostice a 200°C por 20 min.",
        "Caliente los beans con especias adicionales durante 3 min.",
        "Caliente las tortillas en una sartén seca.",
        "Arme capas de sweet potato, beans y avocado en las tortillas.",
        "Cubra con lime, coriander y salsa."
      ]
    }
  },
  "l14": {
    "ru": {
      "recovery_note": "Классический средиземноморский обед — нежирный белок, яркие овощи, полезные жиры. Такой тип питания имеет самую сильную доказательную базу для поддержки ментального здоровья.",
      "ingredients": [
        "1 куриная грудка",
        "1 огурец, нарезанный кусочками",
        "2 томата, нарезанных кусочками",
        "1/4 красного лука, нарезанного ломтиками",
        "50g feta, оливки каламата",
        "Olive oil, лимон, орегано"
      ],
      "steps": [
        "Приправьте курицу; обжаривайте на гриле по 4 min с каждой стороны. Нарежьте ломтиками.",
        "Смешайте огурец, tomatoes, лук и olives в миске.",
        "Сверху выложите feta, затем нарезанную курицу.",
        "Взбейте оливковое масло, лимон и орегано; полейте сверху.",
        "Аккуратно перемешайте и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Класичний середземноморський обід — нежирний білок, яскраві овочі, корисні жири. Такий тип харчування має найвагоміші докази на користь підтримки психічного здоров'я.",
      "ingredients": [
        "1 куряча грудка",
        "1 огірок, нарізаний шматочками",
        "2 томати, нарізані шматочками",
        "1/4 червоної цибулі, нарізаної скибочками",
        "50g feta, оливки kalamata",
        "Olive oil, лимон, орегано"
      ],
      "steps": [
        "Приправте курку; обсмажуйте на грилі по 4 min з кожного боку. Наріжте скибочками.",
        "Змішайте огірок, томати, цибулю та оливки в мисці.",
        "Викладіть зверху фета, а потім нарізану курку.",
        "Збийте оливкову олію, лимон та орегано; полийте зверху.",
        "Обережно перемішайте та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "지방이 적은 단백질, 선명한 색감의 채소, 그리고 건강한 지방이 어우러진 전형적인 지중해식 점심 식사입니다. 이러한 식습관은 정신 건강 증진에 가장 강력한 효과가 있는 것으로 입증되었습니다.",
      "ingredients": [
        "1 chicken breast",
        "오이 1개, 큼직하게 썬 것",
        "토마토 2개, 큼직하게 썬 것",
        "적양파 1/4개, 슬라이스",
        "50g feta, kalamata olives",
        "Olive oil, 레몬, 오레가노"
      ],
      "steps": [
        "닭고기에 시즈닝을 한 뒤, 양면을 각각 4 min 동안 그릴에 굽습니다. 그 다음 슬라이스합니다.",
        "볼에 cucumber, tomatoes, onion, olives를 넣고 섞습니다.",
        "그 위에 feta를 올린 후, 슬라이스한 닭고기를 얹습니다.",
        "olive oil, lemon, oregano를 휘저어 섞은 뒤 위에 붓습니다.",
        "가볍게 버무려 내놓습니다."
      ]
    },
    "fr": {
      "recovery_note": "Un déjeuner méditerranéen par excellence — des protéines maigres, des légumes colorés et des graisses saines. Ce mode d'alimentation est celui qui dispose des preuves les plus solides en matière de soutien à la santé mentale.",
      "ingredients": [
        "1 blanc de poulet",
        "1 concombre, coupé en morceaux",
        "2 tomates, coupées en morceaux",
        "1/4 d'oignon rouge, émincé",
        "50g de feta, olives kalamata",
        "Huile d'olive, citron, origan"
      ],
      "steps": [
        "Assaisonner le poulet ; griller 4 min par côté. Couper en tranches.",
        "Mélanger le concombre, les tomates, l'oignon et les olives dans un bol.",
        "Garnir de feta, puis du poulet tranché.",
        "Fouetter l'huile d'olive, le citron et l'origan ; verser par-dessus.",
        "Mélanger délicatement et servir."
      ]
    },
    "it": {
      "recovery_note": "Un pranzo mediterraneo da manuale: proteine magre, verdure vivaci e grassi sani. Questo modello alimentare vanta le prove scientifiche più solide a supporto della salute mentale.",
      "ingredients": [
        "1 petto di pollo",
        "1 cetriolo, a pezzi",
        "2 pomodori, a pezzi",
        "1/4 di cipolla rossa, affettata",
        "50g feta, olive kalamata",
        "Olive oil, limone, origano"
      ],
      "steps": [
        "Condire il pollo; grigliare per 4 min per lato. Tagliare a fette.",
        "Unire cetriolo, pomodori, cipolla e olive in una ciotola.",
        "Guarnire con la feta, quindi aggiungere il pollo a fette.",
        "Sbattere olio d'oliva, limone e origano; versare sopra.",
        "Mescolare delicatamente e servire."
      ]
    },
    "es": {
      "recovery_note": "Un almuerzo mediterráneo clásico: proteína magra, vegetales brillantes y grasas saludables. Este patrón de alimentación cuenta con la evidencia más sólida para el apoyo de la salud mental.",
      "ingredients": [
        "1 pechuga de pollo",
        "1 pepino, en trozos",
        "2 tomates, en trozos",
        "1/4 cebolla roja, en rodajas",
        "50g feta, aceitunas kalamata",
        "Aceite de oliva, limón, orégano"
      ],
      "steps": [
        "Sazone el pollo; áselo a la parrilla 4 min por cada lado. Córtelo en rebanadas.",
        "Combine el pepino, los tomates, la cebolla y las aceitunas en un bol.",
        "Cubra con queso feta, luego con el pollo rebanado.",
        "Bata el aceite de oliva, el limón y el orégano; viértalo encima.",
        "Mezcle suavemente y sirva."
      ]
    }
  },
  "l15": {
    "ru": {
      "recovery_note": "Противовоспалительная куркума, богатая витаминами группы B чечевица, бета-каротин из тыквы — полезное для мозга блюдо, которое дарит ощущение гастрономического удовольствия и исцеляет.",
      "ingredients": [
        "1 стакан красной чечевицы",
        "2 стакана тыквы, нарезанной кубиками",
        "1 луковица, чеснок, имбирь",
        "1 банка кокосового молока",
        "2 ч. л. порошка карри, куркума",
        "Шпинат, лайм, рис басмати"
      ],
      "steps": [
        "Обжаривайте onion, garlic и ginger в течение 3 min.",
        "Добавьте специи; готовьте 30 sec.",
        "Добавьте lentils, pumpkin, coconut milk + 1 cup water.",
        "Тушите на медленном огне 25 min, пока lentils не разварятся, а pumpkin не станет мягкой.",
        "Вмешайте spinach; подавайте с rice и lime."
      ]
    },
    "uk": {
      "recovery_note": "Протизапальна куркума, багата на вітаміни групи B сочевиця та бета-каротин із гарбуза — корисна для мозку страва, яка дарує відчуття насолоди та зцілює.",
      "ingredients": [
        "1 чашка червоної сочевиці",
        "2 чашки гарбуза, нарізаного кубиками",
        "1 цибуля, часник, імбир",
        "1 банка кокосового молока",
        "2 ч. л. порошку карі, куркума",
        "Шпинат, лайм, рис басматі (basmati rice)"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник та імбир протягом 3 min.",
        "Додайте спеції; готуйте 30 sec.",
        "Додайте сочевицю, гарбуз, кокосове молоко + 1 cup води.",
        "Тушкуйте 25 min до розварювання сочевиці та м'якості гарбуза.",
        "Вмішайте шпинат; подавайте з рисом та лаймом."
      ]
    },
    "ko": {
      "recovery_note": "항염 작용을 하는 강황, 비타민 B가 풍부한 렌틸콩, 단호박의 베타카로틴까지 — 뇌 건강에 도움을 주며 풍성한 맛과 치유를 동시에 선사하는 한 그릇 요리입니다.",
      "ingredients": [
        "1 cup 레드 렌틸콩",
        "2 cups 단호박, 깍둑썰기한 것",
        "양파 1개, 마늘, 생강",
        "코코넛 밀크 1 tin",
        "2 tsp 커리 파우더, 강황",
        "시금치, 라임, 바스마티 쌀"
      ],
      "steps": [
        "양파, 마늘, 생강을 3 min 동안 볶습니다.",
        "향신료를 넣고 30 sec 동안 익힙니다.",
        "렌틸콩, 단호박, 코코넛 밀크와 물 1 cup을 넣습니다.",
        "렌틸콩이 뭉개지고 단호박이 부드러워질 때까지 25 min 동안 뭉근하게 끓입니다.",
        "시금치를 넣어 섞은 후 밥, 라임과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Curcuma anti-inflammatoire, lentilles riches en vitamine B, bêta-carotène du potiron — un bol bienfaisant pour le cerveau qui semble gourmand mais qui guérit.",
      "ingredients": [
        "1 cup lentilles corail",
        "2 cups courge, coupée en cubes",
        "1 oignon, ail, gingembre",
        "1 tin lait de coco",
        "2 tsp curry powder, curcuma",
        "Épinards, lime, riz basmati"
      ],
      "steps": [
        "Faire revenir l'oignon, l'ail et le gingembre pendant 3 min.",
        "Ajouter les épices ; cuire 30 sec.",
        "Ajouter les lentilles, le potiron, le lait de coco + 1 cup d'eau.",
        "Mijoter 25 min jusqu'à ce que les lentilles se défassent et que le potiron soit tendre.",
        "Incorporer les épinards ; servir avec du riz et du citron vert."
      ]
    },
    "it": {
      "recovery_note": "Curcuma antinfiammatoria, lenticchie ricche di vitamina B, beta-carotene della zucca: una ciotola amica del cervello che regala una sensazione di piacere ma rigenera l’organismo.",
      "ingredients": [
        "1 cup lenticchie rosse",
        "2 cups zucca, a cubetti",
        "1 cipolla, aglio, zenzero",
        "1 tin latte di cocco",
        "2 tsp curry in polvere, curcuma",
        "Spinaci, lime, riso basmati"
      ],
      "steps": [
        "Soffriggere cipolla, aglio e zenzero per 3 min.",
        "Aggiungere le spezie; cuocere per 30 sec.",
        "Aggiungere lenticchie, zucca, latte di cocco + 1 cup d'acqua.",
        "Sobbollire per 25 min finché le lenticchie non si sfaldano e la zucca è tenera.",
        "Incorporare gli spinaci; servire con riso e lime."
      ]
    },
    "es": {
      "recovery_note": "Cúrcuma antiinflamatoria, lentejas ricas en vitamina B y betacaroteno de la calabaza: un cuenco para cuidar el cerebro que se siente indulgente pero sana.",
      "ingredients": [
        "1 cup de lentejas rojas",
        "2 cups de calabaza, en cubos",
        "1 cebolla, ajo, jengibre",
        "1 lata de leche de coco",
        "2 tsp de curry en polvo, cúrcuma",
        "Espinacas, lima, arroz basmati"
      ],
      "steps": [
        "Saltear la cebolla, el ajo y el jengibre durante 3 min.",
        "Añadir las especias; cocinar 30 sec.",
        "Añadir las lentejas, la calabaza, la coconut milk + 1 cup de agua.",
        "Cocinar a fuego lento 25 min hasta que las lentejas se deshagan y la calabaza esté tierna.",
        "Incorporar las espinacas; servir con arroz y lima."
      ]
    }
  },
  "l16": {
    "ru": {
      "recovery_note": "Итальянское блюдо за 10 минут. Еда ресторанного качества без соблазна заказать алкоголь. Белок, кальций и антиоксиданты на одной красивой тарелке.",
      "ingredients": [
        "1 шарик свежей mozzarella, нарезанный ломтиками",
        "2 помидора, нарезанных ломтиками",
        "60g prosciutto",
        "Листья свежего базилика",
        "Balsamic glaze, оливковое масло",
        "Хрустящий цельнозерновой хлеб"
      ],
      "steps": [
        "Чередуйте ломтики томатов и моцареллы на тарелке.",
        "Выложите прошутто складками поверх блюда.",
        "Вложите листья базилика между ломтиками.",
        "Сбрызните оливковым маслом и бальзамической глазурью.",
        "Приправьте по вкусу; подавайте с хлебом."
      ]
    },
    "uk": {
      "recovery_note": "Італійська страва за 10 хвилин. Їжа ресторанної якості без спокуси ресторанного алкоголю. Білок, кальцій та антиоксиданти в одній чудовій тарілці.",
      "ingredients": [
        "1 кулька свіжої mozzarella, нарізана скибочками",
        "2 томати, нарізані скибочками",
        "60g prosciutto",
        "Свіже листя базиліку",
        "Balsamic glaze, оливкова олія",
        "Хрусткий цільнозерновий хліб"
      ],
      "steps": [
        "Викладіть на тарілку, чергуючи, скибочки томатів та моцарели.",
        "Розподіліть прошуто складками по всій тарілці.",
        "Викладіть листочки базиліку між скибочками.",
        "Полийте оливковою олією та balsamic glaze.",
        "Приправте за смаком; подавайте з хлібом."
      ]
    },
    "ko": {
      "recovery_note": "10분 만에 완성하는 이탈리아풍 요리입니다. 레스토랑의 술 유혹 없이 즐길 수 있는 고품격 요리입니다. 단백질, 칼슘, 항산화 성분을 한 접시에 아름답게 담았습니다.",
      "ingredients": [
        "생 모짜렐라 1덩이, 슬라이스",
        "토마토 2개, 슬라이스",
        "60g 프로슈토",
        "신선한 바질 잎",
        "발사믹 글레이즈, 올리브 오일",
        "겉바속촉한 통곡물 빵 (Crusty wholegrain bread)"
      ],
      "steps": [
        "토마토와 모짜렐라 슬라이스를 접시 위에 교차하여 놓습니다.",
        "프로슈토를 접시 전체에 주름을 잡아 겹쳐 올립니다.",
        "슬라이스 사이에 바질 잎을 끼워 넣습니다.",
        "올리브 오일과 발사믹 글레이즈를 뿌립니다.",
        "간을 맞춘 뒤 빵을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Une assiette d'inspiration italienne prête en 10 minutes. Une cuisine digne d'un restaurant, sans la tentation de l'alcool. Des protéines, du calcium et des antioxydants réunis dans une magnifique assiette.",
      "ingredients": [
        "1 boule de mozzarella fraîche, tranchée",
        "2 tomates, tranchées",
        "60g de prosciutto",
        "Feuilles de basilic frais",
        "Balsamic glaze, huile d'olive",
        "Pain complet croustillant"
      ],
      "steps": [
        "Alternez les tranches de tomate et de mozzarella sur une assiette.",
        "Disposez le prosciutto en chiffonnade sur l'assiette.",
        "Glissez des feuilles de basilic entre les tranches.",
        "Arrosez d'un filet d'huile d'olive et de crème de balsamique.",
        "Assaisonnez ; servez avec du pain."
      ]
    },
    "it": {
      "recovery_note": "Un piatto d'ispirazione italiana pronto in 10 minuti. Cibo di qualità da ristorante senza la tentazione degli alcolici del locale. Proteine, calcio e antiossidanti in un unico, splendido piatto.",
      "ingredients": [
        "1 palla di mozzarella fresca, affettata",
        "2 pomodori, affettati",
        "60g prosciutto",
        "Foglie di basilico fresco",
        "Balsamic glaze, olio d'oliva",
        "Pane integrale croccante"
      ],
      "steps": [
        "Alternare fette di pomodoro e mozzarella su un piatto.",
        "Disporre il prosciutto a pieghe su tutto il piatto.",
        "Inserire foglie di basilico tra le fette.",
        "Condire con un filo di olio d'oliva e glassa di balsamico.",
        "Condire con sale e pepe; servire con pane."
      ]
    },
    "es": {
      "recovery_note": "Un plato de inspiración italiana en 10 minutos. Comida con calidad de restaurante sin la tentación del alcohol de un establecimiento. Proteína, calcio y antioxidantes en un solo plato espectacular.",
      "ingredients": [
        "1 bola de mozzarella fresca, en rodajas",
        "2 tomates, en rodajas",
        "60g prosciutto",
        "Hojas de albahaca fresca",
        "Balsamic glaze, aceite de oliva",
        "Pan integral crujiente"
      ],
      "steps": [
        "Alterne rodajas de tomate y mozzarella en un plato.",
        "Coloque el prosciutto en pliegues a través del plato.",
        "Meta hojas de albahaca entre las rodajas.",
        "Rocíe con aceite de oliva y balsamic glaze.",
        "Condimente; sirva con pan."
      ]
    }
  },
  "pt1": {
    "ru": {
      "recovery_note": "Богатый железом кейл и богатый калием картофель — восстанавливают минералы, утраченные за годы неправильного питания в период активного употребления.",
      "ingredients": [
        "4 картофеля, очищенных и нарезанных",
        "1 луковица, 4 зубчика чеснока",
        "4 cups бульона",
        "2 cups кале, мелко шинкованной",
        "1/4 cup оливкового масла",
        "Соль, перец"
      ],
      "steps": [
        "Обжаривайте лук и чеснок 5 min.",
        "Добавьте картофель и stock; варите на медленном огне 20 min.",
        "Измельчите блендером до однородности.",
        "Добавьте kale; готовьте 3 min.",
        "Сбрызните оливковым маслом; добавьте специи."
      ]
    },
    "uk": {
      "recovery_note": "Багата на залізо капуста кале та багата на калій картопля — відновлюють мінерали, втрачені за роки неповноцінного харчування під час активного вживання.",
      "ingredients": [
        "4 картоплини, очищені та нарізані",
        "1 цибуля, 4 зубчики часнику",
        "4 cups бульйону",
        "2 cups капусти кале, дрібно нашаткованої",
        "1/4 cup оливкової олії",
        "Сіль, перець"
      ],
      "steps": [
        "Пасеруйте цибулю та часник 5 min.",
        "Додайте картоплю та stock; тушкуйте 20 min.",
        "Збийте блендером до однорідності.",
        "Додайте kale; готуйте 3 min.",
        "Збризніть оливковою олією; додайте спеції."
      ]
    },
    "ko": {
      "recovery_note": "철분이 풍부한 케일과 칼륨이 풍부한 감자는 사용량이 많았던 시기의 불규칙한 식습관으로 손실된 미네랄을 보충해 줍니다.",
      "ingredients": [
        "껍질을 벗겨 다진 감자 4개",
        "양파 1개, 마늘 4쪽",
        "육수 4 cups",
        "가늘게 채 썬 케일 2 cups",
        "올리브 오일 1/4 cup",
        "소금, 후추"
      ],
      "steps": [
        "양파와 마늘을 5 min 동안 볶습니다.",
        "감자와 육수를 넣고 20 min 동안 뭉근하게 끓입니다.",
        "부드러워질 때까지 블렌더로 갑니다.",
        "케일을 넣고 저으며 3 min 동안 익힙니다.",
        "올리브 오일을 뿌리고 간을 맞춥니다."
      ]
    },
    "fr": {
      "recovery_note": "Le chou kale riche en fer et la pomme de terre riche en potassium — restaure les minéraux perdus par des années de mauvaise alimentation durant la période de consommation active.",
      "ingredients": [
        "4 pommes de terre, épluchées et coupées",
        "1 oignon, 4 gousses d'ail",
        "4 cups de bouillon",
        "2 cups de chou kale, finement émincé",
        "1/4 cup d'huile d'olive",
        "Sel, poivre"
      ],
      "steps": [
        "Faire sauter l'oignon et l'ail pendant 5 min.",
        "Ajouter les pommes de terre et le bouillon ; faire mijoter 20 min.",
        "Mixer jusqu'à l'obtention d'une texture lisse.",
        "Incorporer le kale ; cuire 3 min.",
        "Arroser d'un filet d'huile d'olive ; assaisonner."
      ]
    },
    "it": {
      "recovery_note": "Cavolo riccio ricco di ferro e patate ricche di tassio — ripristinano i minerali persi in anni di cattiva alimentazione durante l'uso attivo.",
      "ingredients": [
        "4 patate, pelate e tagliate a pezzetti",
        "1 cipolla, 4 spicchi d'aglio",
        "4 cups di brodo",
        "2 cups di cavolo riccio, tritato finemente",
        "1/4 cup di olio d’oliva",
        "Sale, pepe"
      ],
      "steps": [
        "Soffriggere cipolla e aglio per 5 min.",
        "Aggiungere le patate e il brodo; cuocere a fuoco lento per 20 min.",
        "Frullare fino a ottenere un composto omogeneo.",
        "Incorporare il kale; cuocere per 3 min.",
        "Condire con un filo di olio d'oliva e regolare di sale e pepe."
      ]
    },
    "es": {
      "recovery_note": "Col rizada rica en hierro y patata rica en potasio: restaura los minerales perdidos tras años de mala nutrición durante el consumo activo.",
      "ingredients": [
        "4 potatoes, peladas y picadas",
        "1 onion, 4 garlic cloves",
        "4 cups stock",
        "2 cups kale, finamente triturado",
        "1/4 cup olive oil",
        "Salt, pepper"
      ],
      "steps": [
        "Saltee la cebolla y el ajo durante 5 min.",
        "Añada las patatas y el stock; cocine a fuego lento durante 20 min.",
        "Licue hasta que esté suave.",
        "Incorpore la col kale; cocine por 3 min.",
        "Rocíe con aceite de oliva; sazone."
      ]
    }
  },
  "pt2": {
    "ru": {
      "recovery_note": "Омега-3 из трески и полноценный белок из яиц — поддерживающая работу мозга португальская классика для любого времени суток.",
      "ingredients": [
        "400g филе трески, разобранного на хлопья",
        "4 яйца",
        "2 луковицы, нарезанные ломтиками",
        "300g картофеля пай (картофельной соломки)",
        "Olive oil, петрушка, оливки"
      ],
      "steps": [
        "Обжаривайте лук в масле до мягкости 8 min.",
        "Добавьте треску; готовьте 3 min.",
        "Вмешайте готовую картофельную соломку (matchstick potatoes).",
        "Залейте взбитыми яйцами; помешивайте до момента, когда они схватятся.",
        "Сверху посыпьте петрушкой и украсьте оливками."
      ]
    },
    "uk": {
      "recovery_note": "Омега-3 з тріски та повноцінний білок з яєць — португальська класика для підтримки мозку, що ідеально підійде для будь-якого часу доби.",
      "ingredients": [
        "400g філе cod, розділеного на шматочки",
        "4 яйця",
        "2 цибулини, нарізані скибочками",
        "300g картоплі соломкою (matchstick potatoes)",
        "Olive oil, петрушка, оливки"
      ],
      "steps": [
        "Пасеруйте цибулю в олії до м'якості 8 min.",
        "Додайте cod; готуйте 3 min.",
        "Вмішайте приготовану нарізану соломкою картоплю (matchstick potatoes).",
        "Залийте збитими яйцями; помішуйте до ледь застиглого стану.",
        "Посипте петрушкою та оливками."
      ]
    },
    "ko": {
      "recovery_note": "대구에 풍부한 오메가-3와 달걀의 완전 단백질이 만났습니다. 하루 중 언제 즐겨도 좋은, 뇌 건강을 돕는 포르투갈의 고전 요리입니다.",
      "ingredients": [
        "400g cod fillet, 가시를 발라낸 것",
        "계란 4개",
        "양파 2개, 채 썬 것",
        "300g matchstick potatoes",
        "올리브 오일, 파슬리, 올리브"
      ],
      "steps": [
        "양파가 부드러워질 때까지 오일에 8 min 동안 볶습니다.",
        "대구를 넣고 3 min 동안 익힙니다.",
        "조리된 채 썬 감자를 넣고 섞습니다.",
        "풀어둔 달걀을 붓고 살짝 익을 때까지 젓습니다.",
        "파슬리와 올리브를 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Des oméga-3 provenant de la morue et des protéines complètes issues des œufs — un classique portugais bon pour le cerveau, à déguster à tout moment de la journée.",
      "ingredients": [
        "400g de filet de cabillaud, effiloché",
        "4 œufs",
        "2 oignons, émincés",
        "300g de pommes de terre allumettes",
        "Huile d'olive, persil, olives"
      ],
      "steps": [
        "Faire revenir les oignons dans l'huile jusqu'à ce qu'ils soient tendres, environ 8 min.",
        "Ajouter le cabillaud ; cuire 3 min.",
        "Incorporer les pommes de terre allumettes cuites.",
        "Verser les œufs battus par-dessus ; remuer jusqu'à ce qu'ils soient tout juste pris.",
        "Garnir de persil et d'olives."
      ]
    },
    "it": {
      "recovery_note": "Omega-3 dal merluzzo e proteine complete dalle uova: un classico portoghese amico del cervello per ogni momento della giornata.",
      "ingredients": [
        "400g filetto di merluzzo, a scaglie",
        "4 uova",
        "2 cipolle, affettate",
        "300g patate tagliate a fiammifero",
        "Olio d'oliva, prezzemolo, olive"
      ],
      "steps": [
        "Soffriggere le cipolle nell'olio fino a quando non si ammorbidiscono, circa 8 min.",
        "Aggiungere il cod; cuocere per 3 min.",
        "Incorporare le matchstick potatoes cotte.",
        "Versare sopra le uova sbattute; mescolare fino a quando non si saranno appena rapprese.",
        "Guarnire con prezzemolo e olive."
      ]
    },
    "es": {
      "recovery_note": "Omega-3 del bacalao más proteína completa de los huevos: un clásico portugués para favorecer el cerebro en cualquier momento del día.",
      "ingredients": [
        "400g cod fillet, desmigado",
        "4 eggs",
        "2 onions, en rodajas",
        "300g matchstick potatoes",
        "Olive oil, perejil, aceitunas"
      ],
      "steps": [
        "Sofreír las cebollas en aceite hasta que estén blandas 8 min.",
        "Añadir el bacalao; cocinar 3 min.",
        "Incorporar las patatas paja cocinadas.",
        "Verter los huevos batidos por encima; remover hasta que estén cuajados.",
        "Decorar con perejil y aceitunas."
      ]
    }
  },
  "pt3": {
    "ru": {
      "recovery_note": "Острая еда способствует выработке эндорфинов — это здоровая гедонистическая альтернатива химическому опьянению от психоактивных веществ.",
      "ingredients": [
        "600g куриных бедер",
        "4 зубчика чеснока, измельченных",
        "2 tbsp соуса piri-piri или хлопьев чили",
        "1 лимон, сок",
        "Olive oil, паприка, соль"
      ],
      "steps": [
        "Маринуйте курицу с garlic, piri-piri, lemon и oil в течение 30 min.",
        "Запекайте при 200°C в течение 30 min до полной готовности.",
        "В середине процесса смажьте выделившимся соком.",
        "Дайте отдохнуть 5 min.",
        "Подавайте с салатом и рисом."
      ]
    },
    "uk": {
      "recovery_note": "Гостра їжа стимулює вироблення природних ендорфінів — здорову гедоністичну заміну хімічному кайфу від вживання психоактивних речовин.",
      "ingredients": [
        "600g курячих стегон",
        "4 зубчики часнику, подрібнені",
        "2 tbsp соусу piri-piri або пластівців чилі",
        "1 лимон, вичавлений сік",
        "Olive oil, паприка, сіль"
      ],
      "steps": [
        "Маринуйте курку з часником, piri-piri, лимоном та олією протягом 30 min.",
        "Запікайте при 200°C протягом 30 min до повної готовності.",
        "На половині часу приготування змастіть соком, що виділився.",
        "Залиште відпочити на 5 min.",
        "Подавайте з салатом та рисом."
      ]
    },
    "ko": {
      "recovery_note": "매운 음식은 천연 엔도르핀을 생성하며, 이는 약물 사용으로 인한 화학적 쾌락보다 건강하고 즐거운 대안이 됩니다.",
      "ingredients": [
        "600g chicken thighs",
        "다진 마늘 4쪽",
        "2 tbsp piri-piri sauce 또는 chilli flakes",
        "레몬 1개분 즙",
        "Olive oil, paprika, salt"
      ],
      "steps": [
        "치킨을 마늘, piri-piri, 레몬, 오일과 함께 30 min 동안 재워둡니다.",
        "200°C에서 속까지 다 익을 때까지 30 min 동안 굽습니다.",
        "조리 중간에 육즙을 골고루 바릅니다.",
        "5 min 동안 레스팅합니다.",
        "샐러드, rice와 함께 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "La nourriture épicée déclenche des endorphines naturelles — une amélioration hédonique saine par rapport aux pics chimiques de la consommation de substances.",
      "ingredients": [
        "600g chicken thighs",
        "4 gousses d'ail, hachées",
        "2 tbsp piri-piri sauce ou flocons de piment",
        "1 citron, pressé",
        "Olive oil, paprika, sel"
      ],
      "steps": [
        "Mariner le poulet avec de l'ail, du piri-piri, du citron et de l'huile pendant 30 min.",
        "Cuire au four à 200°C pendant 30 min jusqu'à ce qu'il soit bien cuit.",
        "Badigeonner avec le jus de cuisson à mi-cuisson.",
        "Laisser reposer 5 min.",
        "Servir avec de la salade et du riz."
      ]
    },
    "it": {
      "recovery_note": "Il cibo piccante stimola le endorfine naturali: un miglioramento edonistico salutare rispetto allo sballo chimico derivante dall'uso di sostanze.",
      "ingredients": [
        "600g di cosce di pollo",
        "4 spicchi d'aglio, tritati",
        "2 tbsp di salsa piri-piri o fiocchi di peperoncino",
        "1 limone, succo",
        "Olio d'oliva, paprika, sale"
      ],
      "steps": [
        "Marinare il pollo con aglio, piri-piri, limone e olio per 30 min.",
        "Cuocere in forno a 200°C per 30 min fino a cottura completa.",
        "Spennellare con i succhi di cottura a metà tempo.",
        "Lasciare riposare per 5 min.",
        "Servire con insalata e riso."
      ]
    },
    "es": {
      "recovery_note": "La comida picante libera endorfinas naturales, una mejorahedónica saludable en comparación con los subidones químicos del consumo de sustancias.",
      "ingredients": [
        "600g contramuslos de pollo",
        "4 dientes de ajo, picados",
        "2 tbsp de salsa piri-piri o copos de chile",
        "1 limón, exprimido",
        "Aceite de oliva, pimentón, sal"
      ],
      "steps": [
        "Marinar el pollo con ajo, piri-piri, limón y aceite durante 30 min.",
        "Hornear a 200°C durante 30 min hasta que esté bien cocido.",
        "Pincelar con los jugos a mitad de la cocción.",
        "Dejar reposar 5 min.",
        "Servir con ensalada y arroz."
      ]
    }
  },
  "pt4": {
    "ru": {
      "recovery_note": "Классическая португальская домашняя еда из простых продуктов — тот самый вид дешевого и питательного блюда, который доказывает, что восстановление не требует дорогих ингредиентов.",
      "ingredients": [
        "1 стакан риса",
        "1 банка томатов",
        "1 луковица, 2 зубчика чеснока",
        "2 стакана бульона",
        "1 ч. л. паприки",
        "Оливковое масло, базилик, соль"
      ],
      "steps": [
        "Обжаривайте onion и garlic 4 min.",
        "Добавьте tomatoes и paprika; готовьте 5 min.",
        "Вмешайте rice и stock.",
        "Томите под крышкой 20 min до мягкости rice.",
        "Посыпьте сверху basil."
      ]
    },
    "uk": {
      "recovery_note": "Португальська домашня їжа з продуктів, що завжди під рукою — той тип дешевої та поживної страви, яка доводить, що відновлення не потребує дорогих інгредієнтів.",
      "ingredients": [
        "1 склянка рису",
        "1 банка томатів",
        "1 цибулина, 2 зубчики часнику",
        "2 склянки бульйону (stock)",
        "1 ч. л. паприки",
        "Olive oil, базилік, сіль"
      ],
      "steps": [
        "Обсмажуйте цибулю та часник 4 min.",
        "Додайте томати та paprika; готуйте 5 min.",
        "Додайте рис та stock, помішуючи.",
        "Тушкуйте під кришкою 20 min до м'якості рису.",
        "Посипте зверху basil."
      ]
    },
    "ko": {
      "recovery_note": "팬트리에 있는 기본 재료로 만드는 포르투갈식 소울 푸드 — 회복식에 비싼 식재료가 필요하지 않다는 것을 증명하는 저렴하고 영양가 높은 식사입니다.",
      "ingredients": [
        "쌀 1 cup",
        "토마토 통조림 1 tin",
        "양파 1개, 마늘 2쪽",
        "육수 2 cups",
        "파프리카 가루 1 tsp",
        "올리브 오일, 바질, 소금"
      ],
      "steps": [
        "양파와 마늘을 4 min 동안 볶습니다.",
        "토마토와 paprika를 넣고 5 min 동안 익힙니다.",
        "쌀과 육수를 넣고 젓습니다.",
        "뚜껑을 덮고 쌀이 부드러워질 때까지 20 min 동안 뭉근하게 끓입니다.",
        "basil을 위에 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat réconfortant portugais à base de produits du placard — le genre de repas économique et nourrissant qui prouve que la guérison ne nécessite pas d'ingrédients coûteux.",
      "ingredients": [
        "1 cup de riz",
        "1 boîte de tomates",
        "1 oignon, 2 gousses d'ail",
        "2 cups de bouillon",
        "1 tsp de paprika",
        "Huile d'olive, basilic, sel"
      ],
      "steps": [
        "Faire sauter l'oignon et l'ail pendant 4 min.",
        "Ajouter les tomates et le paprika ; cuire 5 min.",
        "Incorporer le riz et le bouillon.",
        "Mijoter à couvert pendant 20 min jusqu'à ce que le riz soit tendre.",
        "Garnir de basilic."
      ]
    },
    "it": {
      "recovery_note": "Comfort food portoghese con ingredienti di dispensa: il tipo di pasto economico e nutriente che dimostra come la Recovery non richieda ingredienti costosi.",
      "ingredients": [
        "1 tazza di riso",
        "1 lattina di pomodori",
        "1 cipolla, 2 spicchi d'aglio",
        "2 tazze di brodo",
        "1 tsp di paprika",
        "Olio d'oliva, basilico, sale"
      ],
      "steps": [
        "Soffriggere la cipolla e l'aglio per 4 min.",
        "Aggiungere i pomodori e la paprika; cuocere per 5 min.",
        "Incorporare il riso e il brodo.",
        "Cuocere a fuoco lento con il coperchio per 20 min finché il riso non sarà tenero.",
        "Guarnire con il basilico."
      ]
    },
    "es": {
      "recovery_note": "Comida reconfortante portuguesa con ingredientes básicos de la despensa: el tipo de plato económico y nutritivo que demuestra que la recuperación no requiere ingredientes caros.",
      "ingredients": [
        "1 cup arroz",
        "1 tin tomates",
        "1 cebolla, 2 garlic cloves",
        "2 cups caldo",
        "1 tsp pimentón",
        "Aceite de oliva, albahaca, sal"
      ],
      "steps": [
        "Sofreír la cebolla y el ajo durante 4 min.",
        "Añadir los tomates y la paprika; cocinar 5 min.",
        "Incorporar el arroz y el stock.",
        "Cocinar a fuego lento y tapado durante 20 min hasta que el arroz esté tierno.",
        "Decorar con albahaca por encima."
      ]
    }
  },
  "pt5": {
    "ru": {
      "recovery_note": "Консервированные сардины — это самый дешевый источник омега-3 EPA/DHA на планете. Употребление их дважды в неделю — одна из привычек с наиболее доказанной эффективностью для поддержания настроения.",
      "ingredients": [
        "8 свежих или консервированных сардин",
        "2 лимона",
        "Морская соль (Sea salt), оливковое масло (olive oil)",
        "Хлеб с хрустящей корочкой (Crusty bread)",
        "Смесь салатных листьев для подачи (Mixed leaves)"
      ],
      "steps": [
        "Обсушите сардины; посыпайте морской солью.",
        "Жарьте на гриле по 3-4 min с каждой стороны до появления подпалин.",
        "Сбрызните лимонным соком.",
        "Подавайте на хлебе с листьями салата.",
        "Сбрызните оливковым маслом."
      ]
    },
    "uk": {
      "recovery_note": "Консервовані сардини — це найдешевше джерело омега-3 ЕПК/ДГК на планеті — вживання їх двічі на тиждень є однією з найбільш науково обґрунтованих звичок для підтримки гарного настрою.",
      "ingredients": [
        "8 свіжих або консервованих сардин",
        "2 lemons",
        "Sea salt, olive oil",
        "Crusty bread",
        "Mixed leaves для подачі"
      ],
      "steps": [
        "Обсушіть сардини; посипте sea salt.",
        "Смажте на грилі 3-4 min з кожного боку до появи підпалин.",
        "Полийте вичавленим соком lemon.",
        "Подавайте на bread із листям салату.",
        "Збризніть olive oil."
      ]
    },
    "ko": {
      "recovery_note": "통조림 정어리는 지구상에서 가장 저렴한 오메가-3 EPA/DHA 공급원입니다. 일주일에 2번 섭취하는 것은 기분 조절에 도움을 주는 가장 확실한 습관 중 하나입니다.",
      "ingredients": [
        "신선한 또는 통조림 정어리 8마리",
        "레몬 2개",
        "Sea salt, olive oil",
        "바삭한 빵 (Crusty bread)",
        "곁들임용 모둠 채소 (Mixed leaves)"
      ],
      "steps": [
        "정어리의 물기를 닦아낸 후, sea salt를 뿌립니다.",
        "겉면이 살짝 탈 때까지 각 면당 3-4 min 동안 그릴에 굽습니다.",
        "그 위에 레몬즙을 짭니다.",
        "채소 잎과 함께 빵 위에 올려 냅니다.",
        "올리브 오일을 뿌려 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les sardines en conserve sont la source d'oméga-3 EPA/DHA la moins chère de la planète — en consommer deux fois par semaine est l'une des habitudes les plus probantes pour soutenir l'humeur.",
      "ingredients": [
        "8 sardines fraîches ou en conserve",
        "2 citrons",
        "Sea salt, olive oil",
        "Pain croustillant",
        "Mélange de jeunes pousses pour servir"
      ],
      "steps": [
        "Sécher les sardines en tapotant ; saupoudrer de sea salt.",
        "Griller 3-4 min par côté jusqu'à ce qu'elles soient bien saisies.",
        "Presser du citron par-dessus.",
        "Servir sur du pain avec des feuilles.",
        "Arroser d'huile d'olive."
      ]
    },
    "it": {
      "recovery_note": "Le sardine in scatola sono la fonte più economica di omega-3 EPA/DHA del pianeta — consumarle due volte a settimana è una delle abitudini più supportate da evidenze scientifiche per sostenere l'umore.",
      "ingredients": [
        "8 sardine fresche o in scatola",
        "2 limoni",
        "Sale marino, olio d'oliva",
        "Pane croccante",
        "Insalata mista per servire"
      ],
      "steps": [
        "Asciugare le sardine tamponandole; cospargere con sea salt.",
        "Grigliare per 3-4 min per lato fino a quando non saranno ben rosolate.",
        "Spremere del limone sopra.",
        "Servire su pane con foglie di insalata.",
        "Irrorare con olive oil."
      ]
    },
    "es": {
      "recovery_note": "Las sardinas en conserva son la fuente más barata de omega-3 EPA/DHA del planeta; consumirlas dos veces por semana es uno de los hábitos con mayor evidencia científica para mejorar el estado de ánimo.",
      "ingredients": [
        "8 sardinas frescas o en conserva",
        "2 limones",
        "Sea salt, olive oil",
        "Crusty bread",
        "Mezcla de hojas verdes para servir"
      ],
      "steps": [
        "Seque las sardinas; espolvoree con sea salt.",
        "Cocine a la parrilla de 3-4 min por lado hasta que estén chamuscadas.",
        "Exprima limón encima.",
        "Sirva sobre pan con hojas verdes.",
        "Rocíe con aceite de oliva."
      ]
    }
  },
  "pt6": {
    "ru": {
      "recovery_note": "Растительный уют с серьезным зарядом энергии — бобовые содержат клетчатку, которая питает кишечные бактерии, производящие в свою очередь 90% вашего серотонина.",
      "ingredients": [
        "2 банки белой фасоли",
        "1 луковица, 3 зубчика чеснока",
        "1 морковь, 1 болгарский перец (capsicum), нарезанные кубиками",
        "1 банка томатов",
        "1 tsp паприки, лавровый лист",
        "Кинза (Coriander), оливковое масло"
      ],
      "steps": [
        "Обжаривайте onion, garlic, carrot и capsicum в течение 8 min.",
        "Добавьте beans, tomatoes, paprika и bay.",
        "Тушите на медленном огне 25 min.",
        "Помешивая, добавьте свежий coriander.",
        "Подавайте с rice или crusty bread."
      ]
    },
    "uk": {
      "recovery_note": "Рослинна їжа для затишку, яка дає справжній заряд енергії — квасоля містить клітковину, що живить кишкові бактерії, які, у свою чергу, виробляють 90% вашого серотоніну.",
      "ingredients": [
        "2 банки білої квасолі",
        "1 цибулина, 3 зубчики часнику",
        "1 морква, 1 болгарський перець (capsicum), нарізані кубиками",
        "1 банка томатів",
        "1 tsp паприки, лавровий лист",
        "Коріандр, оливкова олія"
      ],
      "steps": [
        "Обсмажуйте цибулю, часник, моркву та болгарський перець (capsicum) 8 хв.",
        "Додайте квасолю, томати, paprika та лавровий лист (bay).",
        "Тушкуйте на повільному вогні 25 хв.",
        "Вмішайте свіжий коріандр.",
        "Подавайте з рисом або хрустким хлібом."
      ]
    },
    "ko": {
      "recovery_note": "든든한 포만감을 선사하는 식물성 위안 — 콩에 풍부한 식이섬유는 장내 유익균의 먹이가 되며, 이 유익균은 행복 호르몬인 세로토닌의 90%를 생성합니다.",
      "ingredients": [
        "흰 강낭콩 2캔",
        "양파 1개, 마늘 3쪽",
        "당근 1개, 피망 1개, 깍둑썰기한 것",
        "토마토 1캔",
        "1 tsp 파프리카 가루, 월계수 잎",
        "고수, 올리브 오일"
      ],
      "steps": [
        "양파, 마늘, 당근, capsicum을 8 min 동안 볶습니다.",
        "콩, 토마토, paprika, bay 리프를 넣습니다.",
        "25 min 동안 뭉근하게 끓입니다.",
        "신선한 고수(coriander)를 넣고 섞습니다.",
        "밥이나 바삭한 빵을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un réconfort végétal avec un véritable effet de satiété — les haricots apportent des fibres qui nourrissent les bactéries intestinales, lesquelles produisent à leur tour 90% de votre sérotonine.",
      "ingredients": [
        "2 boîtes de haricots blancs",
        "1 oignon, 3 gousses d'ail",
        "1 carotte, 1 capsicum, coupé en dés",
        "1 boîte de tomates",
        "1 tsp paprika, feuille de laurier",
        "Coriandre, huile d'olive"
      ],
      "steps": [
        "Faire sauter l'oignon, l'ail, la carotte et le capsicum pendant 8 min.",
        "Ajouter les beans, les tomatoes, le paprika et le bay.",
        "Mijoter pendant 25 min.",
        "Incorporer la fresh coriander.",
        "Servir avec du rice ou du crusty bread."
      ]
    },
    "it": {
      "recovery_note": "Comfort food vegetale con una marcia in più: i fagioli apportano fibre che nutrono i batteri intestinali, i quali a loro volta producono il 90% della serotonina.",
      "ingredients": [
        "2 lattine di fagioli bianchi",
        "1 cipolla, 3 spicchi d'aglio",
        "1 carota, 1 capsicum, a dadini",
        "1 lattina di pomodori",
        "1 tsp di paprika, foglia di alloro",
        "Coriandolo, olio d'oliva"
      ],
      "steps": [
        "Soffriggere cipolla, aglio, carota e peperone per 8 min.",
        "Aggiungere fagioli, pomodori, paprika e alloro.",
        "Sobbollire per 25 min.",
        "Incorporare il coriandolo fresco.",
        "Servire con riso o pane croccante."
      ]
    },
    "es": {
      "recovery_note": "Bienestar vegetal con un gran poder saciante: las legumbres aportan fibra que alimenta las bacterias intestinales, las cuales a su vez producen el 90% de tu serotonina.",
      "ingredients": [
        "2 latas de white beans",
        "1 cebolla, 3 dientes de ajo",
        "1 zanahoria, 1 capsicum, picado en cubos",
        "1 lata de tomates",
        "1 tsp de paprika, hoja de laurel",
        "Cilantro, aceite de oliva"
      ],
      "steps": [
        "Saltear la cebolla, el ajo, la zanahoria y el capsicum durante 8 min.",
        "Añadir los frijoles, los tomates, la paprika y el laurel.",
        "Cocinar a fuego lento durante 25 min.",
        "Incorporar el cilantro fresco.",
        "Servir con arroz o pan crujiente."
      ]
    }
  },
  "pt7": {
    "ru": {
      "recovery_note": "А",
      "ingredients": [
        "1 банка красной фасоли",
        "200g chorizo или копченой колбасы",
        "1 луковица, 2 картофелины, 2 моркови",
        "1/4 кочана капусты, 4 cups бульона",
        "Лавровый лист, петрушка"
      ],
      "steps": [
        "Обжаривайте chorizo и лук 5 min.",
        "Добавьте нарезанные кубиками овощи и stock.",
        "Тушите на медленном огне 30 min.",
        "Добавьте фасоль и лавровый лист; готовьте еще 5 min.",
        "Посыпьте петрушкой."
      ]
    },
    "uk": {
      "recovery_note": "А",
      "ingredients": [
        "1 банка червоної квасолі",
        "200g chorizo або копченої ковбаси",
        "1 цибулина, 2 картоплини, 2 моркви",
        "1/4 капусти, 4 cups stock",
        "Лавровий лист, петрушка"
      ],
      "steps": [
        "Обсмажте chorizo та цибулю 5 min.",
        "Додайте нарізані кубиками овочі та бульйон (stock).",
        "Тушкуйте на повільному вогні 30 min.",
        "Додайте квасолю та лавровий лист; готуйте ще 5 min.",
        "Посипте зверху петрушкою."
      ]
    },
    "ko": {
      "recovery_note": "가",
      "ingredients": [
        "1 tin 레드 빈",
        "200g 초리조 또는 훈제 소시지",
        "양파 1개, 감자 2개, 당근 2개",
        "양배추 1/4개, 육수 4 cups",
        "월계수 잎, 파슬리"
      ],
      "steps": [
        "chorizo와 양파를 5 min 동안 볶습니다.",
        "깍둑썰기한 채소와 육수를 넣습니다.",
        "30 min 동안 뭉근하게 끓입니다.",
        "콩과 bay 잎을 넣고 5 min 더 조리합니다.",
        "파슬리를 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "À",
      "ingredients": [
        "1 boîte de haricots rouges",
        "200g de chorizo ou saucisse fumée",
        "1 oignon, 2 pommes de terre, 2 carottes",
        "1/4 de chou, 4 cups de bouillon",
        "Laurier, persil"
      ],
      "steps": [
        "Faire sauter le chorizo et l'oignon pendant 5 min.",
        "Ajouter les légumes coupés en dés et le bouillon (stock).",
        "Faire mijoter 30 min.",
        "Ajouter les haricots et le laurier ; cuire encore 5 min de plus.",
        "Garnir de persil."
      ]
    },
    "it": {
      "recovery_note": "Un",
      "ingredients": [
        "1 lattina di fagioli rossi",
        "200g di chorizo o salsiccia affumicata",
        "1 cipolla, 2 patate, 2 carote",
        "1/4 di cavolo, 4 tazze di brodo",
        "Foglia di alloro, prezzemolo"
      ],
      "steps": [
        "Soffriggere il chorizo e la cipolla per 5 min.",
        "Aggiungere le verdure a dadini e il brodo.",
        "Sobbollire per 30 min.",
        "Aggiungere i fagioli e l'alloro; cuocere per altri 5 min.",
        "Guarnire con il prezzemolo."
      ]
    },
    "es": {
      "recovery_note": "Un 1/2 de taza de harina de almendras o 60g.",
      "ingredients": [
        "1 lata de red beans",
        "200g de chorizo o salchicha ahumada",
        "1 cebolla, 2 patatas, 2 zanahorias",
        "1/4 de repollo, 4 tazas de stock",
        "Hoja de laurel, perejil"
      ],
      "steps": [
        "Saltee el chorizo y la cebolla durante 5 min.",
        "Añada las verduras picadas y el caldo.",
        "Cocine a fuego lento durante 30 min.",
        "Añada los frijoles y el laurel; cocine 5 min más.",
        "Decore con perejil por encima."
      ]
    }
  },
  "pt8": {
    "ru": {
      "recovery_note": "Лакомство, которое по-честному задействует систему вознаграждения за счет сочетания жирного и сладкого — доказательство того, что для удовольствия не нужен алкоголь.",
      "ingredients": [
        "3 яичных желтка",
        "1 cup молока",
        "2 tbsp кукурузного крахмала",
        "3 tbsp меда",
        "1 tsp ванили",
        "Корица для посыпки"
      ],
      "steps": [
        "Взбейте желтки, cornflour и milk в кастрюле.",
        "Готовьте на медленном огне, помешивая, до загустения.",
        "Вмешайте vanilla и honey.",
        "Разлейте по формочкам (ramekins); выпекайте при 200°C в течение 15 min.",
        "Остудите; присыпьте cinnamon."
      ]
    },
    "uk": {
      "recovery_note": "Ласощі, які по-справжньому активують систему винагороди через поєднання солодкого та жирного — доказ того, що задоволення не обов'язково має бути в пляшці.",
      "ingredients": [
        "3 яєчних жовтки",
        "1 cup молока",
        "2 tbsp кукурудзяного крохмалю",
        "3 tbsp меду",
        "1 tsp ванілі",
        "Кориця для посипання"
      ],
      "steps": [
        "Збийте жовтки, кукурудзяний крохмаль та молоко у каструлі.",
        "Готуйте на слабкому вогні, помішуючи, до загустіння.",
        "Додайте ваніль та мед.",
        "Розлийте у формочки (ramekins); випікайте при 200°C протягом 15 хвилин.",
        "Охолодіть; посипте корицею."
      ]
    },
    "ko": {
      "recovery_note": "단맛과 지방의 보상 회로를 정직하게 자극하는 즐거움 — 기쁨이 굳이 병에 담겨 있을 필요가 없다는 사실을 증명하는 맛입니다.",
      "ingredients": [
        "계란 노른자 3개",
        "우유 1 cup",
        "옥수수 전분 2 tbsp",
        "꿀 3 tbsp",
        "바닐라 1 tsp",
        "뿌려줄 시나몬 가루 (Cinnamon to dust)"
      ],
      "steps": [
        "냄비에 노른자, cornflour, milk를 넣고 거품기로 섞습니다.",
        "약한 불에서 걸쭉해질 때까지 저어가며 익힙니다.",
        "vanilla와 honey를 넣고 섞습니다.",
        "ramekins에 붓고 200°C에서 15분 동안 굽습니다.",
        "식힌 후 cinnamon 가루를 뿌립니다."
      ]
    },
    "fr": {
      "recovery_note": "Une gourmandise qui flatte franchement le circuit de la récompense sucre-gras — la preuve que le plaisir n'a pas besoin d'être mis en bouteille.",
      "ingredients": [
        "3 jaunes d'œufs",
        "1 cup de lait",
        "2 tbsp de cornflour",
        "3 tbsp de miel",
        "1 tsp de vanille",
        "Cannelle pour saupoudrer"
      ],
      "steps": [
        "Fouetter les jaunes d'œufs, la fécule de maïs (cornflour) et le lait dans une casserole.",
        "Cuire à feu doux, en remuant, jusqu'à épaississement.",
        "Incorporer la vanille et le miel.",
        "Verser dans des ramequins ; cuire à 200°C pendant 15 min.",
        "Laisser refroidir ; saupoudrer de cannelle."
      ]
    },
    "it": {
      "recovery_note": "Una delizia che appaga onestamente il circuito della ricompensa tra zuccheri e grassi — la prova che il piacere non deve necessariamente venire da una bottiglia.",
      "ingredients": [
        "3 tuorli d'uovo",
        "1 cup di latte",
        "2 tbsp di cornflour",
        "3 tbsp di miele",
        "1 tsp di vaniglia",
        "Cannella per spolverare"
      ],
      "steps": [
        "Sbattere i tuorli, la cornflour e il milk in una pentola.",
        "Cuocere a fuoco basso, mescolando, fino a quando non si addensa.",
        "Incorporare la vanilla e il honey.",
        "Versare nei ramekins; cuocere a 200°C per 15 min.",
        "Lasciare raffreddare; spolverare con cinnamon."
      ]
    },
    "es": {
      "recovery_note": "Un capricho que activa directamente el circuito de recompensa de grasa y dulce; la prueba de que el placer no tiene por qué venir en una botella.",
      "ingredients": [
        "3 yemas de huevo",
        "1 cup de leche",
        "2 tbsp de cornflour",
        "3 tbsp de miel",
        "1 tsp de vainilla",
        "Canela para espolvorear"
      ],
      "steps": [
        "Batir las yemas, el cornflour y la leche en una olla.",
        "Cocinar a fuego lento, revolviendo, hasta que espese.",
        "Incorporar la vainilla y la honey.",
        "Verter en moldes (ramekins); hornear a 200°C por 15 min.",
        "Dejar enfriar; espolvorear con canela."
      ]
    }
  },
  "pt9": {
    "ru": {
      "recovery_note": "Полноценный обед в одной тарелке — белки, полезные жиры, сложные углеводы и минералы за 10 минут.",
      "ingredients": [
        "1 банка тунца в оливковом масле",
        "1 вареное яйцо, нарезанное ломтиками",
        "1 вареный картофель, нарезанный кубиками",
        "1 томат, 1/4 луковицы",
        "10 оливок, петрушка",
        "Оливковое масло, уксус"
      ],
      "steps": [
        "Выложите слоями картофель, тунец, яйцо, помидор и лук в миску.",
        "Добавьте оливки и петрушку.",
        "Взбейте оливковое масло и уксус.",
        "Полейте сверху.",
        "Подавайте немедленно."
      ]
    },
    "uk": {
      "recovery_note": "Повноцінний обід в одній тарілці — білок, корисні жири, складні вуглеводи та мінерали за 10 хвилин.",
      "ingredients": [
        "1 банка тунця в оливковій олії",
        "1 варене яйце, нарізане скибочками",
        "1 варена картоплина, нарізана кубиками",
        "1 помідор, 1/4 цибулини",
        "10 оливок, петрушка",
        "Оливкова олія, оцет"
      ],
      "steps": [
        "Викладіть шарами картоплю, тунець, яйце, помідор та цибулю у миску.",
        "Додайте оливки та петрушку.",
        "Збийте оливкову олію та оцет.",
        "Полийте зверху.",
        "Подавайте негайно."
      ]
    },
    "ko": {
      "recovery_note": "단 10분 만에 완성하는 완벽한 한 그릇 점심 식사 — 단백질, 건강한 지방, 복합 탄수화물 그리고 미네랄까지 모두 담았습니다.",
      "ingredients": [
        "올리브 오일에 담긴 참치 통조림 1개",
        "슬라이스한 삶은 계란 1개",
        "깍둑썰기한 삶은 감자 1개",
        "토마토 1개, 양파 1/4개",
        "올리브 10알, 파슬리",
        "올리브 오일, 식초"
      ],
      "steps": [
        "볼에 감자, 참치, 달걀, 토마토, 양파를 층층이 담습니다.",
        "올리브와 파슬리를 추가합니다.",
        "올리브 오일과 식초를 휘퍼로 섞습니다.",
        "위에 고루 붓습니다.",
        "즉시 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un déjeuner complet dans un seul bol — des protéines, de bons gras, des glucides complexes et des minéraux en 10 minutes.",
      "ingredients": [
        "1 boîte de thon à l'huile d'olive",
        "1 œuf dur, tranché",
        "1 pomme de terre bouillie, coupée en dés",
        "1 tomate, 1/4 d'oignon",
        "10 olives, persil",
        "Huile d'olive, vinaigre"
      ],
      "steps": [
        "Disposer les couches de pommes de terre, de thon, d'œuf, de tomate et d'oignon dans un bol.",
        "Ajouter les olives et le persil.",
        "Fouetter l'olive oil et le vinaigre.",
        "Verser par-dessus.",
        "Servir immédiatement."
      ]
    },
    "it": {
      "recovery_note": "Un pranzo completo in un'unica ciotola: proteine, grassi sani, carboidrati complessi e minerali in soli 10 minuti.",
      "ingredients": [
        "1 scatoletta di tuna in olive oil",
        "1 uovo sodo, affettato",
        "1 patata bollita, a cubetti",
        "1 pomodoro, 1/4 di cipolla",
        "10 olive, prezzemolo",
        "Olive oil, aceto"
      ],
      "steps": [
        "Disporre a strati patate, tonno, uova, pomodori e cipolla in una ciotola.",
        "Aggiungere le olive e il prezzemolo.",
        "Mescolare con una frusta l'olio d'oliva e l'aceto.",
        "Versare sopra il condimento.",
        "Servire immediatamente."
      ]
    },
    "es": {
      "recovery_note": "Un almuerzo completo en un solo bol: proteína, grasas saludables, carbohidratos complejos y minerales en 10 minutos.",
      "ingredients": [
        "1 lata de tuna in olive oil",
        "1 huevo cocido, en rebanadas",
        "1 papa cocida, en cubos",
        "1 tomate, 1/4 de cebolla",
        "10 aceitunas, perejil",
        "Olive oil, vinagre"
      ],
      "steps": [
        "Coloque capas de potato, tuna, egg, tomato y onion en un bol.",
        "Añada las olives y el parsley.",
        "Bata el olive oil y el vinegar.",
        "Vierta por encima.",
        "Sirva inmediatamente."
      ]
    }
  },
  "pt10": {
    "ru": {
      "recovery_note": "Дешевое, традиционное и согревающее — португальское напоминание о том, что самые простые блюда зачастую насыщают лучше всего.",
      "ingredients": [
        "4 ломтика черствого цельнозернового хлеба, нарезанного кубиками",
        "4 зубчика чеснока, измельченных",
        "4 чашки vegetable stock",
        "2 яйца",
        "Оливковое масло, кориандр, соль"
      ],
      "steps": [
        "Обжаривайте чеснок в оливковом масле 1 мин.",
        "Добавьте бульон и хлеб; варите на медленном огне 5 мин.",
        "Разбейте туда яйца; готовьте яйца-пашот 3 мин.",
        "Посыпьте сверху кориандром.",
        "Подавайте горячим."
      ]
    },
    "uk": {
      "recovery_note": "Дешева, традиційна та зігріваюча — португальське нагадування про те, що найпростіші страви часто насичують найкраще.",
      "ingredients": [
        "4 скибочки черствого цільнозернового хліба, нарізаного кубиками",
        "4 garlic cloves, подрібнені",
        "4 cups vegetable stock",
        "2 яйця",
        "Olive oil, коріандр, сіль"
      ],
      "steps": [
        "Пасеруйте часник в оливковій олії 1 хв.",
        "Додайте бульйон та хліб; варіть на повільному вогні 5 хв.",
        "Вбийте яйця; готуйте яйця пашот 3 хв.",
        "Посипте зверху коріандром.",
        "Подавайте гарячим."
      ]
    },
    "ko": {
      "recovery_note": "저렴하고 전통적이며 마음까지 따뜻하게 데워주는 이 요리는, 가장 단순한 음식이 종종 최고의 영양을 선사한다는 사실을 일깨워주는 포르투갈의 유산입니다.",
      "ingredients": [
        "4 slices 오래된 통밀빵, 깍둑썰기한 것",
        "4 garlic cloves, 다진 것",
        "4 cups vegetable stock",
        "2 eggs",
        "Olive oil, 고수, salt"
      ],
      "steps": [
        "올리브 오일에 마늘을 1 min 동안 볶습니다.",
        "육수와 빵을 넣고 5 min 동안 뭉근하게 끓입니다.",
        "달걀을 깨서 넣고 3 min 동안 수란 형태로 익힙니다.",
        "위에 고수를 올립니다.",
        "뜨거울 때 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Bon marché, traditionnel et réconfortant — un rappel portugais que les repas les plus simples sont souvent ceux qui nourrissent le mieux.",
      "ingredients": [
        "4 tranches de pain complet de la veille, coupées en dés",
        "4 gousses d'ail, hachées",
        "4 cups de bouillon de légumes",
        "2 œufs",
        "Olive oil, coriandre, sel"
      ],
      "steps": [
        "Faire sauter l'ail dans l'huile d'olive pendant 1 min.",
        "Ajouter le bouillon et le pain ; faire mijoter 5 min.",
        "Casser les œufs à l'intérieur ; pocher 3 min.",
        "Garnir de coriandre.",
        "Servir chaud."
      ]
    },
    "it": {
      "recovery_note": "Economico, tradizionale e avvolgente — un ricordo portoghese del fatto che i pasti più semplici sono spesso i più nutrienti.",
      "ingredients": [
        "4 fette di pane integrale raffermo, tagliato a cubetti",
        "4 spicchi d'aglio, tritati",
        "4 tazze di vegetable stock",
        "2 uova",
        "Olio d'oliva, coriandolo, sale"
      ],
      "steps": [
        "Soffriggere l'aglio in olive oil per 1 min.",
        "Aggiungere il brodo e il pane; cuocere a fuoco lento per 5 min.",
        "Rompere le uova all'interno; cuocere in camicia per 3 min.",
        "Guarnire con coriandolo.",
        "Servire caldo."
      ]
    },
    "es": {
      "recovery_note": "Económico, tradicional y reconfortante: un recordatorio portugués de que las comidas más sencillas suelen ser las que mejor alimentan.",
      "ingredients": [
        "4 rebanadas de pan integral de un día anterior, en cubos",
        "4 dientes de ajo, picados",
        "4 tazas de caldo de verduras",
        "2 huevos",
        "Aceite de oliva, cilantro, sal"
      ],
      "steps": [
        "Saltee el ajo en aceite de oliva 1 min.",
        "Añada el caldo y el pan; cocine a fuego lento 5 min.",
        "Casque los huevos dentro; escalfarlos 3 min.",
        "Cubra con coriander.",
        "Sirva caliente."
      ]
    }
  },
  "ru1": {
    "ru": {
      "recovery_note": "Свекла способствует детоксикации печени, что крайне важно на ранних этапах восстановления, когда организм избавляется от метаболической нагрузки, вызванной длительным употреблением психоактивных веществ.",
      "ingredients": [
        "3 средние свеклы, очищенные и натертые",
        "1 луковица, 2 моркови, 2 картофелины, нарезанные кубиками",
        "1/4 небольшого кочана капусты, нашинкованная",
        "1 tbsp томатной пасты",
        "6 cups овощного бульона",
        "Сметана, укроп, чеснок"
      ],
      "steps": [
        "Обжаривайте onion и carrot 5 min.",
        "Добавьте beetroot, potatoes, cabbage и stock.",
        "Вмешайте tomato paste; томите на медленном огне 35 min до мягкости овощей.",
        "Приправьте salt, pepper и garlic.",
        "Подавайте с sour cream и dill."
      ]
    },
    "uk": {
      "recovery_note": "Буряк сприяє детоксикації печінки, що є життєво важливим на ранніх етапах відновлення, коли організм очищується від метаболічного навантаження, спричиненого тривалим вживанням психоактивних речовин.",
      "ingredients": [
        "3 середніх буряки, очищених і натертих",
        "1 цибуля, 2 моркви, 2 картоплини, нарізані кубиками",
        "1/4 невеликої капусти, нашаткованої",
        "1 tbsp томатної пасти",
        "6 cups овочевого бульйону",
        "Сметана, кріп, часник"
      ],
      "steps": [
        "Пасеруйте цибулю та моркву 5 min.",
        "Додайте буряк, картоплю, капусту та stock.",
        "Додайте томатну пасту; варіть на повільному вогні 35 min до м'якості овочів.",
        "Приправте сіллю, перцем, часником.",
        "Подавайте зі сметаною та кропом."
      ]
    },
    "ko": {
      "recovery_note": "비트루트는 간 해독을 돕습니다. 이는 장기적인 약물 사용으로 인한 대사 부담을 신체가 제거하는 회복 초기 단계에서 매우 중요합니다.",
      "ingredients": [
        "껍질을 벗기고 강판에 간 중간 크기 비트루트 3개",
        "주사위 모양으로 썬 양파 1개, 당근 2개, 감자 2개",
        "채 썬 작은 양배추 1/4개",
        "tomato paste 1 tbsp",
        "vegetable stock 6 cups",
        "Sour cream, dill, 마늘"
      ],
      "steps": [
        "양파와 당근을 5 min 동안 볶습니다.",
        "beetroot, 감자, 양배추와 stock을 넣습니다.",
        "tomato paste를 넣고 잘 저어준 뒤, 채소가 부드러워질 때까지 35 min 동안 뭉근하게 끓입니다.",
        "소금, 후추, 마늘로 간을 합니다.",
        "sour cream과 dill을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "La betterave favorise la détoxification du foie — un processus vital au début du rétablissement, lorsque le corps élimine la charge métabolique liée à une consommation de substances sur le long terme.",
      "ingredients": [
        "3 betteraves moyennes, épluchées et râpées",
        "1 oignon, 2 carottes, 2 pommes de terre, coupés en dés",
        "1/4 de petit chou, émincé",
        "1 tbsp de concentré de tomate",
        "6 cups de bouillon de légumes",
        "Crème aigre, aneth, ail"
      ],
      "steps": [
        "Faire sauter l'oignon et la carotte pendant 5 min.",
        "Ajouter la betterave, les pommes de terre, le chou et le bouillon.",
        "Incorporer le concentré de tomate ; faire mijoter 35 min jusqu'à ce que les légumes soient tendres.",
        "Assaisonner avec du sel, du poivre et de l'ail.",
        "Servir avec de la crème aigre et de l'aneth."
      ]
    },
    "it": {
      "recovery_note": "La barbabietola supporta la disintossicazione del fegato — vitale nelle prime fasi del recupero mentre l'organismo smaltisce il carico metabolico derivante dall'uso prolungato di sostanze.",
      "ingredients": [
        "3 barbabietole medie, pelate e grattugiate",
        "1 cipolla, 2 carote, 2 patate, tagliate a cubetti",
        "1/4 di cavolo piccolo, sminuzzato",
        "1 tbsp di concentrato di pomodoro",
        "6 cups di brodo vegetale",
        "Panna acida, aneto, aglio"
      ],
      "steps": [
        "Soffriggere la cipolla e la carota per 5 min.",
        "Aggiungere barbabietola, patate, cavolo e stock.",
        "Incorporare il tomato paste; sobbollire per 35 min finché le verdure non saranno tenere.",
        "Condire con sale, pepe e aglio.",
        "Servire con sour cream e aneto."
      ]
    },
    "es": {
      "recovery_note": "La remolacha favorece la desintoxicación del hígado, algo vital en las primeras etapas de la recuperación, ya que el cuerpo elimina la carga metabólica del consumo de sustancias a largo plazo.",
      "ingredients": [
        "3 remolachas medianas, peladas y ralladas",
        "1 cebolla, 2 zanahorias, 2 papas, cortadas en cubos",
        "1/4 de col pequeña, rallada",
        "1 tbsp de pasta de tomate",
        "6 tazas de caldo de verduras",
        "Crema agria, eneldo, ajo"
      ],
      "steps": [
        "Saltear la cebolla y la zanahoria por 5 min.",
        "Añadir beetroot, las patatas, el repollo y el stock.",
        "Incorporar la pasta de tomate; cocinar a fuego lento 35 min hasta que las verduras estén tiernas.",
        "Sazonar con sal, pimienta y ajo.",
        "Servir con crema agria y eneldo."
      ]
    }
  },
  "ru2": {
    "ru": {
      "recovery_note": "Богатая железом говядина в сочетании с нежным кремом — восстанавливает силы без пустых калорий, характерных для ресторанных версий.",
      "ingredients": [
        "400g нежирной говядины, нарезанной полосками",
        "300g грибов, нарезанных ломтиками",
        "1 луковица, нарезанная ломтиками",
        "3/4 cup сметаны",
        "1 tbsp горчицы Dijon",
        "Цельнозерновые макароны или гречка"
      ],
      "steps": [
        "Обжарьте говядину в масле 2 min; снимите с огня.",
        "Обжарьте лук и грибы 6 min.",
        "Верните говядину в сковороду; добавьте горчицу и бульон, если необходимо.",
        "Снимите с огня и вмешайте сметану.",
        "Подавайте с пастой или гречкой."
      ]
    },
    "uk": {
      "recovery_note": "Багата на залізо яловичина та ніжні вершки — відновлюють сили без зайвих калорій, притаманних ресторанним версіям.",
      "ingredients": [
        "400g нежирної яловичини, нарізаної смужками",
        "300g печериць, нарізаних скибочками",
        "1 цибулина, нарізана скибочками",
        "3/4 склянки сметани",
        "1 tbsp Dijon mustard",
        "Цільнозернова паста або гречка"
      ],
      "steps": [
        "Обсмажте яловичину в олії 2 хв; вийміть.",
        "Обсмажте цибулю та гриби 6 хв.",
        "Поверніть яловичину; додайте гірчицю та бульйон, якщо потрібно.",
        "Зніміть з вогню та вмішайте сметану.",
        "Подавайте з пастою або гречкою."
      ]
    },
    "ko": {
      "recovery_note": "철분이 풍부한 소고기에 부드러운 크림을 더해, 외식 메뉴의 불필요한 칼로리는 덜어내고 에너지는 가득 채워주는 요리입니다.",
      "ingredients": [
        "400g lean beef strips",
        "300g mushrooms, sliced",
        "1 onion, sliced",
        "3/4 cup sour cream",
        "1 tbsp Dijon mustard",
        "Wholemeal pasta 또는 buckwheat"
      ],
      "steps": [
        "소고기를 식용유에 2분간 갈색이 나도록 볶은 후 건져냅니다.",
        "양파와 양송이버섯을 6분간 볶습니다.",
        "소고기를 다시 넣고, 머스터드와 필요에 따라 육수(stock)를 추가합니다.",
        "불을 끄고 사워크림을 넣어 섞습니다.",
        "파스타나 메밀(buckwheat) 위에 얹어 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Du bœuf riche en fer allié à une crème réconfortante — restaure l'énergie sans les calories vides des versions de restaurant.",
      "ingredients": [
        "400g de lanières de bœuf maigre",
        "300g de champignons, émincés",
        "1 oignon, émincé",
        "3/4 tasse de crème aigre",
        "1 tbsp de moutarde de Dijon",
        "Pâtes complètes ou sarrasin"
      ],
      "steps": [
        "Faire dorer le bœuf dans l'huile pendant 2 min ; retirer.",
        "Faire sauter l'oignon et les champignons pendant 6 min.",
        "Remettre le bœuf ; ajouter la moutarde et du bouillon si nécessaire.",
        "Incorporer la crème aigre hors du feu.",
        "Servir sur des pâtes ou du sarrasin."
      ]
    },
    "it": {
      "recovery_note": "Manzo ricco di ferro unito a una confortevole crema: ripristina le energie senza le calorie vuote delle versioni da ristorante.",
      "ingredients": [
        "400g di straccetti di manzo magro",
        "300g di funghi affettati",
        "1 cipolla affettata",
        "3/4 di tazza di panna acida",
        "1 cucchiaio di senape di Dijon",
        "Pasta integrale o grano saraceno"
      ],
      "steps": [
        "Rosolare il manzo in olio per 2 min; rimuovere.",
        "Saltare la cipolla e i funghi per 6 min.",
        "Reinserire il manzo; aggiungere la senape e il brodo se necessario.",
        "Incorporare la panna acida fuori dal fuoco.",
        "Servire sopra la pasta o il grano saraceno."
      ]
    },
    "es": {
      "recovery_note": "Ternera rica en hierro junto con una reconfortante crema: restaura la energía sin las calorías vacías de las versiones de restaurante.",
      "ingredients": [
        "400g lean beef strips",
        "300g mushrooms, sliced",
        "1 onion, sliced",
        "3/4 cup sour cream",
        "1 tbsp Dijon mustard",
        "Wholemeal pasta o buckwheat"
      ],
      "steps": [
        "Dore la carne de res en aceite durante 2 min; retire.",
        "Saltee la cebolla y los champiñones durante 6 min.",
        "Regrese la carne; añada mostaza y caldo si es necesario.",
        "Incorpore la crema agria fuera del fuego.",
        "Sirva sobre pasta o trigo sarraceno (buckwheat)."
      ]
    }
  },
  "ru3": {
    "ru": {
      "recovery_note": "Гречка является источником полноценного белка и богата магнием — минералом, запас которого часто истощается при хроническом употреблении алкоголя и который необходим для спокойствия нервной системы.",
      "ingredients": [
        "1 стакан гречневой крупы",
        "300g грибов, нарезанных ломтиками",
        "1 луковица, нарезанная кубиками",
        "2 стакана воды",
        "2 tbsp сливочного или оливкового масла",
        "Свежий укроп, соль, перец"
      ],
      "steps": [
        "Обжаривайте гречку на сухой сковороде 2 min.",
        "Добавьте воду; варите под крышкой на медленном огне 18 min до мягкости.",
        "Обжаривайте лук и грибы в сливочном масле 8 min.",
        "Смешайте гречку с грибной смесью.",
        "Посыпьте укропом; подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Гречка є джерелом повноцінного білка та багатою на магній — мінерал, запаси якого часто виснажуються при хронічному вживанні алкоголю і який є необхідним для спокою нервової системи.",
      "ingredients": [
        "1 склянка гречаної крупи",
        "300g грибів, нарізаних скибочками",
        "1 цибулина, нарізана кубиками",
        "2 склянки води",
        "2 tbsp вершкового масла або оливкової олії",
        "Свіжий кріп, сіль, перець"
      ],
      "steps": [
        "Підсмажте гречку на сухій сковорідці 2 хвилини.",
        "Додайте воду; тушкуйте під кришкою 18 хвилин до м'якості.",
        "Обсмажте цибулю та гриби у вершковому маслі 8 хвилин.",
        "З’єднайте гречку з грибною сумішшю.",
        "Посипте кропом; подавайте."
      ]
    },
    "ko": {
      "recovery_note": "메밀은 완전 단백질이자 마그네슘이 풍부한 식품입니다. 마그네슘은 만성적인 음주로 인해 체내에서 결핍되기 쉬운 미네랄이며, 신경계의 안정을 유지하는 데 필수적입니다.",
      "ingredients": [
        "1 cup 통메밀 (buckwheat groats)",
        "300g mushrooms, 슬라이스",
        "1 onion, 다짐",
        "2 cups water",
        "2 tbsp butter 또는 olive oil",
        "Fresh dill, salt, pepper"
      ],
      "steps": [
        "마른 팬에서 메밀을 2분 동안 볶습니다.",
        "물을 붓고 뚜껑을 덮은 뒤, 부드러워질 때까지 18분 동안 뭉근하게 끓입니다.",
        "버터에 양파와 양송이버섯을 8분 동안 볶습니다.",
        "메밀을 버섯 볶음과 섞습니다.",
        "딜을 위에 올린 뒤 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Le sarrasin est une protéine complète et riche en magnésium — un minéral dont les réserves sont souvent épuisées par une consommation chronique d'alcool et qui est essentiel à l'apaisement du système nerveux.",
      "ingredients": [
        "1 cup de grains de sarrasin",
        "300g de champignons, émincés",
        "1 oignon, coupé en dés",
        "2 cups d'eau",
        "2 tbsp de beurre ou d'huile d'olive",
        "Aneth frais, sel, poivre"
      ],
      "steps": [
        "Faire griller le sarrasin dans une poêle à sec pendant 2 min.",
        "Ajouter l'eau ; laisser mijoter à couvert pendant 18 min jusqu'à ce qu'il soit tendre.",
        "Faire sauter l'oignon et les mushrooms dans du butter pendant 8 min.",
        "Mélanger le sarrasin avec la préparation aux mushrooms.",
        "Garnir de dill ; servir."
      ]
    },
    "it": {
      "recovery_note": "Il grano saraceno è una proteina completa e ricca di magnesio — un minerale che tende a scarseggiare in caso di consumo cronico di alcol ed è essenziale per la calma del sistema nervoso.",
      "ingredients": [
        "1 cup di grano saraceno in chicchi",
        "300g funghi, affettati",
        "1 cipolla, dadini",
        "2 cups d'acqua",
        "2 tbsp di burro o olio d'oliva",
        "Aneto fresco, sale, pepe"
      ],
      "steps": [
        "Tostare il buckwheat in una padella asciutta per 2 min.",
        "Aggiungere acqua; cuocere a fuoco lento con coperchio per 18 min fino a quando non sarà tenero.",
        "Soffriggere cipolla e funghi nel burro per 8 min.",
        "Unire il buckwheat al composto di funghi.",
        "Completare con il dill; servire."
      ]
    },
    "es": {
      "recovery_note": "El trigo sarraceno es una proteína completa y rica en magnesio, un mineral que suele agotarse con el consumo crónico de alcohol y que es esencial para la calma del sistema nervioso.",
      "ingredients": [
        "1 taza de buckwheat groats",
        "300g de champiñones, en láminas",
        "1 cebolla, picada en cubos",
        "2 tazas de agua",
        "2 tbsp de mantequilla o aceite de oliva",
        "Eneldo fresco, sal, pimienta"
      ],
      "steps": [
        "Tostar el buckwheat en una sartén seca durante 2 min.",
        "Añadir agua; cocinar a fuego lento con tapa durante 18 min hasta que esté tierno.",
        "Saltear la cebolla y los mushrooms en butter durante 8 min.",
        "Combinar el buckwheat con la mezcla de mushrooms.",
        "Cubrir con dill y servir."
      ]
    }
  },
  "ru4": {
    "ru": {
      "recovery_note": "Сытное, богатое белком и идеально подходящее для трезвого праздничного стола — российская классика без традиционной стопки водки.",
      "ingredients": [
        "2 вареных картофеля, нарезанных кубиками",
        "2 вареные моркови, нарезанные кубиками",
        "4 вареных яйца, нарезанных кубиками",
        "200g отварной курицы или ветчины, нарезанной кубиками",
        "1 cup горошка",
        "1/2 cup маринованных огурцов, light mayo, укроп"
      ],
      "steps": [
        "Отварите картофель, морковь и яйца по отдельности; остудите и нарежьте кубиками.",
        "Смешайте все ингредиенты в большой миске.",
        "Добавьте майонез и соленые огурцы, тщательно перемешайте.",
        "Приправьте солью, перцем и укропом.",
        "Охладите 30 min перед подачей."
      ]
    },
    "uk": {
      "recovery_note": "Поживна, багата білком страва, що ідеально пасує до святкового столу — класика без традиційної чарки горілки.",
      "ingredients": [
        "2 варені картоплини, нарізані кубиками",
        "2 варені моркви, нарізані кубиками",
        "4 варені яйця, нарізані кубиками",
        "200g вареної курки або шинки, нарізаної кубиками",
        "1 cup горошку",
        "1/2 cup маринованих огірків, light mayo, кріп"
      ],
      "steps": [
        "Відваріть картоплю, моркву та яйця окремо; охолодіть і наріжте кубиками.",
        "Змішайте всі інгредієнти у великій мисці.",
        "Додайте майонез і мариновані огірки (pickles) та перемішайте.",
        "Приправте сіллю, перцем і кропом.",
        "Охолодіть протягом 30 min перед подачею."
      ]
    },
    "ko": {
      "recovery_note": "든든하고 단백질이 풍부하며 차분한 파티 상차림에도 잘 어울리는 메뉴입니다. 전통적인 보드카 안주가 아닌 요리 그 자체로 즐기는 러시아 클래식 요리를 만나보세요.",
      "ingredients": [
        "삶은 감자 2개, 깍둑썰기",
        "삶은 당근 2개, 깍둑썰기",
        "삶은 계란 4개, 깍둑썰기",
        "익힌 치킨 또는 햄 200g, 깍둑썰기",
        "완두콩 1컵",
        "피클 1/2컵, 라이트 마요네즈(light mayo), 딜(dill)"
      ],
      "steps": [
        "감자, 당근, 달걀을 각각 따로 삶은 뒤 식혀서 깍둑썰기합니다.",
        "큰 볼에 모든 재료를 넣고 섞습니다.",
        "마요네즈와 피클을 넣고 젓습니다.",
        "소금, 후추, 딜로 간을 합니다.",
        "서빙하기 전 30분 동안 차갑게 식힙니다."
      ]
    },
    "fr": {
      "recovery_note": "Riche, riche en protéines et parfait pour une table de fête sobre — un classique russe sans le traditionnel petit verre de vodka.",
      "ingredients": [
        "2 pommes de terre bouillies, coupées en dés",
        "2 carottes bouillies, coupées en dés",
        "4 œufs bouillis, coupés en dés",
        "200g de poulet cuit ou de jambon, coupé en dés",
        "1 cup de petits pois",
        "1/2 cup de cornichons, light mayo, aneth"
      ],
      "steps": [
        "Faire bouillir les pommes de terre, les carottes et les œufs séparément ; laisser refroidir et couper en dés.",
        "Mélanger tous les ingrédients dans un grand bol.",
        "Incorporer la mayo et les pickles.",
        "Assaisonner avec du sel, du poivre et de l'aneth.",
        "Réfrigérer 30 min avant de servir."
      ]
    },
    "it": {
      "recovery_note": "Sostanzioso, ricco di proteine e perfetto per una tavola festiva sobria — un classico russo senza il tradizionale cicchetto di vodka.",
      "ingredients": [
        "2 patate bollite, tagliate a dadini",
        "2 carote bollite, tagliate a dadini",
        "4 uova sode, tagliate a dadini",
        "200g di pollo cotto o prosciutto, tagliato a dadini",
        "1 tazza di piselli",
        "1/2 tazza di sottaceti, maionese light, aneto"
      ],
      "steps": [
        "Lessare le patate, le carote e le uova separatamente; lasciare raffreddare e tagliare a dadini.",
        "Unire tutti gli ingredienti in una ciotola capiente.",
        "Incorporare la maionese e i cetriolini.",
        "Condire con sale, pepe e aneto.",
        "Lasciare raffreddare 30 min prima di servire."
      ]
    },
    "es": {
      "recovery_note": "Sustancioso, rico en proteínas e ideal para una mesa de celebración sobria: un clásico ruso sin el tradicional acompañamiento de vodka.",
      "ingredients": [
        "2 papas hervidas, en cubos",
        "2 zanahorias hervidas, en cubos",
        "4 huevos hervidos, en cubos",
        "200g de pollo cocido o jamón, en cubos",
        "1 cup de guisantes",
        "1/2 cup de pepinillos, light mayo, eneldo"
      ],
      "steps": [
        "Hervir las patatas, las zanahorias y los huevos por separado; dejar enfriar y cortar en cubos.",
        "Combinar todos los ingredientes en un bol grande.",
        "Mezclar con la mayo y los pepinillos.",
        "Sazonar con sal, pimienta y eneldo.",
        "Enfriar 30 min antes de servir."
      ]
    }
  },
  "ru5": {
    "ru": {
      "recovery_note": "Высокобелковый завтрак, который стабилизирует уровень сахара в крови на несколько часов — особенно полезен на ранних этапах восстановления, когда упадок сил легко спутать с тягой к срыву.",
      "ingredients": [
        "250g cottage cheese",
        "1 яйцо",
        "3 tbsp муки",
        "1 tsp ванили",
        "1 tbsp сахара (опционально)",
        "Сметана и джем для подачи"
      ],
      "steps": [
        "Разомните cottage cheese с яйцом, мукой, ванилью и сахаром.",
        "Сформируйте небольшие биточки.",
        "Обжаривайте на сливочном масле по 2 min с каждой стороны.",
        "Выложите на бумажное полотенце, чтобы впитался лишний жир.",
        "Подавайте со сметаной и ложкой джема."
      ]
    },
    "uk": {
      "recovery_note": "Високобілковий сніданок, який стабілізує рівень цукру в крові на кілька годин — особливо корисно на ранніх етапах відновлення, коли падіння рівня енергії можна помилково прийняти за тягу до шкідливих звичок.",
      "ingredients": [
        "250g cottage cheese",
        "1 egg",
        "3 tbsp flour",
        "1 tsp vanilla",
        "1 tbsp sugar (optional)",
        "Sour cream and jam to serve"
      ],
      "steps": [
        "Розітріть сир із яйцем, борошном, ваніллю та цукром.",
        "Сформуйте невеликі сирники.",
        "Смажте на вершковому маслі по 2 min з кожного боку.",
        "Викладіть на паперовий рушник, щоб прибрати зайвий жир.",
        "Подавайте зі сметаною та ложкою джему."
      ]
    },
    "ko": {
      "recovery_note": "혈당을 몇 시간 동안 안정적으로 유지해 주는 고단백 아침 식사입니다. 특히 에너지 급락이 가짜 식욕처럼 느껴질 수 있는 회복 초기 단계에 매우 유용합니다.",
      "ingredients": [
        "250g cottage cheese",
        "1 egg",
        "3 tbsp flour",
        "1 tsp vanilla",
        "1 tbsp sugar (optional)",
        "Sour cream and jam to serve"
      ],
      "steps": [
        "cottage cheese를 egg, flour, vanilla, sugar와 함께 으깹니다.",
        "작은 패티 모양으로 만듭니다.",
        "butter를 두른 팬에 양면을 각각 2 min 동안 굽습니다.",
        "키친타월에 올려 기름기를 뺍니다.",
        "sour cream과 한 스푼의 jam을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Petit-déjeuner riche en protéines qui stabilise la glycémie pendant des heures — particulièrement utile au début du rétablissement lorsque les baisses d'énergie imitent les fringales.",
      "ingredients": [
        "250g cottage cheese",
        "1 œuf",
        "3 tbsp de farine",
        "1 tsp de vanille",
        "1 tbsp de sucre (optionnel)",
        "Crème aigre et confiture pour servir"
      ],
      "steps": [
        "Écraser le cottage cheese avec l'œuf, la flour, la vanilla et le sugar.",
        "Former de petites galettes.",
        "Faire frire dans du butter pendant 2 min par côté.",
        "Égoutter sur du papier absorbant.",
        "Servir avec de la sour cream et une cuillère de jam."
      ]
    },
    "it": {
      "recovery_note": "Colazione ad alto contenuto proteico che stabilizza la glicemia per ore — particolarmente utile nelle prime fasi del recupero quando i cali di energia simulano il desiderio compulsivo di cibo.",
      "ingredients": [
        "250g cottage cheese",
        "1 uovo",
        "3 tbsp farina",
        "1 tsp vaniglia",
        "1 tbsp zucchero (opzionale)",
        "Panna acida e confettura per servire"
      ],
      "steps": [
        "Schiacciare il cottage cheese con l'uovo, la farina, la vaniglia e lo zucchero.",
        "Formare delle piccole polpette (patties).",
        "Friggere nel burro per 2 min per lato.",
        "Scolare su carta assorbente.",
        "Servire con sour cream e un cucchiaio di marmellata."
      ]
    },
    "es": {
      "recovery_note": "Desayuno alto en proteínas que estabiliza el azúcar en sangre durante horas, especialmente útil en las primeras etapas de la recuperación, cuando los bajones de energía imitan los antojos.",
      "ingredients": [
        "250g cottage cheese",
        "1 huevo",
        "3 tbsp harina",
        "1 tsp vainilla",
        "1 tbsp azúcar (opcional)",
        "Sour cream y mermelada para servir"
      ],
      "steps": [
        "Triture el cottage cheese con el huevo, la harina, la vainilla y el azúcar.",
        "Forme pequeñas tortitas.",
        "Fría en mantequilla durante 2 min por cada lado.",
        "Escurra sobre papel.",
        "Sirva con sour cream y una cucharada de mermelada."
      ]
    }
  },
  "ru6": {
    "ru": {
      "recovery_note": "Капуста содержит витамин С и полезную для кишечника клетчатку — оба эти элемента имеют решающее значение для восстановления иммунной и пищеварительной систем.",
      "ingredients": [
        "1/2 небольшого кочана капусты, нашинкованного",
        "1 луковица, 2 моркови, 1 картофелина, нарезанные кубиками",
        "1 tin томатов",
        "6 cups овощного бульона",
        "Лавровый лист, укроп, чеснок"
      ],
      "steps": [
        "Обжаривайте onion и carrot 5 min.",
        "Добавьте cabbage, potato, tomatoes, stock и bay leaf.",
        "Варите на медленном огне 25-30 min до мягкости cabbage.",
        "Добавьте измельченный свежий garlic и dill.",
        "Подавайте с rye bread."
      ]
    },
    "uk": {
      "recovery_note": "Капуста містить вітамін С та корисну для кишечника клітковину — обидва компоненти є критично важливими для імунного та травного відновлення.",
      "ingredients": [
        "1/2 маленької капусти, нашаткованої",
        "1 цибулина, 2 моркви, 1 картоплина, нарізані кубиками",
        "1 бляшанка томатів",
        "6 склянок овочевого бульйону",
        "Лавровий лист, кріп, часник"
      ],
      "steps": [
        "Обсмажуйте цибулю та моркву 5 min.",
        "Додайте капусту, картоплю, томати, stock, лавровий лист.",
        "Тушкуйте 25-30 min, поки капуста не стане м'якою.",
        "Додайте свіжий часник та кріп.",
        "Подавайте з житнім хлібом."
      ]
    },
    "ko": {
      "recovery_note": "양배추는 비타민 C와 장 건강을 돕는 식이섬유를 제공하며, 이는 면역력 강화와 소화 기능 회복에 매우 중요합니다.",
      "ingredients": [
        "1/2 small cabbage, 가늘게 채 썬 것",
        "1 onion, 2 carrots, 1 potato, 깍둑썰기한 것",
        "1 tin tomatoes",
        "6 cups vegetable stock",
        "Bay leaf, dill, garlic"
      ],
      "steps": [
        "양파와 당근을 5 min 동안 볶습니다.",
        "양배추, 감자, 토마토, stock, bay leaf를 넣습니다.",
        "양배추가 부드러워질 때까지 25-30 min 동안 뭉근하게 끓입니다.",
        "신선한 마늘과 dill을 넣고 섞습니다.",
        "호밀빵(rye bread)을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Le chou apporte de la vitamine C et des fibres bénéfiques pour l'intestin — toutes deux cruciales pour la récupération immunitaire et digestive.",
      "ingredients": [
        "1/2 petit chou, émincé",
        "1 oignon, 2 carottes, 1 pomme de terre, coupés en dés",
        "1 boîte de tomates",
        "6 cups de bouillon de légumes",
        "Feuille de laurier, aneth, ail"
      ],
      "steps": [
        "Faire sauter l'oignon et la carotte pendant 5 min.",
        "Ajouter le chou, la pomme de terre, les tomates, le bouillon et la feuille de laurier.",
        "Laisser mijoter 25-30 min jusqu'à ce que le chou soit tendre.",
        "Incorporer l'ail frais et l'aneth.",
        "Servir avec du pain de seigle."
      ]
    },
    "it": {
      "recovery_note": "Il cavolo apporta vitamina C e fibre amiche dell'intestino, entrambe fondamentali per il recupero immunitario e digestivo.",
      "ingredients": [
        "1/2 piccolo cavolo, sminuzzato",
        "1 cipolla, 2 carote, 1 patata, tagliate a dadini",
        "1 lattina di pomodori",
        "6 tazze di brodo vegetale",
        "Foglia di alloro, aneto, aglio"
      ],
      "steps": [
        "Rosolare la cipolla e la carota per 5 min.",
        "Aggiungere il cavolo, la patata, i pomodori, il brodo e la foglia di alloro.",
        "Sobbollire per 25-30 min finché il cavolo non sarà tenero.",
        "Incorporare l'aglio fresco e l'aneto.",
        "Servire con pane di segale."
      ]
    },
    "es": {
      "recovery_note": "El repollo aporta vitamina C y fibra beneficiosa para el intestino, ambas fundamentales para la recuperación inmunológica y digestiva.",
      "ingredients": [
        "1/2 repollo pequeño, rallado",
        "1 onion, 2 carrots, 1 potato, en cubos",
        "1 lata de tomates",
        "6 tazas de caldo de verduras",
        "Hoja de laurel, eneldo, ajo"
      ],
      "steps": [
        "Saltear la cebolla y la zanahoria 5 min.",
        "Añadir el repollo, la papa, los tomates, el stock y la hoja de laurel.",
        "Cocinar a fuego lento 25-30 min hasta que el repollo esté tierno.",
        "Incorporar el ajo fresco y el eneldo.",
        "Servir con pan de centeno."
      ]
    }
  },
  "ru7": {
    "ru": {
      "recovery_note": "Блюдо в одной кастрюле, которое возвращает уверенность в кулинарных способностях, утраченную многими в период активной зависимости — практичное, сытное и подходящее для частого приготовления.",
      "ingredients": [
        "400g chicken thigh, нарезанного кубиками",
        "1.5 cups длиннозерного риса",
        "2 моркови, нарезанные соломкой",
        "1 onion, нарезанная ломтиками",
        "3 cups воды",
        "4 зубчика garlic, cumin, соль"
      ],
      "steps": [
        "Обжаривайте курицу 5 min; добавьте лук и морковь.",
        "Вмешайте рис и кумин; обжаривайте 1 min.",
        "Добавьте воду и зубчики чеснока целиком.",
        "Томите под крышкой 25 min до мягкости риса.",
        "Дайте постоять 10 min; разрыхлите вилкой и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Страва в одній каструлі, що повертає впевненість у приготуванні їжі, яку багато людей втрачають під час активної залежності — практична, ситна та проста для повторення.",
      "ingredients": [
        "400g курячого стегна, нарізаного кубиками",
        "1.5 склянки довгозернистого рису",
        "2 моркви, нарізані соломкою (julienned)",
        "1 цибулина, нарізана скибочками",
        "3 склянки води",
        "4 зубчики часнику, кумин, сіль"
      ],
      "steps": [
        "Обсмажте курку протягом 5 min; додайте цибулю та моркву.",
        "Всипте рис і cumin; підсмажуйте 1 min.",
        "Додайте воду та цілі зубчики garlic.",
        "Тушкуйте під кришкою 25 min до м'якості рису.",
        "Дайте страві відпочити 10 min; розпушіть виделкою та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "중독 회복 과정에서 잃었던 요리에 대한 자신감을 되찾아주는 원팬 요리입니다. 실용적이고 만족스러우며 언제든 다시 만들어 먹기 좋습니다.",
      "ingredients": [
        "400g 닭다리살, 깍둑썰기",
        "1.5 cups 장립종 쌀",
        "당근 2개, 채썰기",
        "양파 1개, 슬라이스",
        "3 cups 물",
        "마늘 4쪽, 큐민, 소금"
      ],
      "steps": [
        "닭고기를 5 min 동안 노릇하게 굽다가 양파와 당근을 넣습니다.",
        "쌀과 cumin을 넣고 저어가며 1 min 동안 볶습니다.",
        "물과 통마늘(garlic cloves whole)을 넣습니다.",
        "뚜껑을 덮고 쌀이 부드러워질 때까지 25 min 동안 뭉근하게 끓입니다.",
        "10 min 동안 휴지시킨 후, 가볍게 섞어 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un repas tout-en-un qui renforce la confiance en cuisine que beaucoup perdent pendant l'addiction active — pratique, satisfaisant, facile à reproduire.",
      "ingredients": [
        "400g de haut de cuisse de poulet, coupé en dés",
        "1.5 cups de riz long grain",
        "2 carottes, coupées en julienne",
        "1 oignon, émincé",
        "3 cups d'eau",
        "4 gousses d'ail, cumin, sel"
      ],
      "steps": [
        "Faire dorer le poulet 5 min ; ajouter l'oignon et la carotte.",
        "Incorporer le riz et le cumin ; faire griller 1 min.",
        "Ajouter l'eau et les garlic cloves entières.",
        "Mijoter à couvert 25 min jusqu'à ce que le riz soit tendre.",
        "Laisser reposer 10 min ; égrener et servir."
      ]
    },
    "it": {
      "recovery_note": "Un pasto preparato in un'unica pentola che infonde quella fiducia in cucina che molte persone perdono durante la dipendenza attiva: pratico, soddisfacente e facile da replicare.",
      "ingredients": [
        "400g di cosce di pollo, a cubetti",
        "1.5 tazze di riso a chicco lungo",
        "2 carote, tagliate a julienne",
        "1 cipolla, affettata",
        "3 tazze d'acqua",
        "4 spicchi d'aglio, cumino, sale"
      ],
      "steps": [
        "Rosolare il pollo per 5 min; aggiungere cipolla e carota.",
        "Incorporare il riso e il cumin; tostare per 1 min.",
        "Aggiungere l'acqua e gli spicchi di garlic interi.",
        "Cuocere a fuoco lento con il coperchio per 25 min finché il riso non sarà tenero.",
        "Lasciare riposare per 10 min; sgranare e servire."
      ]
    },
    "es": {
      "recovery_note": "Una comida en una sola olla que fomenta la confianza al cocinar que muchas personas pierden durante la adicción activa: práctica, satisfactoria y repetible.",
      "ingredients": [
        "400g chicken thigh, en cubos",
        "1.5 cups de arroz de grano largo",
        "2 zanahorias, en juliana",
        "1 cebolla, en rebanadas",
        "3 cups de agua",
        "4 dientes de ajo, comino, sal"
      ],
      "steps": [
        "Dore el pollo 5 min; añada la cebolla y la zanahoria.",
        "Incorpore el arroz y el cumin; tueste 1 min.",
        "Añada el agua y los garlic cloves enteros.",
        "Cocine a fuego lento tapado 25 min hasta que el arroz esté tierno.",
        "Deje reposar 10 min; remueva con un tenedor y sirva."
      ]
    }
  },
  "ru8": {
    "ru": {
      "recovery_note": "Увлажнение и свежесть — обезвоживание является скрытым триггером тяги и усталости на ранних этапах отказа от алкоголя.",
      "ingredients": [
        "2 cucumbers, нарезанных ломтиками",
        "2 tbsp сметаны или Greek yoghurt",
        "2 tbsp свежего укропа, измельченного",
        "1 зубчик garlic, измельченный",
        "Salt, pepper"
      ],
      "steps": [
        "Нарежьте огурцы тонкими ломтиками.",
        "Смешайте со сметаной, укропом и чесноком.",
        "Приправьте; аккуратно перемешайте.",
        "Охладите 10 min перед подачей."
      ]
    },
    "uk": {
      "recovery_note": "Зволожує та освіжає — зневоднення є прихованою причиною тяги до їжі та втоми на ранніх етапах тверезості.",
      "ingredients": [
        "2 огірки, нарізані скибочками",
        "2 tbsp сметани або грецького йогурту",
        "2 tbsp свіжого кропу, подрібненого",
        "1 зубчик часнику, подрібнений",
        "Сіль, перець"
      ],
      "steps": [
        "Тонко наріжте огірки.",
        "Змішайте зі сметаною, кропом та часником.",
        "Приправте; обережно перемішайте.",
        "Охолодіть протягом 10 min перед подачею."
      ]
    },
    "ko": {
      "recovery_note": "수분 보충과 상쾌함 — 수분 부족은 단주 초기 단계에서 갈망과 피로를 유발하는 숨겨진 원인입니다.",
      "ingredients": [
        "오이 2개, 슬라이스",
        "sour cream 또는 Greek yoghurt 2 tbsp",
        "신선한 dill 2 tbsp, 다짐",
        "마늘 1쪽, 다짐",
        "Salt, pepper"
      ],
      "steps": [
        "오이를 얇게 썹니다.",
        "sour cream, dill, garlic과 혼합합니다.",
        "양념을 하고 가볍게 버무립니다.",
        "서빙 전 10 min 동안 차갑게 둡니다."
      ]
    },
    "fr": {
      "recovery_note": "Hydratant et rafraîchissant — la déshydratation est un déclencheur caché des fringales et de la fatigue au début de la sobriété.",
      "ingredients": [
        "2 concombres, tranchés",
        "2 tbsp de crème aigre ou de yaourt grec",
        "2 tbsp d'aneth frais, haché",
        "1 gousse d'ail, émincée",
        "Sel, poivre"
      ],
      "steps": [
        "Trancher les concombres finement.",
        "Mélanger avec la sour cream, l'aneth et l'ail.",
        "Assaisonner ; mélanger délicatement.",
        "Réfrigérer 10 min avant de servir."
      ]
    },
    "it": {
      "recovery_note": "Idratante e rinfrescante — la disidratazione è un fattore scatenante nascosto per le voglie improvvise e la stanchezza nelle prime fasi della sobrietà.",
      "ingredients": [
        "2 cetrioli, affettati",
        "2 tbsp sour cream o yogurt greco",
        "2 tbsp aneto fresco, tritato",
        "1 spicchio d'aglio, tritato",
        "Sale, pepe"
      ],
      "steps": [
        "Affettare i cetrioli sottilmente.",
        "Unire alla panna acida, aneto e aglio.",
        "Condire; mescolare delicatamente.",
        "Raffreddare 10 min prima di servire."
      ]
    },
    "es": {
      "recovery_note": "Hidratante y refrescante — la deshidratación es un desencadenante oculto de los antojos y la fatiga en las primeras etapas de la sobriedad.",
      "ingredients": [
        "2 pepinos, rebanados",
        "2 tbsp de crema agria o yogur griego",
        "2 tbsp de eneldo fresco, picado",
        "1 diente de ajo, picado",
        "Sal, pimienta"
      ],
      "steps": [
        "Corte los pepinos en rodajas finas.",
        "Combine con sour cream, eneldo y ajo.",
        "Sazone; mezcle suavemente.",
        "Refrigere 10 min antes de servir."
      ]
    }
  },
  "ru9": {
    "ru": {
      "recovery_note": "Веганская версия голубцов — легкая, питательная и быстрая в приготовлении для загруженных будних вечеров.",
      "ingredients": [
        "4 крупных капустных листа",
        "300g грибов, мелко нарезанных",
        "1 луковица, нарезанная кубиками",
        "1/2 cup вареного риса",
        "Укроп, соль, перец, olive oil"
      ],
      "steps": [
        "Бланшируйте листья капусты 2 min до мягкости.",
        "Обжаривайте грибы и лук 8 min.",
        "Смешайте с рисом и dill.",
        "Выложите начинку ложкой на листья и сверните.",
        "Подавайте холодным или теплым; сочетается со сметаной."
      ]
    },
    "uk": {
      "recovery_note": "Веганська версія голубців — легка, поживна та швидка у приготуванні, що ідеально підходить для зайнятих буднів.",
      "ingredients": [
        "4 великих листки капусти",
        "300g грибів, дрібно нарізаних",
        "1 цибулина, нарізана кубиками",
        "1/2 cup вареного рису",
        "Кріп, сіль, перець, olive oil"
      ],
      "steps": [
        "Бланшуйте листя капусти 2 min до м'якості.",
        "Обсмажуйте гриби та onion 8 min.",
        "Змішайте з рисом та кропом.",
        "Викладіть ложкою начинку на листя і згорніть.",
        "Подавайте холодними або розігрітими; добре смакує зі сметаною."
      ]
    },
    "ko": {
      "recovery_note": "채식 버전의 홀루브치 — 가볍고 영양가가 높으며, 바쁜 평일 저녁에도 빠르게 준비할 수 있습니다.",
      "ingredients": [
        "4 large cabbage leaves",
        "300g mushrooms, finely chopped",
        "1 onion, diced",
        "1/2 cup cooked rice",
        "Dill, salt, pepper, olive oil"
      ],
      "steps": [
        "양배추 잎을 부드러워질 때까지 2 min 동안 데칩니다.",
        "버섯과 양파를 8 min 동안 볶습니다.",
        "밥과 dill을 함께 섞습니다.",
        "양배추 잎 위에 소를 스푼으로 떠 올린 뒤 돌돌 맙니다.",
        "차갑게 또는 따뜻하게 내며, sour cream을 곁들이면 좋습니다."
      ]
    },
    "fr": {
      "recovery_note": "Une version végétalienne des holubtsi — légère, nourrissante et rapide à assembler pour les soirs de semaine bien remplis.",
      "ingredients": [
        "4 grandes feuilles de chou",
        "300g de champignons, hachés finement",
        "1 oignon, coupé en dés",
        "1/2 tasse de riz cuit",
        "Aneth, sel, poivre, huile d'olive"
      ],
      "steps": [
        "Blanchir les feuilles de chou 2 min jusqu'à ce qu'elles soient souples.",
        "Faire sauter les champignons et l'oignon 8 min.",
        "Mélanger avec le riz et le dill.",
        "Déposer la garniture sur les feuilles à l'aide d'une cuillère et rouler.",
        "Servir froid ou chaud ; se marie bien avec de la sour cream."
      ]
    },
    "it": {
      "recovery_note": "Una versione vegana degli holubtsi: leggeri, nutrienti e veloci da preparare per le serate infrasettimanali più impegnative.",
      "ingredients": [
        "4 grandi foglie di cavolo",
        "300g di funghi, tritati finemente",
        "1 cipolla, tagliata a dadini",
        "1/2 tazza di riso cotto",
        "Aneto, sale, pepe, olive oil"
      ],
      "steps": [
        "Sbollentare le foglie di cavolo per 2 min finché non diventano flessibili.",
        "Saltare i funghi e la cipolla per 8 min.",
        "Mescolare con riso e dill.",
        "Versare il ripieno sulle foglie con un cucchiaio e arrotolare.",
        "Servire freddo o riscaldato; si abbina con sour cream."
      ]
    },
    "es": {
      "recovery_note": "Una versión vegana de holubtsi: ligera, nutritiva y rápida de preparar para las noches ocupadas de la semana.",
      "ingredients": [
        "4 hojas grandes de repollo",
        "300g mushrooms, finamente picados",
        "1 cebolla, picada en cubos",
        "1/2 taza de arroz cocido",
        "Eneldo, sal, pimienta, olive oil"
      ],
      "steps": [
        "Escalde las hojas de col durante 2 min hasta que estén flexibles.",
        "Saltee los champiñones y la cebolla durante 8 min.",
        "Mezcle con el arroz y el eneldo.",
        "Coloque el relleno sobre las hojas con una cuchara y enrolle.",
        "Sirva frío o caliente; combina con crema agria."
      ]
    }
  },
  "ru10": {
    "ru": {
      "recovery_note": "Традиционный безалкогольный горячий напиток, который заменит привычный вечерний ритуал бокалом чего-то согревающего и богатого антиоксидантами.",
      "ingredients": [
        "2 cups ягодного микса (замороженного или свежего)",
        "4 cups воды",
        "2 tbsp меда или сахара",
        "1 палочка корицы (cinnamon stick)",
        "1 звездочка аниса (star anise) (по желанию)"
      ],
      "steps": [
        "Соедините ягоды, воду, подсластитель и специи в кастрюле.",
        "Варите на медленном огне 15 min.",
        "Процедите (или оставьте ягоды внутри).",
        "Подавайте горячим зимой или холодным летом.",
        "Хранится в холодильнике 5 days."
      ]
    },
    "uk": {
      "recovery_note": "Традиційний безалкогольний гарячий напій, що замінить вечірній ритуал споживання алкоголю чимось зігріваючим і багатим на антиоксиданти.",
      "ingredients": [
        "2 склянки суміші ягід (заморожених або свіжих)",
        "4 склянки води",
        "2 tbsp меду або цукру",
        "1 паличка кориці",
        "1 зірочка анісу (за бажанням)"
      ],
      "steps": [
        "Змішайте ягоди, воду, підсолоджувач і спеції в каструлі.",
        "Варіть на повільному вогні 15 min.",
        "Процідіть (або залиште ягоди всередині).",
        "Подавайте гарячим взимку або холодним влітку.",
        "Зберігається протягом 5 днів у холодильнику."
      ]
    },
    "ko": {
      "recovery_note": "매일 밤 술을 마시는 문화적 관습 대신 따뜻한 온기와 풍부한 항산화 성분으로 몸을 채워줄 전통 무알코올 핫 뱅쇼입니다.",
      "ingredients": [
        "2 cups 믹스 베리 (냉동 또는 생과)",
        "4 cups 물",
        "2 tbsp 꿀 또는 설탕",
        "1 cinnamon stick",
        "1 star anise (선택 사항)"
      ],
      "steps": [
        "냄비에 베리류, 물, 감미료, 향신료를 넣고 섞습니다.",
        "15분 동안 뭉근하게 끓입니다.",
        "체에 거릅니다 (또는 베리를 그대로 두어도 좋습니다).",
        "겨울에는 따뜻하게, 여름에는 차갑게 즐기세요.",
        "냉장고에서 5일 동안 보관 가능합니다."
      ]
    },
    "fr": {
      "recovery_note": "Une boisson chaude traditionnelle sans alcool pour remplacer le rituel culturel du verre du soir par une alternative réconfortante et riche en antioxydants.",
      "ingredients": [
        "2 cups de mélange de baies (surgelées ou fraîches)",
        "4 cups d'eau",
        "2 tbsp de miel ou de sucre",
        "1 bâton de cannelle",
        "1 anis étoilé (facultatif)"
      ],
      "steps": [
        "Mélanger les baies, l'eau, l'édulcorant et les épices dans une casserole.",
        "Laisser mijoter 15 min.",
        "Filtrer (ou laisser les baies à l'intérieur).",
        "Servir chaud en hiver ou froid en été.",
        "Se conserve 5 jours au réfrigérateur."
      ]
    },
    "it": {
      "recovery_note": "Una bevanda calda analcolica tradizionale per sostituire il rituale culturale del drink serale con qualcosa di confortante e ricco di antiossidanti.",
      "ingredients": [
        "2 cups frutti di bosco misti (surgelati o freschi)",
        "4 cups acqua",
        "2 tbsp miele o zucchero",
        "1 stecca di cannella",
        "1 anice stellato (opzionale)"
      ],
      "steps": [
        "Unire i frutti di bosco, l'acqua, il dolcificante e le spezie in una pentola.",
        "Sobbollire per 15 min.",
        "Filtrare (o lasciare i frutti di bosco all'interno).",
        "Servire caldo in inverno o freddo in estate.",
        "Si conserva per 5 giorni in frigorifero."
      ]
    },
    "es": {
      "recovery_note": "Una bebida caliente tradicional sin alcohol para sustituir el ritual cultural de beber por las noches con algo reconfortante y rico en antioxidantes.",
      "ingredients": [
        "2 tazas de mixed berries (congeladas o frescas)",
        "4 tazas de agua",
        "2 tbsp de miel o azúcar",
        "1 rama de canela",
        "1 anís estrellado (opcional)"
      ],
      "steps": [
        "Combine las bayas, el agua, el endulzante y las especias en una olla.",
        "Cocine a fuego lento durante 15 min.",
        "Cuele (o deje las bayas adentro).",
        "Sirva caliente en invierno o frío en verano.",
        "Se mantiene en buen estado por 5 días en el refrigerador."
      ]
    }
  },
  "s1": {
    "ru": {
      "recovery_note": "Простая закуска, сочетающая в себе клетчатку, полезные жиры и капельку натурального сахара — идеальный вариант при упадке сил в середине дня.",
      "ingredients": [
        "1 яблоко, нарезанное ломтиками",
        "2 ст. л. миндальной пасты (almond butter)",
        "Щепотка корицы (по желанию)"
      ],
      "steps": [
        "Нарежьте яблоко дольками.",
        "Посыпьте корицей.",
        "Подавайте с миндальным маслом для макания."
      ]
    },
    "uk": {
      "recovery_note": "Проста закуска, що поєднує в собі клітковину, корисні жири та дрібку натурального цукру — ідеально підходить для відновлення сил під час післяобіднього занепаду енергії.",
      "ingredients": [
        "1 яблуко, нарізане скибочками",
        "2 tbsp мигдалевої пасти (almond butter)",
        "Дрібка кориці (за бажанням)"
      ],
      "steps": [
        "Наріжте яблуко скибочками.",
        "Посипте корицею.",
        "Подавайте з almond butter для вмочування."
      ]
    },
    "ko": {
      "recovery_note": "식이섬유, 건강한 지방, 그리고 약간의 천연 당분을 결합한 간단한 간식으로, 에너지가 떨어지는 오후 시간대에 즐기기 완벽합니다.",
      "ingredients": [
        "사과 1개, 슬라이스",
        "almond butter 2 tbsp",
        "계피가루 한 꼬집 (선택 사항)"
      ],
      "steps": [
        "사과를 웨지 모양으로 썹니다.",
        "시나몬을 뿌립니다.",
        "찍어 먹을 수 있도록 almond butter와 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un en-cas simple qui allie fibres, graisses saines et une touche de sucre naturel — parfait pour les baisses d'énergie du milieu d'après-midi.",
      "ingredients": [
        "1 pomme, coupée en tranches",
        "2 tbsp de beurre d'amande",
        "Une pincée de cannelle (optionnel)"
      ],
      "steps": [
        "Coupez la pomme en quartiers.",
        "Saupoudrez de cannelle.",
        "Servez avec du beurre d'amande pour tremper."
      ]
    },
    "it": {
      "recovery_note": "Uno spuntino semplice che unisce fibre, grassi sani e un tocco di zucchero naturale — perfetto per i cali di energia di metà pomeriggio.",
      "ingredients": [
        "1 mela, affettata",
        "2 tbsp di almond butter",
        "Un pizzico di cannella (opzionale)"
      ],
      "steps": [
        "Tagliare la mela a spicchi.",
        "Cospargere con la cannella.",
        "Servire con almond butter per intingere."
      ]
    },
    "es": {
      "recovery_note": "Un snack sencillo que combina fibra, grasas saludables y un toque de azúcar natural; perfecto para los bajones de energía a media tarde.",
      "ingredients": [
        "1 manzana, rebanada",
        "2 tbsp de mantequilla de almendras",
        "Una pizca de canela (opcional)"
      ],
      "steps": [
        "Corte la manzana en gajos.",
        "Espolvoree con canela.",
        "Sirva con mantequilla de almendras para mojar."
      ]
    }
  },
  "s2": {
    "ru": {
      "recovery_note": "Хрустящие, сытные и богатые клетчаткой — заменяют соленые закуски из пачек, которые провоцируют циклы переедания соли и сахара.",
      "ingredients": [
        "1/2 cup хумус",
        "1 carrot, нарезанная палочками",
        "1 celery stalk, нарезанный палочками",
        "1/2 cucumber, нарезанный ломтиками",
        "1/2 capsicum, нарезанный ломтиками"
      ],
      "steps": [
        "Нарежьте все овощи соломкой.",
        "Переложите хумус ложкой в небольшую миску.",
        "Разложите овощи вокруг хумуса и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Хрусткі, ситні та багаті на клітковину — вони замінюють солоні снеки з пачок, які провокують цикли переїдання сіллю та цукром.",
      "ingredients": [
        "1/2 склянки hummus",
        "1 морква, нарізана паличками",
        "1 стебло селери, нарізане паличками",
        "1/2 огірка, нарізаного скибочками",
        "1/2 capsicum, нарізаного скибочками"
      ],
      "steps": [
        "Наріжте всі овочі соломкою.",
        "Викладіть хумус ложкою в невелику миску.",
        "Розкладіть овочі навколо хумусу та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "바삭하고 만족스러우며 식이섬유가 풍부합니다 — 소금과 설탕의 폭식 굴레로 몰아넣는 짠 봉지 과자를 대신해 보세요.",
      "ingredients": [
        "1/2 cup hummus",
        "당근 1개, 스틱 모양으로 썰기",
        "셀러리 1줄기, 스틱 모양으로 썰기",
        "오이 1/2개, 슬라이스",
        "capsicum 1/2개, 슬라이스"
      ],
      "steps": [
        "모든 채소를 스틱 모양으로 써세요.",
        "hummus를 작은 볼에 숟가락으로 떠서 담으세요.",
        "hummus 주변에 채소들을 가지런히 놓고 내세요."
      ]
    },
    "fr": {
      "recovery_note": "Croustillants, rassasiants et riches en fibres — ils remplacent les snacks industriels salés qui vous poussent vers des cycles de consommation excessive de sel et de sucre.",
      "ingredients": [
        "1/2 cup de houmous",
        "1 carotte, coupée en bâtonnets",
        "1 branche de céleri, coupée en bâtonnets",
        "1/2 concombre, tranché",
        "1/2 capsicum, tranché"
      ],
      "steps": [
        "Coupez tous les légumes en bâtonnets.",
        "Déposez le hummus dans un petit bol à l'aide d'une cuillère.",
        "Disposez les légumes autour du hummus et servez."
      ]
    },
    "it": {
      "recovery_note": "Croccanti, appaganti e ricchi di fibre: sostituiscono gli snack salati confezionati che spingono verso cicli di abbuffate di sale e zuccheri.",
      "ingredients": [
        "1/2 cup hummus",
        "1 carota, tagliata a bastoncini",
        "1 costa di sedano, tagliata a bastoncini",
        "1/2 cetriolo, affettato",
        "1/2 peperone, affettato"
      ],
      "steps": [
        "Tagliare tutte le verdure a bastoncini.",
        "Trasferire l'hummus in una ciotola piccola con un cucchiaio.",
        "Disporre le verdure intorno all'hummus e servire."
      ]
    },
    "es": {
      "recovery_note": "Crujientes, saciantes y llenos de fibra: sustituyen a los snacks salados de bolsa que te empujan a ciclos de atracones de sal + azúcar.",
      "ingredients": [
        "1/2 cup de hummus",
        "1 zanahoria, cortada en bastones",
        "1 rama de apio, cortada en bastones",
        "1/2 pepino, rebanado",
        "1/2 pimiento, rebanado"
      ],
      "steps": [
        "Corte todos los vegetales en bastoncitos.",
        "Coloque el hummus con una cuchara en un tazón pequeño.",
        "Organice los vegetales alrededor del hummus y sirva."
      ]
    }
  },
  "s3": {
    "ru": {
      "recovery_note": "Белок и полезные жиры дольше сохраняют чувство сытости, чем закуски с высоким содержанием углеводов. Грецкие орехи являются единственным растительным источником значительного количества омега-3 АЛК.",
      "ingredients": [
        "3/4 cup греческий йогурт без добавок",
        "1 tsp мед",
        "2 tbsp грецкие орехи, измельченные",
        "Pinch корица"
      ],
      "steps": [
        "Выложите йогурт ложкой в миску.",
        "Полейте медом.",
        "Посыпьте грецкими орехами и cinnamon."
      ]
    },
    "uk": {
      "recovery_note": "Білки та корисні жири забезпечують відчуття ситості довше, ніж перекуски з високим вмістом вуглеводів. Волоські горіхи є єдиним рослинним джерелом значної кількості омега-3 АЛК.",
      "ingredients": [
        "3/4 cup грецького йогурту без добавок",
        "1 tsp меду",
        "2 tbsp волоських горіхів, подрібнених",
        "Pinch кориці"
      ],
      "steps": [
        "Викладіть йогурт ложкою в миску.",
        "Полийте медом.",
        "Посипте зверху волоськими горіхами та корицею."
      ]
    },
    "ko": {
      "recovery_note": "단백질과 건강한 지방은 탄수화물 위주의 간식보다 포만감을 더 오래 유지해 줍니다. 호두는 식물성 영양소 중 유일하게 상당량의 ALA 오메가-3를 제공합니다.",
      "ingredients": [
        "3/4 cup 플레인 Greek yoghurt",
        "1 tsp honey",
        "2 tbsp walnuts, chopped",
        "Pinch of cinnamon"
      ],
      "steps": [
        "요거트를 볼에 숟가락으로 떠서 담습니다.",
        "꿀을 그 위에 뿌립니다.",
        "호두와 cinnamon을 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les protéines et les graisses saines vous rassasient plus longtemps que les collations riches en glucides. Les noix constituent la seule source végétale importante d'oméga-3 ALA.",
      "ingredients": [
        "3/4 cup yaourt grec nature",
        "1 tsp miel",
        "2 tbsp noix, hachées",
        "Une pincée de cannelle"
      ],
      "steps": [
        "Déposer le yoghurt à la cuillère dans un bol.",
        "Arroser de honey.",
        "Garnir de noix et de cinnamon."
      ]
    },
    "it": {
      "recovery_note": "Le proteine e i grassi sani mantengono il senso di sazietà più a lungo rispetto agli snack ricchi di carboidrati. Le noci rappresentano l'unica fonte vegetale con un apporto significativo di omega-3 ALA.",
      "ingredients": [
        "3/4 cup plain Greek yoghurt",
        "1 tsp miele",
        "2 tbsp noci, tritate",
        "Pizzico di cannella"
      ],
      "steps": [
        "Mettere lo yoghurt in una ciotola con un cucchiaio.",
        "Guarnire con un filo di miele.",
        "Completare con noci e cannella."
      ]
    },
    "es": {
      "recovery_note": "Las proteínas y las grasas saludables te mantienen saciado por más tiempo que los snacks con alto contenido de carbohidratos. Las nueces aportan la única fuente vegetal de cantidades significativas de omega-3 ALA.",
      "ingredients": [
        "3/4 cup plain Greek yoghurt",
        "1 tsp honey",
        "2 tbsp walnuts, chopped",
        "Pinch of cinnamon"
      ],
      "steps": [
        "Poner el yoghurt en un bol con una cuchara.",
        "Rociar con honey.",
        "Cubrir con walnuts y cinnamon."
      ]
    }
  },
  "s4": {
    "ru": {
      "recovery_note": "Семена, богатые магнием, поддерживают спокойствие нервной системы. Темный шоколад дает небольшой дофаминовый заряд без резкого спада энергии, характерного для рафинированного сахара.",
      "ingredients": [
        "2 tbsp сырого миндаля",
        "2 tbsp тыквенных семечек",
        "1 tbsp сушеной клюквы",
        "1 tbsp dark chocolate chips"
      ],
      "steps": [
        "Соедините все ингредиенты.",
        "Разделите на порции по 30g.",
        "Храните в герметичной банке; используйте по мере необходимости."
      ]
    },
    "uk": {
      "recovery_note": "Насіння, багате на магній, підтримує спокій нервової системи. Чорний шоколад забезпечує невелику дофамінову винагороду без різкого спаду енергії, характерного для рафінованого цукру.",
      "ingredients": [
        "2 tbsp сирого мигдалю",
        "2 tbsp гарбузового насіння",
        "1 tbsp сушеної журавлини",
        "1 tbsp крапель чорного шоколаду"
      ],
      "steps": [
        "Змішайте всі інгредієнти.",
        "Розділіть на порції по 30g.",
        "Зберігайте в герметичній банці; беріть, коли необхідно."
      ]
    },
    "ko": {
      "recovery_note": "마그네슘이 풍부한 씨앗류는 신경계의 안정을 도와줍니다. 다크 초콜릿은 정제 설탕처럼 혈당이 급격히 떨어지는 증상 없이 약간의 도파민 보상을 더해줍니다.",
      "ingredients": [
        "2 tbsp 생 아몬드",
        "2 tbsp 호박씨",
        "1 tbsp 건 크랜베리",
        "1 tbsp 다크 초콜릿 칩"
      ],
      "steps": [
        "모든 재료를 섞습니다.",
        "30g씩 분량대로 나눕니다.",
        "밀폐 용기에 보관하고 필요할 때마다 꺼내어 사용합니다."
      ]
    },
    "fr": {
      "recovery_note": "Les graines riches en magnésium favorisent le calme du système nerveux. Le chocolat noir apporte une petite récompense de dopamine sans le contrecoup du sucre raffiné.",
      "ingredients": [
        "2 tbsp d'amandes crues",
        "2 tbsp de graines de courge",
        "1 tbsp de canneberges séchées",
        "1 tbsp de pépites de chocolat noir"
      ],
      "steps": [
        "Mélanger tous les ingrédients.",
        "Diviser en portions de 30g.",
        "Conserver dans un bocal hermétique ; à emporter au besoin."
      ]
    },
    "it": {
      "recovery_note": "I semi ricchi di magnesio favoriscono la calma del sistema nervoso. Il cioccolato fondente aggiunge una piccola ricompensa di dopamina senza il crollo tipico dello zucchero raffinato.",
      "ingredients": [
        "2 tbsp mandorle crude",
        "2 tbsp semi di zucca",
        "1 tbsp mirtilli rossi essiccati",
        "1 tbsp gocce di cioccolato fondente"
      ],
      "steps": [
        "Unire tutti gli ingredienti.",
        "Suddividere in porzioni da 30g.",
        "Conservare in un barattolo a chiusura ermetica; prelevare all'occorrenza."
      ]
    },
    "es": {
      "recovery_note": "Las semillas ricas en magnesio favorecen la calma del sistema nervioso. El chocolate negro añade una pequeña recompensa de dopamina sin el bajón del azúcar refinado.",
      "ingredients": [
        "2 tbsp almendras crudas",
        "2 tbsp semillas de calabaza",
        "1 tbsp arándanos rojos secos",
        "1 tbsp chips de chocolate negro"
      ],
      "steps": [
        "Combine todos los ingredientes.",
        "Divida en porciones de 30g.",
        "Guarde en un frasco hermético; tome cuando sea necesario."
      ]
    }
  },
  "s5": {
    "ru": {
      "recovery_note": "Сытное лакомство, которое воздействует на рецепторы сладкого, соленого и жирного без избытка сахара — идеальный вариант для того четырехчасового порыва, который раньше обычно означал время для коктейля.",
      "ingredients": [
        "1 спелый банан",
        "1 tbsp арахисовой пасты",
        "1 tsp темного шоколада в каплях (70%+)",
        "Щепотка корицы"
      ],
      "steps": [
        "Нарежьте банан вдоль.",
        "Намажьте сверху арахисовое масло.",
        "Посыпьте шоколадной крошкой и корицей.",
        "Подавайте немедленно или заверните и охладите 10 min для более плотной текстуры."
      ]
    },
    "uk": {
      "recovery_note": "Заспокійливі ласощі, що активують центри винагороди за солодке, солоне та жирне без цукрового перевантаження — ідеально підходять для того моменту о 4-й годині дня, коли зазвичай виникає бажання випити чогось міцного.",
      "ingredients": [
        "1 стиглий банан",
        "1 ст. л. арахісової пасти",
        "1 ч. л. дропсів із чорного шоколаду (70%+)",
        "Дрібка кориці"
      ],
      "steps": [
        "Розріжте banana вздовж.",
        "Намажте peanut butter зверху.",
        "Посипте chocolate chips та cinnamon.",
        "Подавайте негайно або загорніть і охолодіть протягом 10 min для більш твердої текстури."
      ]
    },
    "ko": {
      "recovery_note": "과도한 당분 섭취 없이도 단맛, 짠맛, 지방의 보상 회복 회로를 충족해 주는 만족스러운 간식입니다. 흔히 술 한 잔이 생각나는 시간대인 오후 4시의 갈증을 해소하기에 완벽합니다.",
      "ingredients": [
        "1 ripe banana",
        "1 tbsp peanut butter",
        "1 tsp dark chocolate chips (70%+)",
        "Pinch of cinnamon"
      ],
      "steps": [
        "바나나를 세로 방향으로 길게 자릅니다.",
        "그 위에 피넛 버터를 펴 바릅니다.",
        "초콜릿 칩과 시나몬을 뿌립니다.",
        "즉시 서빙하거나, 더 단단한 식감을 위해 랩으로 감싸 10 min 동안 차갑게 둡니다."
      ]
    },
    "fr": {
      "recovery_note": "Une gourmandise satisfaisante qui stimule les circuits de la récompense sucré/salé/gras sans surcharge de sucre — idéal pour l'envie de 16h00 qui marquait souvent l'heure de l'apéritif.",
      "ingredients": [
        "1 banane mûre",
        "1 tbsp de beurre de cacahuète",
        "1 tsp de pépites de chocolat noir (70%+)",
        "Une pincée de cannelle"
      ],
      "steps": [
        "Coupez la banane dans le sens de la longueur.",
        "Étalez du peanut butter sur le dessus.",
        "Saupoudrez des pépites de chocolat et de la cannelle.",
        "Servez immédiatement ou emballez et réfrigérez 10 min pour une texture plus ferme."
      ]
    },
    "it": {
      "recovery_note": "Uno spuntino appagante che soddisfa i circuiti di ricompensa dolce/salato/grasso senza un sovraccarico di zuccheri — perfetto per quella voglia delle 16:00 che spesso segnava l'ora dell'aperitivo.",
      "ingredients": [
        "1 banana matura",
        "1 tbsp di burro di arachidi",
        "1 tsp di gocce di cioccolato fondente (70%+)",
        "Un pizzico di cannella"
      ],
      "steps": [
        "Tagliare la banana per il lungo.",
        "Spalmare il peanut butter sulla parte superiore.",
        "Cospargere con chocolate chips e cannella.",
        "Servire immediatamente o avvolgere e raffreddare 10 min per una consistenza più soda."
      ]
    },
    "es": {
      "recovery_note": "Un capricho saciante que activa los circuitos de recompensa dulce/salado/grasa sin un exceso de azúcar; perfecto para ese antojo de las 4 de la tarde que solía marcar la hora de la primera copa.",
      "ingredients": [
        "1 banana madura",
        "1 tbsp de mantequilla de maní",
        "1 tsp de chispas de chocolate amargo (70%+)",
        "Una pizca de canela"
      ],
      "steps": [
        "Corte el plátano a lo largo.",
        "Unte la mantequilla de cacahuete por encima.",
        "Esparza pepitas de chocolate y canela.",
        "Sirva inmediatamente o envuelva y refrigere 10 min para una textura más firme."
      ]
    }
  },
  "sm1": {
    "ru": {
      "recovery_note": "Ягоды, богатые антиоксидантами, плюс омега-3 из семян чиа — отличный способ поддержать работу мозга в начале дня или восстановить силы после тренировки.",
      "ingredients": [
        "1 стакан смеси ягод (замороженных)",
        "1 банан",
        "1 стакан несладкого молока или овсяного молока",
        "1 мерная ложка ванильного протеина (по желанию)",
        "1 tbsp семян чиа",
        "Лед по необходимости"
      ],
      "steps": [
        "Добавьте все ингредиенты в blender.",
        "Взбивайте на высокой скорости 30–45 секунд до однородного состояния.",
        "Перелейте в стакан; подавайте холодным."
      ]
    },
    "uk": {
      "recovery_note": "Багаті на антиоксиданти ягоди та омега-3 з насіння чіа — корисний для мозку спосіб почати день або відновити сили після тренування.",
      "ingredients": [
        "1 склянка суміші ягід (заморожених)",
        "1 банан",
        "1 склянка несолодкого молока або вівсяного молока",
        "1 мірна ложка ванільного протеїнового порошку (за бажанням)",
        "1 tbsp насіння чіа",
        "Лід за потребою"
      ],
      "steps": [
        "Додайте всі інгредієнти в blender.",
        "Збивайте на високій швидкості 30–45 seconds до однорідності.",
        "Налийте в склянку; подавайте холодним."
      ]
    },
    "ko": {
      "recovery_note": "항산화 성분이 풍부한 베리에 치아씨드의 오메가-3를 더했습니다 — 두뇌 건강을 돕는 아침 식사로도, 운동 후 기력을 회복하는 간식으로도 완벽합니다.",
      "ingredients": [
        "1 cup 믹스 베리 (냉동)",
        "1 banana",
        "1 cup 무가당 milk 또는 oat milk",
        "1 scoop 바닐라 protein powder (선택 사항)",
        "1 tbsp chia seeds",
        "Ice 적당량"
      ],
      "steps": [
        "모든 재료를 blender에 넣습니다.",
        "부드러워질 때까지 고속으로 30–45초간 블렌딩합니다.",
        "유리잔에 붓고 차갑게 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Des baies riches en antioxydants et des oméga-3 de chia — une façon de soutenir le cerveau pour commencer la journée ou de récupérer après une séance d’entraînement.",
      "ingredients": [
        "1 cup mixed berries (frozen)",
        "1 banana",
        "1 cup unsweetened milk or oat milk",
        "1 scoop vanilla protein powder (optional)",
        "1 tbsp chia seeds",
        "Ice as needed"
      ],
      "steps": [
        "Ajoutez tous les ingrédients dans le blender.",
        "Mixez à haute vitesse pendant 30–45 seconds jusqu'à l'obtention d'un mélange lisse.",
        "Versez dans un verre ; servez froid."
      ]
    },
    "it": {
      "recovery_note": "Bacche ricche di antiossidanti e omega-3 dei semi di chia: un modo per sostenere le funzioni cerebrali con cui iniziare la giornata o recuperare dopo un allenamento.",
      "ingredients": [
        "1 cup di frutti di bosco misti (surgelati)",
        "1 banana",
        "1 cup di latte non zuccherato o latte d'avena",
        "1 scoop di proteine in polvere alla vaniglia (opzionale)",
        "1 tbsp di semi di chia",
        "Ghiaccio quanto basta"
      ],
      "steps": [
        "Aggiungere tutti gli ingredienti nel frullatore.",
        "Frullare alla massima velocità per 30–45 secondi fino a ottenere un composto omogeneo.",
        "Versare in un bicchiere; servire freddo."
      ]
    },
    "es": {
      "recovery_note": "Bayas ricas en antioxidantes junto con el omega-3 de la chía: una forma de apoyar la salud cerebral para empezar el día o recuperarse después de un entrenamiento.",
      "ingredients": [
        "1 cup frutos rojos mixtos (congelados)",
        "1 banana",
        "1 cup leche sin azúcar o leche de avena",
        "1 scoop vanilla protein powder (opcional)",
        "1 tbsp semillas de chia",
        "Hielo según sea necesario"
      ],
      "steps": [
        "Agregue todos los ingredientes a la licuadora.",
        "Licúe a velocidad alta de 30–45 segundos hasta que esté suave.",
        "Vierta en un vaso; sirva frío."
      ]
    }
  },
  "sm2": {
    "ru": {
      "recovery_note": "Увлажняет и мягко способствует детоксикации — поддерживает функцию печени в период восстановления после метаболической нагрузки, вызванной длительным употреблением психоактивных веществ.",
      "ingredients": [
        "1 cup беби-шпината",
        "1/2 огурца",
        "1 зеленое яблоко, без сердцевины",
        "1 tbsp лимонного сока",
        "1-inch свежего имбиря",
        "1 cup кокосовой воды"
      ],
      "steps": [
        "Добавьте все ингредиенты в blender.",
        "Взбивайте до состояния полной однородности.",
        "Процедите при желании и подавайте со льдом."
      ]
    },
    "uk": {
      "recovery_note": "Зволожує та м'яко очищує від токсинів — підтримує функцію печінки під час її відновлення після метаболічного навантаження внаслідок тривалого вживання психоактивних речовин.",
      "ingredients": [
        "1 склянка baby spinach",
        "1/2 огірка",
        "1 зелене яблуко, без серцевини",
        "1 tbsp лимонного соку",
        "1-дюймовий шматочок свіжого ginger",
        "1 склянка coconut water"
      ],
      "steps": [
        "Додайте всі інгредієнти в blender.",
        "Збивайте до повної однорідності.",
        "Процідіть за бажанням і подавайте з льодом."
      ]
    },
    "ko": {
      "recovery_note": "수분을 공급하고 부드럽게 독소를 배출합니다. 장기간의 약물 사용으로 인한 대사 부하 이후 간 기능이 회복되도록 돕습니다.",
      "ingredients": [
        "1 cup 베이비 시금치",
        "1/2 cucumber",
        "1 green apple, 씨를 제거한 것",
        "1 tbsp lemon juice",
        "1-inch fresh ginger",
        "1 cup coconut water"
      ],
      "steps": [
        "모든 재료를 blender에 넣습니다.",
        "완전히 부드러워질 때까지 블렌딩합니다.",
        "기호에 따라 체에 거른 뒤 얼음 위에 부어 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Hydratant et délicatement détoxifiant — soutient la fonction hépatique lors de sa régénération après la charge métabolique liée à une consommation de substances à long terme.",
      "ingredients": [
        "1 cup de jeunes pousses d'épinards",
        "1/2 concombre",
        "1 pomme verte, évidée",
        "1 tbsp de jus de citron",
        "1-inch de gingembre frais",
        "1 cup d'eau de coco"
      ],
      "steps": [
        "Ajoutez tous les ingrédients dans le blender.",
        "Mixez jusqu'à l'obtention d'un mélange parfaitement lisse.",
        "Filtrez si vous le souhaitez et servez sur de la glace."
      ]
    },
    "it": {
      "recovery_note": "Idratante e delicatamente disintossicante — supporta la funzione epatica durante la fase di rigenerazione dopo il carico metabolico causato dall'uso prolungato di sostanze.",
      "ingredients": [
        "1 cup baby spinach",
        "1/2 cetriolo",
        "1 mela verde, privata del torsolo",
        "1 tbsp succo di limone",
        "1 pollice di zenzero fresco",
        "1 cup acqua di cocco"
      ],
      "steps": [
        "Aggiungere tutti gli ingredienti nel blender.",
        "Frullare fino a ottenere un composto completamente liscio.",
        "Filtrare se desiderato e servire con ghiaccio."
      ]
    },
    "es": {
      "recovery_note": "Hidratante y suavemente desintoxicante: apoya la función hepática mientras se reconstruye tras la carga metabólica del consumo de sustancias a largo plazo.",
      "ingredients": [
        "1 cup espinacas baby",
        "1/2 pepino",
        "1 manzana verde, sin corazón",
        "1 tbsp jugo de limón",
        "1 pulgada de jengibre fresco",
        "1 cup agua de coco"
      ],
      "steps": [
        "Agregue todos los ingredientes a la licuadora.",
        "Licue hasta que esté completamente suave.",
        "Cuele si lo desea y sirva sobre hielo."
      ]
    }
  },
  "sm3": {
    "ru": {
      "recovery_note": "Какао богато флаванолами и содержит теобромин — мягкий природный стимулятор настроения, не вызывающий привыкания. Идеальное вознаграждение после рабочих встреч или тренировки.",
      "ingredients": [
        "1 банан",
        "1 tbsp какао-порошка (неподслащенного)",
        "1 мерная ложка шоколадного протеина",
        "1 стакан молока на ваш выбор",
        "1 tbsp арахисовой пасты",
        "Лед"
      ],
      "steps": [
        "Смешайте все ингредиенты в блендере.",
        "Взбивайте на высокой скорости до получения густой и кремообразной консистенции.",
        "Перелейте в стакан и подавайте немедленно."
      ]
    },
    "uk": {
      "recovery_note": "Какао багате на флаваноли та містить теобромін — м’який природний засіб для підняття настрою, що не викликає звикання. Ідеальна винагорода після наради або тренування.",
      "ingredients": [
        "1 банан",
        "1 tbsp какао-порошку (несолодкого)",
        "1 мірна ложка шоколадного протеїнового порошку",
        "1 склянка молока на ваш вибір",
        "1 tbsp арахісової пасти",
        "Лід"
      ],
      "steps": [
        "Змішайте всі інгредієнти в блендері.",
        "Збивайте на високій швидкості до густої та кремоподібної консистенції.",
        "Налийте в склянку та насолоджуйтеся негайно."
      ]
    },
    "ko": {
      "recovery_note": "코코아는 플라바놀이 풍부하며, 완만하고 중독성 없는 기분 전환 효과를 주는 테오브로민을 함유하고 있습니다. 회의 후나 운동 후에 스스로에게 주는 보상으로 이상적입니다.",
      "ingredients": [
        "바나나 1개",
        "코코아 가루 1 tbsp (무가당)",
        "초콜릿 단백질 파우더 1 scoop",
        "취향에 맞는 우유 1 cup",
        "땅콩 버터 1 tbsp",
        "얼음"
      ],
      "steps": [
        "모든 재료를 블렌더에 넣습니다.",
        "걸쭉하고 부드러워질 때까지 고속으로 블렌딩합니다.",
        "유리잔에 붓고 즉시 즐기세요."
      ]
    },
    "fr": {
      "recovery_note": "Le cacao est riche en flavanols et contient de la théobromine — un stimulant de l'humeur doux et non addictif. Une récompense idéale après une réunion ou une séance de sport.",
      "ingredients": [
        "1 banane",
        "1 tbsp de cacao en poudre (non sucré)",
        "1 scoop de protéine en poudre au chocolat",
        "1 cup de lait au choix",
        "1 tbsp de beurre de cacahuète",
        "Glaçons"
      ],
      "steps": [
        "Mélanger tous les ingrédients dans un blender.",
        "Mixer à haute vitesse jusqu'à l'obtention d'une texture épaisse et crémeuse.",
        "Verser dans un verre et déguster immédiatement."
      ]
    },
    "it": {
      "recovery_note": "Il cacao è ricco di flavanoli e contiene teobromina, un delicato stimolante dell'umore che non crea dipendenza. È la ricompensa ideale dopo una riunione o dopo l'allenamento.",
      "ingredients": [
        "1 banana",
        "1 tbsp di cacao in polvere (non dolcificato)",
        "1 misurino di proteine in polvere al cioccolato",
        "1 cup di latte a scelta",
        "1 tbsp di burro di arachidi",
        "Ghiaccio"
      ],
      "steps": [
        "Unire tutti gli ingredienti in un blender.",
        "Frullare alla massima velocità fino a ottenere un composto denso e cremoso.",
        "Versare in un bicchiere e gustare immediatamente."
      ]
    },
    "es": {
      "recovery_note": "El cacao es rico en flavanoles y contiene teobromina, un estimulante del estado de ánimo suave y no adictivo. Es la recompensa ideal para después de una reunión o de un entrenamiento.",
      "ingredients": [
        "1 banana",
        "1 tbsp cocoa powder (sin endulzar)",
        "1 scoop chocolate protein powder",
        "1 cup leche de su elección",
        "1 tbsp peanut butter",
        "Hielo"
      ],
      "steps": [
        "Combine todos los ingredientes en una licuadora.",
        "Licue a velocidad alta hasta que esté espeso y cremoso.",
        "Vierta en un vaso y disfrute de inmediato."
      ]
    }
  },
  "sm4": {
    "ru": {
      "recovery_note": "Настоящий заряд витамина С для поддержки восстановления надпочечников — полезно в первые месяцы, когда реакция на стресс перенастраивается без участия алкоголя.",
      "ingredients": [
        "1 cup замороженного манго",
        "1/2 cup замороженного ананаса",
        "1 банан",
        "1 cup апельсинового сока или кокосовой воды",
        "1 tbsp молотых семян льна"
      ],
      "steps": [
        "Добавьте все ингредиенты в блендер.",
        "Смешивайте до однородной шелковистой консистенции.",
        "Перелейте в стакан и подавайте."
      ]
    },
    "uk": {
      "recovery_note": "Потужне джерело вітаміну С для підтримки відновлення надниркових залоз — корисно в перші місяці, коли реакція на стрес перебудовується без участі алкоголю.",
      "ingredients": [
        "1 cup замороженого манго",
        "1/2 cup замороженого ананаса",
        "1 банан",
        "1 cup апельсинового соку або кокосової води",
        "1 tbsp меленого насіння льону"
      ],
      "steps": [
        "Додайте всі інгредієнти в blender.",
        "Збивайте до шовковистої однорідності.",
        "Налийте в склянку та подавайте."
      ]
    },
    "ko": {
      "recovery_note": "부신 회복을 돕는 강력한 비타민 C 공급원 — 알코올 없이 스트레스 반응을 재조정하는 초기 몇 달 동안 유용합니다.",
      "ingredients": [
        "1 cup 냉동 망고",
        "1/2 cup 냉동 파인애플",
        "1 banana",
        "1 cup 오렌지 주스 또는 coconut water",
        "1 tbsp ground flaxseed"
      ],
      "steps": [
        "모든 재료를 blender에 넣습니다.",
        "부드러워질 때까지 블렌딩합니다.",
        "유리잔에 부어 서빙합니다."
      ]
    },
    "fr": {
      "recovery_note": "Une véritable mine de vitamine C pour soutenir la récupération des glandes surrénales — utile durant les premiers mois lorsque la réponse au stress se recalibre sans alcool.",
      "ingredients": [
        "1 cup de mangue surgelée",
        "1/2 cup d'ananas surgelé",
        "1 banane",
        "1 cup de jus d'orange ou d'eau de coco",
        "1 tbsp de graines de lin moulues"
      ],
      "steps": [
        "Ajoutez tous les ingrédients dans le blender.",
        "Mixez jusqu'à l'obtention d'une texture parfaitement lisse.",
        "Versez dans un verre et servez."
      ]
    },
    "it": {
      "recovery_note": "Una sferzata di vitamina C per supportare il recupero surrenale — utile nei primi mesi, quando la risposta allo stress si sta ricalibrando in assenza di alcol.",
      "ingredients": [
        "1 cup di mango surgelato",
        "1/2 cup di ananas surgelato",
        "1 banana",
        "1 cup di succo d'arancia o acqua di cocco",
        "1 tbsp di semi di lino macinati"
      ],
      "steps": [
        "Aggiungere tutti gli ingredienti nel frullatore.",
        "Frullare fino a ottenere un composto liscio e vellutato.",
        "Versare in un bicchiere e servire."
      ]
    },
    "es": {
      "recovery_note": "Fuente inagotable de vitamina C para apoyar la recuperación de las glándulas suprarrenales — útil durante los primeros meses cuando la respuesta al estrés se está recalibrando sin alcohol.",
      "ingredients": [
        "1 cup mango congelado",
        "1/2 cup piña congelada",
        "1 banana",
        "1 cup jugo de naranja o agua de coco",
        "1 tbsp semillas de lino molidas"
      ],
      "steps": [
        "Añadir todos los ingredientes a la licuadora.",
        "Licuar hasta que esté suave y sedoso.",
        "Verter en un vaso y servir."
      ]
    }
  },
  "ua1": {
    "ru": {
      "recovery_note": "Растительный белок из фасоли и поддерживающая печень свекла — одна тарелка, которая питает и тело, и душу.",
      "ingredients": [
        "3 beetroot, тертые",
        "1 tin белой фасоли",
        "1 onion, 2 carrots, 2 potatoes",
        "1/4 cabbage, шинкованной",
        "1 tin томатов",
        "Garlic, dill, sour cream"
      ],
      "steps": [
        "Обжаривайте onion и carrot 5 min.",
        "Добавьте beetroot, tomatoes; готовьте 5 min.",
        "Добавьте stock, potatoes, cabbage, beans.",
        "Варите на медленном огне 35-40 min.",
        "Украсьте garlic, dill и sour cream."
      ]
    },
    "uk": {
      "recovery_note": "Рослинний білок з квасолі та корисний для печінки буряк — одна тарілка, що живить тіло і душу.",
      "ingredients": [
        "3 beetroot, натерті",
        "1 tin білої квасолі",
        "1 onion, 2 carrots, 2 potatoes",
        "1/4 cabbage, нашаткованої",
        "1 tin томатів",
        "Garlic, dill, sour cream"
      ],
      "steps": [
        "Обсмажте цибулю та моркву протягом 5 min.",
        "Додайте буряк, томати; готуйте 5 min.",
        "Додайте бульйон, картоплю, капусту, квасолю.",
        "Тушкуйте на повільному вогні 35-40 min.",
        "Прикрасьте часником, кропом та сметаною."
      ]
    },
    "ko": {
      "recovery_note": "콩에서 얻는 식물성 단백질에 간 건강을 돕는 비트루트까지, 몸과 마음을 모두 채워주는 든든한 한 그릇 요리입니다.",
      "ingredients": [
        "비트루트 3개, 강판에 간 것",
        "화이트 빈 1캔",
        "양파 1개, 당근 2개, 감자 2개",
        "양배추 1/4개, 채 썬 것",
        "토마토 1캔",
        "마늘, 딜, 사워크림"
      ],
      "steps": [
        "양파와 당근을 5 min 동안 볶습니다.",
        "비트루트와 토마토를 넣고 5 min 동안 익힙니다.",
        "육수, 감자, 양배추, 콩을 넣습니다.",
        "35-40 min 동안 뭉근하게 끓입니다.",
        "마늘, 딜, 사워크림을 고명으로 얹습니다."
      ]
    },
    "fr": {
      "recovery_note": "Des protéines végétales issues des haricots associées à de la betterave bénéfique pour le foie — un bol unique qui nourrit le corps et l'esprit.",
      "ingredients": [
        "3 betteraves, râpées",
        "1 boîte de haricots blancs",
        "1 oignon, 2 carottes, 2 pommes de terre",
        "1/4 de chou, émincé",
        "1 boîte de tomates",
        "Ail, dill, crème sure"
      ],
      "steps": [
        "Faire sauter l'oignon et la carotte pendant 5 min.",
        "Ajouter la betterave et les tomates ; cuire 5 min.",
        "Ajouter le bouillon, les pommes de terre, le chou et les haricots.",
        "Mijoter de 35 à 40 min.",
        "Garnir d'ail, d'aneth et de crème aigre."
      ]
    },
    "it": {
      "recovery_note": "Proteine vegetali dai fagioli unite alla barbabietola che supporta il fegato: un’unica ciotola che nutre il corpo e l’anima.",
      "ingredients": [
        "3 barbabietole, grattugiate",
        "1 tin fagioli bianchi",
        "1 cipolla, 2 carote, 2 patate",
        "1/4 cavolo, tagliato a strisce",
        "1 tin pomodori",
        "Aglio, aneto, panna acida"
      ],
      "steps": [
        "Soffriggere cipolla e carota per 5 min.",
        "Aggiungere barbabietola, pomodori; cuocere 5 min.",
        "Aggiungere stock, patate, cavolo, fagioli.",
        "Sobbollire per 35-40 min.",
        "Guarnire con aglio, aneto, panna acida."
      ]
    },
    "es": {
      "recovery_note": "Proteína vegetal proveniente de las alubias junto con remolacha para fortalecer el hígado: un solo cuenco que nutre el cuerpo y el alma.",
      "ingredients": [
        "3 beetroot, ralladas",
        "1 tin white beans",
        "1 onion, 2 carrots, 2 potatoes",
        "1/4 cabbage, rallado",
        "1 tin tomatoes",
        "Garlic, dill, sour cream"
      ],
      "steps": [
        "Saltear la cebolla y la zanahoria 5 min.",
        "Añadir la remolacha y los tomates; cocinar 5 min.",
        "Añadir el caldo, las patatas, el repollo y los frijoles.",
        "Cocinar a fuego lento 35-40 min.",
        "Guarnecer con ajo, eneldo y crema agria."
      ]
    }
  },
  "ua2": {
    "ru": {
      "recovery_note": "Готовка своими руками сродни медитации: замешивание теста и лепка пельменей заменяют то беспокойство, которое часто приводило к выпивке.",
      "ingredients": [
        "2 стакана муки",
        "3/4 стакана теплой воды, 1 яйцо, соль",
        "3 вареные картофелины, размятые в пюре",
        "100g тертого сыра",
        "Сливочное масло, жареный лук, сметана"
      ],
      "steps": [
        "Замесите тесто из муки, воды, яйца и соли; дайте отдохнуть 30 min.",
        "Смешайте картофельное пюре с сыром.",
        "Тонко раскатайте тесто; вырежьте кружочки.",
        "Выложите начинку, сложите и защипните края.",
        "Отваривайте 5 min; подавайте со сливочным маслом, жареным луком и сметаной."
      ]
    },
    "uk": {
      "recovery_note": "Готувати власноруч — це медитація: замішування тіста та ліплення вареників замінюють тривожність, яка часто спонукала до випивки.",
      "ingredients": [
        "2 склянки борошна",
        "3/4 склянки теплої води, 1 яйце, сіль",
        "3 варені картоплини, розім'яті в пюре",
        "100g тертого сиру",
        "Butter, смажена цибуля, сметана"
      ],
      "steps": [
        "Замісіть тісто з борошна, води, яйця та солі; залиште відпочити на 30 min.",
        "Змішайте картопляне пюре з сиром.",
        "Тонко розкачайте тісто; виріжте кружечки.",
        "Наповніть начинкою, складіть та заліпіть краї.",
        "Варіть 5 min; подавайте з вершковим маслом, смаженою цибулею та сметаною."
      ]
    },
    "ko": {
      "recovery_note": "손으로 요리하는 것은 명상과도 같습니다. 반죽을 치대고 만두를 빚는 과정은 한때 술로 이어지곤 했던 불안함을 대신해 줍니다.",
      "ingredients": [
        "2 cups flour",
        "3/4 cup warm water, 1 egg, salt",
        "3 boiled potatoes, mashed",
        "100g grated cheese",
        "Butter, fried onions, sour cream"
      ],
      "steps": [
        "flour, water, egg, salt로 반죽을 만듭니다; 30 min 동안 휴지시킵니다.",
        "으깬 potato와 cheese를 섞습니다.",
        "반죽을 얇게 밀어 원형으로 자릅니다.",
        "속을 채우고 접어서 밀봉합니다.",
        "5 min 동안 삶습니다; butter, fried onions, sour cream을 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Cuisiner avec ses mains est méditatif — pétrir la pâte et plier des raviolis remplace l'agitation qui menait souvent à la consommation d'alcool.",
      "ingredients": [
        "2 cups de farine",
        "3/4 cup d'eau tiède, 1 œuf, sel",
        "3 pommes de terre bouillies, écrasées en purée",
        "100g de fromage râpé",
        "Beurre, oignons frits, crème aigre"
      ],
      "steps": [
        "Préparer la pâte avec de la farine, de l'eau, un œuf et du sel ; laisser reposer 30 min.",
        "Mélanger la purée de pommes de terre avec du fromage.",
        "Étaler la pâte finement ; découper des cercles.",
        "Garnir, plier et sceller.",
        "Bouillir 5 min ; servir avec du beurre, des oignons frits et de la crème aigre."
      ]
    },
    "it": {
      "recovery_note": "Cucinare con le mani è meditativo — impastare e chiudere i dumpling sostituisce l'agitazione che spesso portava a bere.",
      "ingredients": [
        "2 tazze di farina",
        "3/4 tazza di acqua tiepida, 1 uovo, sale",
        "3 patate bollite, schiacciate",
        "100g di formaggio grattugiato",
        "Burro, cipolle fritte, panna acida"
      ],
      "steps": [
        "Preparare l'impasto con farina, acqua, uovo, sale; far riposare 30 min.",
        "Mescolare le patate schiacciate con il formaggio.",
        "Stendere l'impasto sottilmente; ritagliare dei cerchi.",
        "Riempire, piegare e sigillare.",
        "Bollire per 5 min; servire con burro, cipolle fritte, panna acida."
      ]
    },
    "es": {
      "recovery_note": "Cocinar con las manos es meditativo; amasar masa y cerrar dumplings sustituye la agitación que a menudo conducía a la bebida.",
      "ingredients": [
        "2 cups harina",
        "3/4 cup agua tibia, 1 huevo, sal",
        "3 papas hervidas, hechas puré",
        "100g queso rallado",
        "Mantequilla, cebollas fritas, crema agria"
      ],
      "steps": [
        "Prepare la masa con harina, agua, huevo, sal; deje reposar 30 min.",
        "Mezcle el puré de papa con queso.",
        "Extienda la masa finamente; corte círculos.",
        "Rellene, doble y selle.",
        "Hierva por 5 min; sirva con mantequilla, cebollas fritas y crema agria."
      ]
    }
  },
  "ua3": {
    "ru": {
      "recovery_note": "Блюдо в одной кастрюле, приготовленное на медленном огне — та инвестиция в себя, которую зависимость никогда не позволяла сделать.",
      "ingredients": [
        "1 большой кочан капусты",
        "300g нежирного мясного фарша",
        "1/2 cup риса",
        "1 луковица, чеснок",
        "1 tin томатов",
        "Лавровый лист, укроп, соль"
      ],
      "steps": [
        "Blanch cabbage; separate leaves.",
        "Mix mince with rice, onion, garlic, dill.",
        "Roll filling in cabbage leaves.",
        "Place in pot; cover with tomatoes and stock.",
        "Simmer 50 min."
      ]
    },
    "uk": {
      "recovery_note": "Блюдо в одному горщику, приготоване на повільному вогні — та інвестиція в себе, якої залежність ніколи не дозволяла.",
      "ingredients": [
        "1 велика капустина",
        "300g нежирного фаршу",
        "1/2 склянки рису",
        "1 цибуля, часник",
        "1 банка томатів",
        "Лавровий лист, кріп, сіль"
      ],
      "steps": [
        "Бланшуйте капусту; розділіть листя.",
        "Змішайте фарш з рисом, цибулею, часником та dill.",
        "Загорніть начинку в капустяне листя.",
        "Викладіть у каструлю; залийте томатами та stock.",
        "Тушкуйте 50 min."
      ]
    },
    "ko": {
      "recovery_note": "천천히 조리한 원팬 요리 — 중독에 빠져있을 때는 결코 허락되지 않았던, 나 자신을 위한 일종의 투자입니다.",
      "ingredients": [
        "1 large cabbage",
        "300g lean mince",
        "1/2 cup rice",
        "1 onion, garlic",
        "1 tin tomatoes",
        "Bay leaf, dill, salt"
      ],
      "steps": [
        "양배추를 데친 후 잎을 분리합니다.",
        "다진 고기에 쌀, 양파, 마늘, dill을 넣고 섞습니다.",
        "양배추 잎에 속재료를 넣고 돌돌 맙니다.",
        "냄비에 담고 토마토와 육수를 부어 덮습니다.",
        "50분 동안 뭉근하게 끓입니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat mijoté à la cocotte — le genre d'investissement en soi que l'addiction n'a jamais permis.",
      "ingredients": [
        "1 large chou",
        "300g lean mince",
        "1/2 cup de riz",
        "1 oignon, ail",
        "1 boîte de tomates",
        "Laurier, aneth, sel"
      ],
      "steps": [
        "Blanchir le chou ; séparer les feuilles.",
        "Mélanger la viande hachée avec le riz, l'oignon, l'ail et l'aneth.",
        "Rouler la farce dans les feuilles de chou.",
        "Placer dans une cocotte ; couvrir avec les tomates et le bouillon.",
        "Mijoter pendant 50 min."
      ]
    },
    "it": {
      "recovery_note": "Piatto unico a cottura lenta: il tipo di investimento su se stessi che la dipendenza non ha mai permesso.",
      "ingredients": [
        "1 cavolo grande",
        "300g lean mince",
        "1/2 cup di riso",
        "1 cipolla, aglio",
        "1 lattina di pomodori",
        "Foglia di alloro, aneto, sale"
      ],
      "steps": [
        "Sbollentare il cavolo; separare le foglie.",
        "Mescolare il macinato con riso, cipolla, aglio e dill.",
        "Arrotolare il ripieno nelle foglie di cavolo.",
        "Disporre in una pentola; coprire con i pomodori e lo stock.",
        "Sobbollire per 50 min."
      ]
    },
    "es": {
      "recovery_note": "Comida de olla a fuego lento: el tipo de inversión en ti mismo que la adicción nunca permitió.",
      "ingredients": [
        "1 repollo grande",
        "300g lean mince",
        "1/2 taza de arroz",
        "1 cebolla, ajo",
        "1 lata de tomates",
        "Hoja de laurel, eneldo, sal"
      ],
      "steps": [
        "Blanquear el repollo; separar las hojas.",
        "Mezclar la carne picada con el arroz, la cebolla, el ajo y el dill.",
        "Enrollar el relleno en las hojas de repollo.",
        "Colocar en una olla; cubrir con los tomates y el stock.",
        "Cocinar a fuego lento durante 50 min."
      ]
    }
  },
  "ua4": {
    "ru": {
      "recovery_note": "Уютная еда, которая оправдывает ожидания — хрустящая, пикантная и сытная, без чувства тяжести наутро.",
      "ingredients": [
        "4 картофелины, натертые и отжатые",
        "1 луковица, натертая",
        "1 яйцо",
        "2 tbsp муки",
        "Соль, перец",
        "Сметана для подачи"
      ],
      "steps": [
        "Соедините тертый картофель и лук; отожмите лишнюю воду.",
        "Смешайте с яйцом, мукой, солью и перцем.",
        "Обжаривайте по одной ложке в масле 3-4 min с каждой стороны.",
        "Выложите на бумажное полотенце, чтобы впитался жир.",
        "Подавайте горячими со сметаной."
      ]
    },
    "uk": {
      "recovery_note": "Затишна їжа, яка виправдовує очікування — хрустка, пікантна та ситна, без жодних ранкових жалкувань.",
      "ingredients": [
        "4 картоплини, натерті та віджаті від зайвої вологи",
        "1 цибулина, натерта",
        "1 яйце",
        "2 tbsp борошна",
        "Сіль, перець",
        "Sour cream для подачі"
      ],
      "steps": [
        "Змішайте натерту картоплю та цибулю; відіжміть зайву рідину.",
        "Змішайте з egg, борошном, salt та pepper.",
        "Обсмажуйте ложкою в олії по 3-4 min з кожного боку.",
        "Промокніть на паперовому рушнику.",
        "Подавайте гарячими зі сметаною."
      ]
    },
    "ko": {
      "recovery_note": "바삭하고 짭조름하며, 다음 날 아침 후회 없을 만큼 만족스러운 진정한 소울 푸드입니다.",
      "ingredients": [
        "감자 4개, 강판에 갈아 물기를 짠 것",
        "양파 1개, 강판에 갈 것",
        "계란 1개",
        "2 tbsp 밀가루",
        "소금, 후추",
        "곁들임용 Sour cream"
      ],
      "steps": [
        "강판에 간 감자와 양파를 섞은 뒤, 과도한 물기를 짜냅니다.",
        "계란, 밀가루, salt, pepper와 함께 섞습니다.",
        "기름을 두른 팬에 한 스푼씩 떠 넣고 양면을 각각 3-4 min 동안 튀기듯 굽습니다.",
        "키친타월에 올려 기름기를 뺍니다.",
        "sour cream을 곁들여 뜨거울 때 제공합니다."
      ]
    },
    "fr": {
      "recovery_note": "Un plat réconfortant qui tient ses promesses — croustillant, savoureux, satisfaisant et sans les regrets du lendemain matin.",
      "ingredients": [
        "4 pommes de terre, râpées et pressées pour les égoutter",
        "1 oignon, râpé",
        "1 œuf",
        "2 tbsp de farine",
        "Sel, poivre",
        "Sour cream pour servir"
      ],
      "steps": [
        "Mélanger la pomme de terre râpée et l'oignon ; presser pour extraire l'excès d'eau.",
        "Mélanger avec l'œuf, la farine, le sel et le poivre.",
        "Faire frire des cuillères de préparation dans l'huile 3-4 min par côté.",
        "Égoutter sur du papier.",
        "Servir chaud avec de la sour cream."
      ]
    },
    "it": {
      "recovery_note": "Un comfort food che mantiene le promesse: croccante, saporito e soddisfacente, senza i rimpianti del mattino dopo.",
      "ingredients": [
        "4 patate, grattugiate e strizzate",
        "1 cipolla, grattugiata",
        "1 uovo",
        "2 tbsp farina",
        "Sale, pepe",
        "Sour cream per servire"
      ],
      "steps": [
        "Unire le patate grattugiate e la cipolla; strizzare l'acqua in eccesso.",
        "Mescolare con uovo, farina, sale e pepe.",
        "Friggere a cucchiaiate nell'olio per 3-4 min per lato.",
        "Scolare su carta assorbente.",
        "Servire caldi con sour cream."
      ]
    },
    "es": {
      "recovery_note": "Comida reconfortante que cumple su promesa: crujiente, sabrosa y satisfactoria sin los remordimientos de la mañana siguiente.",
      "ingredients": [
        "4 papas, ralladas y exprimidas",
        "1 cebolla, rallada",
        "1 huevo",
        "2 tbsp harina",
        "Sal, pimienta",
        "Sour cream para servir"
      ],
      "steps": [
        "Combine la papa rallada y la cebolla; exprima el exceso de agua.",
        "Mezcle con el huevo, la harina, sal y pimienta.",
        "Fría cucharadas en aceite de 3-4 min por lado.",
        "Escurra sobre papel.",
        "Sirva caliente con sour cream."
      ]
    }
  },
  "ua5": {
    "ru": {
      "recovery_note": "Свекла + грецкие орехи = поддержка печени и мозга в одной тарелке. Оба органа нуждаются в годах целенаправленного восстановления после употребления психоактивных веществ.",
      "ingredients": [
        "3 свеклы, запеченные и нарезанные кубиками",
        "1/4 cup грецких орехов, измельченных",
        "1 зубчик чеснока, измельченный",
        "2 tbsp оливкового масла",
        "Лимонный сок, соль, укроп"
      ],
      "steps": [
        "Запекайте свеклу в фольге при 200°C в течение 45 min.",
        "Охладите, очистите и нарежьте кубиками.",
        "Взбейте чеснок, масло, лимон и соль.",
        "Смешайте со свеклой и грецкими орехами.",
        "Посыпьте укропом."
      ]
    },
    "uk": {
      "recovery_note": "Буряк + волоські горіхи = підтримка печінки та мозку в одній тарілці. Обидва органи потребують років ретельного відновлення після вживання психоактивних речовин.",
      "ingredients": [
        "3 буряки, запечені та нарізані кубиками",
        "1/4 cup волоських горіхів, подрібнених",
        "1 зубчик часнику, подрібнений",
        "2 tbsp оливкової олії",
        "Лимонний сік, сіль, кріп"
      ],
      "steps": [
        "Запікайте буряк у фользі при 200°C протягом 45 min.",
        "Остудіть, очистьте від шкірки та наріжте кубиками.",
        "Збийте часник, олію, лимон та сіль.",
        "Перемішайте з буряком та волоськими горіхами.",
        "Зверху посипте кропом."
      ]
    },
    "ko": {
      "recovery_note": "비트와 호두의 조합은 한 그릇으로 간과 뇌 건강을 모두 챙길 수 있게 해줍니다. 이 두 장기는 약물이나 알코올 섭취 후 원래의 상태로 회복되기까지 수년간의 정성 어린 관리가 필요합니다.",
      "ingredients": [
        "비트루트 3개, 구워서 깍둑썰기한 것",
        "호두 1/4컵, 다진 것",
        "마늘 1쪽, 다진 것",
        "올리브 오일 2 tbsp",
        "레몬 주스, 소금, 딜"
      ],
      "steps": [
        "비트루트를 호일에 싸서 200°C에서 45분간 굽습니다.",
        "식힌 뒤 껍질을 벗기고 깍둑썰기합니다.",
        "마늘, 오일, 레몬, 소금을 휘퍼로 잘 섞습니다.",
        "비트루트와 호두를 넣고 가볍게 버무립니다.",
        "딜을 위에 얹어 마무리합니다."
      ]
    },
    "fr": {
      "recovery_note": "Betterave + noix = un soutien pour le foie et le cerveau dans un seul bol. Ces deux organes nécessitent des années de réparation ciblée après une consommation de substances.",
      "ingredients": [
        "3 betteraves, rôties et coupées en dés",
        "1/4 cup de cerneaux de noix, hachés",
        "1 gousse d'ail, émincée",
        "2 tbsp d'huile d'olive",
        "Jus de citron, sel, aneth"
      ],
      "steps": [
        "Faire rôtir les betteraves dans du papier aluminium à 200°C pendant 45 min.",
        "Laisser refroidir, éplucher et couper en dés.",
        "Fouetter l'ail, l'huile, le citron et le sel.",
        "Mélanger avec les betteraves et les noix.",
        "Garnir avec de l'aneth."
      ]
    },
    "it": {
      "recovery_note": "Barbabietola + noci = supporto per fegato e cervello in un'unica ciotola. Entrambi gli organi richiedono anni di riparazione dedicata dopo l'uso di sostanze.",
      "ingredients": [
        "3 barbabietole, arrostite e tagliate a dadini",
        "1/4 cup di noci, tritate",
        "1 spicchio d'aglio, tritato finemente",
        "2 tbsp di olio d'oliva",
        "Succo di limone, sale, aneto"
      ],
      "steps": [
        "Arrostire la barbabietola in un foglio di alluminio a 200°C per 45 min.",
        "Lasciare raffreddare, sbucciare e tagliare a dadini.",
        "Mescolare con una frusta aglio, olio, limone e sale.",
        "Condire la barbabietola e le noci con il composto.",
        "Guarnire con aneto."
      ]
    },
    "es": {
      "recovery_note": "Remolacha + nueces = apoyo para el hígado y el cerebro en un solo tazón. Ambos órganos necesitan años de reparación dedicada después del consumo de sustancias.",
      "ingredients": [
        "3 beetroot, rostizados y cortados en cubos",
        "1/4 cup de walnuts, picadas",
        "1 diente de ajo, picado finamente",
        "2 tbsp de olive oil",
        "Lemon juice, salt, dill"
      ],
      "steps": [
        "Ase la remolacha en papel de aluminio a 200°C durante 45 min.",
        "Deje enfriar, pele y corte en cubos.",
        "Bata el ajo, el aceite, el limón y la sal.",
        "Mezcle con la remolacha y las nueces.",
        "Cubra con eneldo."
      ]
    }
  },
  "ua6": {
    "ru": {
      "recovery_note": "Ужин со вкусом дома, который связывает вас с культурным наследием — мощная опора для самопознания на ранних этапах восстановления.",
      "ingredients": [
        "2 куриные грудки",
        "50g сливочного масла, размягченного",
        "2 зубчика чеснока, петрушка",
        "1 яйцо, панировочные сухари",
        "Соль, перец, растительное масло"
      ],
      "steps": [
        "Смешайте butter с garlic и parsley; заморозьте на 15 min.",
        "Отбейте chicken; положите butter сверху и сверните в рулет.",
        "Обваляйте в egg и breadcrumbs.",
        "Выпекайте при 200°C в течение 25 min до золотистого цвета.",
        "Подавайте с mashed potato или салатом."
      ]
    },
    "uk": {
      "recovery_note": "Вечеря зі смаком дому, яка поєднує вас із культурною спадщиною — потужним якорем ідентичності на ранніх етапах одужання.",
      "ingredients": [
        "2 курячі грудки",
        "50g butter, розм’якшеного",
        "2 зубчики garlic, parsley",
        "1 egg, breadcrumbs",
        "Salt, pepper, oil"
      ],
      "steps": [
        "Змішайте вершкове масло з часником і петрушкою; заморозьте на 15 min.",
        "Відбийте куряче філе; покладіть масло зверху, згорніть у рулет.",
        "Обваляйте в яйці та панірувальних сухарях.",
        "Випікайте при 200°C протягом 25 min до золотистої скоринки.",
        "Подавайте з картопляним пюре або салатом."
      ]
    },
    "ko": {
      "recovery_note": "문화적 유산을 이어주는 고향의 맛이 담긴 저녁 식사는 회복 초기 단계에서 정체성을 지탱해 주는 강력한 버팀목이 됩니다.",
      "ingredients": [
        "닭가슴살 2개",
        "부드러워진 버터 50g",
        "마늘 2쪽, 파슬리",
        "달걀 1개, 빵가루",
        "소금, 후추, 식용유"
      ],
      "steps": [
        "버터, garlic, parsley를 섞은 후 15 min 동안 냉동 보관합니다.",
        "chicken을 두드려 폅니다. 그 위에 버터를 올리고 돌돌 맙니다.",
        "egg와 breadcrumbs를 묻힙니다.",
        "200°C에서 25 min 동안 노릇해질 때까지 굽습니다.",
        "mashed potato 또는 salad를 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Un dîner aux saveurs d'enfance qui vous connecte à votre héritage culturel — un ancrage identitaire puissant au début du rétablissement.",
      "ingredients": [
        "2 blancs de poulet",
        "50g de beurre, ramolli",
        "2 gousses d'ail, persil",
        "1 œuf, chapelure",
        "Sel, poivre, huile"
      ],
      "steps": [
        "Mélanger le beurre avec l'ail et le persil ; congeler 15 min.",
        "Aplatir le poulet ; placer le beurre sur le dessus, rouler.",
        "Enrober dans l'œuf et la chapelure.",
        "Cuire à 200°C pendant 25 min jusqu'à ce que ce soit doré.",
        "Servir avec de la purée de pommes de terre ou une salade."
      ]
    },
    "it": {
      "recovery_note": "Una cena dal sapore di casa che ti connette alle tue radici culturali — un potente punto di riferimento per l'identità nelle prime fasi del recupero.",
      "ingredients": [
        "2 petti di pollo",
        "50g butter, ammorbidito",
        "2 spicchi d'aglio, prezzemolo",
        "1 uovo, pangrattato",
        "Sale, pepe, olio"
      ],
      "steps": [
        "Mescolare il burro con aglio e prezzemolo; congelare per 15 min.",
        "Battere il pollo; posizionare il burro sopra, arrotolare.",
        "Rivestire nell'uovo e nel pangrattato.",
        "Cuocere a 200°C per 25 min fino a doratura.",
        "Servire con purè di patate o insalata."
      ]
    },
    "es": {
      "recovery_note": "Una cena con sabor a hogar que te conecta con tu herencia cultural: un poderoso anclaje de identidad en las primeras etapas de la recuperación.",
      "ingredients": [
        "2 pechugas de pollo",
        "50g de mantequilla, ablandada",
        "2 dientes de ajo, perejil",
        "1 huevo, pan rallado",
        "Sal, pimienta, aceite"
      ],
      "steps": [
        "Mezcle la mantequilla con el ajo y el perejil; congele por 15 min.",
        "Machaque el pollo; coloque la mantequilla encima y enróllelo.",
        "Cubra con huevo y pan rallado (breadcrumbs).",
        "Hornee a 200°C durante 25 min hasta que esté dorado.",
        "Sirva con puré de papas o ensalada."
      ]
    }
  },
  "ua7": {
    "ru": {
      "recovery_note": "Завтрак на скорую руку — нафаршируйте их творогом или фруктами для быстрого перекуса в те ленивые утра, когда совсем нет сил на готовку.",
      "ingredients": [
        "1 cup муки",
        "2 яйца",
        "1 1/2 cups молока",
        "Pinch соли",
        "Butter для сковороды",
        "Honey или свежие ягоды для подачи"
      ],
      "steps": [
        "Взбейте муку, яйца, молоко и соль до однородного состояния.",
        "Разогрейте небольшую сковороду, смажьте ее butter.",
        "Налейте тесто тонким слоем; готовьте по 1 мин с каждой стороны.",
        "Складывайте стопкой по мере готовности.",
        "Подавайте свернутыми с медом или ягодами."
      ]
    },
    "uk": {
      "recovery_note": "Сніданок заздалегідь — загорніть у них сир або фрукти для швидкого ранку, коли бракує сили волі.",
      "ingredients": [
        "1 склянка борошна",
        "2 яйця",
        "1 1/2 склянки молока",
        "Дрібка солі",
        "Butter для сковорідки",
        "Honey або свіжі ягоди для подачі"
      ],
      "steps": [
        "Збийте борошно, яйця, молоко та сіль до однорідності.",
        "Розігрійте невелику сковорідку, змастіть вершковим маслом.",
        "Налийте тонкий шар тіста; смажте по 1 хв з кожного боку.",
        "Складайте млинці стопкою один на одного.",
        "Подавайте згорнутими з медом або ягодами."
      ]
    },
    "ko": {
      "recovery_note": "미리 만들어두는 아침 식사 — 의지력이 떨어지는 바쁜 아침에 코티지 치즈나 과일을 넣어 접어 먹으면 간편합니다.",
      "ingredients": [
        "밀가루 1 cup",
        "계란 2개",
        "우유 1 1/2 cups",
        "소금 한 꼬집",
        "팬용 버터",
        "곁들임용 꿀 또는 신선한 베리류"
      ],
      "steps": [
        "밀가루, 계란, 우유, 소금을 덩어리 없이 부드러워질 때까지 휘퍼로 섞습니다.",
        "작은 팬을 가열한 뒤 버터를 얇게 바릅니다.",
        "반죽을 얇게 붓고 한 면당 1분씩 굽습니다.",
        "다 구워진 것은 차곡차곡 쌓아 둡니다.",
        "돌돌 말아서 꿀이나 베리류를 곁들여 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Petit-déjeuner à préparer à l'avance — garnissez-les de fromage frais ou de fruits pour les matins pressés où la motivation manque.",
      "ingredients": [
        "1 cup de farine",
        "2 œufs",
        "1 1/2 cups de lait",
        "Une pincée de sel",
        "Beurre pour la poêle",
        "Miel ou baies fraîches pour servir"
      ],
      "steps": [
        "Fouetter la farine, les œufs, le lait et le sel jusqu'à l'obtention d'un mélange lisse.",
        "Chauffer une petite poêle, badigeonner avec du beurre.",
        "Verser une fine couche de pâte ; cuire 1 min par côté.",
        "Empiler au fur et à mesure.",
        "Servir roulé avec du miel ou des baies."
      ]
    },
    "it": {
      "recovery_note": "Colazione da preparare in anticipo: farciscili con fiocchi di latte o frutta per le mattine frenetiche quando la forza di volontà scarseggia.",
      "ingredients": [
        "1 cup di farina",
        "2 uova",
        "1 1/2 cups di latte",
        "Un pizzico di sale",
        "Burro per la padella",
        "Miele o frutti di bosco freschi per servire"
      ],
      "steps": [
        "Sbattere farina, uova, latte e sale fino a ottenere un composto liscio.",
        "Scaldare una padella piccola e spennellare con del burro.",
        "Versare uno strato sottile di pastella; cuocere per 1 min per lato.",
        "Impilare man mano che si procede.",
        "Servire arrotolate con miele o frutti di bosco."
      ]
    },
    "es": {
      "recovery_note": "Desayuno preparado con antelación: rellénalos con queso cottage o fruta para esas mañanas rápidas en las que falta la fuerza de voluntad.",
      "ingredients": [
        "1 taza de harina",
        "2 huevos",
        "1 1/2 tazas de leche",
        "Pizca de sal",
        "Mantequilla para la sartén",
        "Miel o bayas frescas para servir"
      ],
      "steps": [
        "Batir la harina, los huevos, la leche y la sal hasta obtener una mezcla suave.",
        "Calentar una sartén pequeña y pincelar con mantequilla.",
        "Verter una capa fina de masa; cocinar 1 min por cada lado.",
        "Apilar a medida que se vayan haciendo.",
        "Servir enrollados con miel o bayas."
      ]
    }
  },
  "ua8": {
    "ru": {
      "recovery_note": "Грибы вырабатывают витамин D и витамины группы B — уровень и тех, и других часто понижен у людей с длительной зависимостью, при этом они крайне важны для настроения.",
      "ingredients": [
        "500g mushrooms, нарезанных ломтиками",
        "1 onion, 1 carrot, 2 potatoes",
        "4 cups stock",
        "1/4 cup pearl barley",
        "Bay leaf, dill, sour cream"
      ],
      "steps": [
        "Обжаривайте onion и carrot 5 min.",
        "Добавьте mushrooms; готовьте 8 min.",
        "Добавьте potatoes, stock, barley, bay leaf.",
        "Варите на медленном огне 25 min.",
        "Посыпьте dill и добавьте sour cream."
      ]
    },
    "uk": {
      "recovery_note": "Гриби виробляють вітамін D та вітаміни групи B — обидва ці показники зазвичай низькі у людей з тривалою залежністю і мають вирішальне значення для настрою.",
      "ingredients": [
        "500g mushrooms, нарізаних скибочками",
        "1 onion, 1 carrot, 2 potatoes",
        "4 cups stock",
        "1/4 cup pearl barley",
        "Bay leaf, dill, sour cream"
      ],
      "steps": [
        "Пасеруйте цибулю та моркву протягом 5 min.",
        "Додайте гриби; готуйте 8 min.",
        "Додайте картоплю, бульйон, ячмінь, лавровий лист.",
        "Тушкуйте на повільному вогні 25 min.",
        "Зверху прикрасьте кропом і додайте сметану."
      ]
    },
    "ko": {
      "recovery_note": "버섯은 비타민 D와 비타민 B군을 생성하는데, 이 두 성분은 장기 약물 사용자들에게 흔히 결핍되어 있으며 기분 조절에 매우 중요합니다.",
      "ingredients": [
        "500g mushrooms, sliced",
        "1 onion, 1 carrot, 2 potatoes",
        "4 cups stock",
        "1/4 cup pearl barley",
        "Bay leaf, dill, sour cream"
      ],
      "steps": [
        "양파와 당근을 5 min 동안 볶습니다.",
        "버섯을 넣고 8 min 동안 익힙니다.",
        "감자, 육수(stock), 보리(barley), 월계수 잎(bay leaf)을 넣습니다.",
        "25 min 동안 뭉근하게 끓입니다(Simmer).",
        "딜(dill)과 사워크림(sour cream)을 고명으로 올립니다."
      ]
    },
    "fr": {
      "recovery_note": "Les champignons produisent de la vitamine D et des vitamines B — toutes deux souvent carencées chez les consommateurs de substances à long terme et cruciales pour l'humeur.",
      "ingredients": [
        "500g mushrooms, émincés",
        "1 oignon, 1 carotte, 2 pommes de terre",
        "4 cups stock",
        "1/4 cup pearl barley",
        "Bay leaf, dill, sour cream"
      ],
      "steps": [
        "Faire sauter l'oignon et la carotte pendant 5 min.",
        "Ajouter les champignons ; cuire 8 min.",
        "Ajouter les pommes de terre, le bouillon, l'orge et la feuille de laurier.",
        "Mijoter 25 min.",
        "Garnir d'aneth et de crème aigre."
      ]
    },
    "it": {
      "recovery_note": "I funghi producono vitamina D e vitamine del gruppo B — entrambe spesso carenti in chi ha fatto uso prolungato di sostanze e fondamentali per l'umore.",
      "ingredients": [
        "500g funghi, affettati",
        "1 cipolla, 1 carota, 2 patate",
        "4 tazze di brodo",
        "1/4 tazza di orzo perlato",
        "Foglia di alloro, aneto, panna acida"
      ],
      "steps": [
        "Soffriggere la cipolla e la carota per 5 min.",
        "Aggiungere i funghi; cuocere per 8 min.",
        "Aggiungere le patate, il brodo, l'orzo e la foglia di alloro.",
        "Sobbollire per 25 min.",
        "Guarnire con aneto e panna acida."
      ]
    },
    "es": {
      "recovery_note": "Los champiñones producen vitamina D y vitaminas del grupo B, ambas comúnmente bajas en consumidores de sustancias a largo plazo y cruciales para el estado de ánimo.",
      "ingredients": [
        "500g mushrooms, rebanados",
        "1 onion, 1 carrot, 2 potatoes",
        "4 cups de stock",
        "1/4 cup de pearl barley",
        "Bay leaf, dill, sour cream"
      ],
      "steps": [
        "Saltear la cebolla y la zanahoria durante 5 min.",
        "Añadir los champiñones; cocinar 8 min.",
        "Añadir las patatas, el caldo, la cebada y la hoja de laurel.",
        "Cocinar a fuego lento durante 25 min.",
        "Cubrir con el eneldo y la crema agria."
      ]
    }
  },
  "ua9": {
    "ru": {
      "recovery_note": "Традиционный холодный салат — корнеплоды обеспечивают поступление медленных углеводов и минералов для поддержания стабильности нервной системы.",
      "ingredients": [
        "2 вареные свеклы, нарезанные кубиками",
        "2 вареных картофеля, нарезанных кубиками",
        "1 вареная морковь, нарезанная кубиками",
        "1/2 cup маринованных огурцов, нарезанных кубиками",
        "1/2 cup горошка",
        "Sunflower oil, уксус, укроп"
      ],
      "steps": [
        "Отварите и нарежьте кубиками beetroot, potatoes, carrot.",
        "Смешайте все овощи в миске.",
        "Заправьте маслом и vinegar.",
        "Посолите и поперчите; посыпьте dill.",
        "Подавайте холодным."
      ]
    },
    "uk": {
      "recovery_note": "Традиційний холодний салат — коренеплоди забезпечують стабільне надходження вуглеводів та мінералів для підтримки стійкості нервової системи.",
      "ingredients": [
        "2 варених буряка, нарізані кубиками",
        "2 варені картоплини, нарізані кубиками",
        "1 варена морква, нарізана кубиками",
        "1/2 cup маринованих огірків, нарізаних кубиками",
        "1/2 cup горошку",
        "Sunflower oil, vinegar, кріп"
      ],
      "steps": [
        "Відваріть і наріжте кубиками beetroot, potatoes та carrot.",
        "Змішайте всі овочі в мисці.",
        "Заправте oil та vinegar.",
        "Додайте спеції; посипте dill.",
        "Подавайте холодним."
      ]
    },
    "ko": {
      "recovery_note": "전통적인 콜드 샐러드입니다. 뿌리채소는 꾸준한 탄수화물과 미네랄을 공급하여 신경계 안정에 도움을 줍니다.",
      "ingredients": [
        "삶은 비트 2개, 깍둑썰기",
        "삶은 감자 2개, 깍둑썰기",
        "삶은 당근 1개, 깍둑썰기",
        "피클 1/2컵, 깍둑썰기",
        "완두콩 1/2컵",
        "Sunflower oil, 식초, 딜"
      ],
      "steps": [
        "Beetroot, potatoes, carrot를 삶은 뒤 깍둑썰기합니다.",
        "모든 채소를 볼에 넣고 섞습니다.",
        "Oil과 vinegar를 넣어 버무립니다.",
        "간을 맞춘 뒤 dill을 뿌립니다.",
        "차갑게 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Une salade froide traditionnelle — les légumes-racines apportent des glucides lents et des minéraux pour favoriser la stabilité du système nerveux.",
      "ingredients": [
        "2 betteraves bouillies, coupées en dés",
        "2 pommes de terre bouillies, coupées en dés",
        "1 carotte bouillie, coupée en dés",
        "1/2 cup de cornichons, coupés en dés",
        "1/2 cup de petits pois",
        "Huile de tournesol, vinaigre, aneth"
      ],
      "steps": [
        "Faire bouillir et couper en dés la betterave, les pommes de terre et la carotte.",
        "Mélanger tous les légumes dans un bol.",
        "Assaisonner avec de l'huile et du vinaigre.",
        "Assaisonner ; saupoudrer d'aneth.",
        "Servir froid."
      ]
    },
    "it": {
      "recovery_note": "Un'insalata fredda tradizionale: gli ortaggi a radice forniscono carboidrati a lento rilascio e minerali per favorire la stabilità del sistema nervoso.",
      "ingredients": [
        "2 barbabietole bollite, tagliate a cubetti",
        "2 patate bollite, tagliate a cubetti",
        "1 carota bollita, tagliata a cubetti",
        "1/2 cup di cetriolini sott'aceto, tagliati a cubetti",
        "1/2 cup di piselli",
        "Olio di girasole, aceto, aneto"
      ],
      "steps": [
        "Bollire e tagliare a dadini beetroot, patate e carote.",
        "Unire tutte le verdure in una ciotola.",
        "Condire con olio e aceto.",
        "Salare e pepare; cospargere con dill.",
        "Servire freddo."
      ]
    },
    "es": {
      "recovery_note": "Una ensalada fría tradicional — las hortalizas de raíz aportan carbohidratos de absorción lenta y minerales para favorecer la estabilidad del sistema nervioso.",
      "ingredients": [
        "2 boiled beetroot, diced",
        "2 boiled potatoes, diced",
        "1 boiled carrot, diced",
        "1/2 cup pickles, diced",
        "1/2 cup peas",
        "Sunflower oil, vinegar, dill"
      ],
      "steps": [
        "Hervir y cortar en cubos beetroot, potatoes y carrot.",
        "Combinar todos los vegetales en un bol.",
        "Aliñar con oil y vinegar.",
        "Salpimentar; espolvorear dill.",
        "Servir frío."
      ]
    }
  },
  "ua10": {
    "ru": {
      "recovery_note": "Традиционный безалкогольный рождественский напиток — доказательство того, что праздничные ритуалы вполне могут обходиться без алкоголя.",
      "ingredients": [
        "200g mixed dried fruit (яблоки, груши, сливы, изюм)",
        "6 cups воды",
        "2 tbsp меда",
        "1 cinnamon stick",
        "4 cloves"
      ],
      "steps": [
        "Тщательно промойте сухофрукты.",
        "Доведите воду со специями до кипения.",
        "Добавьте фрукты; варите на медленном огне 20 min.",
        "Добавьте мед, когда смесь немного остынет.",
        "Процедите или подавайте вместе с фруктами."
      ]
    },
    "uk": {
      "recovery_note": "Традиційний безалкогольний різдвяний напій — доказ того, що святкові ритуали цілком можуть відбуватися без алкоголю.",
      "ingredients": [
        "200g суміші сухофруктів (яблука, груші, сливи, родзинки)",
        "6 cups води",
        "2 tbsp меду",
        "1 паличка кориці",
        "4 гвоздики"
      ],
      "steps": [
        "Ретельно промийте сухофрукти.",
        "Доведіть воду зі спеціями до кипіння.",
        "Додайте фрукти; варіть на повільному вогні 20 min.",
        "Додайте мед, коли суміш трохи охолоне.",
        "Процідіть або подавайте разом із фруктами."
      ]
    },
    "ko": {
      "recovery_note": "알코올 없이도 충분히 격식 있는 축제 분위기를 낼 수 있다는 것을 보여주는 전통적인 무알코올 크리스마스 음료입니다.",
      "ingredients": [
        "200g mixed dried fruit (사과, 배, 자두, 건포도)",
        "6 cups water",
        "2 tbsp honey",
        "1 cinnamon stick",
        "4 cloves"
      ],
      "steps": [
        "말린 과일을 깨끗하게 헹굽니다.",
        "물과 향신료를 넣고 끓입니다.",
        "과일을 넣고 20분간 뭉근하게 끓입니다.",
        "약간 식으면 꿀을 넣고 젓습니다.",
        "체에 거르거나 과일과 함께 냅니다."
      ]
    },
    "fr": {
      "recovery_note": "Une boisson de Noël traditionnelle sans alcool — la preuve que les célébrations rituelles peuvent tout à fait se dérouler sans alcool.",
      "ingredients": [
        "200g mixed dried fruit (pommes, poires, prunes, raisins)",
        "6 cups d'eau",
        "2 tbsp de miel",
        "1 bâton de cannelle",
        "4 clous de girofle"
      ],
      "steps": [
        "Rincer soigneusement les fruits secs.",
        "Porter l'eau et les épices à ébullition.",
        "Ajouter les fruits ; laisser mijoter 20 min.",
        "Incorporer le miel quand le mélange a légèrement refroidi.",
        "Filtrer ou servir avec les fruits."
      ]
    },
    "it": {
      "recovery_note": "Una tradizionale bevanda natalizia analcolica — la prova che i festeggiamenti rituali possono assolutamente aver luogo anche senza alcol.",
      "ingredients": [
        "200g frutta secca mista (mele, pere, prugne, uvetta)",
        "6 cups acqua",
        "2 tbsp miele",
        "1 stecca di cannella",
        "4 chiodi di garofano"
      ],
      "steps": [
        "Sciacquare accuratamente la frutta secca.",
        "Portare l'acqua e le spezie a bollore.",
        "Aggiungere la frutta; cuocere a fuoco lento per 20 min.",
        "Incorporare il miele quando è leggermente raffreddato.",
        "Filtrare o servire con la frutta."
      ]
    },
    "es": {
      "recovery_note": "Una bebida navideña tradicional sin alcohol que demuestra que las celebraciones rituales pueden llevarse a cabo perfectamente sin alcohol.",
      "ingredients": [
        "200g mixed dried fruit (apples, pears, plums, raisins)",
        "6 cups water",
        "2 tbsp honey",
        "1 cinnamon stick",
        "4 cloves"
      ],
      "steps": [
        "Enjuague bien la fruta seca.",
        "Ponga a hervir el agua y las especias.",
        "Añada la fruta; cocine a fuego lento durante 20 min.",
        "Incorpore la miel cuando esté ligeramente frío.",
        "Cuele o sirva con la fruta."
      ]
    }
  }
};

export const MEAL_CONTENT_TRANSLATIONS = __DATA;

export function localizedRecoveryNote(meal, langCode) {
  if (!meal) return '';
  if (!langCode || langCode === 'en') return meal.recovery_note;
  const e = MEAL_CONTENT_TRANSLATIONS[meal.id]?.[langCode];
  return e?.recovery_note || meal.recovery_note;
}

export function localizedIngredients(meal, langCode) {
  if (!meal) return [];
  if (!langCode || langCode === 'en') return meal.ingredients;
  const e = MEAL_CONTENT_TRANSLATIONS[meal.id]?.[langCode];
  return (e?.ingredients?.length === meal.ingredients.length) ? e.ingredients : meal.ingredients;
}

export function localizedSteps(meal, langCode) {
  if (!meal) return [];
  if (!langCode || langCode === 'en') return meal.steps;
  const e = MEAL_CONTENT_TRANSLATIONS[meal.id]?.[langCode];
  return (e?.steps?.length === meal.steps.length) ? e.steps : meal.steps;
}
